import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Account = Contact | Staff;

/** AccountCardsOnFileFilterInput */
export type AccountCardsOnFileFilterInput = {
  /** See bookkeepingAccounts query */
  accountID: Scalars['ID']['input'];
  currency: Scalars['String']['input'];
};

/** AdjustReservationPayloadInput */
export type AdjustReservationPayloadInput = {
  /**
   * An override of the default policy type, e.g. Not required, Card on file, etc.
   * Requires reservations-admin permission to allow this override, leave this value as null if not overriding.
   */
  damageProtectionPolicyType?: InputMaybe<Scalars['String']['input']>;
  /** discount amount in the currency of the target property, if applicable */
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Discount reason is required if discountAmount is set.
   * See config{reservationDiscountReasons} query.
   */
  discountReason?: InputMaybe<Scalars['String']['input']>;
  /**
   * Send the grand total that's displayed on the FE, to validate the final amount matches what's expected.
   * This also verifies prices haven't changed in the background while the adjustment was being issued.
   *
   * This amount must be discounted if discountAmount is set.
   * When set, the adjustment uses the quotation-based repricing flow even if discountAmount is null.
   */
  grandTotal?: InputMaybe<Scalars['Float']['input']>;
  /**
   * In the format YYYY-MM-DD.
   * If moving reservation (targetPropertyID is set) and this date is greater than the check-in date, then the existing reservation is shortened and a new reservation is created in the target property.
   */
  moveToCheckInDate: Scalars['String']['input'];
  /** In the format YYYY-MM-DD */
  moveToCheckOutDate?: InputMaybe<Scalars['String']['input']>;
  /**
   * List of payment methods, only set if values were overridden by the staff.
   * See paymentMethods in the response of reservationQuotation query.
   */
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  /** this is set if paymentMethods were overridden by the staff */
  paymentMethodsOverrideReason?: InputMaybe<Scalars['String']['input']>;
  reservationID: Scalars['ID']['input'];
  /**
   * An override of the default security deposit of the property.
   * Requires reservations-admin permission to allow this override, leave this value as null if not overriding.
   *
   * This can only be set if damageProtectionPolicyType is "Security deposit (capture)".
   */
  securityDepositAmount?: InputMaybe<Scalars['Int']['input']>;
  /** target property, if moving the booking */
  targetPropertyID?: InputMaybe<Scalars['ID']['input']>;
};

/** AdjustReservationResponse */
export type AdjustReservationResponse = {
  __typename?: 'AdjustReservationResponse';
  /** Confirmation number of the split booking created by this adjustment, if any. */
  splitReservationConfirmationNumber?: Maybe<Scalars['String']['output']>;
  /** ID of the split booking created by this adjustment, if any. */
  splitReservationID?: Maybe<Scalars['ID']['output']>;
};

/** Attachment */
export type Attachment = {
  __typename?: 'Attachment';
  /** name of the uploaded file */
  fileName: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** AttachmentInput */
export type AttachmentInput = {
  /** name of the uploaded file */
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  /** see UploadResponse.assetUrl */
  url: Scalars['String']['input'];
};

/** BookingChannel */
export type BookingChannel = {
  __typename?: 'BookingChannel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** BookingCompletionLink */
export type BookingCompletionLink = {
  __typename?: 'BookingCompletionLink';
  /**
   * Raw booking completion code used to build bookingCompletionLink.
   * Provided primarily to allow the mobile app to call websiteBookingRegistrationLink query to check for pending steps.
   */
  bookingCompletionCode?: Maybe<Scalars['String']['output']>;
  /** URL sent to the guest if the invitation was sent out */
  bookingCompletionLink?: Maybe<Scalars['String']['output']>;
  /** the last sent corporate contact email */
  corporateContactEmail?: Maybe<EmailDeliveryInfo>;
  /** the last time the corporate contact booking completion link was sent */
  corporateContactLastSentAt?: Maybe<DateTime>;
  /** the next time the corporate contact link is scheduled to be sent, as a reminder for the corporate contact */
  corporateContactNextScheduledFor?: Maybe<DateTime>;
  /** Raw booking completion code used to build corporateContactOwnBookingCompletionLink */
  corporateContactOwnBookingCompletionCode?: Maybe<Scalars['String']['output']>;
  /**
   * This is sent to corporate contacts if they have to pay for the security deposit themselves or if they're responsible for uploading their documents.
   *
   * In this case, bookingCompletionLink is the link sent to the point of contact.
   *
   * See isCorporatePocResponsibleForIDSubmission & corporatePaysForTheSecurityDeposit in DamageProtectionPolicyPayment.
   */
  corporateContactOwnBookingCompletionLink?: Maybe<Scalars['String']['output']>;
  /** this is either the staff who created the booking, or the initiator of sendReservationCompletionLink, or null, if initiated by Nest */
  corporateContactSentBy?: Maybe<Staff>;
  /** the last sent email */
  email?: Maybe<EmailDeliveryInfo>;
  /**
   * Booking invitation expiry or hold expiry (for extensions).
   *
   * This is set for direct-contact bookings only.
   */
  expirationTime?: Maybe<DateTime>;
  /** the last time the booking completion link was sent */
  lastSentAt?: Maybe<DateTime>;
  /** the next time the link is scheduled to be sent, as a reminder for the contact */
  nextScheduledFor?: Maybe<DateTime>;
  /** this is either the staff who created the booking, or the initiator of sendReservationCompletionLink, or null, if initiated by Nest */
  sentBy?: Maybe<Staff>;
};

/** BookkeepingAccount */
export type BookkeepingAccount = {
  __typename?: 'BookkeepingAccount';
  /** total unused account credit per currency */
  accountCredit?: Maybe<Array<BookkeepingAccountBalance>>;
  accountType: BookkeepingAccountType;
  /** total amounts pending payment per currency, this excludes amounts in escrow account */
  accountsReceivable?: Maybe<Array<BookkeepingAccountReceivable>>;
  channel?: Maybe<BookingChannel>;
  /** available fields: id, firstName, lastName, email, contactType, phone */
  contact?: Maybe<Contact>;
  /** available fields: id, internalName, legalName */
  corporate?: Maybe<Corporate>;
  createdAt?: Maybe<DateTime>;
  /** refundable deposits for account */
  deposits?: Maybe<Array<BookkeepingAccountBalance>>;
  id: Scalars['ID']['output'];
  /** name of the channel (if OTA) or corporate / contact */
  name: Scalars['String']['output'];
  /** includes count of deposit invoices */
  overdueInvoiceCount?: Maybe<Scalars['Int']['output']>;
  /** includes count of deposit payments */
  paymentRecordCount?: Maybe<Scalars['Int']['output']>;
  /** includes count of deposit invoices */
  pendingInvoiceCount?: Maybe<Scalars['Int']['output']>;
  reservationCount?: Maybe<Scalars['Int']['output']>;
};

/** BookkeepingAccountBalance */
export type BookkeepingAccountBalance = {
  __typename?: 'BookkeepingAccountBalance';
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

/** BookkeepingAccountCreditInvoiceAllocationInput */
export type BookkeepingAccountCreditInvoiceAllocationInput = {
  amountAllocatedInAllocationCurrency: Scalars['Float']['input'];
  /**
   * Both amountAllocatedInInvoiceCurrency & conversionRate are required when invoice currency is different from allocation currency.
   * Do not set this if currencies match.
   */
  amountAllocatedInInvoiceCurrency?: InputMaybe<Scalars['Float']['input']>;
  conversionRate?: InputMaybe<Scalars['Float']['input']>;
  invoiceID: Scalars['ID']['input'];
};

/** BookkeepingAccountCreditInvoiceAllocationPayloadInput */
export type BookkeepingAccountCreditInvoiceAllocationPayloadInput = {
  accountID: Scalars['ID']['input'];
  allocations: Array<BookkeepingAccountCreditInvoiceAllocationInput>;
  /** allocation currency */
  currency: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** BookkeepingAccountCreditRefundPayloadInput */
export type BookkeepingAccountCreditRefundPayloadInput = {
  accountID: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  /** see config{bookkeepingRefundMethods} query */
  refundMethod: Scalars['String']['input'];
};

/** BookkeepingAccountDepositTransferPayloadInput */
export type BookkeepingAccountDepositTransferPayloadInput = {
  accountID: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
  /** must match invoice currency */
  currency: Scalars['String']['input'];
  /** filter invoices by accountIDs, currencies=[Allocation currency], statuses=['Pending','Paid'], invoiceTypes=['Security Deposit'] */
  invoiceID: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
};

/** BookkeepingAccountFilterInput */
export type BookkeepingAccountFilterInput = {
  accountCredit?: InputMaybe<NumericFilterInput>;
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  accountTypes?: InputMaybe<Array<BookkeepingAccountType>>;
  accountsReceivable?: InputMaybe<NumericFilterInput>;
  depositsBalance?: InputMaybe<NumericFilterInput>;
  invoiceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  overdueInvoices?: InputMaybe<NumericFilterInput>;
  /** search by account name or reservation confirmation number */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** BookkeepingAccountHistoryFilterInput */
export type BookkeepingAccountHistoryFilterInput = {
  accountID: Scalars['ID']['input'];
};

/** BookkeepingAccountReceivable */
export type BookkeepingAccountReceivable = {
  __typename?: 'BookkeepingAccountReceivable';
  /**
   * Accounts-Receivable pending / outstanding amount.
   *
   * This is the total unpaid balance on all account invoices that are still pending, this includes amounts not yet due and amounts past due.
   */
  amount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
  /**
   * Accounts-Receivable overdue amount.
   *
   * This is the subset of pending AR where the due date has passed.
   *
   * Overdue amount = sum of pending amounts on invoices with due date < today.
   */
  overdueAmount: Scalars['Float']['output'];
};

/** BookkeepingAccountResult */
export type BookkeepingAccountResult = {
  __typename?: 'BookkeepingAccountResult';
  /** Records count */
  count: Scalars['Int']['output'];
  /**
   * Exports to Excel.
   *
   * Pass the active BookkeepingAccountFilterInput that's applied to the grid, if any to get the same records.
   *
   * Also send the active sort criteria that's applied on the grid through options.sort. Pagination is ignored here.
   *
   * The columns field is the enabled columns on the grid, in order of display as customized by the staff or the default grid columns if not customized.
   *
   * This is fetched from the query columnDisplayCustomizationOptions for the page route.
   *
   * The reason we take a direct columns array instead of route, is that there could be no previous customization by the staff but the default grid display hides a few auxiliary columns and the Excel export needs to match that.
   *
   * The exportable columns are limited to the options below and need to match each one exactly (case sensitive):
   *
   * <pre>
   *     Account
   *     Account Type
   *     Account Credit
   *     Accounts Receivable
   *     Deposits
   *     Pending Invoices
   *     Overdue Invoices
   *     Payment Records
   *     Reservations
   *     Created At
   * </pre>
   */
  export: Scalars['String']['output'];
  /** Fetches account history */
  history: Array<ResourceHistory>;
  /**
   * To fetch all accounts without pagination, when populating dropdowns for instance, create a dedicated GraphQL file with this field selection:
   *
   * <pre>
   * bookkeepingAccounts {
   *     result: records(filter: $filter, options: $options) {
   *         id
   *         name
   *         accountType
   *         contact {
   *             id
   *             firstName
   *             lastName
   *             email
   *             contactType
   *             phone {
   *                 code
   *                 number
   *             }
   *         }
   *         corporate {
   *             id
   *             internalName
   *             legalName
   *         }
   *         channel {
   *             id
   *             name
   *         }
   *     }
   * }
   * </pre>
   *
   * When this exact field selection is detected, the server runs a faster query that returns all data without pagination.
   *
   * The unpaginated query supports the following filters: accountIDs, invoiceIDs, accountTypes, search.
   *
   * The list of supported sort criteria in options.sort:
   *
   * <pre>
   *     Account
   *     Account desc
   *     Account Type
   *     Account Type desc
   *     Account Credit
   *     Account Credit desc
   *     Accounts Receivable
   *     Accounts Receivable desc
   *     Pending Invoices
   *     Pending Invoices desc
   *     Overdue Invoices
   *     Overdue Invoices desc
   *     Payment Records
   *     Payment Records desc
   *     Reservations
   *     Reservations desc
   *     Created At
   *     Created At desc
   * </pre>
   */
  records: Array<BookkeepingAccount>;
};


/** BookkeepingAccountResult */
export type BookkeepingAccountResultCountArgs = {
  filter?: InputMaybe<BookkeepingAccountFilterInput>;
};


/** BookkeepingAccountResult */
export type BookkeepingAccountResultExportArgs = {
  columns: Array<Scalars['String']['input']>;
  filter?: InputMaybe<BookkeepingAccountFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};


/** BookkeepingAccountResult */
export type BookkeepingAccountResultHistoryArgs = {
  filter: BookkeepingAccountHistoryFilterInput;
};


/** BookkeepingAccountResult */
export type BookkeepingAccountResultRecordsArgs = {
  filter?: InputMaybe<BookkeepingAccountFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** BookkeepingAccountType */
export enum BookkeepingAccountType {
  Contact = 'Contact',
  Corporate = 'Corporate',
  Ota = 'OTA'
}

/** BookkeepingBankSettlement */
export type BookkeepingBankSettlement = {
  __typename?: 'BookkeepingBankSettlement';
  bankSettlementDate: Date;
  fees?: Maybe<Array<BookkeepingBankSettlementFee>>;
  memo?: Maybe<Scalars['String']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  /** net amount after deducting bank settlement fees */
  settlementAmount?: Maybe<Scalars['Float']['output']>;
};

/** BookkeepingBankSettlementFee */
export type BookkeepingBankSettlementFee = {
  __typename?: 'BookkeepingBankSettlementFee';
  amount: Scalars['Float']['output'];
  feeType: Scalars['String']['output'];
};

/** BookkeepingBankSettlementFeeInput */
export type BookkeepingBankSettlementFeeInput = {
  amount: Scalars['Float']['input'];
  /** see config{bookkeepingBankSettlementFeeTypes} */
  feeType: Scalars['String']['input'];
};

/** BookkeepingCashAccount */
export type BookkeepingCashAccount = {
  __typename?: 'BookkeepingCashAccount';
  id: Scalars['ID']['output'];
  isClearingAccount?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

/** BookkeepingCashAccountFilterInput */
export type BookkeepingCashAccountFilterInput = {
  /** e.g. to filter out clearing accounts when selecting a destination for bank settlement */
  isClearingAccount?: InputMaybe<Scalars['Boolean']['input']>;
};

/** BookkeepingCreditNotePayloadInput */
export type BookkeepingCreditNotePayloadInput = {
  /** this is used for verification only, to ensure backend calculations mirrors displayed value on the frontend */
  accountCreditAmount: Scalars['Float']['input'];
  /** See bookkeepingAccounts query */
  accountID: Scalars['ID']['input'];
  creditNoteAmount: Scalars['Float']['input'];
  /**
   * Invoice to apply credit note to.
   * To fetch account invoices, use unpaginated invoices{records}, filtering by accountIDs
   */
  invoiceID: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  /** see config{bookkeepingCreditNoteReasons} */
  reason: Scalars['String']['input'];
};

/** BookkeepingDepositRefundPayloadInput */
export type BookkeepingDepositRefundPayloadInput = {
  accountID: Scalars['ID']['input'];
  amount: Scalars['Float']['input'];
  /** must match invoice currency */
  currency: Scalars['String']['input'];
  /** filter invoices by accountIDs, currencies=[Allocation currency], statuses=['Pending','Paid'], invoiceTypes=['Security Deposit'] */
  invoiceID: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  /** see config{bookkeepingRefundMethods} query */
  refundMethod: Scalars['String']['input'];
};

/** BookkeepingPayment */
export type BookkeepingPayment = {
  __typename?: 'BookkeepingPayment';
  /** available fields: id, name, accountType */
  account?: Maybe<BookkeepingAccount>;
  /** in 'currency' */
  accountCreditAllocationTotal?: Maybe<Scalars['Float']['output']>;
  allocations?: Maybe<Array<BookkeepingPaymentAllocation>>;
  amountReceived: Scalars['Float']['output'];
  bankSettlement?: Maybe<BookkeepingBankSettlement>;
  createdAt?: Maybe<DateTime>;
  createdBy?: Maybe<Staff>;
  currency: Scalars['String']['output'];
  /** aka: Receipt Account */
  destination?: Maybe<BookkeepingCashAccount>;
  id: Scalars['ID']['output'];
  /** in 'currency' */
  invoiceAllocationTotal?: Maybe<Scalars['Float']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentReceivedOn?: Maybe<Date>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  secondaryReferenceNumber?: Maybe<Scalars['String']['output']>;
};

/** BookkeepingPaymentAllocation */
export type BookkeepingPaymentAllocation = {
  __typename?: 'BookkeepingPaymentAllocation';
  amountAllocatedInInvoiceCurrency?: Maybe<Scalars['Float']['output']>;
  /**
   * To display the conversion details. This is always set even if the conversion rate is 1.
   * For "Account Credit" allocations, use this field to display the allocation amount.
   */
  amountAllocatedInPaymentCurrency?: Maybe<Scalars['Float']['output']>;
  conversionRate?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<DateTime>;
  id: Scalars['ID']['output'];
  /**
   * Set for invoice allocations. If this is null, then "Allocation Destination" is "Account Credit".
   *
   * Available fields: id, invoiceNumber, totalAmount, dueAmount, paidAmount, totalRefunds, totalAdjustments, currency, invoiceType, status, reservations, extensions, breakdown, creditNotes, paymentAllocations, discrepancy
   */
  invoice?: Maybe<Invoice>;
  /**
   * An invoice may actually be paid via multiple payment collections. This collection is the payment collection chosen when allocating payment, regardless of how many collections the invoice is split across.
   * Note: Not all invoices have corresponding payment collections. For example, an invoice created for an Airbnb booking won't have a payment collection.
   *
   * Available fields: id, paymentNumber
   */
  paymentCollection?: Maybe<PaymentCollection>;
  /**
   * This is 'id' from BookkeepingPayment.
   *
   * An invoice could be allocated in multiple payments (multiple BookkeepingPayment entries), this field lets you highlight the payment matching the current one, when retrieving all invoice allocations through the invoices query.
   */
  paymentID: Scalars['ID']['output'];
};

/** BookkeepingPaymentAllocationInput */
export type BookkeepingPaymentAllocationInput = {
  /**
   * Both amountAllocatedInInvoiceCurrency & conversionRate are required when invoice currency is different from payment currency.
   * Do not set this if currencies match.
   */
  amountAllocatedInInvoiceCurrency?: InputMaybe<Scalars['Float']['input']>;
  amountAllocatedInPaymentCurrency: Scalars['Float']['input'];
  conversionRate?: InputMaybe<Scalars['Float']['input']>;
  /** set invoiceID if allocating payment to an invoice, leave it as null when allocating to an account credit */
  invoiceID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * See paymentCollections{records} query.
   *
   * This is optional, and can only be used when allocating to an invoice.
   *
   * Not all invoices have corresponding payment collections, for example, an invoice created for an Airbnb booking won't have a payment collection.
   *
   * In most cases, Nest can correctly complete the allocation just using the invoice id, but if it finds an invoice in more than one payment collection (split payments), it returns an error to the FE to select a payment collection to allocate correctly.
   */
  paymentCollectionID?: InputMaybe<Scalars['ID']['input']>;
};

/** BookkeepingPaymentBankSettlementPayloadInput */
export type BookkeepingPaymentBankSettlementPayloadInput = {
  /** in the format YYYY-MM-DD */
  bankSettlementDate: Scalars['String']['input'];
  /**
   * Bank account to settle to.
   *
   * see bookkeepingCashAccounts query, filter by {isClearingAccount: false}
   */
  destinationID: Scalars['ID']['input'];
  fees?: InputMaybe<Array<BookkeepingBankSettlementFeeInput>>;
  memo?: InputMaybe<Scalars['String']['input']>;
  paymentID: Scalars['ID']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
};

/** BookkeepingPaymentFilterInput */
export type BookkeepingPaymentFilterInput = {
  /** see bookkeepingAccounts query */
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  allocationCount?: InputMaybe<NumericFilterInput>;
  amountReceived?: InputMaybe<NumericFilterInput>;
  createdByIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdOn?: InputMaybe<DateFilterInput>;
  /** see bookkeepingCashAccounts query */
  destinationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** if payment is in a clearing account */
  isPendingBankSettlement?: InputMaybe<Scalars['Boolean']['input']>;
  /** see config{currencies} query */
  paymentCurrency?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** see reservationPaymentMethods query */
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentReceivedOn?: InputMaybe<DateFilterInput>;
  /** search by reservation confirmation number, reference number, or secondary reference number */
  search?: InputMaybe<Scalars['String']['input']>;
};

/** BookkeepingPaymentHistoryFilterInput */
export type BookkeepingPaymentHistoryFilterInput = {
  paymentID: Scalars['ID']['input'];
};

/** BookkeepingPaymentNotesPayloadInput */
export type BookkeepingPaymentNotesPayloadInput = {
  /** set to null to remove the note */
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentID: Scalars['ID']['input'];
};

/** BookkeepingPaymentPayloadInput */
export type BookkeepingPaymentPayloadInput = {
  /** See bookkeepingAccounts query */
  accountID: Scalars['ID']['input'];
  allocations: Array<BookkeepingPaymentAllocationInput>;
  amountReceived: Scalars['Float']['input'];
  /** see config{currencies} query */
  currency: Scalars['String']['input'];
  /**
   * aka Receipt-Account, Cash-Account, Destination-Account, etc.
   * see bookkeepingCashAccounts query
   */
  destinationID: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  /** see reservationPaymentMethods query */
  paymentMethod: Scalars['String']['input'];
  /** in the format YYYY-MM-DD */
  receivedOn: Scalars['String']['input'];
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  secondaryReferenceNumber?: InputMaybe<Scalars['String']['input']>;
};

/** BookkeepingPaymentResult */
export type BookkeepingPaymentResult = {
  __typename?: 'BookkeepingPaymentResult';
  /** Records count */
  count: Scalars['Int']['output'];
  /**
   * Exports to Excel.
   *
   * Pass the active BookkeepingPaymentFilterInput that's applied to the grid, if any to get the same records.
   *
   * Also send the active sort criteria that's applied on the grid through options.sort. Pagination is ignored here.
   *
   * The columns field is the enabled columns on the grid, in order of display as customized by the staff or the default grid columns if not customized.
   *
   * This is fetched from the query columnDisplayCustomizationOptions for the page route.
   *
   * The reason we take a direct columns array instead of route, is that there could be no previous customization by the staff but the default grid display hides a few auxiliary columns and the Excel export needs to match that.
   *
   * The exportable columns are limited to the options below and need to match each one exactly (case sensitive):
   *
   * <pre>
   *     Payment ID
   *     Account
   *     Payment Method
   *     Receipt Account
   *     Currency
   *     Settlement Amount
   *     Amount Received
   *     Payment Received on
   *     Invoice Allocation
   *     Account Credit Allocation
   *     No. of Allocations
   *     Created At
   * </pre>
   */
  export: Scalars['String']['output'];
  /** Fetches payment history */
  history: Array<ResourceHistory>;
  /**
   * The list of supported sort criteria in options.sort:
   *
   * <pre>
   *     Payment ID
   *     Payment ID desc
   *     Account
   *     Account desc
   *     Payment Method
   *     Payment Method desc
   *     Receipt Account
   *     Receipt Account desc
   *     Currency
   *     Currency desc
   *     Settlement Amount
   *     Settlement Amount desc
   *     Amount Received
   *     Amount Received desc
   *     Payment Received on
   *     Payment Received on desc
   *     Invoice Allocation
   *     Invoice Allocation desc
   *     Account Credit Allocation
   *     Account Credit Allocation desc
   *     No. of Allocations
   *     No. of Allocations desc
   *     Created At
   *     Created At desc
   * </pre>
   */
  records: Array<BookkeepingPayment>;
};


/** BookkeepingPaymentResult */
export type BookkeepingPaymentResultCountArgs = {
  filter?: InputMaybe<BookkeepingPaymentFilterInput>;
};


/** BookkeepingPaymentResult */
export type BookkeepingPaymentResultExportArgs = {
  columns: Array<Scalars['String']['input']>;
  filter?: InputMaybe<BookkeepingPaymentFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};


/** BookkeepingPaymentResult */
export type BookkeepingPaymentResultHistoryArgs = {
  filter: BookkeepingPaymentHistoryFilterInput;
};


/** BookkeepingPaymentResult */
export type BookkeepingPaymentResultRecordsArgs = {
  filter?: InputMaybe<BookkeepingPaymentFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** Building */
export type Building = {
  __typename?: 'Building';
  aboutBuilding?: Maybe<Array<TranslatedContent>>;
  /**
   * The aboutBuilding text for the language code sent in header.
   * This is used on the website / mobile only.
   */
  aboutBuildingRendered?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<DateTime>;
  createdBy?: Maybe<Staff>;
  /** the fields id, name and iconUrl are available here */
  highLevelAmenities?: Maybe<Array<HighLevelAmenity>>;
  id: Scalars['ID']['output'];
  images?: Maybe<ImageSet>;
  /** "internalName is computed from {cityAirportCode}-{buildingCode}", for example: DXB-BAR */
  internalName: Scalars['String']['output'];
  lastUpdated?: Maybe<DateTime>;
  listingName?: Maybe<Array<TranslatedContent>>;
  /**
   * The listing name for the language code sent in header.
   * This is used on the website / mobile only.
   */
  listingNameRendered?: Maybe<Scalars['String']['output']>;
  location?: Maybe<EntityLocation>;
  /**
   * Set when sending withQuotation in BuildingFilterInput.
   *
   * Use the values in "quotation.paymentPlan.singlePayment[0]" to display rates on the website / mobile.
   */
  quotation?: Maybe<ReservationQuotation>;
};

/** BuildingFilterInput */
export type BuildingFilterInput = {
  buildingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  cityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdByIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filters by buildings which have housekeeping configured, to prevent creating reservations in unconfigured buildings */
  hasHousekeepingConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  neighbourhoodIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filters by buildings which contain properties that can accommodate the specified number of guests.
   * Used for the website / mobile only.
   */
  numberOfGuests?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * When checkInDate and checkOutDate are set, returns quotation info for the specified dates.
   * Used for the website / mobile only.
   */
  withQuotation?: InputMaybe<ReservationQuotationInput>;
};

/** BuildingOrProperty */
export type BuildingOrProperty = Building | Property;

/** BuildingPayloadInput */
export type BuildingPayloadInput = {
  /**
   * A short description of the building, typically 1 to 3 paragraphs.
   *
   * This field does not support variables.
   */
  aboutBuilding?: InputMaybe<Array<TranslatedContentInput>>;
  code: Scalars['String']['input'];
  highLevelAmenityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  images: Array<ChannelManagerImageInput>;
  listingName: Array<TranslatedContentInput>;
  location: EntityLocationInput;
};

/** BuildingResult */
export type BuildingResult = {
  __typename?: 'BuildingResult';
  /** Records count */
  count: Scalars['Int']['output'];
  /**
   * Exports to Excel.
   *
   * Pass the active BuildingFilterInput that's applied to the grid, if any to get the same records.
   *
   * Also send the active sort criteria that's applied on the grid through options.sort. Pagination is ignored here.
   *
   * The columns field is the enabled columns on the grid, in order of display as customized by the staff or the default grid columns if not customized.
   *
   * This is fetched from the query columnDisplayCustomizationOptions for the page route.
   *
   * The reason we take a direct columns array instead of route, is that there could be no previous customization by the staff but the default grid display hides a few auxiliary columns and the Excel export needs to match that.
   *
   * The exportable columns are limited to the options below and need to match each one exactly (case sensitive):
   *
   * <pre>
   *     Building Name
   *     Country
   *     City
   *     Address
   *     Neighbourhood
   *     Amenities
   *     Created At
   *     Created By
   *     Last Updated
   * </pre>
   */
  export: Scalars['String']['output'];
  /**
   * When fetching records anonymously or as a guest, the field selection must be restricted to the following:
   *
   * <pre>
   * buildings {
   *     result: records(filter: $filter, options: $options) {
   *         id
   *         listingNameRendered
   *         location {
   *             id
   *             address
   *             zipCode
   *             coordinates {
   *                 lat
   *                 lng
   *             }
   *             neighbourhood {
   *                 id
   *                 name
   *                 city {
   *                     id
   *                     name
   *                     country {
   *                         id
   *                         name
   *                         code3
   *                         code2
   *                         currency
   *                     }
   *                 }
   *             }
   *         }
   *         highLevelAmenities {
   *             id
   *             name
   *             iconUrl
   *             contentRendered
   *         }
   *         images {
   *             main {
   *                 url
   *                 webp {
   *                     thumbnailUrl
   *                     mediumUrl
   *                     largeUrl
   *                 }
   *             }
   *             all {
   *                 url
   *                 webp {
   *                     thumbnailUrl
   *                     mediumUrl
   *                     largeUrl
   *                 }
   *                 imageType
   *                 displayOrder
   *                 captionRendered
   *             }
   *         }
   *         aboutBuildingRendered
   *         quotation {
   *             paymentPlan {
   *                 singlePayment {
   *                     nights
   *                     nightlyRate
   *                     bookingAmount
   *                     bookingTotal
   *                 }
   *                 grandBookingTotal
   *                 grandTotal
   *                 currency
   *             }
   *         }
   *     }
   * }
   * </pre>
   *
   * To receive translated content in the user's language, set the "Accept-Language" header to a two-letter code, e.g. "en" or "ar".
   *
   * See "languages" GraphQL query for a list of supported language codes.
   *
   * To display a canonical name for buildings, use "internalName" instead of "code", which is computed from "{cityAirportCode}-{buildingCode}", for example: "DXB-BAR".
   *
   * To fetch all buildings without pagination, when populating dropdowns for instance, create a dedicated GraphQL file with this field selection:
   *
   * <pre>
   * buildings {
   *     result: records(filter: $filter, options: $options) {
   *         id
   *         internalName
   *         images {
   *             main {
   *                 url
   *                 webp {
   *                     thumbnailUrl
   *                 }
   *             }
   *         }
   *         location {
   *             id
   *             address
   *             neighbourhood {
   *                 id
   *                 name
   *                 city {
   *                     id
   *                     name
   *                     airportCode
   *                     country {
   *                         id
   *                         name
   *                         code3
   *                         code2
   *                         currency
   *                     }
   *                 }
   *             }
   *         }
   *     }
   * }
   * </pre>
   *
   * When this exact field selection is detected, the server runs a faster query that returns all data without pagination.
   *
   * All fields of BuildingFilterInput are still applicable with the exception of "search", "numberOfGuests" and "withQuotation". CommonQueryOptionsInput is ignored here.
   *
   * The list of supported sort criteria in options.sort:
   *
   * <pre>
   *     Building Name
   *     Building Name desc
   *     Country
   *     Country desc
   *     City
   *     City desc
   *     Address
   *     Address desc
   *     Neighbourhood
   *     Neighbourhood desc
   *     Created At
   *     Created At desc
   *     Last Updated
   *     Last Updated desc
   * </pre>
   */
  records: Array<Building>;
};


/** BuildingResult */
export type BuildingResultCountArgs = {
  filter?: InputMaybe<BuildingFilterInput>;
};


/** BuildingResult */
export type BuildingResultExportArgs = {
  columns: Array<Scalars['String']['input']>;
  filter?: InputMaybe<BuildingFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};


/** BuildingResult */
export type BuildingResultRecordsArgs = {
  filter?: InputMaybe<BuildingFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** BuildingsWithStandalonePropertiesFilterInput */
export type BuildingsWithStandalonePropertiesFilterInput = {
  cityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filters by buildings / properties that can accommodate the specified number of guests */
  numberOfGuests?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** returns quotation info for the specified dates */
  withQuotation: ReservationQuotationInput;
};

/** CardOnFile */
export type CardOnFile = {
  __typename?: 'CardOnFile';
  cardBrand?: Maybe<Scalars['String']['output']>;
  cardNumber: Scalars['String']['output'];
  createdAt?: Maybe<DateTime>;
  currency?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Date>;
  id: Scalars['ID']['output'];
  /** name of payment processor: TotalPay, etc. */
  pspType?: Maybe<Scalars['String']['output']>;
};

/** ChannelManagerImageInput */
export type ChannelManagerImageInput = {
  /** caption is used for our website and anywhere it's supported */
  caption?: InputMaybe<Array<TranslatedContentInput>>;
  /** controls the display order of images on Nest & external channels */
  displayOrder: Scalars['Int']['input'];
  imageType: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

/** ChannelManagerProperty */
export type ChannelManagerProperty = {
  __typename?: 'ChannelManagerProperty';
  /** the currency in which we publish prices, fees, receive bookings, etc. */
  currency?: Maybe<Scalars['String']['output']>;
  /** ID of the property on the channel manager, this is set if the property is successfully published */
  id?: Maybe<Scalars['ID']['output']>;
  /** location ID of the property on the channel manager, this confirms property's location can be mapped to the channel manager, regardless of the property's publishing status */
  locationID?: Maybe<Scalars['ID']['output']>;
  /** error encountered while publishing property, prompt for retries if this field is not null */
  publishingError?: Maybe<Scalars['String']['output']>;
};

/** CheckInOutInstructions */
export type CheckInOutInstructions = {
  __typename?: 'CheckInOutInstructions';
  /** content of check-in / check-out instructions */
  content?: Maybe<Array<TranslatedContent>>;
  /**
   * The check-in/out instructions for the language code sent in header.
   * This is used on the website / mobile only.
   */
  contentRendered?: Maybe<Scalars['String']['output']>;
  /** the last sent email */
  email?: Maybe<EmailDeliveryInfo>;
  scheduledFor?: Maybe<DateTime>;
  sentAt?: Maybe<DateTime>;
  /** if it was sent manually by a staff member */
  sentBy?: Maybe<Staff>;
};

/** City */
export type City = {
  __typename?: 'City';
  airportCode: Scalars['String']['output'];
  country?: Maybe<Country>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  vatPercentage?: Maybe<Scalars['Int']['output']>;
};

/** ColumnDisplayOption */
export type ColumnDisplayOption = {
  __typename?: 'ColumnDisplayOption';
  headerName: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  pinned?: Maybe<ColumnDisplayPinning>;
  width?: Maybe<Scalars['Float']['output']>;
};

/** ColumnDisplayOptionInput */
export type ColumnDisplayOptionInput = {
  headerName: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  pinned?: InputMaybe<ColumnDisplayPinning>;
  width?: InputMaybe<Scalars['Float']['input']>;
};

/** ColumnDisplayPinning */
export enum ColumnDisplayPinning {
  Left = 'left',
  Right = 'right'
}

/** CommonPropertyInput */
export type CommonPropertyInput = {
  /**
   * A short description of the property, typically 1 to 3 paragraphs.
   *
   * This field supports variables, see config{variables} query
   */
  aboutProperty?: InputMaybe<Array<TranslatedContentInput>>;
  /**
   * This creates a multi-unit if more than one record is set here. Set one record for single-units.
   * On edit, you'll need to set the IDs of previously assigned units
   */
  assignedUnits?: InputMaybe<Array<PropertyAssignmentInput>>;
  balconySizeSqm?: InputMaybe<Scalars['Int']['input']>;
  /** number of bathrooms, can be increments of 0.5, for example: 1.5 is one full bathroom that includes a shower or a bathtub and one that includes a toilet only */
  bathCount?: InputMaybe<Scalars['Float']['input']>;
  /** number of bedrooms, set to 0 for Studios */
  bedroomCount?: InputMaybe<Scalars['Int']['input']>;
  /** unit-type prefix, used in multi-units and single-units to build the internal name */
  code?: InputMaybe<Scalars['String']['input']>;
  hasKitchen?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * List of standard unit amenities, the amenities you display in React depend on the property model and type.
   *
   * - For furnished properties that are not standalone (Apartments, Studios, etc.), call highLevelAmenities query, setting category to "property". The building amenities are set at the building level.
   * - For furnished properties that are standalone (Villas, etc.), call highLevelAmenities query, leave category to null to display both building and property amenities.
   * - For unfurnished properties, call highLevelAmenities query, leave category to null. Most applicable amenities here will be building related, but might apply to property-related amenities as well (e.g. "Balcony", "Smoke Detector").
   *
   * For furnished properties, extendedAmenityIDs in FurnishedPropertyInput is also required.
   */
  highLevelAmenityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * See houseRules{records} query.
   *
   * Make sure to call houseRules{records} with the preset field selection documented to fetch all records, without pagination.
   *
   * House rules are displayed for the property in the order they are provided by React.
   */
  houseRuleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** minimum of 10 images are required with a minimum resolution of 1024 x 756 */
  images?: InputMaybe<Array<ChannelManagerImageInput>>;
  /** public listing name */
  listingName?: InputMaybe<Array<TranslatedContentInput>>;
  /** in local currency */
  securityDepositAmount?: InputMaybe<Scalars['Int']['input']>;
  sizeSqm?: InputMaybe<Scalars['Int']['input']>;
};

/** Common query options, sorting, filters, pagination */
export type CommonQueryOptionsInput = {
  pagination?: InputMaybe<QueryPaginationInput>;
  sort?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Config = {
  __typename?: 'Config';
  /**
   * List of bookkeeping bank settlement fee types.
   *
   * @staff
   */
  bookkeepingBankSettlementFeeTypes: Array<Scalars['String']['output']>;
  /**
   * List of bookkeeping credit note reasons.
   *
   * @staff
   */
  bookkeepingCreditNoteReasons: Array<Scalars['String']['output']>;
  /**
   * List of bookkeeping refund methods.
   *
   * @staff
   */
  bookkeepingRefundMethods: Array<Scalars['String']['output']>;
  /**
   * Types of beds supported by the channel manager, used when registering properties.
   *
   * Examples: King size bed, Sofa bed, etc.
   *
   * @staff
   */
  channelManagerBedTypes: Array<Scalars['String']['output']>;
  /**
   * Retrieves all image types supported by the channel manager.
   *
   * These types are used to annotate images of buildings & properties when publishing to the channel manager.
   *
   * Examples of such types are Main image, Exterior, Interior, etc.
   *
   * @staff
   */
  channelManagerImageTypes: Array<Scalars['String']['output']>;
  /**
   * List of contact document statuses.
   *
   * @staff
   */
  contactDocumentStatuses: Array<Scalars['String']['output']>;
  /**
   * Supported contact documents (example: Passport, etc.)
   *
   * @staff
   */
  contactDocumentTypes: Array<Scalars['String']['output']>;
  /**
   * Types of contacts (example: Standard, VIP)
   *
   * @staff
   */
  contactTypes: Array<Scalars['String']['output']>;
  /**
   * Supported corporate documents (example: Trade License, etc.)
   *
   * @staff
   */
  corporateDocumentTypes: Array<Scalars['String']['output']>;
  /**
   * List of supported currencies for locations.
   *
   * @staff
   */
  currencies: Array<Scalars['String']['output']>;
  /**
   * Types of damage protection policies, for example: Not required, Card on file
   *
   * @staff
   */
  damageProtectionPolicyTypes: Array<Scalars['String']['output']>;
  /**
   * List of extended invoice statuses (Partially Paid, Reversed, etc).
   *
   * @staff
   */
  extendedInvoiceStatuses: Array<Scalars['String']['output']>;
  /**
   * List of housekeeping cleaning slots (e.g. Morning, Afternoon, etc.).
   *
   * @staff
   */
  housekeepingCleaningSlots: Array<Scalars['String']['output']>;
  /**
   * List of housekeeping cleaning statuses (e.g. Unscheduled, Scheduled, etc.).
   *
   * @staff
   */
  housekeepingCleaningStatuses: Array<Scalars['String']['output']>;
  /**
   * List of housekeeping cleaning types (e.g. Checkout, Complimentary, etc.).
   *
   * @staff
   */
  housekeepingCleaningTypes: Array<Scalars['String']['output']>;
  /**
   * List of housekeeping service types (e.g. Quick, Deep).
   *
   * @staff
   */
  housekeepingServiceTypes: Array<Scalars['String']['output']>;
  /**
   * List of invoice types.
   *
   * @staff
   */
  invoiceTypes: Array<Scalars['String']['output']>;
  /**
   * List of payment collection proof statuses.
   *
   * e.g. Awaiting Proof, Pending Acceptance, etc.
   *
   * @staff
   */
  paymentCollectionProofStatuses: Array<Scalars['String']['output']>;
  /**
   * List of property availability blocking reasons (e.g. Maintenance, Unit Launch, etc.).
   *
   * @staff
   */
  propertyBlockReasons: Array<Scalars['String']['output']>;
  /**
   * Retrieves list of property configuration parameters.
   *
   * - Parameters ending with _FINE are fees to be collected and should be displayed as numeric input fields that accept integers only.
   * - Parameters ending with _HOUR should display a time picker but then normalized to an integer (0 to 23) when sent to the backend.
   *
   * @staff
   */
  propertyConfigParameters: Array<Scalars['String']['output']>;
  /**
   * Supported property models. For example: Furnished, Unfurnished
   *
   * @staff
   */
  propertyModels: Array<Scalars['String']['output']>;
  /**
   * All property types. For example: Apartment, Villa, etc.
   *
   * @staff
   */
  propertyTypes: Array<PropertyType>;
  /**
   * List of reservation discount reasons.
   *
   * @staff
   */
  reservationDiscountReasons: Array<Scalars['String']['output']>;
  /**
   * List of reservation lead qualities.
   *
   * When isForFiltering is true, returns all values.
   * When isForFiltering is false, returns values for use when creating reservations.
   *
   * @staff
   */
  reservationLeadQualities: Array<Scalars['String']['output']>;
  /**
   * List of reservation statuses.
   *
   * @staff
   */
  reservationStatuses: Array<Scalars['String']['output']>;
  /**
   * List of all supported staff permissions
   *
   * @staff(permissions: ["staff-viewer"])
   */
  staffPermissions: Array<Scalars['String']['output']>;
  /**
   * List of task priorities (e.g. P1, P2, etc.).
   *
   * @staff
   */
  taskPriorities: Array<Scalars['String']['output']>;
  /**
   * List of task statuses (e.g. Unassigned, In Progress, etc.).
   *
   * @staff
   */
  taskStatuses: Array<Scalars['String']['output']>;
  /**
   * List of task types / categories (e.g. Maintenance, Operations, etc.).
   *
   * @staff
   */
  taskTypes: Array<Scalars['String']['output']>;
  /**
   * List of system timezones
   *
   * @staff
   */
  timezones: Array<Scalars['String']['output']>;
  /**
   * Retrieves all interpolation variables that can be used to create dynamic content on the platform.
   *
   * Examples of such content are house rules, property description, etc.
   *
   * @staff
   */
  variables: Array<Scalars['String']['output']>;
};


export type ConfigReservationLeadQualitiesArgs = {
  isForFiltering: Scalars['Boolean']['input'];
};

/** Contact */
export type Contact = {
  __typename?: 'Contact';
  birthdate?: Maybe<Date>;
  contactType?: Maybe<Scalars['String']['output']>;
  /** available fields: id, internalName, legalName */
  corporate?: Maybe<Corporate>;
  createdAt?: Maybe<DateTime>;
  createdBy?: Maybe<Staff>;
  documents?: Maybe<Array<ReservationDocument>>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  /**
   * True if the contact has signed up on the website / app and can login.
   * This value is independent of isActive
   */
  hasAccount?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** see toggleContactActiveState */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /**
   * If email is an anonymous OTA email address.
   * This can be used - on the website - to request contacts to sign up with their email address.
   */
  isOTAEmail?: Maybe<Scalars['Boolean']['output']>;
  /** if this contact is the point of contact for the corporate */
  isPointOfContact?: Maybe<Scalars['Boolean']['output']>;
  /** set when signing up on the website */
  isSubscribedToNewsLetter?: Maybe<Scalars['Boolean']['output']>;
  /** JWT token is returned on sign-in */
  jwtToken?: Maybe<Scalars['String']['output']>;
  /** contact's preferred language, as set by contact on the website */
  language?: Maybe<Language>;
  lastName: Scalars['String']['output'];
  lastUpdated?: Maybe<DateTime>;
  nationality?: Maybe<Nationality>;
  notes?: Maybe<Array<Note>>;
  phone?: Maybe<Phone>;
  source?: Maybe<LeadSource>;
  /** see contactTags query */
  tags?: Maybe<Array<ContactTag>>;
  /** contact profile on Zoho */
  zoho?: Maybe<ZohoProfile>;
};

/** ContactDocumentPayloadInput */
export type ContactDocumentPayloadInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  contactID: Scalars['ID']['input'];
  content?: InputMaybe<ReservationIdentityDocumentContentInput>;
  /** see config{contactDocumentTypes} */
  documentType: Scalars['String']['input'];
  /** if document was rejected by document-AI then overridden by the staff to approved */
  isStatusOverridden?: InputMaybe<Scalars['Boolean']['input']>;
};

/** ContactFilterInput */
export type ContactFilterInput = {
  birthdate?: InputMaybe<DateFilterInput>;
  contactIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** config{contactTypes} query */
  contactTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** see the unpaginated corporates{records} query */
  corporateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<DateFilterInput>;
  /** see staff{records} query (unpaginated) */
  createdBy?: InputMaybe<Array<Scalars['ID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isCorporate?: InputMaybe<Scalars['Boolean']['input']>;
  /** sync status */
  isOnCrm?: InputMaybe<Scalars['Boolean']['input']>;
  isPointOfContact?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdated?: InputMaybe<DateFilterInput>;
  /** see nationalities query */
  nationalityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** see leadSources query */
  sourceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** see contactTags query */
  tagIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** ContactMergePayloadInput */
export type ContactMergePayloadInput = {
  emailFromContactID: Scalars['ID']['input'];
  intoContactID: Scalars['ID']['input'];
  mergeContactID: Scalars['ID']['input'];
  phoneFromContactID: Scalars['ID']['input'];
};

/** ContactNotePayloadInput */
export type ContactNotePayloadInput = {
  contactID: Scalars['ID']['input'];
  note: NotePayloadInput;
};

/** ContactPayloadInput */
export type ContactPayloadInput = {
  /** in the format YYYY-MM-DD */
  birthDate?: InputMaybe<Scalars['String']['input']>;
  /** see config{contactTypes} query */
  contactType?: InputMaybe<Scalars['String']['input']>;
  /** if this contact is part of a corporate. Use the unpaginated corporates query to populate the dropdown for this field */
  corporateID?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /** see nationalities query */
  nationalityID?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<NotePayloadInput>;
  phone?: InputMaybe<PhoneInput>;
  /** see leadSources query */
  sourceID?: InputMaybe<Scalars['ID']['input']>;
  /** see contactTags query */
  tagIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** ContactResult */
export type ContactResult = {
  __typename?: 'ContactResult';
  /** Records count */
  count: Scalars['Int']['output'];
  /**
   * Exports to Excel.
   *
   * Pass the active ContactFilterInput that's applied to the grid, if any to get the same records.
   *
   * Also send the active sort criteria that's applied on the grid through options.sort. Pagination is ignored here.
   *
   * The columns field is the enabled columns on the grid, in order of display as customized by the staff or the default grid columns if not customized.
   *
   * This is fetched from the query columnDisplayCustomizationOptions for the page route.
   *
   * The reason we take a direct columns array instead of route, is that there could be no previous customization by the staff but the default grid display hides a few auxiliary columns and the Excel export needs to match that.
   *
   * The exportable columns are limited to the options below and need to match each one exactly (case sensitive):
   *
   * <pre>
   *     Contact Name
   *     Status
   *     Email
   *     Phone
   *     Tags
   *     Sync Status
   *     Birthdate
   *     Nationality
   *     Contact Type
   *     Source
   *     Corporate
   *     Point of Contact
   *     Created At
   *     Created By
   *     Last Updated
   * </pre>
   */
  export: Scalars['String']['output'];
  /**
   * Returns paginated contact records.
   *
   * To fetch all contacts without pagination, when populating dropdowns for instance, create a dedicated GraphQL file with this field selection:
   *
   * <pre>
   * contacts {
   *     result: records(filter: $filter, options: $options) {
   *         id
   *         firstName
   *         lastName
   *         email
   *         phone {
   *             code
   *             number
   *         }
   *         corporate {
   *             id
   *             internalName
   *             legalName
   *         }
   *     }
   * }
   * </pre>
   *
   * Here is the allowed field selection on the Contact type, anonymously or as a contact:
   *
   * <pre>
   * contacts {
   *     result: records(filter: $filter, options: $options) {
   *         id
   *         firstName
   *         lastName
   *         email
   *         jwtToken
   *         phone {
   *             code
   *             number
   *         }
   *         isSubscribedToNewsLetter
   *         birthdate
   *         nationality {
   *             id
   *             name
   *         }
   *         documents {
   *             isMainGuest
   *             documentStatus
   *             document {
   *                 id
   *                 documentType
   *                 attachments {
   *                     fileName
   *                     mimeType
   *                     url
   *                 }
   *                 createdAt
   *                 lastUpdated
   *             }
   *             content {
   *                 firstName
   *                 lastName
   *                 fatherName
   *                 grandfatherName
   *                 documentNumber
   *                 documentVersionNumber
   *                 expiryDate
   *                 issuingCountry {
   *                     id
   *                     name
   *                 }
   *                 issuingDate
   *                 issuingPlace
   *                 nationality {
   *                     id
   *                     name
   *                 }
   *                 gender
   *                 birthdate
   *                 employer
   *                 occupation
   *                 placeOfBirth {
   *                     id
   *                     name
   *                 }
   *             }
   *         }
   *         language {
   *             id
   *             code
   *             direction
   *             name
   *         }
   *         hasAccount
   *         isOTAEmail
   *         createdAt
   *         lastUpdated
   *     }
   * }
   * </pre>
   *
   * When this exact field selection is detected, the server runs a faster query that returns all data without pagination.
   *
   * All fields of ContactFilterInput are still applicable with the exception of "search", "createdAt" and "lastUpdated". CommonQueryOptionsInput is ignored here.
   *
   * You should set a default filter for unpaginated queries based on how the data is used. For example, setting "isActive" to true ensures that only active contacts are retrieved, which is the desired outcome in most scenarios.
   *
   * The list of supported sort criteria in options.sort:
   *
   * <pre>
   *     Contact Name
   *     Contact Name desc
   *     Status
   *     Status desc
   *     Email
   *     Email desc
   *     Phone
   *     Phone desc
   *     Birthdate
   *     Birthdate desc
   *     Nationality
   *     Nationality desc
   *     Contact Type
   *     Contact Type desc
   *     Source
   *     Source desc
   *     Created By
   *     Created By desc
   *     Created At
   *     Created At desc
   *     Last Updated
   *     Last Updated desc
   * </pre>
   */
  records: Array<Contact>;
};


/** ContactResult */
export type ContactResultCountArgs = {
  filter?: InputMaybe<ContactFilterInput>;
};


/** ContactResult */
export type ContactResultExportArgs = {
  columns: Array<Scalars['String']['input']>;
  filter?: InputMaybe<ContactFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};


/** ContactResult */
export type ContactResultRecordsArgs = {
  filter?: InputMaybe<ContactFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** ContactSignInPayloadInput */
export type ContactSignInPayloadInput = {
  birthdate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Updates an existing contact record instead of creating a new one.
   * See findMyReservation query for details.
   */
  contactReferenceKey?: InputMaybe<Scalars['String']['input']>;
  isSubscribedToNewsLetter?: InputMaybe<Scalars['Boolean']['input']>;
};

/** ContactSignUpPayloadInput */
export type ContactSignUpPayloadInput = {
  birthdate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Updates an existing contact record instead of creating a new one.
   * See findMyReservation query for details.
   */
  contactReferenceKey?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  isSubscribedToNewsLetter?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone?: InputMaybe<PhoneInput>;
};

/** ContactTag */
export type ContactTag = {
  __typename?: 'ContactTag';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** ContactTagPayloadInput */
export type ContactTagPayloadInput = {
  name: Scalars['String']['input'];
};

/** Coordinates */
export type Coordinates = {
  __typename?: 'Coordinates';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

/** CoordinatesInput */
export type CoordinatesInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

/** Corporate */
export type Corporate = {
  __typename?: 'Corporate';
  accountOwner?: Maybe<Staff>;
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  /** count of all corporate contacts */
  contactCount?: Maybe<Scalars['Int']['output']>;
  /** address-related fields are used on Zoho as is based on where the corporate operates and aren't related to the predefined locations on Nest */
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<DateTime>;
  createdBy?: Maybe<Staff>;
  documents?: Maybe<Array<Document>>;
  id: Scalars['ID']['output'];
  internalName: Scalars['String']['output'];
  /** see toggleCorporateActiveState */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** isDraft is false if the corporate registration is complete, that is, it includes the legal name, tax registration number, address fields & point-of-contact */
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  lastUpdated?: Maybe<DateTime>;
  legalName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Note>>;
  /**
   * Points of contact.
   *
   * This is not the full list of corporate contacts, to retrieve all of them, call the contacts{records} query, filtering by corporateIDs.
   *
   * Available contact fields here are: id, firstName, lastName, email and phone
   */
  pointsOfContact?: Maybe<Array<Contact>>;
  source?: Maybe<LeadSource>;
  taxRegistrationNumber?: Maybe<Scalars['String']['output']>;
  /** corporate profile on Zoho */
  zoho?: Maybe<ZohoProfile>;
};

/** CorporateContactAssignmentPayloadInput */
export type CorporateContactAssignmentPayloadInput = {
  contactIDs: Array<Scalars['ID']['input']>;
  corporateID: Scalars['ID']['input'];
};

/** CorporateDocumentPayloadInput */
export type CorporateDocumentPayloadInput = {
  attachment: AttachmentInput;
  corporateID: Scalars['ID']['input'];
  /** see config{corporateDocumentTypes} */
  documentType: Scalars['String']['input'];
};

/** CorporateFilterInput */
export type CorporateFilterInput = {
  /** the staff who manage the corporate accounts. See the unpaginated staff{records} query */
  accountOwnerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  corporateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<DateFilterInput>;
  /** see staff{records} query (unpaginated) */
  createdBy?: InputMaybe<Array<Scalars['ID']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isOnZohoBooks?: InputMaybe<Scalars['Boolean']['input']>;
  lastUpdated?: InputMaybe<DateFilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** see leadSources query */
  sourceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** CorporateNotePayloadInput */
export type CorporateNotePayloadInput = {
  corporateID: Scalars['ID']['input'];
  note: NotePayloadInput;
};

/** CorporatePayloadInput */
export type CorporatePayloadInput = {
  /** the staff who manages this corporate account. See the unpaginated staff{records} query */
  accountOwnerID: Scalars['ID']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  /**
   * One or more contacts assigned to this corporate.
   * This is a convenience field, the same functionality is available via assignContactsToCorporate
   */
  assignedContactIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** address-related fields are sent to Zoho as is based on where the corporate operates and aren't related to the predefined locations on Nest */
  country?: InputMaybe<Scalars['String']['input']>;
  /** corporate alias (short form of the legal name), used internally */
  internalName: Scalars['String']['input'];
  legalName?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<NotePayloadInput>;
  /** one or more points of contact for this corporate */
  pointOfContactIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** see leadSources query */
  sourceID?: InputMaybe<Scalars['ID']['input']>;
  taxRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
};

/** CorporateResult */
export type CorporateResult = {
  __typename?: 'CorporateResult';
  /** Records count */
  count: Scalars['Int']['output'];
  /**
   * Exports to Excel.
   *
   * Pass the active CorporateFilterInput that's applied to the grid, if any to get the same records.
   *
   * Also send the active sort criteria that's applied on the grid through options.sort. Pagination is ignored here.
   *
   * The columns field is the enabled columns on the grid, in order of display as customized by the staff or the default grid columns if not customized.
   *
   * This is fetched from the query columnDisplayCustomizationOptions for the page route.
   *
   * The reason we take a direct columns array instead of route, is that there could be no previous customization by the staff but the default grid display hides a few auxiliary columns and the Excel export needs to match that.
   *
   * The exportable columns are limited to the options below and need to match each one exactly (case sensitive):
   *
   * <pre>
   *     Corporate Name
   *     Legal Name
   *     Tax Registration Number
   *     Account Owner
   *     Created By
   *     Status
   *     Country
   *     City
   *     Address
   *     Associated Contacts
   *     Zoho ID
   *     Sync Status
   *     Source
   *     Created At
   *     Last Updated
   * </pre>
   */
  export: Scalars['String']['output'];
  /**
   * Returns paginated corporate records.
   *
   * To fetch all corporates without pagination, when populating dropdowns for instance, create a dedicated GraphQL file with this field selection:
   *
   * <pre>
   * corporates {
   *     result: records(filter: $filter, options: $options) {
   *         id
   *         internalName
   *         legalName
   *     }
   * }
   * </pre>
   *
   * When this exact field selection is detected, the server runs a faster query that returns all data without pagination.
   *
   * All fields of CorporateFilterInput are still applicable with the exception of "search", "createdAt" and "lastUpdated". CommonQueryOptionsInput is ignored here.
   *
   * You should set a default filter for unpaginated queries based on where the corporate dropdown is used, for example, setting "isActive" to true and "isDraft" to false to retrieve active corporates that are fully registered when assigning a corporate to a booking.
   *
   * To retrieve the list of corporate contacts, call the contacts{records} query, filtering by corporateIDs.
   *
   * Here is the allowed field selection on the Corporate type, anonymously or as a contact:
   *
   * <pre>
   * corporates {
   *     result: records(filter: $filter, options: $options) {
   *         id
   *         legalName
   *     }
   * }
   * </pre>
   *
   * The list of supported sort criteria in options.sort, where "Corporate Name" is the internal name:
   *
   * <pre>
   *     Corporate Name
   *     Corporate Name desc
   *     Legal Name
   *     Legal Name desc
   *     Tax Registration Number
   *     Tax Registration Number desc
   *     Country
   *     Country desc
   *     City
   *     City desc
   *     Address
   *     Address desc
   *     Source
   *     Source desc
   *     Created By
   *     Created By desc
   *     Created At
   *     Created At desc
   *     Last Updated
   *     Last Updated desc
   * </pre>
   */
  records: Array<Corporate>;
};


/** CorporateResult */
export type CorporateResultCountArgs = {
  filter?: InputMaybe<CorporateFilterInput>;
};


/** CorporateResult */
export type CorporateResultExportArgs = {
  columns: Array<Scalars['String']['input']>;
  filter?: InputMaybe<CorporateFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};


/** CorporateResult */
export type CorporateResultRecordsArgs = {
  filter?: InputMaybe<CorporateFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** Country */
export type Country = {
  __typename?: 'Country';
  /** ISO 3166-1 alpha-2 code */
  code2?: Maybe<Scalars['String']['output']>;
  /** ISO 3166-1 alpha-3 code */
  code3?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
  vatPercentage?: Maybe<Scalars['Int']['output']>;
  weekendDays?: Maybe<Array<Scalars['String']['output']>>;
};

/** CurrencyConversion */
export type CurrencyConversion = {
  __typename?: 'CurrencyConversion';
  /** rate used to convert 'amount' */
  rate: Scalars['Float']['output'];
  /** converted amount in 'toCurrency' */
  value: Scalars['Float']['output'];
};

/** DamageProtectionPolicy */
export type DamageProtectionPolicy = {
  __typename?: 'DamageProtectionPolicy';
  /** id, name & airportCode */
  cities?: Maybe<Array<City>>;
  /** id & name */
  countries?: Maybe<Array<Country>>;
  createdAt?: Maybe<DateTime>;
  createdBy?: Maybe<Staff>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<DateTime>;
  locations?: Maybe<Array<ExtendedEntityLocation>>;
  name: Scalars['String']['output'];
  /** one or more property types assigned to policy, see config{propertyTypes} */
  propertyTypes?: Maybe<Array<Scalars['String']['output']>>;
  ranges: Array<DamageProtectionPolicyRange>;
};

/** DamageProtectionPolicyFilterInput */
export type DamageProtectionPolicyFilterInput = {
  policyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** DamageProtectionPolicyPayloadInput */
export type DamageProtectionPolicyPayloadInput = {
  /** cities assigned to policy, cannot be set without countryIDs */
  cityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** countries assigned to policy */
  countryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** one or more locations, both countryIDs & cityIDs must be set before setting locationIDs */
  locationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** name of the policy */
  name: Scalars['String']['input'];
  /** one or more property types assigned to policy, see config{propertyTypes} */
  propertyTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * One or more ranges, in order. The first "from" must be 1 and the last "to" must be null.
   *
   * For example:
   * - from: 1, to: 10
   * - from: 11, to: 15
   * - from: 16, to: null
   *
   * This is a valid example that leaves no gaps and maintains the order between ranges.
   *
   * Examples of invalid ranges:
   *
   * - 1 to 3 then 3 to 5 (ranges overlap and the last value is not null)
   * - 1 to null then 3 to 5 ("to" isn't allowed to be null unless it's the last range)
   * - 5 to null then 1 to 4 (isn't valid because 1 to 4 should be the first range)
   */
  ranges: Array<DamageProtectionPolicyRangeInput>;
};

/** DamageProtectionPolicyPayment */
export type DamageProtectionPolicyPayment = {
  __typename?: 'DamageProtectionPolicyPayment';
  /**
   * For corporate bookings only, if true, then corporate pays for the security deposit on behalf of all contacts & the point of contact gets one check-in link to pay for the booking & the security deposit.
   * If false, then the point of contact pays for the booking only, and each contact gets a separate link to pay for their security deposit.
   */
  corporatePaysForTheSecurityDeposit?: Maybe<Scalars['Boolean']['output']>;
  /**
   * For quotations, this is the applicable policy type for this property & dates.
   * For reservations, this is the same value for quotations unless it was overridden by the staff.
   *
   * To get the list of policy types for a property, see the "damageProtectionPolicy.ranges" field in the properties{records} query.
   */
  damageProtectionPolicyType?: Maybe<Scalars['String']['output']>;
  /**
   * Security deposit due date.
   *
   * Note: whenever isDueNow is true, get today's date from the browser to take the contact's timezone into account.
   * dueOn is sent from the backend in UTC, so for example, Jun 10th at 11 PM UTC should be displayed as Jun 11th in Dubai.
   *
   * If isDueNow is false, you can safely use dueOn as is.
   */
  dueOn?: Maybe<Date>;
  invoice?: Maybe<Invoice>;
  isDueNow?: Maybe<Scalars['Boolean']['output']>;
  /**
   * if the security deposit is charged in a separate transaction (example: with a credit card),
   * or the same transaction as the single-payment or first installment (example: through bank transfer)
   */
  isInSameTransaction?: Maybe<Scalars['Boolean']['output']>;
  /**
   * True if the policy is satisfied (e.g., card exists, deposit paid, SD not required).
   *
   * Maybe true even if invoice is unset (e.g. SD not required)
   */
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  totalAmount?: Maybe<Scalars['Float']['output']>;
};

/** DamageProtectionPolicyRange */
export type DamageProtectionPolicyRange = {
  __typename?: 'DamageProtectionPolicyRange';
  /** from number of nights */
  from: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  /** see config{damageProtectionPolicyTypes} */
  policyType: Scalars['String']['output'];
  /** to number of nights */
  to?: Maybe<Scalars['Int']['output']>;
};

/** DamageProtectionPolicyRange */
export type DamageProtectionPolicyRangeInput = {
  /** from number of nights */
  from: Scalars['Int']['input'];
  /** id should only be set when editing policies */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** see config{damageProtectionPolicyTypes} */
  policyType: Scalars['String']['input'];
  /** to number of nights */
  to?: InputMaybe<Scalars['Int']['input']>;
};

/** DamageProtectionPolicyResult */
export type DamageProtectionPolicyResult = {
  __typename?: 'DamageProtectionPolicyResult';
  count: Scalars['Int']['output'];
  records: Array<DamageProtectionPolicy>;
};


/** DamageProtectionPolicyResult */
export type DamageProtectionPolicyResultCountArgs = {
  filter?: InputMaybe<DamageProtectionPolicyFilterInput>;
};


/** DamageProtectionPolicyResult */
export type DamageProtectionPolicyResultRecordsArgs = {
  filter?: InputMaybe<DamageProtectionPolicyFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** Date */
export type Date = {
  __typename?: 'Date';
  formatted: Scalars['String']['output'];
  raw?: Maybe<Scalars['String']['output']>;
};

/** DateFilterInput */
export type DateFilterInput = {
  /** in YYYY-MM-DD format, set when the operator is 'between' */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** set when the operator is 'last' */
  last?: InputMaybe<DateFilterLastInput>;
  operator: DateFilterOperator;
  /** in YYYY-MM-DD format, set when the operator is 'before', 'after', 'equal' or 'between' */
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/** DateFilterLastInput */
export type DateFilterLastInput = {
  unit: DateFilterLastUnit;
  value: Scalars['Int']['input'];
};

/** DateFilterLastUnit */
export enum DateFilterLastUnit {
  Days = 'days',
  Hours = 'hours',
  Months = 'months',
  Weeks = 'weeks'
}

/** DateFilterOperator */
export enum DateFilterOperator {
  After = 'after',
  Before = 'before',
  Between = 'between',
  Equal = 'equal',
  Last = 'last'
}

/** DateTime */
export type DateTime = {
  __typename?: 'DateTime';
  formatted: Scalars['String']['output'];
  raw?: Maybe<Scalars['String']['output']>;
};

/** Document */
export type Document = {
  __typename?: 'Document';
  attachments: Array<Attachment>;
  createdAt?: Maybe<DateTime>;
  createdBy?: Maybe<Staff>;
  documentType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<DateTime>;
};

/** EmailDeliveryInfo */
export type EmailDeliveryInfo = {
  __typename?: 'EmailDeliveryInfo';
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  recipients?: Maybe<Array<EmailRecipientDeliveryInfo>>;
  title: Scalars['String']['output'];
};

/** EmailRecipientDeliveryInfo */
export type EmailRecipientDeliveryInfo = {
  __typename?: 'EmailRecipientDeliveryInfo';
  bouncedAt?: Maybe<DateTime>;
  clickedAt?: Maybe<DateTime>;
  deferredAt?: Maybe<DateTime>;
  deliveredAt?: Maybe<DateTime>;
  /** additional delivery details on success or failure */
  deliveryDetails?: Maybe<Scalars['String']['output']>;
  /** one of Pending, Successful or Failed */
  deliveryState?: Maybe<Scalars['String']['output']>;
  droppedAt?: Maybe<DateTime>;
  email: Scalars['String']['output'];
  openedAt?: Maybe<DateTime>;
  reportedAsSpamAt?: Maybe<DateTime>;
  unsubscribedAt?: Maybe<DateTime>;
};

/** EntityLocation */
export type EntityLocation = {
  __typename?: 'EntityLocation';
  address: Scalars['String']['output'];
  coordinates?: Maybe<Coordinates>;
  id: Scalars['ID']['output'];
  neighbourhood?: Maybe<Neighbourhood>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** EntityLocationFilterInput */
export type EntityLocationFilterInput = {
  cityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Can be used to filter out unrelated buildings / properties based on context.
   *
   * For example, set this to ["Furnished"] to filter out other types.
   *
   * See config{propertyModels}.
   */
  modelTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filters by property types, for instance, setting this to ["Villa"] excludes buildings and other standalone units.
   *
   * Setting it to ["Studio"] excludes villas, townhouses and buildings that don't contain studios.
   *
   * See config{propertyTypes} for the full list of types.
   */
  propertyTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The location of a building or a standalone unit (Villa, etc.) */
export type EntityLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<CoordinatesInput>;
  /** id is null for new locations */
  id?: InputMaybe<Scalars['ID']['input']>;
  neighbourhoodID?: InputMaybe<Scalars['ID']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** ExtendedAmenity */
export type ExtendedAmenity = {
  __typename?: 'ExtendedAmenity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** ExtendedEntityLocation */
export type ExtendedEntityLocation = Building | Property;

/** ExtractReservationIdentityDocumentsPayloadInput */
export type ExtractReservationIdentityDocumentsPayloadInput = {
  /**
   * Must be set if called by contacts, cannot be set by staff.
   * See websiteBookingRegistrationLink query.
   */
  brCode?: InputMaybe<Scalars['String']['input']>;
  /** up to two identity documents */
  documents?: InputMaybe<Array<AttachmentInput>>;
  /** must be set to true if called by contacts */
  withApprovalStatus: Scalars['Boolean']['input'];
};

/** ExtractReservationIdentityDocumentsResult */
export type ExtractReservationIdentityDocumentsResult = {
  __typename?: 'ExtractReservationIdentityDocumentsResult';
  content?: Maybe<ReservationIdentityDocumentContent>;
  /** this is null if withApprovalStatus is null, otherwise, it's true if approved, false if rejected */
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Set when approval is requested, for example:
   *
   * - Not a valid ID document
   * - Document is manipulated
   * - Suspicious words found
   * - Stock image suspected
   * - Document is expired
   * - Failed to extract required fields
   */
  rejectionReasons?: Maybe<Array<Scalars['String']['output']>>;
};

/** FileUploadHandlePayloadInput */
export type FileUploadHandlePayloadInput = {
  /**
   * Must be set if called by contacts, cannot be set by staff.
   * See websiteBookingRegistrationLink query.
   */
  brCode?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  fileSizeBytes: Scalars['Int']['input'];
  mimeType: Scalars['String']['input'];
  /**
   * Must be set if called by contacts, cannot be set by staff.
   * See websitePaymentLink query.
   */
  plNumber?: InputMaybe<Scalars['String']['input']>;
};

/** FindMyReservationResult */
export type FindMyReservationResult = {
  __typename?: 'FindMyReservationResult';
  contact: Contact;
  contactReferenceKey?: Maybe<Scalars['String']['output']>;
  reservation: Reservation;
};

/** FurnishedProperty */
export type FurnishedProperty = {
  __typename?: 'FurnishedProperty';
  /** number of beds in all bedrooms */
  bedCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Detailed description of the property, which often includes house rules & used exclusively when publishing to OTAs, as it's the only medium available to convey such info.
   *
   * This is an English-only section, and supports variables to avoid repetition.
   */
  channelManagerDescription?: Maybe<Scalars['String']['output']>;
  /** check-in instructions. Supports variables, see config{variables} query */
  checkInInstructions?: Maybe<Array<TranslatedContent>>;
  /**
   * 24h time format, padded with 0, e.g. 09:00, 17:00, etc.
   * This value gets set from the CHECK_IN_HOUR config parameter
   */
  checkInTime?: Maybe<Scalars['String']['output']>;
  /** check-out instructions. Supports variables, see config{variables} query */
  checkOutInstructions?: Maybe<Array<TranslatedContent>>;
  /** same as checkInTime, gets set from the CHECK_OUT_HOUR config parameter */
  checkOutTime?: Maybe<Scalars['String']['output']>;
  /** the damage-protection policy of the property */
  damageProtectionPolicy?: Maybe<DamageProtectionPolicy>;
  /** extended amenities */
  extendedAmenities?: Maybe<Array<ExtendedAmenity>>;
  /** applicable to furnished units only */
  licenseNumber?: Maybe<Scalars['String']['output']>;
  /** maximum number of guests allowed in the property */
  maximumGuests?: Maybe<Scalars['Int']['output']>;
  /**
   * Mapping of bed types to bedrooms, including the common area. See config{channelManagerBedTypes} for the list of bed types.
   *
   * See the description of sleepingArrangement in FurnishedPropertyInput for more details on this field.
   */
  sleepingArrangement?: Maybe<Array<FurnishedPropertySleepingArrangement>>;
  wifiPassword?: Maybe<Scalars['String']['output']>;
  /**
   * WiFi SSID & password are only set when:
   *
   * - this query is called by the website / mobile
   * - guest has completed required pre-check-in actions and is within the check-in time window
   *
   * See websiteBookingRegistrationLink query for more details.
   */
  wifiSSID?: Maybe<Scalars['String']['output']>;
};

/** FurnishedPropertyInput */
export type FurnishedPropertyInput = {
  /** number of beds in all bedrooms */
  bedCount?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A detailed description of the property, which often includes house rules & used exclusively when publishing to OTAs, as it's the only medium available to convey such info.
   *
   * This is an English-only section, and supports variables to avoid repetition. The content in React should default to:
   *
   * {ABOUT_PROPERTY}
   *
   * {HOUSE_RULES}
   */
  channelManagerDescription?: InputMaybe<Scalars['String']['input']>;
  /** Check-in instructions. Supports variables, see config{variables} query */
  checkInInstructions?: InputMaybe<Array<TranslatedContentInput>>;
  /** Check-out instructions. Supports variables, see config{variables} query */
  checkOutInstructions?: InputMaybe<Array<TranslatedContentInput>>;
  /** see extendedAmenities query */
  extendedAmenityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** maximum number of guests allowed in the property */
  maximumGuests?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Mapping of bed types to bedrooms, including the common area. See config{channelManagerBedTypes} for the list of bed types.
   *
   * For example, if we have one king-size bed in the first bedroom, two queen beds in the second and a sofa bed in the common area:
   * [
   *     {"bedroomNumber": 1, "bedTypes": ["King size bed"]},
   *     {"bedroomNumber": 2, "bedTypes": ["Queen size bed", "Queen size bed"]},
   *     // pass null for the common area
   *     {"bedroomNumber": null, "bedTypes": ["Sofa bed"]}
   * ]
   *
   * Send bedroomNumber in order (1, 2, etc.), leave the common area to the end of the array.
   *
   * For Studios, bedroomNumber can only be null.
   */
  sleepingArrangement?: InputMaybe<Array<FurnishedPropertySleepingArrangementInput>>;
};

/** FurnishedPropertySleepingArrangement */
export type FurnishedPropertySleepingArrangement = {
  __typename?: 'FurnishedPropertySleepingArrangement';
  /** see config{channelManagerBedTypes} */
  bedTypes: Array<Scalars['String']['output']>;
  bedroomNumber?: Maybe<Scalars['Int']['output']>;
};

/** FurnishedPropertySleepingArrangementInput */
export type FurnishedPropertySleepingArrangementInput = {
  /** see config{channelManagerBedTypes} */
  bedTypes: Array<Scalars['String']['input']>;
  bedroomNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** GuestCheckedInToPropertyPayloadInput */
export type GuestCheckedInToPropertyPayloadInput = {
  /** in the format YYYY-MM-DD HH:mm:ss */
  checkInTime: Scalars['String']['input'];
  reservationID: Scalars['ID']['input'];
};

/** HighLevelAmenity */
export type HighLevelAmenity = {
  __typename?: 'HighLevelAmenity';
  content?: Maybe<Array<HighLevelAmenityContent>>;
  /**
   * Content for the language code sent in header.
   * This is used on the website / mobile only.
   */
  contentRendered?: Maybe<Scalars['String']['output']>;
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** HighLevelAmenityContent */
export type HighLevelAmenityContent = {
  __typename?: 'HighLevelAmenityContent';
  languageCode: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** HistoricalCurrencyConversionInput */
export type HistoricalCurrencyConversionInput = {
  /** price to be converted */
  amount: Scalars['Float']['input'];
  /** day to lookup FX rate for, in YYYY-MM-DD format */
  day: Scalars['String']['input'];
  /** source currency, see config{currencies} for the full list of supported currencies */
  fromCurrency: Scalars['String']['input'];
  /** target currency, see config{currencies} for the full list of supported currencies */
  toCurrency: Scalars['String']['input'];
};

/** HouseRule */
export type HouseRule = {
  __typename?: 'HouseRule';
  content: Array<HouseRuleContent>;
  /**
   * Content for the language code sent in header.
   * This is used on the website / mobile only.
   */
  contentRendered?: Maybe<HouseRuleContent>;
  createdAt?: Maybe<DateTime>;
  createdBy?: Maybe<Staff>;
  iconUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<DateTime>;
  name: Scalars['String']['output'];
};

/** HouseRuleContent */
export type HouseRuleContent = {
  __typename?: 'HouseRuleContent';
  body: Scalars['String']['output'];
  languageCode: LanguageCode;
  title: Scalars['String']['output'];
};

/** HouseRuleContentInput */
export type HouseRuleContentInput = {
  body: Scalars['String']['input'];
  languageCode: LanguageCode;
  title: Scalars['String']['input'];
};

/** HouseRulePayloadInput */
export type HouseRulePayloadInput = {
  /** The number of records in content must match the number of languages fetched through languages query */
  content: Array<HouseRuleContentInput>;
  iconUrl: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** HouseRuleResult */
export type HouseRuleResult = {
  __typename?: 'HouseRuleResult';
  count: Scalars['Int']['output'];
  records: Array<HouseRule>;
};


/** HouseRuleResult */
export type HouseRuleResultCountArgs = {
  filter?: InputMaybe<HouseRulesFilterInput>;
};


/** HouseRuleResult */
export type HouseRuleResultRecordsArgs = {
  filter?: InputMaybe<HouseRulesFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** HouseRulesFilterInput */
export type HouseRulesFilterInput = {
  ruleIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** HousekeepingAddOnCleaningQuotation */
export type HousekeepingAddOnCleaningQuotation = {
  __typename?: 'HousekeepingAddOnCleaningQuotation';
  currency: Scalars['String']['output'];
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountReason?: Maybe<Scalars['String']['output']>;
  /**
   * The discountAmount is not subtracted from the grand total, so display the total after discount (if any) as:
   *
   * (servicePrice - discountAmount) + VAT
   */
  grandTotal: Scalars['Float']['output'];
  /** cleaning cost */
  servicePrice: Scalars['Float']['output'];
  vat?: Maybe<PaymentVat>;
};

/** HousekeepingAddOnCleaningQuotationFilterInput */
export type HousekeepingAddOnCleaningQuotationFilterInput = {
  reservationID: Scalars['ID']['input'];
  /** see config{housekeepingServiceTypes} query */
  serviceType: Scalars['String']['input'];
};

/** HousekeepingBlockedCleaningTime */
export type HousekeepingBlockedCleaningTime = {
  __typename?: 'HousekeepingBlockedCleaningTime';
  day: Date;
  endTime: Scalars['String']['output'];
  /** 24h time format, padded with 0, e.g. 09:00, 17:30, etc. */
  startTime: Scalars['String']['output'];
  /** the team that's unavailable */
  team: HousekeepingTeam;
};

/** HousekeepingCleanersLoad */
export type HousekeepingCleanersLoad = {
  __typename?: 'HousekeepingCleanersLoad';
  capacityMinutes: Scalars['Float']['output'];
  loadPercentage: Scalars['Float']['output'];
  scheduledMinutes: Scalars['Float']['output'];
  team: HousekeepingTeam;
};

/** HousekeepingCleaning */
export type HousekeepingCleaning = {
  __typename?: 'HousekeepingCleaning';
  /** Checkout, Complimentary, etc. */
  cleaningType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<DateTime>;
  createdBy?: Maybe<Staff>;
  id: Scalars['ID']['output'];
  isAccessInGuestAbsenceAllowed?: Maybe<Scalars['Boolean']['output']>;
  lastUpdated?: Maybe<DateTime>;
  /**
   * Payment collection and allocated invoice details for Add-on cleanings.
   *
   * Available fields: id, paymentNumber, totalPaymentAmount, currency, isPaid, paymentUrl, invoices.
   */
  paymentCollection?: Maybe<PaymentCollection>;
  /**
   * The property this cleaning is for. This may not be the same as the reservation's property.
   * For example, if a reservation is moved mid-stay to another property, two checkout cleanings are created, for the old and new properties.
   *
   * available fields: id, internalName
   */
  property?: Maybe<Property>;
  /** for Add-on cleanings */
  quotation?: Maybe<HousekeepingAddOnCleaningQuotation>;
  /** available fields: id, confirmationNumber */
  reservation?: Maybe<Reservation>;
  scheduledForDay?: Maybe<Date>;
  /** see config{housekeepingCleaningSlots} query */
  scheduledForSlot?: Maybe<Scalars['String']['output']>;
  /** team assigned to this cleaning, if status is Scheduled */
  scheduledForTeam?: Maybe<HousekeepingTeam>;
  /** 24h time format, padded with 0, e.g. 09:00, 17:30, etc. */
  scheduledForTime?: Maybe<Scalars['String']['output']>;
  serviceDurationMinutes?: Maybe<Scalars['Int']['output']>;
  /** Quick or Deep, see config{housekeepingServiceTypes} query */
  serviceType?: Maybe<Scalars['String']['output']>;
  /** Unscheduled, Scheduled, etc. */
  status?: Maybe<Scalars['String']['output']>;
};

/** HousekeepingCleaningBulkSchedulePayloadInput */
export type HousekeepingCleaningBulkSchedulePayloadInput = {
  /** see config{housekeepingCleaningSlots} query */
  cleaningSlot: Scalars['String']['input'];
  /** 0 (Sunday) to 6 (Saturday) */
  cleaningWeekDay: Scalars['Int']['input'];
  isAccessInGuestAbsenceAllowed: Scalars['Boolean']['input'];
  reservationID: Scalars['ID']['input'];
};

/** HousekeepingCleaningCreationResult */
export type HousekeepingCleaningCreationResult = {
  __typename?: 'HousekeepingCleaningCreationResult';
  /** id of the created / edited cleaning */
  id: Scalars['ID']['output'];
  /** when creating an add-on cleaning or editing one that is not paid for */
  paymentUrl?: Maybe<Scalars['String']['output']>;
};

/** HousekeepingCleaningFilterInput */
export type HousekeepingCleaningFilterInput = {
  /** see bookingChannels query */
  channelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** this can either be Scheduled or Unscheduled */
  cleaningStatus?: InputMaybe<Scalars['String']['input']>;
  /** see housekeepingCleaningTypes query */
  cleaningTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** in the format YYYY-MM-DD. The end date is inclusive */
  endDate: Scalars['String']['input'];
  /** accepts both true and false */
  isAccessInGuestAbsenceAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  lengthOfStay?: InputMaybe<NumericFilterInput>;
  /** id from HousekeepingLocation record */
  locationID: Scalars['ID']['input'];
  propertyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  reservationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** aka packageTypes, see config{housekeepingServiceTypes} query */
  serviceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** in the format YYYY-MM-DD */
  startDate: Scalars['String']['input'];
};

/** HousekeepingCleaningHistoryFilterInput */
export type HousekeepingCleaningHistoryFilterInput = {
  reservationID: Scalars['ID']['input'];
};

/** HousekeepingCleaningPackage */
export type HousekeepingCleaningPackage = {
  __typename?: 'HousekeepingCleaningPackage';
  durationMinutes: Scalars['Int']['output'];
  /** in property's currency */
  price: Scalars['Float']['output'];
  /** see config{housekeepingServiceTypes} query */
  serviceType: Scalars['String']['output'];
};

/** HousekeepingCleaningPackageInput */
export type HousekeepingCleaningPackageInput = {
  durationMinutes: Scalars['Int']['input'];
  /** in property's currency */
  price: Scalars['Float']['input'];
  /** see config{housekeepingServiceTypes} query */
  serviceType: Scalars['String']['input'];
};

/** HousekeepingCleaningPayloadInput */
export type HousekeepingCleaningPayloadInput = {
  /** in the format YYYY-MM-DD */
  cleaningDate: Scalars['String']['input'];
  /** see config{housekeepingCleaningSlots} query */
  cleaningSlot: Scalars['String']['input'];
  /** see housekeepingCleaningTypes query */
  cleaningType: Scalars['String']['input'];
  /** discount amount if any, when creating Add-on cleanings */
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Discount reason is required if discountAmount is set.
   * See config{reservationDiscountReasons} query.
   */
  discountReason?: InputMaybe<Scalars['String']['input']>;
  /**
   * For Add-on cleanings.
   *
   * Send the grand total that's displayed on the FE, after subtracting the discount if any, to validate the final amount matches what's expected.
   */
  grandTotal?: InputMaybe<Scalars['Float']['input']>;
  isAccessInGuestAbsenceAllowed: Scalars['Boolean']['input'];
  reservationID: Scalars['ID']['input'];
  /** aka packageTypes, see config{housekeepingServiceTypes} query */
  serviceType: Scalars['String']['input'];
};

/** HousekeepingCleaningResult */
export type HousekeepingCleaningResult = {
  __typename?: 'HousekeepingCleaningResult';
  /** Fetches the cleaning history for a reservation */
  history: Array<ResourceHistory>;
  /**
   * Set cleaningStatus to "Scheduled" to fetch scheduled cleanings for the timeline.
   * To build timeline entries, use scheduledForTime, serviceDurationMinutes and scheduledForTeam.
   *
   * Set cleaningStatus to "Unscheduled" to fetch unscheduled records.
   */
  records: Array<HousekeepingCleaning>;
};


/** HousekeepingCleaningResult */
export type HousekeepingCleaningResultHistoryArgs = {
  filter: HousekeepingCleaningHistoryFilterInput;
};


/** HousekeepingCleaningResult */
export type HousekeepingCleaningResultRecordsArgs = {
  filter: HousekeepingCleaningFilterInput;
};

/** HousekeepingCleaningSchedulePayloadInput */
export type HousekeepingCleaningSchedulePayloadInput = {
  /** in the format YYYY-MM-DD */
  cleaningDate: Scalars['String']['input'];
  cleaningID: Scalars['ID']['input'];
  /** see config{housekeepingCleaningSlots} query */
  cleaningSlot: Scalars['String']['input'];
  /**
   * Schedule the cleaning on a specific time. Leave blank for Nest to auto-assign.
   * Send 24h time format, padded with 0, e.g. 09:00, 17:30, etc.
   * Returns an error if time cannot be assigned.
   */
  cleaningTime?: InputMaybe<Scalars['String']['input']>;
  isAccessInGuestAbsenceAllowed: Scalars['Boolean']['input'];
  /**
   * Set when assigning a specific team to the cleaning (e.g. on drag & drop on the timeline).
   * Gets auto assigned by Nest when null.
   *
   * See housekeepingTeams query
   */
  teamID?: InputMaybe<Scalars['ID']['input']>;
};

/** HousekeepingCleaningsBulkScheduleFailureResult */
export type HousekeepingCleaningsBulkScheduleFailureResult = {
  __typename?: 'HousekeepingCleaningsBulkScheduleFailureResult';
  cleaningID: Scalars['ID']['output'];
  /** the cleaning day that failed to schedule */
  day: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

/** HousekeepingCleaningsBulkScheduleResult */
export type HousekeepingCleaningsBulkScheduleResult = {
  __typename?: 'HousekeepingCleaningsBulkScheduleResult';
  /** count of cleanings that failed to schedule, these are referenced in failures field */
  failureCount: Scalars['Int']['output'];
  failures?: Maybe<Array<HousekeepingCleaningsBulkScheduleFailureResult>>;
  /** count of cleanings that were scheduled successfully */
  successCount: Scalars['Int']['output'];
};

/** HousekeepingDay */
export type HousekeepingDay = {
  __typename?: 'HousekeepingDay';
  assignments?: Maybe<Array<HousekeepingDayAssignment>>;
  /** 0 (Sunday) to 6 (Saturday) */
  dayOfWeek: Scalars['Int']['output'];
};

/** HousekeepingDayAssignment */
export type HousekeepingDayAssignment = {
  __typename?: 'HousekeepingDayAssignment';
  name: Scalars['String']['output'];
  teams?: Maybe<Array<HousekeepingTeam>>;
};

/** HousekeepingDayAssignmentInput */
export type HousekeepingDayAssignmentInput = {
  name: Scalars['String']['input'];
  teamIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** HousekeepingDayInput */
export type HousekeepingDayInput = {
  /**
   * Assignments per slot for this day.
   *
   * To remove assignees for a slot, keep the slot name in the payload and set teamIDs to null
   */
  assignments?: InputMaybe<Array<HousekeepingDayAssignmentInput>>;
  /** 0 (Sunday) to 6 (Saturday) */
  dayOfWeek: Scalars['Int']['input'];
};

/** HousekeepingLocation */
export type HousekeepingLocation = {
  __typename?: 'HousekeepingLocation';
  /** controls how many complimentary cleanings we create in eligible bookings */
  complimentaryCleaningFrequencyDays?: Maybe<Scalars['Int']['output']>;
  /** team assignment per slot per day */
  days?: Maybe<Array<HousekeepingDay>>;
  id: Scalars['ID']['output'];
  /** if complimentary cleaning is enabled for this location */
  isComplimentaryCleaningEnabled?: Maybe<Scalars['Boolean']['output']>;
  location: ExtendedEntityLocation;
  /** minimum number of nights for a booking to be eligible for complimentary cleaning */
  minComplimentaryCleaningLos?: Maybe<Scalars['Int']['output']>;
  /** prevents last-minute changes. A guest cannot schedule or reschedule a cleaning for a day that falls within this window from the current date */
  reschedulingWindowDays?: Maybe<Scalars['Int']['output']>;
  /**
   * Services / packages.
   *
   * To get the list of muli-units for service / package setup, call the unpaginated properties{records} query, filtering by:
   * - isActive: true
   * - isDraft: false
   * - entityTypes: ['multiUnit']
   * - locationIDs: [$id of the location you're configuring]
   */
  services?: Maybe<Array<HousekeepingService>>;
  /** location-global slot configuration */
  slots?: Maybe<Array<HousekeepingSlot>>;
};

/** HousekeepingLocationFilterInput */
export type HousekeepingLocationFilterInput = {
  cityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filters by locations that have at least one active, non-draft property.
   *
   * This only accepts "true". Setting this to "false" has no effect.
   */
  hasProperties?: InputMaybe<Scalars['Boolean']['input']>;
  /** pass true to filter by building locations only, false for standalone property locations, null to ignore this filter */
  isBuildings?: InputMaybe<Scalars['Boolean']['input']>;
  /** if complimentary cleaning is available for this location */
  isComplimentaryCleaningEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If the location has already been configured.
   * Set to true when fetching timeline locations to leave out unconfigured locations.
   */
  isConfigured?: InputMaybe<Scalars['Boolean']['input']>;
  locationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** HousekeepingLocationPayloadInput */
export type HousekeepingLocationPayloadInput = {
  /** controls how many complimentary cleanings we create in eligible bookings */
  complimentaryCleaningFrequencyDays: Scalars['Int']['input'];
  /** team assignment per slot per day */
  days: Array<HousekeepingDayInput>;
  /** if complimentary cleaning is enabled for this location */
  isComplimentaryCleaningEnabled: Scalars['Boolean']['input'];
  locationID: Scalars['ID']['input'];
  /** minimum number of nights for a booking to be eligible for complimentary cleaning */
  minComplimentaryCleaningLos: Scalars['Int']['input'];
  /** prevents last-minute changes. A guest cannot schedule or reschedule a cleaning for a day that falls within this window from the current date */
  reschedulingWindowDays: Scalars['Int']['input'];
  /** Services / packages */
  services?: InputMaybe<Array<HousekeepingServiceInput>>;
  /** location-global slot configuration */
  slots: Array<HousekeepingSlotInput>;
};

/** HousekeepingLocationResult */
export type HousekeepingLocationResult = {
  __typename?: 'HousekeepingLocationResult';
  /** Records count */
  count: Scalars['Int']['output'];
  /**
   * To fetch all records without pagination, when populating dropdowns for instance, create a dedicated GraphQL file with this field selection:
   *
   * <pre>
   *     housekeepingLocations {
   *         result: records(filter: $filter, options: $options) {
   *             id
   *             location {
   *                 ... on Building {
   *                     id
   *                     code
   *                     buildingInternalName: internalName
   *                     buildingLocation: location {
   *                         id
   *                         address
   *                         neighbourhood {
   *                             id
   *                             name
   *                             city {
   *                                 id
   *                                 name
   *                                 airportCode
   *                                 timezone
   *                                 country {
   *                                     id
   *                                     name
   *                                     code3
   *                                     code2
   *                                     currency
   *                                     timezone
   *                                 }
   *                             }
   *                         }
   *                         images {
   *                             main {
   *                                 webp {
   *                                     thumbnailUrl
   *                                 }
   *                             }
   *                         }
   *                     }
   *                 }
   *                 ... on Property {
   *                     id
   *                     propertyInternalName: internalName
   *                     isActive
   *                     modelType
   *                     propertyType {
   *                         name
   *                         isStandalone
   *                     }
   *                     entityType
   *                     propertyLocation: location {
   *                         id
   *                         address
   *                         neighbourhood {
   *                             id
   *                             name
   *                             city {
   *                                 id
   *                                 name
   *                                 airportCode
   *                                 country {
   *                                     id
   *                                     name
   *                                     code3
   *                                     code2
   *                                     currency
   *                                 }
   *                             }
   *                         }
   *                         images {
   *                             main {
   *                                 webp {
   *                                     thumbnailUrl
   *                                 }
   *                             }
   *                         }
   *                     }
   *                 }
   *             }
   *         }
   *     }
   * </pre>
   *
   * When this exact field selection is detected, the server runs a faster query that returns all data without pagination.
   *
   * All fields of HousekeepingLocationFilterInput are still applicable with the exception of "search" and CommonQueryOptionsInput is ignored here.
   */
  records: Array<HousekeepingLocation>;
};


/** HousekeepingLocationResult */
export type HousekeepingLocationResultCountArgs = {
  filter?: InputMaybe<HousekeepingLocationFilterInput>;
};


/** HousekeepingLocationResult */
export type HousekeepingLocationResultRecordsArgs = {
  filter?: InputMaybe<HousekeepingLocationFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** HousekeepingService */
export type HousekeepingService = {
  __typename?: 'HousekeepingService';
  packages: Array<HousekeepingCleaningPackage>;
  /** available fields: id, internalName, propertyType, currency, listingName */
  property: Property;
};

/** HousekeepingServiceInput */
export type HousekeepingServiceInput = {
  /** cleaning packages offered for this property */
  packages: Array<HousekeepingCleaningPackageInput>;
  /**
   * To get the list of muli-units for service / package setup, call the unpaginated properties{records} query, filtering by:
   * - isActive: true
   * - isDraft: false
   * - entityTypes: ['multiUnit']
   * - locationIDs: [$id of the location you're configuring]
   */
  propertyID: Scalars['ID']['input'];
};

/** HousekeepingSlot */
export type HousekeepingSlot = {
  __typename?: 'HousekeepingSlot';
  /** 24h time format, padded with 0, e.g. 09:00, 17:30, etc. */
  endTime?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** 24h time format, padded with 0, e.g. 09:00, 17:30, etc. */
  startTime?: Maybe<Scalars['String']['output']>;
};

/** HousekeepingSlotInput */
export type HousekeepingSlotInput = {
  /** 24h time format, padded with 0, e.g. 09:00, 17:30, etc. */
  endTime?: InputMaybe<Scalars['String']['input']>;
  /** see config{housekeepingCleaningSlots} query */
  name: Scalars['String']['input'];
  /** 24h time format, padded with 0, e.g. 09:00, 17:30, etc. */
  startTime?: InputMaybe<Scalars['String']['input']>;
};

/** HousekeepingTeam */
export type HousekeepingTeam = {
  __typename?: 'HousekeepingTeam';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** HousekeepingTimelineAvailabilityPayloadInput */
export type HousekeepingTimelineAvailabilityPayloadInput = {
  endDateTime: Scalars['String']['input'];
  isBlocked: Scalars['Boolean']['input'];
  locationID: Scalars['ID']['input'];
  /** In the format YYYY-MM-DD HH:mm:ss */
  startDateTime: Scalars['String']['input'];
  teamIDs: Array<Scalars['ID']['input']>;
};

/** ImageSet */
export type ImageSet = {
  __typename?: 'ImageSet';
  /** all images, including the main image */
  all?: Maybe<Array<OptimizedImage>>;
  /** main image */
  main?: Maybe<OptimizedImage>;
};

/** ImageThumbnailGenerationPayloadInput */
export type ImageThumbnailGenerationPayloadInput = {
  url: Scalars['String']['input'];
};

export type Invoice = {
  __typename?: 'Invoice';
  /** available fields: id, name, accountType, contact, corporate, channel */
  account?: Maybe<BookkeepingAccount>;
  /**
   * Breakdown items for this invoice. For reservation and extension invoices, this lists per-payment components; for cleaning invoices, only applicable fields are set.
   *
   * For security deposits, breakdown is null.
   */
  breakdown?: Maybe<Array<InvoiceBreakdown>>;
  createdAt?: Maybe<DateTime>;
  createdBy?: Maybe<Staff>;
  creditNotes?: Maybe<Array<InvoiceCreditNote>>;
  currency?: Maybe<Scalars['String']['output']>;
  /** discrepancy between total invoice amount and received amount */
  discrepancy?: Maybe<InvoiceDiscrepancy>;
  /** net due amount, takes into account credit note adjustments and total refunds issued on invoice */
  dueAmount?: Maybe<Scalars['Float']['output']>;
  dueDate?: Maybe<Date>;
  /** available fields: id, confirmationNumber */
  extensions?: Maybe<Array<ReservationExtension>>;
  id: Scalars['ID']['output'];
  invoiceItems?: Maybe<Array<InvoiceItem>>;
  invoiceNumber: Scalars['String']['output'];
  /** see config{invoiceTypes} query */
  invoiceType?: Maybe<Scalars['String']['output']>;
  issueDate?: Maybe<Date>;
  lastUpdated?: Maybe<DateTime>;
  /** total revenue on invoice, accounts for any credit notes or refunds */
  paidAmount?: Maybe<Scalars['Float']['output']>;
  paidAt?: Maybe<DateTime>;
  /** available fields: id, amountAllocatedInInvoiceCurrency, createdAt */
  paymentAllocations?: Maybe<Array<BookkeepingPaymentAllocation>>;
  paymentCollections?: Maybe<Array<PaymentCollection>>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  reissuedFromInvoice?: Maybe<InvoiceLineage>;
  /** available fields: id, confirmationNumber */
  reservations?: Maybe<Array<Reservation>>;
  /** invoice settlement history: refunds, credit notes and account credit transfers */
  settlements?: Maybe<Array<InvoiceSettlement>>;
  /** Pending, Paid, Voided, etc. */
  status?: Maybe<Scalars['String']['output']>;
  /** sum of credit notes issued on invoice, see settlements for detailed records */
  totalAdjustments?: Maybe<Scalars['Float']['output']>;
  /** the gross invoice amount minus any credit note adjustments */
  totalAmount: Scalars['Float']['output'];
  /** sum of refunds issued on invoice, see settlements for detailed records */
  totalRefunds?: Maybe<Scalars['Float']['output']>;
};

/** InvoiceAdjustmentDetails */
export type InvoiceAdjustmentDetails = {
  __typename?: 'InvoiceAdjustmentDetails';
  amount: Scalars['Float']['output'];
  details?: Maybe<Scalars['String']['output']>;
};

/** InvoiceBreakdown */
export type InvoiceBreakdown = {
  __typename?: 'InvoiceBreakdown';
  /**
   * Changes to the reservation total after the invoice is issued.
   *
   * For example, if the booking duration is shortened and AED 1000 is removed from the total.
   *
   * The adjustment amount can be positive or negative, and its purpose is to make the breakdown match the invoice total.
   */
  adjustments?: Maybe<Array<InvoiceAdjustmentDetails>>;
  bookingAmount?: Maybe<Scalars['Float']['output']>;
  bookingTotal?: Maybe<Scalars['Float']['output']>;
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountReason?: Maybe<Scalars['String']['output']>;
  fees?: Maybe<Array<ReservationFee>>;
  nightlyRate?: Maybe<Scalars['Float']['output']>;
  nights?: Maybe<Scalars['Int']['output']>;
  /** set for OTA channels that deduct their commission before issuing the payout, e.g.: Airbnb */
  otaCommission?: Maybe<Scalars['Float']['output']>;
  vat?: Maybe<PaymentVat>;
};

/** InvoiceCreditNote */
export type InvoiceCreditNote = {
  __typename?: 'InvoiceCreditNote';
  /** in invoice's currency */
  amount: Scalars['Float']['output'];
  createdAt?: Maybe<DateTime>;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

/** InvoiceDiscrepancy */
export type InvoiceDiscrepancy = {
  __typename?: 'InvoiceDiscrepancy';
  amount: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
};

/** InvoiceFilterInput */
export type InvoiceFilterInput = {
  /** Filters by bookkeeping account IDs */
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<DateFilterInput>;
  createdBy?: InputMaybe<Array<Scalars['ID']['input']>>;
  currencies?: InputMaybe<Array<Scalars['String']['input']>>;
  dueAmount?: InputMaybe<NumericFilterInput>;
  dueDate?: InputMaybe<DateFilterInput>;
  invoiceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  invoiceItemCount?: InputMaybe<NumericFilterInput>;
  invoiceTotal?: InputMaybe<NumericFilterInput>;
  invoiceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** see paymentCollections{records} query */
  paymentCollectionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  reservationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** search by invoice number or type, reservation confirmation number, extension confirmation number, property internal name */
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** InvoiceHistoryFilterInput */
export type InvoiceHistoryFilterInput = {
  invoiceID: Scalars['ID']['input'];
};

/** InvoiceItem */
export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  /** available fields: id, name */
  addOnService?: Maybe<ReservationAddOnService>;
  /** available fields: id, name */
  damageType?: Maybe<ReservationDamageType>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  unitPrice: Scalars['Float']['output'];
};

/** InvoiceItemInput */
export type InvoiceItemInput = {
  /**
   * Add-on service ID for service invoices.
   * See reservationAddOnServices query
   */
  addOnServiceID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Damage-type ID for damage-replacement invoices.
   * See reservationDamageTypes query
   */
  damageTypeID?: InputMaybe<Scalars['ID']['input']>;
  /** id on edit */
  id?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  unitPrice: Scalars['Float']['input'];
};

/** InvoiceLineage */
export type InvoiceLineage = {
  __typename?: 'InvoiceLineage';
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
};

/** InvoicePayloadInput */
export type InvoicePayloadInput = {
  /** See bookkeepingAccounts query (unpaginated) */
  accountID: Scalars['ID']['input'];
  /** see config{currencies} query */
  currency: Scalars['String']['input'];
  /** In the format YYYY-MM-DD */
  dueDate: Scalars['String']['input'];
  invoiceItems: Array<InvoiceItemInput>;
  /** this must be one of "Service" or "Damage Replacement" */
  invoiceType: Scalars['String']['input'];
  reservationID: Scalars['ID']['input'];
  /**
   * The total invoice amount including VAT.
   * This is used to validate that the final amount matches what's displayed on the FE.
   */
  totalAmount: Scalars['Float']['input'];
};

/** InvoiceResult */
export type InvoiceResult = {
  __typename?: 'InvoiceResult';
  /** Records count */
  count: Scalars['Int']['output'];
  /**
   * Exports to Excel.
   *
   * Pass the active InvoiceFilterInput that's applied to the grid, if any, to get the same records.
   *
   * Also send the active sort criteria that's applied on the grid through options.sort. Pagination is ignored here.
   *
   * The columns field is the enabled columns on the grid, in order of display as customized by the staff or the default grid columns if not customized.
   *
   * This is fetched from the query columnDisplayCustomizationOptions for the page route.
   *
   * The exportable columns are limited to the options below and need to match each one exactly (case sensitive):
   *
   * <pre>
   *     Invoice Number
   *     Account
   *     Status
   *     Issue Date
   *     Due Date
   *     Paid At
   *     Invoice Type
   *     Payment Method
   *     Total Amount
   *     Due Amount
   *     Total Refunds
   *     Total Adjustments
   *     Currency
   *     Created At
   *     Last Updated
   * </pre>
   */
  export: Scalars['String']['output'];
  /** Fetches invoice history */
  history: Array<ResourceHistory>;
  /**
   * Returns paginated invoice records.
   *
   * To fetch all invoices without pagination, when populating dropdowns for instance, create a dedicated GraphQL file with this field selection:
   *
   * <pre>
   * invoices {
   *     result: records(filter: $filter, options: $options) {
   *         id
   *         invoiceNumber
   *         totalAmount
   *         dueAmount
   *         invoiceType
   *         status
   *         currency
   *         reservation {
   *             id
   *             confirmationNumber
   *         }
   *         extension {
   *             id
   *             confirmationNumber
   *         }
   *         account {
   *             id
   *             name
   *             accountType
   *         }
   *         issueDate
   *         dueDate
   *         paidAt
   *         breakdown {
   *             nights
   *             nightlyRate
   *             bookingAmount
   *             vat {
   *                 amount
   *                 percentage
   *             }
   *             fees {
   *                 name
   *                 value
   *                 percentage
   *             }
   *             discountAmount
   *             discountReason
   *             bookingTotal
   *             otaCommission
   *             adjustments {
   *                 amount
   *                 details
   *             }
   *         }
   *         creditNotes {
   *             id
   *             amount
   *             reason
   *             notes
   *             createdAt {
   *                 formatted
   *             }
   *         }
   *         paymentAllocations {
   *             id
   *             amountAllocatedInInvoiceCurrency
   *             createdAt {
   *                 formatted
   *             }
   *         }
   *         discrepancy {
   *             amount
   *             percentage
   *         }
   *         invoiceItems {
   *             id
   *             unitPrice
   *             quantity
   *             description
   *             addOnService {
   *                 id
   *                 name
   *             }
   *             damageType {
   *                 id
   *                 name
   *             }
   *         }
   *     }
   * }
   * </pre>
   *
   * When this exact field selection is detected, the server runs a faster query that returns all data without pagination.
   *
   * All fields of InvoiceFilterInput are still applicable including "search", which can be used for typeahead in dropdowns, etc.
   *
   * Set a sensible default filter for unpaginated queries based on the UI context (for example, limiting to the currently selected account).
   *
   * The list of supported sort criteria in options.sort:
   *
   * <pre>
   *     Invoice Number
   *     Invoice Number desc
   *     Status
   *     Status desc
   *     Issue Date
   *     Issue Date desc
   *     Due Date
   *     Due Date desc
   *     Paid At
   *     Paid At desc
   *     Invoice Type
   *     Invoice Type desc
   *     Account
   *     Account desc
   *     Currency
   *     Currency desc
   *     Number of Items
   *     Number of Items desc
   *     Created By
   *     Created By desc
   *     Total Amount
   *     Total Amount desc
   *     Created At
   *     Created At desc
   *     Last Updated
   *     Last Updated desc
   * </pre>
   */
  records: Array<Invoice>;
};


/** InvoiceResult */
export type InvoiceResultCountArgs = {
  filter?: InputMaybe<InvoiceFilterInput>;
};


/** InvoiceResult */
export type InvoiceResultExportArgs = {
  columns: Array<Scalars['String']['input']>;
  filter?: InputMaybe<InvoiceFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};


/** InvoiceResult */
export type InvoiceResultHistoryArgs = {
  filter: InvoiceHistoryFilterInput;
};


/** InvoiceResult */
export type InvoiceResultRecordsArgs = {
  filter?: InputMaybe<InvoiceFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** InvoiceSettlement */
export type InvoiceSettlement = {
  __typename?: 'InvoiceSettlement';
  createdAt?: Maybe<DateTime>;
  settlementAmount: Scalars['Float']['output'];
  /** Refund, Credit Transfer, Credit Note */
  settlementType: Scalars['String']['output'];
};

/** Language */
export type Language = {
  __typename?: 'Language';
  /** the two-letter language code: en, ar, etc. */
  code: LanguageCode;
  /** the direction of the language: ltr, rtl */
  direction: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** the display name of the language: English, etc. */
  name: Scalars['String']['output'];
};

/** Language enum */
export enum LanguageCode {
  Ar = 'ar',
  En = 'en'
}

/** LeadSource */
export type LeadSource = {
  __typename?: 'LeadSource';
  createdAt?: Maybe<DateTime>;
  createdBy?: Maybe<Staff>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<DateTime>;
  name: Scalars['String']['output'];
};

/** LeadSourcePayloadInput */
export type LeadSourcePayloadInput = {
  name: Scalars['String']['input'];
};

/** LengthOfStayDay */
export type LengthOfStayDay = {
  __typename?: 'LengthOfStayDay';
  /** in the format YYYY-MM-DD, returned as a raw string */
  day: Scalars['String']['output'];
  /** the minimum LOS required for this day */
  lengthOfStay: Scalars['Int']['output'];
  propertyID: Scalars['ID']['output'];
};

/** Localisation */
export type Localisation = {
  __typename?: 'Localisation';
  content: Scalars['String']['output'];
  lookupKey: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

/** LocalisationContentInput */
export type LocalisationContentInput = {
  /** translation in English, Arabic, etc. */
  content: Scalars['String']['input'];
  languageCode: LanguageCode;
};

/** LocalisationPayloadInput */
export type LocalisationPayloadInput = {
  /**
   * Unique key to identify the localisation.
   * Must be lowercase, optionally with underscores. e.g.: "about_us_title"
   */
  lookupKey: Scalars['String']['input'];
  /**
   * One or more tags to categorize the localisation.
   * This lets you fetch a subset of localisations based on the current page or context.
   *
   * Must be lowercase, optionally with underscores. e.g.: "contact_us"
   */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** an entry must be present for each language, see languages query */
  translations: Array<LocalisationContentInput>;
};

/** LocalisationsFilterInput */
export type LocalisationsFilterInput = {
  languageCode: LanguageCode;
  /** filter by tags (OR condition) e.g.: ["contact_us", "about_us"] */
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Accepts BR terms and conditions for the current link.
   *
   * contractBase64Signature must only be set if canShowSignaturePad from websiteBookingRegistrationLink is true.
   */
  acceptWebsiteBRLinkTermsConditions: Scalars['Boolean']['output'];
  /**
   * This mutation can make the following adjustments to a reservation:
   *
   * - Move reservation: move reservation to another property, set targetPropertyID, moveToCheckInDate and optionally newBookingAmount.
   * - Edit dates: Edit reservation dates without changing the property, set moveToCheckInDate, moveToCheckOutDate and optionally newBookingAmount.
   * - Move & edit dates: combines the two previous actions, set targetPropertyID, moveToCheckInDate, moveToCheckOutDate and optionally newBookingAmount.
   *
   * @staff(permissions: ["reservations-editor"])
   */
  adjustReservation: Scalars['Boolean']['output'];
  /**
   * Same as adjustReservation, but returns split booking details when the adjustment creates a new booking.
   *
   * @staff(permissions: ["reservations-editor"])
   */
  adjustReservationV2: AdjustReservationResponse;
  /**
   * Pays for invoices from account credit. The account must have sufficient credit in the invoice currency.
   *
   * @staff(permissions: ["bookkeeping-editor"])
   */
  allocateBookkeepingAccountCreditToInvoices: Scalars['Boolean']['output'];
  /**
   * Assigns contacts to corporate
   *
   * @staff(permissions: ["corporates-editor"])
   */
  assignContactsToCorporate: Scalars['Boolean']['output'];
  /**
   * Schedules reservation's cleanings in bulk
   *
   * @staff(permissions: ["housekeeping-editor"])
   */
  bulkScheduleHousekeepingCleanings: HousekeepingCleaningsBulkScheduleResult;
  /**
   * Cancels a cleaning.
   *
   * This cannot be a cleaning that is missed or is already cancelled.
   *
   * @staff(permissions: ["housekeeping-editor"])
   */
  cancelHousekeepingCleaning: Scalars['Boolean']['output'];
  /**
   * Cancels a reservation.
   *
   * @staff(permissions: ["reservations-editor"])
   */
  cancelReservation: Scalars['Boolean']['output'];
  /**
   * Cancels an extension.
   *
   * @staff(permissions: ["reservations-editor"])
   */
  cancelReservationExtension: Scalars['Boolean']['output'];
  /**
   * Creates bookkeeping credit note.
   *
   * Editing is not supported.
   *
   * @staff(permissions: ["bookkeeping-editor"])
   */
  createBookkeepingCreditNote: Scalars['ID']['output'];
  /**
   * Creates bookkeeping payment & allocation records.
   *
   * Editing is not supported.
   *
   * @staff(permissions: ["bookkeeping-editor"])
   */
  createBookkeepingPayment: Scalars['ID']['output'];
  /**
   * Creates or edits a building.
   *
   * When creating a building for the first time, set id in EntityLocationInput to null.
   *
   * Set buildingID on edits.
   *
   * highLevelAmenityIDs field is one or more IDs from the result of "highLevelAmenities(category: building)" query.
   *
   * To retrieve a list of supported image types when setting images, see "config{channelManagerImageTypes}" query.
   *
   * @staff(permissions: ["buildings-editor"])
   */
  createBuilding: Scalars['ID']['output'];
  /**
   * Creates or edits a contact.
   *
   * Notes can be set when creating a contact or after it's created but not on edit. Use createContactNote to create notes directly.
   *
   * Contacts get synced with Zoho when they're registered or updated.
   *
   * @staff(permissions: ["contacts-editor"])
   */
  createContact: Scalars['ID']['output'];
  /**
   * Creates or edits a contact document
   *
   * @staff(permissions: ["contacts-editor"])
   */
  createContactDocument: Scalars['ID']['output'];
  /**
   * Creates or edits a contact note. Only the note's owner is allowed to edit it
   *
   * @staff(permissions: ["contacts-editor"])
   */
  createContactNote: Scalars['ID']['output'];
  /**
   * Creates or edits a contact tag
   *
   * @staff(permissions: ["contacts-editor"])
   */
  createContactTag: Scalars['ID']['output'];
  /**
   * Creates or edits a corporate.
   *
   * Corporates can initially be registered with just the company name and the account owner ID when full information isn't available. They remain in draft status until the required details are provided.
   *
   * This approach allows the sales team to quickly create corporates for new leads, even if the legal name and tax registration number aren't available yet.
   *
   * Notes can be set when creating a corporate or after it's created, using createCorporateNote.
   *
   * @staff(permissions: ["corporates-editor"])
   */
  createCorporate: Scalars['ID']['output'];
  /**
   * Creates or edits a corporate document
   *
   * @staff(permissions: ["corporates-editor"])
   */
  createCorporateDocument: Scalars['ID']['output'];
  /**
   * Creates or edits a corporate note. Only the note's owner is allowed to edit it
   *
   * @staff(permissions: ["corporates-editor"])
   */
  createCorporateNote: Scalars['ID']['output'];
  /**
   * Creates a damage-protection policy.
   *
   * These policies dictate how security deposits are charged on new bookings.
   *
   * Policies must be unique, that is, you cannot create two policies that are not assigned to any property types, country, city or location.
   *
   * Similarly, you cannot have two policies that are assigned to the same property types, country, city & location.
   *
   * You can define one global policy that is not bound to any location or property type and then define one or more overrides that set property types or location, without duplicates.
   *
   * @staff(permissions: ["properties-admin"])
   */
  createDamageProtectionPolicy: Scalars['ID']['output'];
  /**
   * Creates or updates a house rule
   *
   * @staff(permissions: ["properties-admin"])
   */
  createHouseRule: Scalars['ID']['output'];
  /**
   * Creates a cleaning of type Add-on or Courtesy.
   *
   * Edits a cleaning of any type.
   *
   * Send values for discountAmount, discountReason and grandTotal when creating an Add-on or editing one that is not paid for.
   * Do not send these values when editing a paid Add-on.
   *
   * @staff(permissions: ["housekeeping-editor"])
   */
  createHousekeepingCleaning: HousekeepingCleaningCreationResult;
  /**
   * Creates or edits a housekeeping location configuration.
   *
   * @staff(permissions: ["housekeeping-admin"])
   */
  createHousekeepingLocation: Scalars['ID']['output'];
  /**
   * Creates or edits an invoice.
   *
   * @staff(permissions: ["invoices-editor"])
   */
  createInvoice: Scalars['ID']['output'];
  /**
   * Creates a new lead source for use on reservations, contacts, and corporates.
   *
   * @staff(anyPermission: ["reservations-admin", "contacts-admin", "corporates-admin"])
   */
  createLeadSource: Scalars['ID']['output'];
  /**
   * Creates or updates a localisation.
   *
   * Submitting translations for a lookup key that already exists will update the existing translations.
   *
   * As this mutation will be frequently used and we don't have a UI for it at the time of writing, we're making authentication optional when used in development.
   *
   * Unauthenticated access gets rejected in staging and production.
   *
   * @staff(permissions: ["localisations-editor"], optional: true)
   */
  createLocalisation: Scalars['Boolean']['output'];
  /**
   * Creates or edits a payment collection.
   *
   * Returns payment link for online payments that are not charged off-session.
   *
   * When collecting online payments using a card on file, paymentUrl is set to null, check for isOffSessionPaymentSuccessful and offSessionPaymentError instead.
   *
   * For offline payments (cash, cheque, etc.), only the id field in PaymentCollectionCreationResult is returned.
   *
   * Important: When creating a collection using a card on file and the charge fails (isOffSessionPaymentSuccessful is false), any retries must pass paymentCollectionID to avoid creating duplicate payment collections.
   *
   * @staff(permissions: ["invoices-editor"])
   */
  createPaymentCollection: PaymentCollectionCreationResult;
  /**
   * Creates multi-unit & single-unit properties.
   *
   * While a property is still a draft, the payload can be partially submitted & saved, as long as the required data in the same step is set.
   *
   * Once the property is fully created and is no longer a draft, only complete submissions are accepted.
   *
   * @staff(permissions: ["properties-editor"])
   */
  createProperty: Scalars['ID']['output'];
  /**
   * Creates or updates a configuration parameter.
   *
   * - Set cities to null for a global configuration (one per parameter).
   * - Provide an array of cities for specific configurations. Overlapping city sets (e.g., ["Dubai"] and ["Dubai", "Riyadh"]) are not allowed.
   * - The combination of parameter and cities must be unique.
   *
   * Use configID to update an existing configuration; omit to create a new one.
   *
   * @staff(permissions: ["properties-admin"])
   */
  createPropertyConfig: Scalars['ID']['output'];
  /**
   * Creates or edits a reservation.
   *
   * Allows creating multiple corporate reservations at once.
   * Bulk submission of corporate bookings is allowed on creation only, but on update, they must be edited individually.
   *
   * On edit, if the booking is Pending or Confirmed, most fields cannot be modified (e.g. property, contact, check-in date, check-out date), existing booking must be cancelled and a new one created.
   *
   * The reason is, allowing edits after the check-in link is sent to the contact can cause discrepancy, e.g. changing the dates while the contact is trying to pay for the old ones.
   *
   * @staff(permissions: ["reservations-editor"])
   */
  createReservation: Array<Scalars['ID']['output']>;
  /**
   * Creates or edits a reservation document.
   *
   * First call extractReservationIdentityDocuments, and then createReservationDocument if it is automatically approved or if staff changes the status to approved.
   *
   * This mutation is usable by both contacts and staff.
   *
   * @staff(permissions: ["reservations-editor"], optional: true)
   */
  createReservationDocument: Scalars['ID']['output'];
  /**
   * Creates or edits an extension.
   *
   * @staff(permissions: ["reservations-editor"])
   */
  createReservationExtension: Scalars['ID']['output'];
  /**
   * Creates or edits a reservation note. Only the note's owner is allowed to edit it
   *
   * @staff(permissions: ["reservations-editor"])
   */
  createReservationNote: Scalars['ID']['output'];
  /**
   * Creates or edits a staff.
   *
   * Staff are not granted automatic access to the system based on their Stella Stays email, but must be created by a privileged staff first and assigned to cities.
   *
   * @staff(permissions: ["staff-editor"])
   */
  createStaff: Scalars['ID']['output'];
  /**
   * Creates or edits a task.
   *
   * @staff(anyPermission: ["tasks-editor", "tasks-worker"])
   */
  createTask: Scalars['ID']['output'];
  /**
   * Creates or edits a task note. Only the note's owner is allowed to edit it
   *
   * @staff(anyPermission: ["tasks-editor", "tasks-worker"])
   */
  createTaskNote: Scalars['ID']['output'];
  /**
   * Creates or updates a things-to-note record.
   *
   * if locationID is set, then all of neighborhoodID, cityID and countryID must be set.
   *
   * The same goes for neighborhoodID and cityID, the parent ID must be set to easily restore React form values on edit.
   *
   * @staff(permissions: ["properties-admin"])
   */
  createThingsToNote: Scalars['ID']['output'];
  /**
   * Creates a credit card payment intent to setup card on file.
   *
   * For PSPs that don't support setup intents, we charge a nominal fee and refund it immediately.
   */
  createWebsiteBRLinkCardOnFileIntent: WebsiteBrLinkPaymentIntentPayloadResponse;
  /**
   * Creates a TotalPay hosted payment-page link for the temporary SAR legacy payment workaround.
   *
   * Supports both BR links (when brCode is set) and payment links (when plNumber is set).
   *
   * Only available when activate_legacy_sar_payment_processing is enabled, currency is SAR,
   * and Credit Card is supported for the payment collection.
   */
  createWebsiteBRLinkLegacyPaymentSession: WebsiteBrLinkLegacyPaymentSessionResponse;
  /** Creates a credit card payment intent that can be used to initialise the payment form on the BR page. */
  createWebsiteBRLinkPaymentIntent: WebsiteBrLinkPaymentIntentPayloadResponse;
  /**
   * Creates a website / Guest app reservation.
   *
   * Returns a link to the website BR page.
   *
   * @contact
   */
  createWebsiteReservation: WebsiteReservationResult;
  /**
   * Deletes a contact document
   *
   * @staff(permissions: ["contacts-editor"])
   */
  deleteContactDocument: Scalars['Boolean']['output'];
  /**
   * Deletes a contact note. Only the note's owner is allowed to perform this action
   *
   * @staff(permissions: ["contacts-editor"])
   */
  deleteContactNote: Scalars['Boolean']['output'];
  /**
   * Deletes a contact tag
   *
   * @staff(permissions: ["contacts-editor"])
   */
  deleteContactTag: Scalars['Boolean']['output'];
  /**
   * Deletes a corporate document
   *
   * @staff(permissions: ["corporates-editor"])
   */
  deleteCorporateDocument: Scalars['Boolean']['output'];
  /**
   * Deletes a corporate note. Only the note's owner is allowed to perform this action
   *
   * @staff(permissions: ["corporates-editor"])
   */
  deleteCorporateNote: Scalars['Boolean']['output'];
  /**
   * Deletes a damage-protection policy
   *
   * @staff(permissions: ["properties-admin"])
   */
  deleteDamageProtectionPolicy: Scalars['Boolean']['output'];
  /**
   * Deletes a cleaning.
   *
   * This cannot be an Add-on cleaning or an unscheduled cleaning.
   *
   * @staff(permissions: ["housekeeping-editor"])
   */
  deleteHousekeepingCleaning: Scalars['Boolean']['output'];
  /**
   * Deletes a notification
   *
   * @staff
   */
  deleteNotification: Scalars['Boolean']['output'];
  /**
   * Deletes a payment collection.
   *
   * @staff(permissions: ["invoices-editor"])
   */
  deletePaymentCollection: Scalars['Boolean']['output'];
  /**
   * Deletes a draft multi-unit or single-unit property
   *
   * @staff(permissions: ["properties-editor"])
   */
  deletePropertyDraft: Scalars['Boolean']['output'];
  /**
   * Deletes a reservation document.
   *
   * This mutation is usable by both contacts and staff.
   *
   * reservationID must be set by POC only.
   *
   * brCode must be set if called by contacts, cannot be set by staff. See websiteBookingRegistrationLink query.
   *
   * @staff(permissions: ["reservations-editor"], optional: true)
   */
  deleteReservationDocument: Scalars['Boolean']['output'];
  /**
   * Deletes a reservation note. Only the note's owner is allowed to perform this action
   *
   * @staff(permissions: ["reservations-editor"])
   */
  deleteReservationNote: Scalars['Boolean']['output'];
  /**
   * Deletes a task note. Only the note's owner is allowed to perform this action
   *
   * @staff(anyPermission: ["tasks-editor", "tasks-worker"])
   */
  deleteTaskNote: Scalars['Boolean']['output'];
  /**
   * Deletes a things-to-note record
   *
   * @staff(permissions: ["properties-admin"])
   */
  deleteThingsToNote: Scalars['Boolean']['output'];
  /**
   * Disconnects lock from property.
   *
   * @staff(permissions: ["smart-locks-editor"])
   */
  disconnectSmartLock: Scalars['Boolean']['output'];
  /**
   * Extracts identity information from up to two reservation documents.
   *
   * This supports one file for a passport or national ID, or two files for the national ID (front & back).
   *
   * Set the withApprovalStatus flag to true to include the approval status of the documents.
   * If you send two files and one of them is rejected, then both get rejected.
   *
   * Some fields in ReservationIdentityDocumentContent may not be currently in use, leave out the ones you don't need.
   *
   * This mutation is usable by both contacts and staff.
   *
   * The underlying document-AI feature is not available on development, so it either needs to be intercepted on Mockery (for staff), or test files from the Google drive below must be used:
   *
   * https://drive.google.com/drive/folders/1U5kFBdJBZJFJ2XK9op7hN8PLE1SZUly0?usp=sharing
   *
   * @staff(permissions: ["reservations-editor"], optional: true)
   */
  extractReservationIdentityDocuments: ExtractReservationIdentityDocumentsResult;
  /**
   * Generates a thumbnail for an image.
   *
   * This is used to display a lightweight preview of HQ images.
   *
   * Upload the HQ image via requestFileUploadHandle first and then send the assetUrl to this mutation.
   *
   * Returns URL of the generated thumbnail.
   *
   * Returns a ValidationError if the image is invalid.
   *
   * @staff
   */
  generateImageThumbnail: Scalars['String']['output'];
  /**
   * Merges two contacts into one.
   *
   * The "intoContactID" will be the one to keep after attributes & related data are merged.
   *
   * This operation updates email & phone based on emailFromContactID & phoneFromContactID and merges tags, documents, notes & reservations.
   *
   * @staff(permissions: ["contacts-editor"])
   */
  mergeContacts: Scalars['Boolean']['output'];
  /**
   * Sends an email to the guest to notify them to schedule their cleanings.
   *
   * This operation is only allowed if the current date is within check-in + 1 and check-out - 1.
   *
   * @staff(permissions: ["housekeeping-editor"])
   */
  notifyGuestToScheduleCleanings: Scalars['Boolean']['output'];
  /**
   * Submits the credit card payment to the PSP for processing.
   *
   * This method of processing the payment form is specific to TotalPay.
   *
   * This mutation is just a proxy for the TotalPay API due to CORs restrictions. It mirrors the request and response params of their endpoint.
   *
   * See "{{CHECKOUT_HOST}}/api/v1/processing/purchase/card" in "https://docs.totalpay.global/docs/guides/hosted_payment_fields/#request-parameters" for more details.
   *
   * Supports both BR links (when brCode is set) and payment links (when plNumber is set).
   */
  processWebsiteBRLinkCardPurchase: WebsiteBrLinkCardPurchaseResponse;
  /**
   * Retries publishing multi-unit or single-unit property on the channel manager.
   *
   * Returns property with channelManager field populated with ID if it completes successfully, or returns an error on failure.
   *
   * @staff(permissions: ["properties-editor"])
   */
  publishPropertyOnChannelManager: Property;
  /**
   * Refunds account credit.
   *
   * @staff(permissions: ["bookkeeping-editor"])
   */
  refundBookkeepingAccountCredit: Scalars['Boolean']['output'];
  /**
   * Refunds deposit.
   *
   * Refunds of regular invoices are done by moving amounts to account credit first and then refunding the credit via refundBookkeepingAccountCredit.
   *
   * @staff(permissions: ["bookkeeping-editor"])
   */
  refundBookkeepingDeposit: Scalars['Boolean']['output'];
  /**
   * Refunds one or more invoices in credit-card payment collections.
   *
   * The refunded amount for each invoice must not exceed the invoice amount covered by collection, regardless of the actual invoice total.
   *
   * A credit note is created for non-escrow based invoices.
   *
   * Note: As of Dec 4 2025, this mutation can be used for credit card collections only. Other payment types are refundable through Bookkeeping.
   *
   * @staff(permissions: ["invoices-editor"])
   */
  refundPaymentCollection: Scalars['Boolean']['output'];
  /**
   * Reloads the list of smart locks, when new locks are installed.
   *
   * After reloading locks, call the smartLocks query to fetch the updated list.
   *
   * @staff(permissions: ["smart-locks-editor"])
   */
  reloadSmartLocks: Scalars['Boolean']['output'];
  /**
   * Unlocks door.
   *
   * This throws SYSTEM_ERROR if unlocking fails.
   *
   * @staff(permissions: ["smart-locks-admin"]) @contact
   */
  remoteUnlockDoor: Scalars['Boolean']['output'];
  /**
   * Requests a password reset email for a contact.
   * Generates a Firebase password reset link and sends it via a branded email template.
   * Always returns true to avoid leaking whether the email exists.
   */
  requestContactPasswordReset: Scalars['Boolean']['output'];
  /**
   * Retrieves a signed URL that can be used to upload a file to Google Cloud Storage.
   *
   * Files must not exceed 30 MB in size and must be one of the following types:
   *
   * - JPEG
   * - PNG
   * - WEBP
   * - SVG
   * - PDF
   * - Excel
   *
   * To implement this on the client:
   *
   * - First, get the file name, mimetype and file size in bytes from the file selected for upload
   * - Call this mutation with the file info to get a signed URL
   * - Make a PUT request to the signed URL to upload the file, as below:
   *
   * <pre>
   * const uploadResponse = await fetch(SIGNED_URL, {
   *     method: 'PUT',
   *     body: FILE_TO_BE_UPLOADED,
   *     headers: {
   *         'Content-Type': FILE_TO_BE_UPLOADED.type,
   *         'x-goog-acl': 'public-read'
   *     }
   * });
   * </pre>
   *
   * - Verify that "status" in the response of Google Cloud Storage is 200
   * - When the final mutation (that expects a file URL) is submitted, pass "assetUrl" that you received when requesting the signed URL
   *
   * Note: you should perform preliminary validation on the frontend before retrieving the signed URL, for example:
   *
   * - When uploading images for properties, restrict uploads to JPEG, PNG and WEBP only (image/jpeg, image/pjpeg, image/png, image/webp)
   * - If uploading an icon, restrict the type to image/svg+xml
   *
   * Signed URLs expire after 5 minutes and should be requested right when uploads are initiated.
   *
   * Supports both BR links (when brCode is set) and payment links (when plNumber is set).
   *
   * @staff(optional: true)
   */
  requestFileUploadHandle: UploadResponse;
  /**
   * Schedules / reschedules a single cleaning.
   *
   * @staff(permissions: ["housekeeping-editor"])
   */
  scheduleHousekeepingCleaning: Scalars['Boolean']['output'];
  /**
   * Sends payment collection URL to the guest.
   *
   * It must be an online collection that is not yet paid. Nest may rate limit this endpoint to prevent spamming.
   *
   * @staff(permissions: ["invoices-editor"])
   */
  sendPaymentCollectionUrl: Scalars['Boolean']['output'];
  /**
   * Sends the check-in instructions to the guest via email.
   *
   * Check-in and check-out instructions are automatically sent to guests. This is used to retry sending on delivery failure.
   *
   * @staff(permissions: ["reservations-editor"])
   */
  sendReservationCheckInInstructions: Scalars['Boolean']['output'];
  /**
   * Sends the check-out instructions to the guest via email.
   *
   * Check-in and check-out instructions are automatically sent to guests. This is used to retry sending on delivery failure.
   *
   * @staff(permissions: ["reservations-editor"])
   */
  sendReservationCheckOutInstructions: Scalars['Boolean']['output'];
  /**
   * Sends an email to the contact to complete their booking.
   *
   * This converts lead bookings to pending, an email with the existing link is still sent out if the booking is already in pending status.
   *
   * If pocReservations is not set, this targets individual contacts, whether regular or corporate (on the reservation progress view).
   *
   * To update multiple reservations in a corporate group at once and customize responsibilities per reservation, set pocReservations.
   *
   * Note: this is usable for all channels and not just for direct-contact bookings, for example, it can be sent to a Booking.com contact when payment, SD or documents are pending.
   *
   * @staff(permissions: ["reservations-editor"])
   */
  sendReservationCompletionLink: Scalars['Boolean']['output'];
  /**
   * Updates payment notes.
   *
   * @staff(permissions: ["bookkeeping-editor"])
   */
  setBookkeepingPaymentNotes: Scalars['Boolean']['output'];
  /**
   * Sets or updates the cancellation policy text
   *
   * @staff(permissions: ["properties-admin"])
   */
  setCancellationPolicyText: Scalars['Boolean']['output'];
  /**
   * Customization of column display (visible columns, column ordering, etc.).
   *
   * This makes it possible for staff to customize which columns in grids or mobile-view they want to make visible and their ordering.
   *
   * Takes a route that identifies the page and an array of columns.
   *
   * Example:
   *
   * Let's say a staff is on the buildings page, which is identified by the unique route "/buildings". In React, we define the default column headers and their ordering as:
   *
   * - Building Code
   * - Listing Name
   * - Address
   *
   * By default, all three columns appear to the staff in the declared order.
   *
   * The staff then chooses to hide "Address" and display "Listing Name" and then "Building Code". The call to the backend looks like this:
   *
   * <pre>
   * setColumnDisplayCustomizationOptions(route: '/buildings', columns: [{headerName: 'Listing Name', isEnabled: true}, {headerName: 'Building Code', isEnabled: true}, {headerName: 'Address', isEnabled: false}])
   * </pre>
   *
   * To reset previous customization for the given route, pass columns as null.
   *
   * Note: You must use the same grid column titles as set in Figma (case-sensitive), as this effects how data gets exported to Excel.
   *
   * @staff
   */
  setColumnDisplayCustomizationOptions: Scalars['Boolean']['output'];
  /**
   * Sets contact's preferred language on the website.
   *
   * See languages query for a list of available languages.
   *
   * @contact
   */
  setContactLanguage: Scalars['Boolean']['output'];
  /**
   * Updates contact's profile info on the website.
   *
   * This can be used on the BR link to update the contact associated with "brCode", with or without a JWT token.
   *
   * If "brCode" is not provided, the contact associated with the JWT token is updated.
   *
   * if "brCode" is provided and it's a POC code, then the POC's own profile is updated.
   *
   * The relevant fields from ContactPayloadInput are: firstName, lastName, email, phone. All others are ignored.
   *
   * @contact(optional: true)
   */
  setContactProfile: Scalars['Boolean']['output'];
  /**
   * Sets a list of emails to be allowed through email-client service in development & staging environments.
   * For example, a developer can set their email to receive & test email notifications.
   *
   * redirects is a JSON encoded dictionary of emails that should be redirected to alternative recipients.
   * For example, to redirect emails sent to reservations@stellastays.com to alternative ones while testing:
   * {"reservations@stellastays.com": "e1@d.com,e2@d.com"}
   *
   * Then any email intended for reservations@stellastays.com gets sent to e1@ & e2@ instead, reservations@stellastays.com never receives it.
   */
  setFEEmailWhiteListAndRedirects: Scalars['Boolean']['output'];
  /**
   * Saves mock scenarios for Query or Mutation (callableName)
   * scenarios is JSON array of mock scenarios
   */
  setFEGraphQLMockToolsScenarios: Scalars['Boolean']['output'];
  /** Sets state of all GraphQL mocks */
  setFEGraphQLMockToolsSwitchState: Scalars['Boolean']['output'];
  /**
   * Sets the check-in time of the guest.
   *
   * Manual updates are required when Nest cannot automatically detect the check-in through the smart lock.
   *
   * @staff(permissions: ["reservations-editor"])
   */
  setGuestCheckedInToProperty: Scalars['Boolean']['output'];
  /**
   * Blocks or unblocks the cleaning calendar for the given location, datetime range and teams.
   *
   * @staff(permissions: ["housekeeping-editor"])
   */
  setHousekeepingTimelineAvailability: Scalars['Boolean']['output'];
  /**
   * Use this mutation to mark all notifications as read / unread and to toggle read state of a single notification.
   *
   * When marking all as read / unread, you need to set "lastNotificationID" to the ID of the last notification you have received on the FE.
   *
   * This prevents falsely including notifications that are not yet delivered to the FE.
   *
   * To target a single notification, set "notificationID" to the ID of the notification you want to update.
   *
   * One of "lastNotificationID" or "notificationID" must be set but not both.
   *
   * @staff
   */
  setNotificationReadState: Scalars['Boolean']['output'];
  /**
   * Accepts or rejects a payment collection proof submitted by guests.
   *
   * The current proof status must be "Pending Acceptance", "Accepted" or "Rejected".
   *
   * If the status is not "Pending Acceptance", the action must negate the current status.
   *
   * @staff(permissions: ["invoices-editor"])
   */
  setPaymentCollectionProofAcceptanceStatus: Scalars['Boolean']['output'];
  /**
   * Blocks or unblocks availability for one or more properties.
   *
   * Start and end date cannot be the same date, that is, to block August 21st for example, send the range as 2025-08-21 -> 2025-08-22.
   *
   * This mutation can only be used with single & subunits, don't send multi-units.
   *
   * The selected dates for each property must all already have the same availability.
   * If the range mixes available and unavailable dates, the mutation rejects it.
   *
   * @staff(permissions: ["timeline-editor"])
   */
  setPropertyAvailability: Scalars['Boolean']['output'];
  /**
   * Sets Price & LOS adjustment for one or more properties.
   *
   * Unlike setPropertyAvailability, the end date here is inclusive, start and end date are allowed to be equal.
   *
   * This mutation can only be used with single & multi-units, don't send subunits.
   *
   * @staff(permissions: ["timeline-editor"])
   */
  setPropertyPriceAndLOSAdjustment: Scalars['Boolean']['output'];
  /**
   * Sets reservation's estimated arrival time as a contact or internally by staff.
   *
   * @staff(permissions: ["reservations-editor"], optional: true)
   */
  setReservationEstimatedArrivalTime: Scalars['Boolean']['output'];
  /**
   * Sets reservation's special requests as a contact or internally by staff.
   *
   * @staff(permissions: ["reservations-editor"], optional: true)
   */
  setReservationSpecialRequests: Scalars['Boolean']['output'];
  /** Sets one or more settings, include the payload keys you want to update */
  setSettings: Scalars['Boolean']['output'];
  /**
   * Sets the assignees for a task.
   *
   * Set assigneeIDs to null to remove all assignees.
   *
   * @staff(anyPermission: ["tasks-admin", "tasks-editor"])
   */
  setTaskAssignees: Scalars['Boolean']['output'];
  /**
   * Cancels a task.
   *
   * @staff(anyPermission: ["tasks-editor", "tasks-worker"])
   */
  setTaskCancelled: Scalars['Boolean']['output'];
  /**
   * Starts a task.
   *
   * @staff(anyPermission: ["tasks-admin", "tasks-worker"])
   */
  setTaskInProgress: Scalars['Boolean']['output'];
  /**
   * Pauses a task.
   *
   * @staff(anyPermission: ["tasks-admin", "tasks-worker"])
   */
  setTaskOnHold: Scalars['Boolean']['output'];
  /**
   * Resolves a task.
   *
   * @staff(anyPermission: ["tasks-admin", "tasks-worker"])
   */
  setTaskResolved: Scalars['Boolean']['output'];
  /**
   * Sets business invoice details through the website BR flow.
   *
   * Supports both BR links (when brCode is set) and payment links (when plNumber is set).
   */
  setWebsiteBRLinkBusinessInvoiceDetails: Scalars['Boolean']['output'];
  /** Sets the number of guests. This mutation can also be used if documents are already approved. */
  setWebsiteBRLinkGuestCount: Scalars['Boolean']['output'];
  /** Sets security deposit refund bank details through the website BR flow. */
  setWebsiteBRLinkRefundBankDetails: Scalars['Boolean']['output'];
  /** Sets security deposit refund crypto details through the website BR flow. */
  setWebsiteBRLinkRefundCryptoDetails: Scalars['Boolean']['output'];
  /**
   * Call this mutation, unconditionally, when the last BR wizard step is rendered.
   *
   * We use this signal to initiate contract generation.
   */
  setWebsiteBRWizardAsCompleted: Scalars['Boolean']['output'];
  /**
   * Settles payment to bank, moving it to a non-clearing account.
   *
   * Recorded fees can be omitted when the channel already deducts their commission from the gross amount we receive.
   *
   * @staff(permissions: ["bookkeeping-editor"])
   */
  settleBookkeepingPaymentToBank: Scalars['Boolean']['output'];
  /**
   * Maps smart lock to property.
   *
   * @staff(permissions: ["smart-locks-editor"])
   */
  setupSmartLock: Scalars['Boolean']['output'];
  /**
   * Sign-in with Google (staff only). authRequester currently supports: staff.
   * This may be extended in the future to support other account types (e.g. landlords).
   */
  signInAccountWithGoogle: Account;
  /**
   * Signs in a contact using a Firebase ID token (Google/Apple/email-password).
   * Use this after client-side Firebase auth; creates a contact record if needed, returns a JWT token.
   *
   * The field selection must be restricted to the following:
   *
   * <pre>
   * signInContact(firebaseToken: String!, payload: ContactSignInPayloadInput) {
   *     id
   *     firstName
   *     lastName
   *     email
   *     jwtToken
   *     phone
   *     isSubscribedToNewsLetter
   *     birthdate
   *     nationality
   *     documents {
   *         isMainGuest
   *         documentStatus
   *         document {
   *             id
   *             documentType
   *             attachments
   *             createdAt
   *             lastUpdated
   *         }
   *         content
   *     }
   *     createdAt
   *     lastUpdated
   * }
   * </pre>
   */
  signInContact: Contact;
  /**
   * Creates a Firebase email/password account for a contact (no OAuth providers), returns a JWT token.
   * Use this for first-time email/password sign-up only.
   *
   * The field selection must be restricted to the following:
   *
   * <pre>
   * signUpContactWithEmailPassword(payload: ContactSignUpPayloadInput!) {
   *     id
   *     firstName
   *     lastName
   *     email
   *     jwtToken
   *     phone
   *     isSubscribedToNewsLetter
   *     birthdate
   *     nationality
   *     documents {
   *         isMainGuest
   *         documentStatus
   *         document {
   *             id
   *             documentType
   *             attachments
   *             createdAt
   *             lastUpdated
   *         }
   *         content
   *     }
   *     createdAt
   *     lastUpdated
   * }
   * </pre>
   */
  signUpContactWithEmailPassword: Contact;
  /**
   * Submits payment collection proof.
   *
   * The collection must not be paid yet and must have the proof status: "Awaiting Proof" or "Rejected".
   *
   * When submitted by staff, this sets status to "Accepted". When submitted by a contact, this sets status to "Pending Acceptance".
   *
   * For Cash and POS payments submitted by staff, this also sets the collection as paid.
   *
   * This mutation is usable both by staff and by contacts on the website BR link or payment link.
   *
   * @staff(permissions: ["invoices-editor"], optional: true)
   */
  submitPaymentCollectionProof: Scalars['Boolean']['output'];
  /**
   * Submits a contact us message from the website.
   *
   * @contact(optional: true)
   */
  submitWebsiteContactUs: Scalars['Boolean']['output'];
  /**
   * Submits a corporate contact inquiry from the website.
   *
   * @contact(optional: true)
   */
  submitWebsiteCorporateContact: Scalars['Boolean']['output'];
  /**
   * Submits a lease form inquiry from the website.
   *
   * @contact(optional: true)
   */
  submitWebsiteLeaseForm: Scalars['Boolean']['output'];
  /**
   * Submits a "Request a viewing" form from the website landing page and notifies reservations@stellastays.com by email.
   *
   * Can be called anonymously; when a contact token is sent, the request is linked to that contact.
   *
   * The request language is taken from the Accept-Language header (en/ar, defaults to en).
   *
   * Returns true once the request is recorded (an email delivery failure does not fail the mutation).
   *
   * Fails with extensions.code = "VALIDATION_ERROR" and one of these messages:
   *
   * - "Name must be at least 2 characters!" (name is trimmed first)
   * - "Email or phone is required!" (blank values count as not provided)
   * - "Invalid email!" (must match /^[^\s@]+@[^\s@]+\.[^\s@]+$/)
   * - "Invalid phone!" (must match /^\+?[\d\s().-]{7,}$/)
   * - "Invalid preferred date!" (must be a real date in the format YYYY-MM-DD)
   * - "Invalid preferred time!" (must be on the hour between 10:00 and 21:00, e.g. 14:00)
   * - "Preferred date and time must be at least 6 hours from now!" (evaluated in the selected city's time zone)
   *
   * @contact(optional: true)
   */
  submitWebsiteViewingRequest: Scalars['Boolean']['output'];
  /**
   * Retries syncing contact with Zoho.
   *
   * Returns contact with Zoho module IDs populated if it completes successfully, or returns an error on failure.
   *
   * @staff(permissions: ["contacts-editor"])
   */
  syncContactWithZoho: Contact;
  /**
   * Retries syncing corporate with Zoho.
   *
   * Returns corporate with Zoho module IDs populated if it completes successfully, or returns an error on failure.
   *
   * @staff(permissions: ["corporates-editor"])
   */
  syncCorporateWithZoho: Corporate;
  /**
   * Blocks / unblocks a contact
   *
   * @staff(permissions: ["contacts-admin"])
   */
  toggleContactActiveState: Scalars['Boolean']['output'];
  /**
   * Pins / unpins a contact note
   *
   * @staff(permissions: ["contacts-editor"])
   */
  toggleContactNotePinningState: Scalars['Boolean']['output'];
  /**
   * Activates / archives a corporate
   *
   * @staff(permissions: ["corporates-admin"])
   */
  toggleCorporateActiveState: Scalars['Boolean']['output'];
  /**
   * Pins / unpins a corporate note
   *
   * @staff(permissions: ["corporates-editor"])
   */
  toggleCorporateNotePinningState: Scalars['Boolean']['output'];
  /**
   * Activates / archives a multi-unit or single-unit property.
   *
   * Draft properties cannot be archived, use deletePropertyDraft to delete them.
   *
   * @staff(permissions: ["properties-admin"])
   */
  togglePropertyActiveState: Scalars['Boolean']['output'];
  /**
   * Pins / unpins a reservation note
   *
   * @staff(permissions: ["reservations-editor"])
   */
  toggleReservationNotePinningState: Scalars['Boolean']['output'];
  /**
   * Activates / deactivates a staff
   *
   * @staff(permissions: ["staff-admin"])
   */
  toggleStaffActiveState: Scalars['Boolean']['output'];
  /**
   * Pins / unpins a task note
   *
   * @staff(anyPermission: ["tasks-editor", "tasks-worker"])
   */
  toggleTaskNotePinningState: Scalars['Boolean']['output'];
  /**
   * Transfers deposit to account credit.
   *
   * @staff(permissions: ["bookkeeping-editor"])
   */
  transferBookkeepingDepositToAccountCredit: Scalars['Boolean']['output'];
  /**
   * Unassigns contacts from corporate
   *
   * @staff(permissions: ["corporates-editor"])
   */
  unassignContactsFromCorporate: Scalars['Boolean']['output'];
  /**
   * Upgrades the damage protection policy from Card on file to Security deposit (capture) through the website BR flow.
   *
   * This is available when Bank Transfer or Cryptocurrency is a supported payment method and the current policy is Card on file.
   * Once upgraded, the policy cannot be reverted back to Card on file.
   */
  upgradeWebsiteBRLinkDamageProtectionPolicy?: Maybe<WebsiteBookingRegistrationLink>;
};


export type MutationAcceptWebsiteBrLinkTermsConditionsArgs = {
  brCode: Scalars['String']['input'];
  contractBase64Signature?: InputMaybe<Scalars['String']['input']>;
};


export type MutationAdjustReservationArgs = {
  payload: AdjustReservationPayloadInput;
};


export type MutationAdjustReservationV2Args = {
  payload: AdjustReservationPayloadInput;
};


export type MutationAllocateBookkeepingAccountCreditToInvoicesArgs = {
  payload: BookkeepingAccountCreditInvoiceAllocationPayloadInput;
};


export type MutationAssignContactsToCorporateArgs = {
  payload: CorporateContactAssignmentPayloadInput;
};


export type MutationBulkScheduleHousekeepingCleaningsArgs = {
  payload: HousekeepingCleaningBulkSchedulePayloadInput;
};


export type MutationCancelHousekeepingCleaningArgs = {
  cleaningID: Scalars['ID']['input'];
};


export type MutationCancelReservationArgs = {
  reservationID: Scalars['ID']['input'];
};


export type MutationCancelReservationExtensionArgs = {
  extensionID: Scalars['ID']['input'];
};


export type MutationCreateBookkeepingCreditNoteArgs = {
  payload: BookkeepingCreditNotePayloadInput;
};


export type MutationCreateBookkeepingPaymentArgs = {
  payload: BookkeepingPaymentPayloadInput;
};


export type MutationCreateBuildingArgs = {
  buildingID?: InputMaybe<Scalars['ID']['input']>;
  payload: BuildingPayloadInput;
};


export type MutationCreateContactArgs = {
  contactID?: InputMaybe<Scalars['ID']['input']>;
  payload: ContactPayloadInput;
};


export type MutationCreateContactDocumentArgs = {
  documentID?: InputMaybe<Scalars['ID']['input']>;
  payload: ContactDocumentPayloadInput;
};


export type MutationCreateContactNoteArgs = {
  noteID?: InputMaybe<Scalars['ID']['input']>;
  payload: ContactNotePayloadInput;
};


export type MutationCreateContactTagArgs = {
  payload: ContactTagPayloadInput;
  tagID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateCorporateArgs = {
  corporateID?: InputMaybe<Scalars['ID']['input']>;
  payload: CorporatePayloadInput;
};


export type MutationCreateCorporateDocumentArgs = {
  documentID?: InputMaybe<Scalars['ID']['input']>;
  payload: CorporateDocumentPayloadInput;
};


export type MutationCreateCorporateNoteArgs = {
  noteID?: InputMaybe<Scalars['ID']['input']>;
  payload: CorporateNotePayloadInput;
};


export type MutationCreateDamageProtectionPolicyArgs = {
  payload: DamageProtectionPolicyPayloadInput;
  policyID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateHouseRuleArgs = {
  payload: HouseRulePayloadInput;
  ruleID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateHousekeepingCleaningArgs = {
  cleaningID?: InputMaybe<Scalars['ID']['input']>;
  payload: HousekeepingCleaningPayloadInput;
};


export type MutationCreateHousekeepingLocationArgs = {
  payload: HousekeepingLocationPayloadInput;
};


export type MutationCreateInvoiceArgs = {
  invoiceID?: InputMaybe<Scalars['ID']['input']>;
  payload: InvoicePayloadInput;
};


export type MutationCreateLeadSourceArgs = {
  leadSourceID?: InputMaybe<Scalars['ID']['input']>;
  payload: LeadSourcePayloadInput;
};


export type MutationCreateLocalisationArgs = {
  payload: LocalisationPayloadInput;
};


export type MutationCreatePaymentCollectionArgs = {
  payload: PaymentCollectionPayloadInput;
  paymentCollectionID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreatePropertyArgs = {
  payload: PropertyPayloadInput;
  propertyID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreatePropertyConfigArgs = {
  configID?: InputMaybe<Scalars['ID']['input']>;
  payload: PropertyConfigInput;
};


export type MutationCreateReservationArgs = {
  payload: ReservationPayloadInput;
  reservationID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateReservationDocumentArgs = {
  documentID?: InputMaybe<Scalars['ID']['input']>;
  payload: ReservationDocumentPayloadInput;
};


export type MutationCreateReservationExtensionArgs = {
  extensionID?: InputMaybe<Scalars['ID']['input']>;
  payload: ReservationExtensionPayloadInput;
};


export type MutationCreateReservationNoteArgs = {
  noteID?: InputMaybe<Scalars['ID']['input']>;
  payload: ReservationNotePayloadInput;
};


export type MutationCreateStaffArgs = {
  payload: StaffPayloadInput;
  staffID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateTaskArgs = {
  payload: TaskPayloadInput;
  taskID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateTaskNoteArgs = {
  noteID?: InputMaybe<Scalars['ID']['input']>;
  payload: TaskNotePayloadInput;
};


export type MutationCreateThingsToNoteArgs = {
  noteID?: InputMaybe<Scalars['ID']['input']>;
  payload: ThingsToNotePayloadInput;
};


export type MutationCreateWebsiteBrLinkCardOnFileIntentArgs = {
  payload: WebsiteBrLinkCardOnFileIntentPayloadInput;
};


export type MutationCreateWebsiteBrLinkLegacyPaymentSessionArgs = {
  payload: WebsiteBrLinkLegacyPaymentSessionPayloadInput;
};


export type MutationCreateWebsiteBrLinkPaymentIntentArgs = {
  payload: WebsiteBrLinkPaymentIntentPayloadInput;
};


export type MutationCreateWebsiteReservationArgs = {
  payload: WebsiteReservationPayloadInput;
};


export type MutationDeleteContactDocumentArgs = {
  documentID: Scalars['ID']['input'];
};


export type MutationDeleteContactNoteArgs = {
  noteID: Scalars['ID']['input'];
};


export type MutationDeleteContactTagArgs = {
  tagID: Scalars['ID']['input'];
};


export type MutationDeleteCorporateDocumentArgs = {
  documentID: Scalars['ID']['input'];
};


export type MutationDeleteCorporateNoteArgs = {
  noteID: Scalars['ID']['input'];
};


export type MutationDeleteDamageProtectionPolicyArgs = {
  policyID: Scalars['ID']['input'];
};


export type MutationDeleteHousekeepingCleaningArgs = {
  cleaningID: Scalars['ID']['input'];
};


export type MutationDeleteNotificationArgs = {
  notificationID: Scalars['ID']['input'];
};


export type MutationDeletePaymentCollectionArgs = {
  payload: PaymentCollectionDeletionPayloadInput;
};


export type MutationDeletePropertyDraftArgs = {
  propertyID: Scalars['ID']['input'];
};


export type MutationDeleteReservationDocumentArgs = {
  brCode?: InputMaybe<Scalars['String']['input']>;
  documentID: Scalars['ID']['input'];
  reservationID?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteReservationNoteArgs = {
  noteID: Scalars['ID']['input'];
};


export type MutationDeleteTaskNoteArgs = {
  noteID: Scalars['ID']['input'];
};


export type MutationDeleteThingsToNoteArgs = {
  noteID: Scalars['ID']['input'];
};


export type MutationDisconnectSmartLockArgs = {
  lockID: Scalars['ID']['input'];
};


export type MutationExtractReservationIdentityDocumentsArgs = {
  payload: ExtractReservationIdentityDocumentsPayloadInput;
};


export type MutationGenerateImageThumbnailArgs = {
  payload: ImageThumbnailGenerationPayloadInput;
};


export type MutationMergeContactsArgs = {
  payload: ContactMergePayloadInput;
};


export type MutationNotifyGuestToScheduleCleaningsArgs = {
  reservationID: Scalars['ID']['input'];
};


export type MutationProcessWebsiteBrLinkCardPurchaseArgs = {
  payload: WebsiteBrLinkCardPurchasePayloadInput;
};


export type MutationPublishPropertyOnChannelManagerArgs = {
  propertyID: Scalars['ID']['input'];
};


export type MutationRefundBookkeepingAccountCreditArgs = {
  payload: BookkeepingAccountCreditRefundPayloadInput;
};


export type MutationRefundBookkeepingDepositArgs = {
  payload: BookkeepingDepositRefundPayloadInput;
};


export type MutationRefundPaymentCollectionArgs = {
  payload: PaymentCollectionRefundPayloadInput;
};


export type MutationRemoteUnlockDoorArgs = {
  payload: RemoteUnlockDoorPayloadInput;
};


export type MutationRequestContactPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationRequestFileUploadHandleArgs = {
  payload: FileUploadHandlePayloadInput;
};


export type MutationScheduleHousekeepingCleaningArgs = {
  payload: HousekeepingCleaningSchedulePayloadInput;
};


export type MutationSendPaymentCollectionUrlArgs = {
  payload: PaymentCollectionUrlPayloadInput;
};


export type MutationSendReservationCheckInInstructionsArgs = {
  reservationID: Scalars['ID']['input'];
};


export type MutationSendReservationCheckOutInstructionsArgs = {
  reservationID: Scalars['ID']['input'];
};


export type MutationSendReservationCompletionLinkArgs = {
  payload: ReservationCompletionLinkPayloadInput;
};


export type MutationSetBookkeepingPaymentNotesArgs = {
  payload: BookkeepingPaymentNotesPayloadInput;
};


export type MutationSetCancellationPolicyTextArgs = {
  payload: Array<TranslatedContentInput>;
};


export type MutationSetColumnDisplayCustomizationOptionsArgs = {
  columns?: InputMaybe<Array<ColumnDisplayOptionInput>>;
  route: Scalars['String']['input'];
};


export type MutationSetContactLanguageArgs = {
  languageID: Scalars['ID']['input'];
};


export type MutationSetContactProfileArgs = {
  brCode?: InputMaybe<Scalars['String']['input']>;
  payload: ContactPayloadInput;
};


export type MutationSetFeEmailWhiteListAndRedirectsArgs = {
  redirects: Scalars['String']['input'];
  whiteListedEmails: Array<Scalars['String']['input']>;
};


export type MutationSetFeGraphQlMockToolsScenariosArgs = {
  callableName: Scalars['String']['input'];
  scenarios: Scalars['String']['input'];
};


export type MutationSetFeGraphQlMockToolsSwitchStateArgs = {
  state: Scalars['Boolean']['input'];
};


export type MutationSetGuestCheckedInToPropertyArgs = {
  payload: GuestCheckedInToPropertyPayloadInput;
};


export type MutationSetHousekeepingTimelineAvailabilityArgs = {
  payload: HousekeepingTimelineAvailabilityPayloadInput;
};


export type MutationSetNotificationReadStateArgs = {
  payload: NotificationReadStatePayloadInput;
};


export type MutationSetPaymentCollectionProofAcceptanceStatusArgs = {
  payload: PaymentCollectionProofAcceptanceStatusPayloadInput;
};


export type MutationSetPropertyAvailabilityArgs = {
  payload: PropertyAvailabilityPayloadInput;
};


export type MutationSetPropertyPriceAndLosAdjustmentArgs = {
  payload: PropertyPriceLosAdjustmentPayloadInput;
};


export type MutationSetReservationEstimatedArrivalTimeArgs = {
  payload: ReservationEstimatedArrivalTimePayloadInput;
};


export type MutationSetReservationSpecialRequestsArgs = {
  payload: ReservationSpecialRequestsPayloadInput;
};


export type MutationSetSettingsArgs = {
  payload: SettingsPayloadInput;
};


export type MutationSetTaskAssigneesArgs = {
  payload: TaskAssigneesPayloadInput;
};


export type MutationSetTaskCancelledArgs = {
  taskID: Scalars['ID']['input'];
};


export type MutationSetTaskInProgressArgs = {
  taskID: Scalars['ID']['input'];
};


export type MutationSetTaskOnHoldArgs = {
  payload: TaskOnHoldPayloadInput;
};


export type MutationSetTaskResolvedArgs = {
  payload: TaskResolvedPayloadInput;
};


export type MutationSetWebsiteBrLinkBusinessInvoiceDetailsArgs = {
  payload: WebsiteBrLinkBusinessInvoiceDetailsPayloadInput;
};


export type MutationSetWebsiteBrLinkGuestCountArgs = {
  payload: WebsiteBrLinkGuestCountPayloadInput;
};


export type MutationSetWebsiteBrLinkRefundBankDetailsArgs = {
  payload: WebsiteBrLinkRefundBankDetailsPayloadInput;
};


export type MutationSetWebsiteBrLinkRefundCryptoDetailsArgs = {
  payload: WebsiteBrLinkRefundCryptoDetailsPayloadInput;
};


export type MutationSetWebsiteBrWizardAsCompletedArgs = {
  brCode: Scalars['String']['input'];
};


export type MutationSettleBookkeepingPaymentToBankArgs = {
  payload: BookkeepingPaymentBankSettlementPayloadInput;
};


export type MutationSetupSmartLockArgs = {
  payload: SetupSmartLockPayloadInput;
};


export type MutationSignInAccountWithGoogleArgs = {
  authRequester: Scalars['String']['input'];
  googleToken: Scalars['String']['input'];
};


export type MutationSignInContactArgs = {
  firebaseToken: Scalars['String']['input'];
  payload?: InputMaybe<ContactSignInPayloadInput>;
};


export type MutationSignUpContactWithEmailPasswordArgs = {
  payload: ContactSignUpPayloadInput;
};


export type MutationSubmitPaymentCollectionProofArgs = {
  payload: PaymentCollectionProofSubmissionPayloadInput;
};


export type MutationSubmitWebsiteContactUsArgs = {
  payload: WebsiteContactMessageInput;
};


export type MutationSubmitWebsiteCorporateContactArgs = {
  payload: WebsiteCorporateContactInput;
};


export type MutationSubmitWebsiteLeaseFormArgs = {
  payload: WebsiteLeaseFormInput;
};


export type MutationSubmitWebsiteViewingRequestArgs = {
  payload: WebsiteViewingRequestInput;
};


export type MutationSyncContactWithZohoArgs = {
  contactID: Scalars['ID']['input'];
};


export type MutationSyncCorporateWithZohoArgs = {
  corporateID: Scalars['ID']['input'];
};


export type MutationToggleContactActiveStateArgs = {
  contactID: Scalars['ID']['input'];
};


export type MutationToggleContactNotePinningStateArgs = {
  noteID: Scalars['ID']['input'];
};


export type MutationToggleCorporateActiveStateArgs = {
  corporateID: Scalars['ID']['input'];
};


export type MutationToggleCorporateNotePinningStateArgs = {
  noteID: Scalars['ID']['input'];
};


export type MutationTogglePropertyActiveStateArgs = {
  propertyID: Scalars['ID']['input'];
};


export type MutationToggleReservationNotePinningStateArgs = {
  noteID: Scalars['ID']['input'];
};


export type MutationToggleStaffActiveStateArgs = {
  staffID: Scalars['ID']['input'];
};


export type MutationToggleTaskNotePinningStateArgs = {
  noteID: Scalars['ID']['input'];
};


export type MutationTransferBookkeepingDepositToAccountCreditArgs = {
  payload: BookkeepingAccountDepositTransferPayloadInput;
};


export type MutationUnassignContactsFromCorporateArgs = {
  payload: CorporateContactAssignmentPayloadInput;
};


export type MutationUpgradeWebsiteBrLinkDamageProtectionPolicyArgs = {
  payload: WebsiteBrLinkUpgradeDamageProtectionPolicyPayloadInput;
};

/** Nationality */
export type Nationality = {
  __typename?: 'Nationality';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Neighbourhood */
export type Neighbourhood = {
  __typename?: 'Neighbourhood';
  city?: Maybe<City>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Note */
export type Note = {
  __typename?: 'Note';
  attachments?: Maybe<Array<Attachment>>;
  content: Scalars['String']['output'];
  createdAt?: Maybe<DateTime>;
  /**
   * Notes maybe auto created by the system, in which case createdBy would be null.
   *
   * Staff should only be allowed to edit or delete note if createdBy is set and their ID matches createdBy.id
   */
  createdBy?: Maybe<Staff>;
  id: Scalars['ID']['output'];
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  lastUpdated?: Maybe<DateTime>;
};

/** NotePayloadInput */
export type NotePayloadInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  content: Scalars['String']['input'];
};

/** Notification */
export type Notification = {
  __typename?: 'Notification';
  body: Scalars['String']['output'];
  /** set for staff, category may be unset for other account types */
  category?: Maybe<Scalars['String']['output']>;
  /** the ID of the entity that the notification is related to, for example, if category is "Buildings", then entityID is the building ID */
  entityID?: Maybe<Scalars['ID']['output']>;
  /**
   * Name of the event key that triggered the notification.
   * This can be used with entityID to accurately route the notification on the FE.
   * See settings{staffNotificationTypes} on how to retrieve the full list of event keys
   */
  eventKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  notificationTime: DateTime;
  title: Scalars['String']['output'];
};

/** NotificationFilterInput */
export type NotificationFilterInput = {
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  notificationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** NotificationReadStatePayloadInput */
export type NotificationReadStatePayloadInput = {
  isRead: Scalars['Boolean']['input'];
  lastNotificationID?: InputMaybe<Scalars['ID']['input']>;
  notificationID?: InputMaybe<Scalars['ID']['input']>;
};

/** NotificationResult */
export type NotificationResult = {
  __typename?: 'NotificationResult';
  /** Notifications count */
  count: Scalars['Int']['output'];
  /** Notification records */
  records: Array<Notification>;
};


/** NotificationResult */
export type NotificationResultCountArgs = {
  filter?: InputMaybe<NotificationFilterInput>;
};


/** NotificationResult */
export type NotificationResultRecordsArgs = {
  filter?: InputMaybe<NotificationFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** NumericFilterInput */
export type NumericFilterInput = {
  operator: NumericFilterOperator;
  /** set for all operator values */
  value1: Scalars['Float']['input'];
  /** set when the operator is 'between' */
  value2?: InputMaybe<Scalars['Float']['input']>;
};

/** NumericFilterOperator */
export enum NumericFilterOperator {
  Between = 'between',
  Equal = 'equal',
  GreaterThan = 'greaterThan',
  LessThan = 'lessThan'
}

/** OptimizedImage */
export type OptimizedImage = {
  __typename?: 'OptimizedImage';
  /** caption is used for our website and anywhere it's supported */
  caption?: Maybe<Array<TranslatedContent>>;
  /**
   * The caption for the language code sent in header.
   * This is used on the website / mobile only.
   */
  captionRendered?: Maybe<Scalars['String']['output']>;
  /** controls the display order of images on Nest & external channels */
  displayOrder?: Maybe<Scalars['Int']['output']>;
  /** the channel-manager image type, set for properties / buildings. see "config{channelManagerImageTypes}" query */
  imageType?: Maybe<Scalars['String']['output']>;
  /**
   * The original URL uploaded from the frontend, as is. Use this as a fallback if no optimized images are available.
   * For example, if looking for mediumUrl: result.webp?.mediumUrl ?? result.url.
   */
  url: Scalars['String']['output'];
  webp?: Maybe<Webp>;
};

/** PaymentCollection */
export type PaymentCollection = {
  __typename?: 'PaymentCollection';
  /** available fields: id, name, accountType, contact, corporate, channel */
  account?: Maybe<BookkeepingAccount>;
  /** the payment method that was actually used to pay */
  actualPaymentMethod?: Maybe<ReservationPaymentMethod>;
  /**
   * If paid off-session.
   *
   * Available fields: id, cardNumber, cardBrand
   */
  cardOnFile?: Maybe<CardOnFile>;
  createdAt?: Maybe<DateTime>;
  createdBy?: Maybe<Staff>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** allocatedAmount here for each invoice is the payment amount allocated from the payment collection and not the invoice total */
  invoices?: Maybe<Array<PaymentCollectionInvoice>>;
  /** payment type: online / offline */
  isOnlineCollection?: Maybe<Scalars['Boolean']['output']>;
  /** payment status, should translate to Paid or Unpaid */
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  lastUpdated?: Maybe<DateTime>;
  paidAt?: Maybe<DateTime>;
  paymentMethodsOverrideReason?: Maybe<Scalars['String']['output']>;
  paymentNumber: Scalars['String']['output'];
  /** receipt URL for all payment types */
  paymentReceiptUrl?: Maybe<Scalars['String']['output']>;
  /** website payment URL, set for online payments that are not charged using a card on file */
  paymentUrl?: Maybe<Scalars['String']['output']>;
  /** payment proof attachments, see proofStatus field */
  proofAttachments?: Maybe<Array<Attachment>>;
  /**
   * Status of the payment proof, e.g. Awaiting Proof, Pending Acceptance, etc.
   * See config{paymentCollectionProofStatuses} query
   */
  proofStatus?: Maybe<Scalars['String']['output']>;
  /** URL to refund receipt */
  refundReceiptUrl?: Maybe<Scalars['String']['output']>;
  /** list of accepted payment methods for collection */
  supportedPaymentMethods?: Maybe<Array<ReservationPaymentMethod>>;
  totalPaymentAmount?: Maybe<Scalars['Float']['output']>;
};

/** PaymentCollectionCreationResult */
export type PaymentCollectionCreationResult = {
  __typename?: 'PaymentCollectionCreationResult';
  id: Scalars['ID']['output'];
  /** these two fields are set for online payments that are charged off-session (using a card on file) */
  isOffSessionPaymentSuccessful?: Maybe<Scalars['Boolean']['output']>;
  offSessionPaymentError?: Maybe<Scalars['String']['output']>;
  /** website payment URL, set for online payments that are not charged using a card on file */
  paymentUrl?: Maybe<Scalars['String']['output']>;
};

/** PaymentCollectionDeletionPayloadInput */
export type PaymentCollectionDeletionPayloadInput = {
  paymentCollectionID: Scalars['ID']['input'];
};

/** PaymentCollectionFilterInput */
export type PaymentCollectionFilterInput = {
  /** See bookkeepingAccounts query */
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** see reservationPaymentMethods query */
  actualPaymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<DateFilterInput>;
  /** see staff{records} query (unpaginated) */
  createdBy?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** see config{currencies} query */
  currencies?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceCount?: InputMaybe<NumericFilterInput>;
  invoiceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** filter by payment type: online / offline */
  isOnlineCollection?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  paymentCollectionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  paymentDate?: InputMaybe<DateFilterInput>;
  /** See config{paymentCollectionProofStatuses} query */
  proofStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  reservationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** search by payment collection number, invoice number, reservation confirmation number, extension confirmation number */
  search?: InputMaybe<Scalars['String']['input']>;
  /** see reservationPaymentMethods query */
  supportedPaymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  totalPaymentAmount?: InputMaybe<NumericFilterInput>;
};

/** PaymentCollectionHistoryFilterInput */
export type PaymentCollectionHistoryFilterInput = {
  paymentCollectionID: Scalars['ID']['input'];
};

/** PaymentCollectionInvoice */
export type PaymentCollectionInvoice = {
  __typename?: 'PaymentCollectionInvoice';
  /** payment amount allocated from the payment collection to this invoice */
  allocatedAmount: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
};

/** PaymentCollectionInvoiceInput */
export type PaymentCollectionInvoiceInput = {
  /** see createInvoice mutation to create new invoices as part of the payment collection flow */
  invoiceID: Scalars['ID']['input'];
  /**
   * Amount allocated to the invoice.
   * currency in PaymentCollectionPayloadInput must match invoice's currency.
   */
  paymentAmount: Scalars['Float']['input'];
};

/** PaymentCollectionInvoiceRefundInput */
export type PaymentCollectionInvoiceRefundInput = {
  invoiceID: Scalars['ID']['input'];
  refundAmount: Scalars['Float']['input'];
};

/** PaymentCollectionPayloadInput */
export type PaymentCollectionPayloadInput = {
  /** See bookkeepingAccounts query (unpaginated) */
  accountID: Scalars['ID']['input'];
  /**
   * When paying for online payments off-session.
   * See accountCardsOnFile query.
   */
  cardOnFileID?: InputMaybe<Scalars['ID']['input']>;
  /** see config{currencies} query */
  currency: Scalars['String']['input'];
  invoices: Array<PaymentCollectionInvoiceInput>;
  /** if the payment is collected online / offline */
  isOnlineCollection: Scalars['Boolean']['input'];
  /**
   * One or more payment methods that are accepted for collection.
   *
   * See reservationPaymentMethods query, filter by isOnline set to true / false, based on isOnlineCollection.
   * For online collection, multiple payment methods can be specified, but for offline collection only one is allowed.
   */
  paymentMethods: Array<Scalars['String']['input']>;
  /** this is set if paymentMethods were overridden by the staff (online collection only) */
  paymentMethodsOverrideReason?: InputMaybe<Scalars['String']['input']>;
  /** must match the sum of paymentAmount for all invoices */
  totalPaymentAmount: Scalars['Float']['input'];
};

/** PaymentCollectionProofAcceptanceStatusPayloadInput */
export type PaymentCollectionProofAcceptanceStatusPayloadInput = {
  isAccepted: Scalars['Boolean']['input'];
  paymentCollectionID: Scalars['ID']['input'];
};

/** PaymentCollectionProofSubmissionPayloadInput */
export type PaymentCollectionProofSubmissionPayloadInput = {
  attachments: Array<AttachmentInput>;
  /**
   * Must be set if called by contacts, cannot be set by staff.
   * See websiteBookingRegistrationLink query.
   */
  brCode?: InputMaybe<Scalars['String']['input']>;
  /** must be set if called by staff, cannot be set by contacts */
  paymentCollectionID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * See reservationPaymentMethods query.
   * If called by contacts, this must be one of "Cryptocurrency" or "Bank Transfer".
   */
  paymentMethod: Scalars['String']['input'];
  /**
   * Must be set if called by contacts, cannot be set by staff.
   * See websitePaymentLink query.
   */
  plNumber?: InputMaybe<Scalars['String']['input']>;
};

/** PaymentCollectionRefundPayloadInput */
export type PaymentCollectionRefundPayloadInput = {
  invoices: Array<PaymentCollectionInvoiceRefundInput>;
  paymentCollectionID: Scalars['ID']['input'];
};

/** PaymentCollectionResult */
export type PaymentCollectionResult = {
  __typename?: 'PaymentCollectionResult';
  /** Records count */
  count: Scalars['Int']['output'];
  /**
   * Exports to Excel.
   *
   * Pass the active PaymentCollectionFilterInput that's applied to the grid, if any, to get the same records.
   *
   * Also send the active sort criteria that's applied on the grid through options.sort. Pagination is ignored here.
   *
   * The columns field is the enabled columns on the grid, in order of display as customized by the staff or the default grid columns if not customized.
   *
   * This is fetched from the query columnDisplayCustomizationOptions for the page route.
   *
   * The exportable columns are limited to the options below and need to match each one exactly (case sensitive):
   *
   * <pre>
   *     Payment ID
   *     Account
   *     Payment Type
   *     Payment URL
   *     Payment Status
   *     Proof Status
   *     Currency
   *     Invoices
   *     Total Payment Amount
   *     Paid At
   *     Supported Payment Methods
   *     Actual Payment Method
   *     Created At
   *     Last Updated
   *     Created By
   * </pre>
   */
  export: Scalars['String']['output'];
  /** Fetches the history of a payment collection */
  history: Array<ResourceHistory>;
  /**
   * Returns paginated payment collection records.
   *
   * To fetch all payment collections without pagination, when populating dropdowns for instance, create a dedicated GraphQL file with this field selection:
   *
   * <pre>
   * paymentCollections {
   *     result: records(filter: $filter, options: $options) {
   *         id
   *         paymentNumber
   *         isOnlineCollection
   *         account {
   *             id
   *             name
   *             accountType
   *             contact {
   *                 id
   *                 firstName
   *                 lastName
   *                 email
   *                 contactType
   *                 phone
   *             }
   *             corporate {
   *                 id
   *                 internalName
   *                 legalName
   *             }
   *             channel {
   *                 id
   *                 name
   *             }
   *         }
   *         isPaid
   *         paidAt
   *         currency
   *         proofStatus
   *         invoices {
   *             id
   *             invoiceNumber
   *             allocatedAmount
   *         }
   *         totalPaymentAmount
   *         supportedPaymentMethods
   *         actualPaymentMethod
   *         paymentUrl
   *         createdAt
   *     }
   * }
   * </pre>
   *
   * When this exact field selection is detected, the server runs a faster query that returns all data without pagination.
   *
   * All fields of PaymentCollectionFilterInput are still applicable with the exception of "search" and CommonQueryOptionsInput is ignored here.
   *
   * Here is the allowed field selection on the PaymentCollection type, anonymously or as a contact:
   *
   * <pre>
   * paymentCollections {
   *     result: records(filter: $filter, options: $options) {
   *         id
   *         paymentNumber
   *         isOnlineCollection
   *         isPaid
   *         proofStatus
   *         currency
   *         invoices {
   *             id
   *             invoiceNumber
   *             allocatedAmount
   *         }
   *         totalPaymentAmount
   *         supportedPaymentMethods {
   *             name
   *             isEnabled
   *         }
   *         actualPaymentMethod {
   *             name
   *             isEnabled
   *         }
   *         proofAttachments {
   *             fileName
   *             mimeType
   *             url
   *         }
   *         paymentUrl
   *         paymentReceiptUrl
   *         refundReceiptUrl
   *         paidAt {
   *             formatted
   *             raw
   *         }
   *     }
   * }
   * </pre>
   *
   * The list of supported sort criteria in options.sort:
   *
   * <pre>
   *     Payment ID
   *     Payment ID desc
   *     Account
   *     Account desc
   *     Payment Type
   *     Payment Type desc
   *     Payment Status
   *     Payment Status desc
   *     Proof Status
   *     Proof Status desc
   *     Currency
   *     Currency desc
   *     Total Payment Amount
   *     Total Payment Amount desc
   *     Paid At
   *     Paid At desc
   *     Created At
   *     Created At desc
   *     Last Updated
   *     Last Updated desc
   *     Created By
   *     Created By desc
   * </pre>
   */
  records: Array<PaymentCollection>;
};


/** PaymentCollectionResult */
export type PaymentCollectionResultCountArgs = {
  filter?: InputMaybe<PaymentCollectionFilterInput>;
};


/** PaymentCollectionResult */
export type PaymentCollectionResultExportArgs = {
  columns: Array<Scalars['String']['input']>;
  filter?: InputMaybe<PaymentCollectionFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};


/** PaymentCollectionResult */
export type PaymentCollectionResultHistoryArgs = {
  filter: PaymentCollectionHistoryFilterInput;
};


/** PaymentCollectionResult */
export type PaymentCollectionResultRecordsArgs = {
  filter?: InputMaybe<PaymentCollectionFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** PaymentCollectionUrlPayloadInput */
export type PaymentCollectionUrlPayloadInput = {
  paymentCollectionID: Scalars['ID']['input'];
};

/** PaymentVat */
export type PaymentVat = {
  __typename?: 'PaymentVat';
  amount: Scalars['Float']['output'];
  percentage: Scalars['Float']['output'];
};

/** Phone */
export type Phone = {
  __typename?: 'Phone';
  /** example: +971 */
  code: Scalars['String']['output'];
  /** example: 501234567 */
  number: Scalars['String']['output'];
};

/** PhoneInput */
export type PhoneInput = {
  /** must start with + and contain digits only, for example: +971 */
  code: Scalars['String']['input'];
  /** phone number without the leading 0, digits only, for example: 501234567 */
  number: Scalars['String']['input'];
};

/** Property */
export type Property = {
  __typename?: 'Property';
  /** short description of the property */
  aboutProperty?: Maybe<Array<TranslatedContent>>;
  /**
   * The about-property text for the language code sent in header.
   * This is used on the website / mobile only.
   */
  aboutPropertyRendered?: Maybe<Scalars['String']['output']>;
  balconySizeSqm?: Maybe<Scalars['Int']['output']>;
  /** number of bathrooms */
  bathCount?: Maybe<Scalars['Float']['output']>;
  /** number of bedrooms */
  bedroomCount?: Maybe<Scalars['Int']['output']>;
  /** for non-standalone properties */
  building?: Maybe<Building>;
  /**
   * Channel-manager registration details.
   * This applies to furnished properties only but might be extended to support unfurnished properties on relevant platforms.
   */
  channelManager?: Maybe<ChannelManagerProperty>;
  /** unit-type prefix */
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<DateTime>;
  createdBy?: Maybe<Staff>;
  /** currency could be different than what's set in building or location, if location's currency changes after the property is created */
  currency?: Maybe<Scalars['String']['output']>;
  /** if property is a multi-unit, single-unit or subunit */
  entityType?: Maybe<PropertyEntityType>;
  /** set for non-standalone units, ground floor is 0 */
  floorNumber?: Maybe<Scalars['Int']['output']>;
  /** attributes specific to furnished properties */
  furnished?: Maybe<FurnishedProperty>;
  hasKitchen?: Maybe<Scalars['Boolean']['output']>;
  /** list of standard unit amenities */
  highLevelAmenities?: Maybe<Array<HighLevelAmenity>>;
  /** house rules assigned to unit */
  houseRules?: Maybe<Array<HouseRule>>;
  id: Scalars['ID']['output'];
  /** unit images, can be combined with building images for a holistic view (example: when publishing on the website) */
  images?: Maybe<ImageSet>;
  /** internal name of the unit */
  internalName?: Maybe<Scalars['String']['output']>;
  /** if property is active or archived */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  lastUpdated?: Maybe<DateTime>;
  /** public listing name */
  listingName?: Maybe<Array<TranslatedContent>>;
  /**
   * The listing name for the language code sent in header.
   * This is used on the website / mobile only.
   */
  listingNameRendered?: Maybe<Scalars['String']['output']>;
  /** for standalone properties */
  location?: Maybe<EntityLocation>;
  /** smart lock connected to the property */
  lock?: Maybe<SmartLock>;
  /** see config{propertyModels} */
  modelType?: Maybe<Scalars['String']['output']>;
  /**
   * ID of the parent multi-unit, if this is a subunit.
   * Use this when building a tree-view hierarchy
   */
  parentID?: Maybe<Scalars['ID']['output']>;
  /** for non-standalone units */
  parkingNumber?: Maybe<Scalars['String']['output']>;
  /** see config{propertyTypes} */
  propertyType?: Maybe<PropertyType>;
  /**
   * Set when sending withQuotation in PropertyFilterInput.
   *
   * Use the values in "quotation.paymentPlan.singlePayment[0]" to display rates on the website / mobile.
   */
  quotation?: Maybe<ReservationQuotation>;
  /** in local currency */
  securityDepositAmount?: Maybe<Scalars['Int']['output']>;
  sizeSqm?: Maybe<Scalars['Int']['output']>;
  /** set for multi-units */
  subUnits?: Maybe<Array<Property>>;
  /** for unfurnished properties */
  unfurnished?: Maybe<UnfurnishedProperty>;
  /** apartment / unit number, set for single-units & subunits */
  unitNumber?: Maybe<Scalars['String']['output']>;
};

/** PropertyAssignmentInput */
export type PropertyAssignmentInput = {
  /** electricityNumber can optionally be set for unfurnished and commercial units */
  electricityNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * Floor number is required if unit is not a standalone unit (Apartment, Studio, etc.).
   * Send ground floor (G) as 0
   */
  floorNumber?: InputMaybe<Scalars['Int']['input']>;
  /** set on edit */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** the internal name of the unit/sub-unit, for example: DXB-BAR-SBB2-11 */
  internalName: Scalars['String']['input'];
  /** applicable to furnished units only */
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  /** parking number can optionally be set for non-standalone units */
  parkingNumber?: InputMaybe<Scalars['String']['input']>;
  unitNumber: Scalars['String']['input'];
};

/** PropertyAvailabilityPayloadInput */
export type PropertyAvailabilityPayloadInput = {
  blockNotes?: InputMaybe<Scalars['String']['input']>;
  /**
   * Set blockReason & blockNotes if isBlocked is true.
   * See config{propertyBlockReasons} query
   */
  blockReason?: InputMaybe<Scalars['String']['input']>;
  endDate: Scalars['String']['input'];
  isBlocked: Scalars['Boolean']['input'];
  propertyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** In the format YYYY-MM-DD */
  startDate: Scalars['String']['input'];
};

/** PropertyAvailabilityRange */
export type PropertyAvailabilityRange = {
  __typename?: 'PropertyAvailabilityRange';
  blockNotes?: Maybe<Scalars['String']['output']>;
  /** block reason, notes, blocked by and blocked at are set if the dates were blocked for reasons other than bookings, e.g. Maintenance, Photography, etc. */
  blockReason?: Maybe<Scalars['String']['output']>;
  blockedAt?: Maybe<DateTime>;
  /** available fields: id, firstName, lastName, email */
  blockedBy?: Maybe<Staff>;
  /** in the format YYYY-MM-DD (inclusive date), returned as a raw string */
  endDate: Scalars['String']['output'];
  isBlocked: Scalars['Boolean']['output'];
  propertyID: Scalars['ID']['output'];
  /** in the format YYYY-MM-DD, returned as a raw string */
  startDate: Scalars['String']['output'];
};

/** PropertyAvailabilityRangesFilterInput */
export type PropertyAvailabilityRangesFilterInput = {
  /** in the format YYYY-MM-DD */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /**
   * If requesting availability for an extension, set this field to true and send the subunit or single unit id in propertyIDs.
   * If the subunit where the guest is staying is booked, the backend may look for available space in other subunits and return adjusted availability depending on if it can move bookings to other subunits.
   */
  isExtension?: InputMaybe<Scalars['Boolean']['input']>;
  propertyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in the format YYYY-MM-DD */
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/** PropertyConfig */
export type PropertyConfig = {
  __typename?: 'PropertyConfig';
  cityOverrides?: Maybe<Array<PropertyConfigCityOverride>>;
  createdAt?: Maybe<DateTime>;
  createdBy?: Maybe<Staff>;
  defaultValue: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<DateTime>;
  parameter: Scalars['String']['output'];
};

/** PropertyConfigCityOverride */
export type PropertyConfigCityOverride = {
  __typename?: 'PropertyConfigCityOverride';
  /** includes id and name */
  city: City;
  value: Scalars['String']['output'];
};

/** PropertyConfigCityOverrideInput */
export type PropertyConfigCityOverrideInput = {
  cityID: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

/** PropertyConfigFilterInput */
export type PropertyConfigFilterInput = {
  configIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** PropertyConfigInput */
export type PropertyConfigInput = {
  cityOverrides?: InputMaybe<Array<PropertyConfigCityOverrideInput>>;
  defaultValue: Scalars['String']['input'];
  parameter: Scalars['String']['input'];
};

/** PropertyConfigResult */
export type PropertyConfigResult = {
  __typename?: 'PropertyConfigResult';
  count: Scalars['Int']['output'];
  records: Array<PropertyConfig>;
};


/** PropertyConfigResult */
export type PropertyConfigResultCountArgs = {
  filter?: InputMaybe<PropertyConfigFilterInput>;
};


/** PropertyConfigResult */
export type PropertyConfigResultRecordsArgs = {
  filter?: InputMaybe<PropertyConfigFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** PropertyEntityType */
export enum PropertyEntityType {
  MultiUnit = 'multiUnit',
  SingleUnit = 'singleUnit',
  SubUnit = 'subUnit'
}

/** PropertyFilterInput */
export type PropertyFilterInput = {
  /**
   * Returns properties that are available in the given date range.
   *
   * This filter is only usable with the operator value of 'between'
   */
  availabilityRange?: InputMaybe<DateFilterInput>;
  bedCount?: InputMaybe<Scalars['Int']['input']>;
  bedroomCount?: InputMaybe<Scalars['Int']['input']>;
  buildingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  cityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityTypes?: InputMaybe<Array<PropertyEntityType>>;
  /** filters by properties which have housekeeping configured, to prevent creating reservations in unconfigured properties */
  hasHousekeepingConfiguration?: InputMaybe<Scalars['Boolean']['input']>;
  hasKitchen?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter by lock status: Mapped or Unmapped */
  isLockMapped?: InputMaybe<Scalars['Boolean']['input']>;
  /** filter by lock's network status: Online or Offline */
  isLockOnline?: InputMaybe<Scalars['Boolean']['input']>;
  /** if the property is published on the channel manager */
  isOnChannelManager?: InputMaybe<Scalars['Boolean']['input']>;
  isStandalone?: InputMaybe<Scalars['Boolean']['input']>;
  locationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  modelTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  neighbourhoodIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filters properties that can accommodate the specified number of guests.
   * Used for the website / mobile only.
   */
  numberOfGuests?: InputMaybe<Scalars['Int']['input']>;
  propertyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  propertyTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * When checkInDate and checkOutDate are set, returns quotation info for the specified dates.
   * Used for the website / mobile only.
   */
  withQuotation?: InputMaybe<ReservationQuotationInput>;
};

/** PropertyLengthOfStayFilterInput */
export type PropertyLengthOfStayFilterInput = {
  /** in the format YYYY-MM-DD */
  endDate?: InputMaybe<Scalars['String']['input']>;
  propertyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in the format YYYY-MM-DD */
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/** PropertyNightlyRate */
export type PropertyNightlyRate = {
  __typename?: 'PropertyNightlyRate';
  /** in the format YYYY-MM-DD, returned as a raw string */
  day: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  /** one of 'Increment' or 'Decrement' */
  priceAdjustmentDirection?: Maybe<Scalars['String']['output']>;
  /** one of 'Percentage', 'Fixed' */
  priceAdjustmentType?: Maybe<Scalars['String']['output']>;
  priceAdjustmentValue?: Maybe<Scalars['Float']['output']>;
  propertyID: Scalars['ID']['output'];
};

/** PropertyNightlyRateFilterInput */
export type PropertyNightlyRateFilterInput = {
  /** in the format YYYY-MM-DD */
  endDate?: InputMaybe<Scalars['String']['input']>;
  propertyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** in the format YYYY-MM-DD */
  startDate?: InputMaybe<Scalars['String']['input']>;
};

/** PropertyPayloadInput */
export type PropertyPayloadInput = {
  /**
   * buildingID is required if propertyType is not standalone (Apartments, Studios, etc.).
   *
   * To get the list of buildings to select from, fetch the buildings{records} query without pagination (using the preset field selection).
   */
  buildingID?: InputMaybe<Scalars['ID']['input']>;
  /** attributes applicable to furnished properties */
  furnished?: InputMaybe<FurnishedPropertyInput>;
  /**
   * Location of Villas and similar type of units, one of buildingID or location must be specified but not both.
   *
   * Set id in EntityLocationInput to null to create a new location on the fly.
   *
   * This will always be a new location when creating a new standalone property, even if it's a Villa in a compound where the location was already registered with another Villa, for simplicity sake.
   *
   * Similarly, the location ID must be set on edit for standalone units.
   */
  location?: InputMaybe<EntityLocationInput>;
  /** see config{propertyModels} */
  modelType: Scalars['String']['input'];
  /** common property attributes, applies to all types of properties */
  property?: InputMaybe<CommonPropertyInput>;
  /** see config{propertyTypes}, check isStandalone in response to know if type requires a building or a location */
  propertyType: Scalars['String']['input'];
  /** attributes applicable to unfurnished & commercial properties */
  unfurnished?: InputMaybe<UnfurnishedPropertyInput>;
};

/** PropertyPriceLOSAdjustmentPayloadInput */
export type PropertyPriceLosAdjustmentPayloadInput = {
  endDate: Scalars['String']['input'];
  /** LOS adjustment, leave it as null to skip */
  lengthOfStay?: InputMaybe<Scalars['Int']['input']>;
  /** one of 'Increment' or 'Decrement' */
  priceAdjustmentDirection?: InputMaybe<Scalars['String']['input']>;
  /** one of 'Percentage', 'Fixed' */
  priceAdjustmentType?: InputMaybe<Scalars['String']['input']>;
  /**
   * Send this value as 0 to reset previous price adjustments in this date range.
   *
   * If priceAdjustmentValue is greater than 0, then priceAdjustmentType and priceAdjustmentDirection must be set.
   *
   * At least one of lengthOfStay or price attributes must be set.
   */
  priceAdjustmentValue?: InputMaybe<Scalars['Float']['input']>;
  propertyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** In the format YYYY-MM-DD */
  startDate: Scalars['String']['input'];
};

/** PropertyResult */
export type PropertyResult = {
  __typename?: 'PropertyResult';
  /** Records count */
  count: Scalars['Int']['output'];
  /**
   * Exports to Excel.
   *
   * Pass the active PropertyFilterInput that's applied to the grid, if any to get the same records.
   *
   * Also send the active sort criteria that's applied on the grid through options.sort. Pagination is ignored here.
   *
   * The columns field is the enabled columns on the grid, in order of display as customized by the staff or the default grid columns if not customized.
   *
   * This is fetched from the query columnDisplayCustomizationOptions for the page route.
   *
   * The reason we take a direct columns array instead of route, is that there could be no previous customization by the staff but the default grid display hides a few auxiliary columns and the Excel export needs to match that.
   *
   * The exportable columns are limited to the options below and need to match each one exactly (case sensitive):
   *
   * <pre>
   *     Property Name
   *     Status
   *     Building
   *     Property Type
   *     Model
   *     City
   *     Neighbourhood
   *     No. of Units
   *     Damage Protection Policy
   *     Publishing Status
   *     Lock Status
   *     Lock Alias
   *     Lock Network Status
   *     Lock Name
   *     Lock Timezone
   *     Created At
   *     Created By
   *     Last Updated
   * </pre>
   */
  export: Scalars['String']['output'];
  /**
   * When fetching records anonymously or as a guest, the field selection must be restricted to the following:
   *
   * <pre>
   * properties {
   *     result: records(filter: $filter, options: $options) {
   *         id
   *         parentID
   *         propertyType {
   *             name
   *             isStandalone
   *         }
   *         entityType
   *         currency
   *         building {
   *             id
   *             listingNameRendered
   *             location {
   *                 id
   *                 address
   *                 zipCode
   *                 coordinates {
   *                     lat
   *                     lng
   *                 }
   *                 neighbourhood {
   *                     id
   *                     name
   *                     city {
   *                         id
   *                         name
   *                         airportCode
   *                         vatPercentage
   *                         country {
   *                             id
   *                             name
   *                             code3
   *                             code2
   *                             currency
   *                             vatPercentage
   *                         }
   *                     }
   *                 }
   *             }
   *             highLevelAmenities {
   *                 id
   *                 name
   *                 iconUrl
   *                 contentRendered
   *             }
   *             images {
   *                 main {
   *                     url
   *                     webp {
   *                         thumbnailUrl
   *                         mediumUrl
   *                         largeUrl
   *                     }
   *                 }
   *                 all {
   *                     url
   *                     webp {
   *                         thumbnailUrl
   *                         mediumUrl
   *                         largeUrl
   *                     }
   *                     imageType
   *                     displayOrder
   *                     captionRendered
   *                 }
   *             }
   *         }
   *         location {
   *             id
   *             address
   *             zipCode
   *             coordinates {
   *                 lat
   *                 lng
   *             }
   *             neighbourhood {
   *                 id
   *                 name
   *                 city {
   *                     id
   *                     name
   *                     airportCode
   *                     vatPercentage
   *                     country {
   *                         id
   *                         name
   *                         code3
   *                         code2
   *                         currency
   *                         vatPercentage
   *                     }
   *                 }
   *             }
   *         }
   *         unitNumber
   *         floorNumber
   *         parkingNumber
   *         listingNameRendered
   *         bedroomCount
   *         bathCount
   *         hasKitchen
   *         sizeSqm
   *         balconySizeSqm
   *         securityDepositAmount
   *         highLevelAmenities {
   *             id
   *             name
   *             iconUrl
   *             contentRendered
   *         }
   *         images {
   *             main {
   *                 url
   *                 webp {
   *                     thumbnailUrl
   *                     mediumUrl
   *                     largeUrl
   *                 }
   *             }
   *             all {
   *                 url
   *                 webp {
   *                     thumbnailUrl
   *                     mediumUrl
   *                     largeUrl
   *                 }
   *                 imageType
   *                 displayOrder
   *                 captionRendered
   *             }
   *         }
   *         aboutPropertyRendered
   *         houseRules {
   *             id
   *             name
   *             iconUrl
   *             contentRendered {
   *                 languageCode
   *                 title
   *                 body
   *             }
   *         }
   *         furnished {
   *             bedCount
   *             maximumGuests
   *             sleepingArrangement {
   *                 bedroomNumber
   *                 bedTypes
   *             }
   *             checkInTime
   *             checkOutTime
   *         }
   *         quotation {
   *             paymentPlan {
   *                 singlePayment {
   *                     nights
   *                     nightlyRate
   *                     bookingAmount
   *                     bookingTotal
   *                 }
   *                 grandBookingTotal
   *                 grandTotal
   *                 currency
   *             }
   *         }
   *     }
   * }
   * </pre>
   *
   *
   * To fetch all properties without pagination when authenticated as staff, for example, when populating dropdowns, create a dedicated GraphQL file with this field selection:
   *
   * <pre>
   * properties {
   *     result: records(filter: $filter, options: $options) {
   *         id
   *         internalName
   *         currency
   *         securityDepositAmount
   *         entityType
   *         propertyType {
   *             name
   *             isStandalone
   *         }
   *         listingName {
   *             languageCode
   *             body
   *         }
   *         parentID
   *         images {
   *             main {
   *                 url
   *                 webp {
   *                     thumbnailUrl
   *                 }
   *             }
   *         }
   *         building {
   *             id
   *             internalName
   *             listingName {
   *                 languageCode
   *                 body
   *             }
   *             location {
   *                 id
   *                 address
   *                 neighbourhood {
   *                     id
   *                     name
   *                     city {
   *                         id
   *                         name
   *                         airportCode
   *                         vatPercentage
   *                         country {
   *                             id
   *                             name
   *                             code3
   *                             code2
   *                             currency
   *                             vatPercentage
   *                         }
   *                     }
   *                 }
   *             }
   *         }
   *         location {
   *             id
   *             address
   *             neighbourhood {
   *                 id
   *                 name
   *                 city {
   *                     id
   *                     name
   *                     airportCode
   *                     vatPercentage
   *                     country {
   *                         id
   *                         name
   *                         code3
   *                         code2
   *                         currency
   *                         vatPercentage
   *                     }
   *                 }
   *             }
   *         }
   *     }
   * }
   * </pre>
   *
   * When this exact field selection is detected, the server runs a faster query that returns all data without pagination.
   *
   * All fields of PropertyFilterInput are still applicable (except withQuotation & numberOfGuests) but CommonQueryOptionsInput is ignored here.
   *
   * The list of supported sort criteria in options.sort:
   *
   * <pre>
   *     Property Name
   *     Property Name desc
   *     Status
   *     Status desc
   *     Building
   *     Building desc
   *     Property Type
   *     Property Type desc
   *     Model
   *     Model desc
   *     City
   *     City desc
   *     Neighbourhood
   *     Neighbourhood desc
   *     Lock Status
   *     Lock Status desc
   *     Lock Alias
   *     Lock Alias desc
   *     Lock Network Status
   *     Lock Network Status desc
   *     Lock Name
   *     Lock Name desc
   *     Lock Timezone
   *     Lock Timezone desc
   *     Created At
   *     Created At desc
   *     Last Updated
   *     Last Updated desc
   * </pre>
   */
  records: Array<Property>;
};


/** PropertyResult */
export type PropertyResultCountArgs = {
  filter?: InputMaybe<PropertyFilterInput>;
};


/** PropertyResult */
export type PropertyResultExportArgs = {
  columns: Array<Scalars['String']['input']>;
  filter?: InputMaybe<PropertyFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};


/** PropertyResult */
export type PropertyResultRecordsArgs = {
  filter?: InputMaybe<PropertyFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** PropertyType */
export type PropertyType = {
  __typename?: 'PropertyType';
  /** indicates if it's a standalone type (not in a building), for example: Villa, Townhouse */
  isStandalone: Scalars['Boolean']['output'];
  /** example: Studio, Villa, etc. */
  name: Scalars['String']['output'];
};

export type Query = {
  __typename?: 'Query';
  /**
   * Retrieves saved payment cards for the given account and currency.
   *
   * @staff(permissions: ["invoices-viewer"])
   */
  accountCardsOnFile: Array<CardOnFile>;
  /**
   * List of supported booking channels
   *
   * @staff
   */
  bookingChannels: Array<BookingChannel>;
  /**
   * Accounts that track a financial entity in the ledger, either a distribution channel (OTA), a corporate client, or an individual contact.
   *
   * @staff
   */
  bookkeepingAccounts: BookkeepingAccountResult;
  /**
   * Financial buckets used as destinations for payments.
   *
   * @staff(permissions: ["bookkeeping-viewer"])
   */
  bookkeepingCashAccounts: Array<BookkeepingCashAccount>;
  /**
   * Payment & allocation records.
   *
   * @staff(permissions: ["bookkeeping-viewer"])
   */
  bookkeepingPayments: BookkeepingPaymentResult;
  /**
   * Retrieves buildings.
   *
   * The following fields are available under location:
   *
   * - id, address, zipCode, coordinates
   * - neighbourhood: id, name
   * - city: id, name, airportCode
   * - country: id, name, code3, code2, currency
   *
   * See the subqueries under BuildingResult for additional details.
   *
   * @staff(permissions: ["buildings-viewer"], optional: true)
   */
  buildings: BuildingResult;
  /**
   * Returns a unified list of buildings and standalone properties for the website / mobile search page.
   *
   * This query is a wrapper for buildings{records} and properties{records}. For properties, it returns standalone properties only.
   *
   * Sorting is fixed by availability (options.sort is ignored):
   * - available buildings first
   * - available standalone properties second
   * - unavailable buildings third
   * - unavailable standalone properties last
   */
  buildingsWithStandaloneProperties: Array<BuildingOrProperty>;
  /** Retrieves cancellation policy text */
  cancellationPolicyText: Array<TranslatedContent>;
  /**
   * List of cities, optionally filtered by one or more country IDs.
   *
   * When fetching records anonymously or as a guest, the field selection must be restricted to the following:
   *
   * <pre>
   * result: cities(countryIDs: $countryIDs) {
   *     id
   *     name
   * }
   * </pre>
   *
   * @staff(optional: true)
   */
  cities: Array<City>;
  /**
   * Retrieves staff's column preferences for the page identified by "route".
   *
   * See setColumnDisplayCustomizationOptions mutation.
   *
   * @staff
   */
  columnDisplayCustomizationOptions?: Maybe<Array<ColumnDisplayOption>>;
  /** Fetches configuration data */
  config: Config;
  /**
   * Retrieves list of contact tags
   *
   * @staff(permissions: ["contacts-viewer"])
   */
  contactTags: Array<ContactTag>;
  /**
   * Retrieves contacts.
   *
   * See the subqueries under ContactResult for additional details.
   *
   * @staff(permissions: ["contacts-viewer"])
   */
  contacts: ContactResult;
  /**
   * Retrieves corporates.
   *
   * See the subqueries under CorporateResult for additional details.
   *
   * @staff(permissions: ["corporates-viewer"])
   */
  corporates: CorporateResult;
  /**
   * List of countries where StellaStays operates.
   *
   * @staff
   */
  countries: Array<Country>;
  /**
   * Retrieves a list of damage-protection policies
   *
   * @staff(permissions: ["properties-admin"])
   */
  damageProtectionPolicies: DamageProtectionPolicyResult;
  /**
   * Fetches locations of buildings & standalone properties (Villas, etc.).
   *
   * Use this query when generic locations are required and you need to perform assignments or filtering by location ID.
   *
   * If a building ID or property ID is needed, use specialized queries such as "buildings{records}" instead of this one.
   *
   * Make sure you're sending to the server the location ID ".location.id" and not the direct entity ID (building or property).
   *
   * This query returns a union type instead of EntityLocation so we can access the names of buildings or properties to use that in place of addresses, if required.
   *
   * @staff
   */
  entityLocations: Array<ExtendedEntityLocation>;
  /**
   * Retrieves a list of extended amenities.
   *
   * Extended amenities are sent to the channel manager when publishing units.
   *
   * Hint: You can optionally set highLevelAmenityID to fetch & scroll to extended amenities or highlight them when a high-level amenity is selected.
   *
   * Note: Some high-level amenities may not have corresponding extended amenities.
   *
   * @staff
   */
  extendedAmenities: Array<ExtendedAmenity>;
  /**
   * Retrieves reservation extensions.
   *
   * See the subqueries under ReservationExtensionResult for additional details.
   *
   * @staff(permissions: ["reservations-viewer"])
   */
  extensions: ReservationExtensionResult;
  /** Fetches JSON-encoded array of scenarios for Query or Mutation */
  feGraphQLMockToolsScenarios?: Maybe<Scalars['String']['output']>;
  /**
   * Fetches the mock state for this FE developer.
   * The mock switch allows switching mocks on/off for a developer.
   *
   * When off, disables all existing mocks
   * When on, allows existing mocks to intercept requests
   *
   * Defaults to true when unset
   */
  feGraphQLMockToolsSwitchState: Scalars['Boolean']['output'];
  /**
   * Fetches whitelisted emails & redirects, see setFEEmailWhiteListAndRedirects.
   * Returns JSON encoded dictionary as {"whiteListedEmails": [...], "redirects": {}}
   */
  feWhiteListedEmailsAndRedirects: Scalars['String']['output'];
  /**
   * Takes a full or partial reservation confirmation number and returns the reservation and contact details.
   *
   * Returns null if reservation is not found.
   *
   * Look for "hasAccount" in contact, if it's true, the contact is registered on Firebase and must login to view their reservation.
   *
   * If "hasAccount" is false, then the query returns a value for "contactReferenceKey", pass this when calling signInContact or signUpContactWithEmailPassword.
   *
   * When "contactReferenceKey" is sent to the sign up mutations, the backend updates the existing contact (that's linked to the reservation) with the new contact info, even if they use a different email, as long as the existing contact is not on Firebase.
   *
   * A common scenario where this is useful, is when an OTA guest uses find-my-reservation on the app:
   *
   * - Contact record is created for them on Nest through the OTA, with a typically anonymous email (e.g. j28snn28@guests.quickconnect.rentals).
   * - Contact doesn't yet have a Firebase account, so the contactReferenceKey is returned.
   * - Contact signs up using signInContact or signUpContactWithEmailPassword, sending along the contactReferenceKey.
   * - The existing contact is updated with the new email, and a Firebase account is created for them.
   *
   * Another handy contact attribute is "isOTAEmail", if true (and "hasAccount" is false, which typically it is for OTA guests), then we don't prefill the email field on the sign up form, to prompt them to use a personal or business email.
   */
  findMyReservation?: Maybe<FindMyReservationResult>;
  /**
   * Fetches high-level amenities. Category can be set to "building" or "property"
   *
   * @staff
   */
  highLevelAmenities: Array<HighLevelAmenity>;
  /**
   * Fetches FX conversion for a specific calendar day.
   *
   * Returns null if no FX rate is found for the given day.
   *
   * @staff
   */
  historicalCurrencyConversion?: Maybe<CurrencyConversion>;
  /**
   * Retrieves a list of house rules.
   *
   * To fetch all records without pagination, when populating dropdowns for instance, create a dedicated GraphQL file with this field selection:
   *
   * <pre>
   * houseRules {
   *     result: records(filter: $filter, options: $options) {
   *         id
   *         name
   *         iconUrl
   *     }
   * }
   * </pre>
   *
   * When this exact field selection is detected, the server runs a faster query that returns all data without pagination.
   *
   * All fields of HouseRulesFilterInput are still applicable with the exception of "search" and CommonQueryOptionsInput is ignored here.
   *
   * @staff(permissions: ["properties-editor"])
   */
  houseRules: HouseRuleResult;
  /**
   * Generates a quotation for Add-on cleanings.
   *
   * @staff(permissions: ["housekeeping-viewer"])
   */
  housekeepingAddOnCleaningQuotation: HousekeepingAddOnCleaningQuotation;
  /**
   * Retrieves list of unavailable cleaning times for a given date range and location.
   *
   * The relevant filter fields here are locationID, startDate and endDate.
   *
   * @staff(permissions: ["housekeeping-viewer"])
   */
  housekeepingBlockedCleaningTimes: Array<HousekeepingBlockedCleaningTime>;
  /**
   * Returns the cleaners load details for the given location, dates and filter fields.
   *
   * You can display the average "loadPercentage" of all records to display a value for the cleaning load percentage bar, and optionally, display a percentage per team in a tooltip.
   *
   * @staff(permissions: ["housekeeping-viewer"])
   */
  housekeepingCleanersLoad: Array<HousekeepingCleanersLoad>;
  /**
   * Returns scheduled / unscheduled cleanings for use on the cleaning timeline
   *
   * @staff(permissions: ["housekeeping-viewer"])
   */
  housekeepingCleanings: HousekeepingCleaningResult;
  /**
   * Returns the occupancy percentage for location in the given date range
   *
   * @staff(permissions: ["housekeeping-viewer"])
   */
  housekeepingLocationOccupancyPercentage: Scalars['Float']['output'];
  /**
   * Retrieves housekeeping configurations per location (building or standalone property).
   *
   * Configuration fields are null for unconfigured locations.
   *
   * @staff(permissions: ["housekeeping-viewer"])
   */
  housekeepingLocations: HousekeepingLocationResult;
  /**
   * Retrieves list of cleaning teams.
   *
   * @staff(permissions: ["housekeeping-viewer"])
   */
  housekeepingTeams: Array<HousekeepingTeam>;
  /**
   * Retrieves list of invoices.
   *
   * @staff(permissions: ["invoices-viewer"])
   */
  invoices: InvoiceResult;
  /** Retrieves the list of supported languages */
  languages: Array<Language>;
  /**
   * Returns a list of lead sources for use on reservations, contacts, and corporates.
   *
   * See createLeadSource mutation.
   *
   * @staff(anyPermission: ["reservations-viewer", "contacts-viewer", "corporates-viewer"])
   */
  leadSources: Array<LeadSource>;
  /**
   * Retrieves list of localisations.
   *
   * @staff(permissions: ["localisations-viewer"], optional: true)
   */
  localisations: Array<Localisation>;
  /**
   * Fetches session of signed-in account
   *
   * When resolving a contact session, the field selection must be restricted to the following:
   *
   * <pre>
   * me {
   *     ... on Contact {
   *         id
   *         firstName
   *         lastName
   *         email
   *         jwtToken
   *         phone
   *         isSubscribedToNewsLetter
   *         birthdate
   *         nationality
   *         documents {
   *             isMainGuest
   *             documentStatus
   *             document {
   *                 id
   *                 documentType
   *                 attachments
   *                 createdAt
   *                 lastUpdated
   *             }
   *             content
   *         }
   *         createdAt
   *         lastUpdated
   *     }
   * }
   * </pre>
   *
   * @staff
   * @contact
   */
  me: Account;
  /** List of nationalities */
  nationalities: Array<Nationality>;
  /**
   * List of neighbourhoods, optionally filtered by one or more city IDs.
   *
   * The response contains id & name only, omitting city information.
   *
   * @staff
   */
  neighbourhoods: Array<Neighbourhood>;
  /**
   * Fetches notifications
   *
   * @staff
   */
  notifications: NotificationResult;
  /**
   * Retrieves list of payment collections.
   *
   * @staff(permissions: ["invoices-viewer"])
   */
  paymentCollections: PaymentCollectionResult;
  /**
   * Retrieves properties.
   *
   * By default, this query fetches all entities (multi-units, single-units and subunits), set entityTypes in PropertyFilterInput to multiUnit and singleUnit to fetch the top-level properties only.
   *
   * See the subqueries under PropertyResult for additional details.
   *
   * @staff(permissions: ["properties-viewer"], optional: true)
   */
  properties: PropertyResult;
  /**
   * Returns availability ranges for one or more properties.
   *
   * This data powers the reservation timeline and any interactive booking calendar you show to users.
   *
   * Each result includes propertyID so you can map the range back to the correct property in your UI.
   *
   * This query can be used with multi-units, subunits and single units.
   *
   * When fetching records anonymously or as a guest, the field selection must be restricted to the following:
   *
   * <pre>
   * propertyAvailabilityRanges {
   *     result: propertyAvailabilityRanges(filter: $filter) {
   *         propertyID
   *         startDate
   *         endDate
   *         isBlocked
   *     }
   * }
   * </pre>
   *
   * @staff(permissions: ["timeline-viewer"], optional: true)
   */
  propertyAvailabilityRanges: Array<PropertyAvailabilityRange>;
  /**
   * Retrieves properties' configuration data.
   *
   * To get the list of configurable parameters, see "config {propertyConfigParameters}" query.
   *
   * @staff(permissions: ["properties-admin"])
   */
  propertyConfig: PropertyConfigResult;
  /**
   * Returns the minimum length-of-stay (LOS) requirement for each day.
   *
   * Use this data to populate the reservation timeline or any interactive booking calendar.
   *
   * Each record in the response includes propertyID, allowing you to map the LOS details back to the correct property in your UI.
   *
   * Note: LOS constraints apply to new bookings only, they're neglected on extensions.
   *
   * This query can be used with multi-units, subunits and single units. If a subunit is used, we return the data for its parent multi-unit.
   *
   * When fetching records anonymously or as a guest, the field selection must be restricted to the following:
   *
   * <pre>
   * propertyLengthOfStayDays {
   *     result: propertyLengthOfStayDays(filter: $filter) {
   *         propertyID
   *         day
   *         lengthOfStay
   *     }
   * }
   * </pre>
   *
   * @staff(permissions: ["timeline-viewer"], optional: true)
   */
  propertyLengthOfStayDays: Array<LengthOfStayDay>;
  /**
   * Returns the property's nightly rates.
   *
   * Use this data to populate the reservation timeline for both multi-units and single-units.
   *
   * Each record in the response includes a propertyID, which allows you to map the price details back to the correct property in your UI.
   *
   * This query works with multi-units, subunits, and single-units. If a subunit is provided, the data for its parent multi-unit is returned.
   *
   * Note: Retrieve the property's currency from the properties query (location field).
   *
   * @staff(permissions: ["timeline-viewer"])
   */
  propertyNightlyRates: Array<PropertyNightlyRate>;
  /**
   * Checks if the remote-unlock button on the Guest app should be enabled and visible.
   *
   * @contact
   */
  remoteUnlockVisibilityStatus?: Maybe<RemoteUnlockVisibilityStatus>;
  /**
   * List of add-on services that can be used when creating "Service" invoices.
   *
   * Note: not all services have corresponding costs, for example, "Early Check-In" and "Late Check-Out" services are charged based on when the guest requested the service.
   * These are left for staff to enter manually.
   *
   * If the price for the service is available, it's provided based on the reservation's currency and number of bedrooms.
   *
   * @staff
   */
  reservationAddOnServices: Array<ReservationAddOnService>;
  /**
   * List of reservation damage types that can be used when creating "Damage Replacement" invoices.
   *
   * Cost is returned in the currency specified in the filter.
   *
   * Note: not all damage types have corresponding costs (dynamic or range-based fees are left out), these are left for staff to enter manually.
   *
   * @staff
   */
  reservationDamageTypes: Array<ReservationDamageType>;
  /**
   * Retrieves all payment methods that can be used to pay for a reservation or an extension.
   * Set the filter to get payment methods that should be enabled for property & reservation dates.
   *
   * Call this query when you need the list of payment methods to populate a dropdown for filtering, if you're generating a quotation,
   * then you don't need to call this query directly, as this list is made available in the paymentMethods field in ReservationPaymentPlan.
   *
   * @staff(permissions: ["reservations-viewer"])
   */
  reservationPaymentMethods: Array<ReservationPaymentMethod>;
  /**
   * Generates a booking or extension quotation.
   *
   * Installments on corporate bookings are supported if one of the bookings spans at least two months or if the bookings overall span that range.
   *
   * The only exception to that is if one of the bookings' checkout date is in the past.
   * Make sure to verify that installments are set on all entries in the result before displaying that option or an error gets thrown when calling createReservation with the installment option.
   *
   * For the payment methods, each method should be enabled on the FE only if it's enabled in all returned quotations, so if you have four quotations and Bank Transfer is enabled in three of them but disabled in the fourth, then it should be disabled.
   *
   * @staff(permissions: ["reservations-viewer"])
   */
  reservationQuotation: Array<ReservationQuotation>;
  /**
   * Retrieves reservations.
   *
   * See the subqueries under ReservationResult for additional details.
   *
   * @staff(permissions: ["reservations-viewer"]) @contact
   */
  reservations: ReservationResult;
  /**
   * Fetches settings
   *
   * @staff
   */
  settings: SettingResult;
  /**
   * Retrieves paginated log records of smart lock.
   *
   * @staff(permissions: ["smart-locks-viewer"])
   */
  smartLockEntryLogs: Array<SmartLockEntryLog>;
  /**
   * Fetches the list of smart lock passcodes.
   *
   * @staff(permissions: ["smart-locks-viewer"])
   */
  smartLockPasscodes: SmartLockPasscodeResult;
  /**
   * Retrieves list of smart locks.
   *
   * Use this list to map single & subunits to locks.
   *
   * @staff(permissions: ["smart-locks-viewer"])
   */
  smartLocks: Array<SmartLock>;
  /**
   * Retrieves staff.
   *
   * See the subqueries under StaffResult for additional details.
   *
   * @staff(permissions: ["staff-viewer"])
   */
  staff: StaffResult;
  /**
   * Retrieves list of staff departments
   *
   * @staff
   */
  staffDepartments: Array<StaffDepartment>;
  /**
   * Fetches list of task issue types with default priority and estimated hours
   *
   * @staff(permissions: ["tasks-viewer"])
   */
  taskIssueTypes: Array<TaskIssueType>;
  /**
   * Retrieves list of tasks.
   *
   * @staff(permissions: ["tasks-viewer"])
   */
  tasks: TaskResult;
  /**
   * Retrieves a list of things-to-note
   *
   * @staff(permissions: ["properties-editor"])
   */
  thingsToNote: ThingsToNoteResult;
  /**
   * Returns the card on file details for the given payment reference key.
   * Use this to display the card details once a card-setup or card payment is completed.
   */
  websiteBRLinkCardOnFileInfo?: Maybe<CardOnFile>;
  /**
   * Returns the total amount of the payment collection converted to the cryptocurrency.
   *
   * Supports both BR links (when brCode is set) and payment links (when plNumber is set).
   */
  websiteBRLinkCryptoTotalAmount: Scalars['Float']['output'];
  /**
   * Retrieves booking-registration data for a booking completion link.
   *
   * Returns null if the brCode is invalid, expired, or no pending action is required and every linked stay is already past local checkout.
   *
   * This query is designed for anonymous / guest access and supports reservation and extension codes,
   * including corporate contact own links and POC links.
   *
   * Note: the BR link flow is intended for fulfilling check-in requirements:
   * - upfront payments of reservation or extensions or the first installment
   * - security deposit
   * - identification documents
   *
   * Subsequent instalments, as well as service and damage-replacement invoices raised after the guest has checked in (provided they previously completed the BR link), can be paid either through the same BR link or via standalone payment links.
   */
  websiteBookingRegistrationLink?: Maybe<WebsiteBookingRegistrationLink>;
  /**
   * Returns the help center content for the website.
   *
   * Language is determined from the Accept-Language header (en/ar).
   */
  websiteHelpCenterContent: Array<WebsiteHelpCenterContent>;
  /**
   * Provides data for standalone payment links.
   *
   * "plNumber" is the payment collection number (e.g. P-12345678).
   *
   * Website payment URL: https://dev.stellastays.com/pay/{collection-number}
   *
   * Returns null if the collection number is not found or the collection is not an online collection.
   */
  websitePaymentLink?: Maybe<WebsitePaymentLink>;
};


export type QueryAccountCardsOnFileArgs = {
  filter: AccountCardsOnFileFilterInput;
};


export type QueryBookkeepingCashAccountsArgs = {
  filter?: InputMaybe<BookkeepingCashAccountFilterInput>;
};


export type QueryBuildingsWithStandalonePropertiesArgs = {
  filter: BuildingsWithStandalonePropertiesFilterInput;
  options?: InputMaybe<CommonQueryOptionsInput>;
};


export type QueryCitiesArgs = {
  countryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryColumnDisplayCustomizationOptionsArgs = {
  route: Scalars['String']['input'];
};


export type QueryContactTagsArgs = {
  tagIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryEntityLocationsArgs = {
  filter?: InputMaybe<EntityLocationFilterInput>;
};


export type QueryExtendedAmenitiesArgs = {
  highLevelAmenityID?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFeGraphQlMockToolsScenariosArgs = {
  callableName: Scalars['String']['input'];
};


export type QueryFindMyReservationArgs = {
  confirmationNumber: Scalars['String']['input'];
};


export type QueryHighLevelAmenitiesArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHistoricalCurrencyConversionArgs = {
  params: HistoricalCurrencyConversionInput;
};


export type QueryHousekeepingAddOnCleaningQuotationArgs = {
  filter: HousekeepingAddOnCleaningQuotationFilterInput;
};


export type QueryHousekeepingBlockedCleaningTimesArgs = {
  filter: HousekeepingCleaningFilterInput;
};


export type QueryHousekeepingCleanersLoadArgs = {
  filter: HousekeepingCleaningFilterInput;
};


export type QueryHousekeepingLocationOccupancyPercentageArgs = {
  filter: HousekeepingCleaningFilterInput;
};


export type QueryLocalisationsArgs = {
  filter: LocalisationsFilterInput;
};


export type QueryNeighbourhoodsArgs = {
  cityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPropertyAvailabilityRangesArgs = {
  filter: PropertyAvailabilityRangesFilterInput;
};


export type QueryPropertyLengthOfStayDaysArgs = {
  filter: PropertyLengthOfStayFilterInput;
};


export type QueryPropertyNightlyRatesArgs = {
  filter: PropertyNightlyRateFilterInput;
};


export type QueryRemoteUnlockVisibilityStatusArgs = {
  reservationID: Scalars['ID']['input'];
};


export type QueryReservationAddOnServicesArgs = {
  filter: ReservationAddOnServicesFilterInput;
};


export type QueryReservationDamageTypesArgs = {
  filter: ReservationDamageTypesFilterInput;
};


export type QueryReservationPaymentMethodsArgs = {
  filter?: InputMaybe<ReservationPaymentMethodFilterInput>;
};


export type QueryReservationQuotationArgs = {
  params: Array<ReservationQuotationInput>;
};


export type QuerySmartLockEntryLogsArgs = {
  filter: SmartLockEntryLogFilterInput;
  options?: InputMaybe<CommonQueryOptionsInput>;
};


export type QuerySmartLocksArgs = {
  filter?: InputMaybe<SmartLocksFilterInput>;
};


export type QueryStaffDepartmentsArgs = {
  departmentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryTaskIssueTypesArgs = {
  filter?: InputMaybe<TaskIssueTypeFilterInput>;
};


export type QueryWebsiteBrLinkCardOnFileInfoArgs = {
  params: WebsiteBrLinkCardOnFileInfoInput;
};


export type QueryWebsiteBrLinkCryptoTotalAmountArgs = {
  params: WebsiteBrLinkCryptoTotalAmountInput;
};


export type QueryWebsiteBookingRegistrationLinkArgs = {
  brCode: Scalars['String']['input'];
};


export type QueryWebsitePaymentLinkArgs = {
  plNumber: Scalars['String']['input'];
};

/** QueryPaginationInput */
export type QueryPaginationInput = {
  /** page number */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** number of records to fetch per page, defaults to 20 */
  records?: InputMaybe<Scalars['Int']['input']>;
};

/** RemoteUnlockDoorPayloadInput */
export type RemoteUnlockDoorPayloadInput = {
  /** lockID and unlockReason must be set by staff, leaving reservationID as null */
  lockID?: InputMaybe<Scalars['ID']['input']>;
  /** reservationID must be set by contact, leaving other fields as null */
  reservationID?: InputMaybe<Scalars['ID']['input']>;
  unlockReason?: InputMaybe<Scalars['String']['input']>;
};

/** RemoteUnlockVisibilityStatus */
export type RemoteUnlockVisibilityStatus = {
  __typename?: 'RemoteUnlockVisibilityStatus';
  /**
   * Set if isVisible is true and isEnabled is false, this is a translation key that can be looked up on the app and translates to:
   *
   * - The door unlock will be available 10 minutes before check-in time.
   * - Please complete your reservation payment to enable door unlock.
   * - A security deposit is required to unlock the door.
   */
  disabledButtonHintTranslationKey?: Maybe<Scalars['String']['output']>;
  /**
   * If the button should be enabled.
   * This is false if:
   *
   * - check-in is too far away
   * - payment is incomplete
   * - SD is unpaid
   */
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * If the button should be displayed.
   * This is false if documents are not submitted or are not yet approved or if the reservation is in the past
   */
  isVisible: Scalars['Boolean']['output'];
  /**
   * Get the apartment number from property.unitNumber, this value is null for standalone units.
   * Use this value to display the title: Apartment no. {{apartmentNumber}} (e.g., Apartment no. 408).
   */
  property?: Maybe<Property>;
  /**
   * Get the passcode from reservation.passcode.code.
   * Used to display the hint: Tap to access your digital key.
   * Check if the code is not null prior to use.
   */
  reservation?: Maybe<Reservation>;
  /**
   * Displays a hint when the button is enabled:
   * Tap to access your digital key.
   */
  tapToUnlockTranslationKey?: Maybe<Scalars['String']['output']>;
};

/** Reservation */
export type Reservation = {
  __typename?: 'Reservation';
  /** available fields: id, name, accountType */
  account?: Maybe<BookkeepingAccount>;
  /** the reservation that this one was adjusted / split from */
  adjustedFromReservation?: Maybe<Reservation>;
  /** the reservation that this one was adjusted / split into */
  adjustedToReservation?: Maybe<Reservation>;
  /**
   * Set specifically for bank transfers, if this payment method isn't enabled by default & it gets enabled as an override.
   * If enabled, we'll send out the check-in instructions even if the payment isn't received.
   */
  allowSendingCheckInInstructionsWithoutPayment?: Maybe<Scalars['Boolean']['output']>;
  bookingCompletion?: Maybe<BookingCompletionLink>;
  /** available fields: id, internalName, listingName */
  building?: Maybe<Building>;
  channel?: Maybe<BookingChannel>;
  checkInDate?: Maybe<Date>;
  checkInInstructions?: Maybe<CheckInOutInstructions>;
  checkInStatus?: Maybe<ReservationCheckInStatus>;
  /** 24h time format, padded with 0, e.g. 09:00, 17:30, etc. */
  checkInTime?: Maybe<Scalars['String']['output']>;
  /** this is the original reservation check-out date & it remains unchanged on extensions */
  checkOutDate?: Maybe<Date>;
  checkOutInstructions?: Maybe<CheckInOutInstructions>;
  checkOutTime?: Maybe<Scalars['String']['output']>;
  /**
   * Cleanings info, requires housekeeping-viewer role.
   * For use on the housekeeping module, create a dedicated GraphQL query for this.
   */
  cleanings?: Maybe<Array<HousekeepingCleaning>>;
  confirmationNumber: Scalars['String']['output'];
  /** available fields: id, firstName, lastName, email, contactType, phone, tags, birthdate */
  contact?: Maybe<Contact>;
  /** available fields: id, internalName, legalName */
  corporate?: Maybe<Corporate>;
  /** A UUID that links corporate bookings created in bulk during the same session */
  corporateReservationGroupReference?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<DateTime>;
  /**
   * Available fields: id, firstName, lastName, email.
   *
   * This is null if the booking was delivered to Nest through the channel-manager
   */
  createdBy?: Maybe<Staff>;
  documents?: Maybe<Array<ReservationDocument>>;
  /**
   * Estimated time of arrival in 24h format (e.g. 14:30).
   * Set by guests on the BR link.
   */
  estimatedArrivalTime?: Maybe<Scalars['String']['output']>;
  /** the checkout date of the last confirmed booking extension, if any */
  extendedCheckOutDate?: Maybe<Date>;
  id: Scalars['ID']['output'];
  /**
   * Invoices-related fields, requires invoices-viewer role.
   * For use on the bookkeeping module, create a dedicated GraphQL query for this.
   *
   * To display currency with pendingInvoicesBalance / overdueInvoicesBalance, use payment.currency.
   */
  invoices?: Maybe<Array<Invoice>>;
  /** if contact accepted T&C on the BR link */
  isContactBrTermsConditionsAccepted?: Maybe<Scalars['Boolean']['output']>;
  /**
   * For corporate bookings only, if true, then the point of contact uploads IDs of all contacts.
   * If false, each contact gets a separate link to upload their IDs.
   */
  isCorporatePocResponsibleForIDSubmission?: Maybe<Scalars['Boolean']['output']>;
  isOngoing?: Maybe<Scalars['Boolean']['output']>;
  isPast?: Maybe<Scalars['Boolean']['output']>;
  /** if POC accepted T&C on the BR link */
  isPocBrTermsConditionsAccepted?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Convenience fields, provided primarily for the Guest App.
   * Uses the property's local timezone for comparison.
   */
  isUpcoming?: Maybe<Scalars['Boolean']['output']>;
  lastUpdated?: Maybe<DateTime>;
  leadDetails?: Maybe<Scalars['String']['output']>;
  /** available fields: id, firstName, lastName, email */
  leadOwner?: Maybe<Staff>;
  leadQuality?: Maybe<Scalars['String']['output']>;
  leadSource?: Maybe<LeadSource>;
  nights?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Array<Note>>;
  numberOfGuests?: Maybe<Scalars['Int']['output']>;
  overdueInvoicesBalance?: Maybe<Scalars['Float']['output']>;
  passcode?: Maybe<SmartLockPasscode>;
  payment?: Maybe<ReservationPaymentPlan>;
  pendingInvoicesBalance?: Maybe<Scalars['Float']['output']>;
  /** available fields: id, firstName, lastName, email, contactType */
  pointOfContact?: Maybe<Contact>;
  /** progress by stage and step */
  progress?: Maybe<Array<ReservationProgress>>;
  /** available fields: id, internalName, listingName, parentID and the main image (images.main) */
  property?: Maybe<Property>;
  rentalAgreement?: Maybe<Attachment>;
  /**
   * Guest special requests.
   * Set by guests on the BR link or by staff on the reservation-progress view.
   */
  specialRequests?: Maybe<Scalars['String']['output']>;
  /** reservation status */
  status?: Maybe<Scalars['String']['output']>;
};

/** ReservationAddOnService */
export type ReservationAddOnService = {
  __typename?: 'ReservationAddOnService';
  cost?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** ReservationAddOnServicesFilterInput */
export type ReservationAddOnServicesFilterInput = {
  reservationID: Scalars['ID']['input'];
};

/** ReservationCheckInStatus */
export type ReservationCheckInStatus = {
  __typename?: 'ReservationCheckInStatus';
  checkedInAt?: Maybe<DateTime>;
  /** if the system could not automatically detect the check-in and it was done by a staff member (through setGuestCheckedInToProperty) */
  confirmedBy?: Maybe<Staff>;
  /** Nest regularly polls the smart lock records to detect if the guest is checked in */
  isCheckedIn: Scalars['Boolean']['output'];
};

/** ReservationCompletionLinkPayloadInput */
export type ReservationCompletionLinkPayloadInput = {
  /**
   * For corporate bookings only, if true, then corporate pays for the security deposit on behalf of all contacts & the point of contact gets one BR link to pay for the booking & the SD.
   * If false, then the point of contact pays for the booking only, and each contact gets a separate link to pay for the security deposit.
   */
  corporatePaysForTheSecurityDeposit?: InputMaybe<Scalars['Boolean']['input']>;
  /** In the format YYYY-MM-DD HH:mm:ss */
  invitationExpiry?: InputMaybe<Scalars['String']['input']>;
  /**
   * For corporate bookings only, if true, then the point of contact uploads IDs of all contacts.
   * If false, each contact gets a separate link to upload their IDs.
   */
  isCorporatePocResponsibleForIDSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * For corporate bookings only, set this to target multiple reservations at once (from the reservation corporate tab).
   *
   * This allows customizing corporatePaysForTheSecurityDeposit & isCorporatePocResponsibleForIDSubmission per reservation and:
   * - Batch updates reservations to pending
   * - Sends out the POC BR link
   * - Sends out the BR link to every contact individually
   *
   * If pocReservations is set, then the top level corporatePaysForTheSecurityDeposit & isCorporatePocResponsibleForIDSubmission are ignored.
   *
   * When sending pocReservations, set the top level reservationID to the current reservation ID (the one from which we're viewing the corporate tabs), this reservation should also be sent in the pocReservations array.
   *
   * All reservations must be leads, pending or confirmed and cannot contain a cancelled booking.
   *
   * Note: if a single corporate reservation was created using createReservation mutation, then still send it in pocReservations array. This is required to send the POC BR link.
   */
  pocReservations?: InputMaybe<Array<ReservationCompletionLinkPocReservationInput>>;
  reservationID: Scalars['ID']['input'];
};

/** ReservationCompletionLinkPocReservationInput */
export type ReservationCompletionLinkPocReservationInput = {
  /**
   * For corporate bookings only, if true, then corporate pays for the security deposit on behalf of this contact & the point of contact gets one BR link to pay for the booking & the SD.
   * If false, then the point of contact pays for the booking only, and each contact gets a separate link to pay for the security deposit.
   */
  corporatePaysForTheSecurityDeposit: Scalars['Boolean']['input'];
  /**
   * For corporate bookings only, if true, then the point of contact uploads IDs on behalf of this contact.
   * If false, this contact gets a separate link to upload their ID.
   */
  isCorporatePocResponsibleForIDSubmission: Scalars['Boolean']['input'];
  reservationID: Scalars['ID']['input'];
};

/** ReservationDamageType */
export type ReservationDamageType = {
  __typename?: 'ReservationDamageType';
  cost?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** ReservationDamageTypesFilterInput */
export type ReservationDamageTypesFilterInput = {
  currency: Scalars['String']['input'];
};

/** ReservationDocument */
export type ReservationDocument = {
  __typename?: 'ReservationDocument';
  content?: Maybe<ReservationIdentityDocumentContent>;
  document: Document;
  /**
   * Approved or Expired.
   *
   * Documents submitted by staff or guests are reviewed before submission and are not accepted if rejected.
   *
   * They become expired when the current date is past the expiry date.
   *
   * This field is null for non-identification documents, for example, Bank Statements. See "contacts{records}" query
   */
  documentStatus?: Maybe<Scalars['String']['output']>;
  /**
   * If this document is for the main guest or accompanying guest.
   * This field is null when fetching documents from "contacts{records}" query
   */
  isMainGuest?: Maybe<Scalars['Boolean']['output']>;
  /** if document was rejected by document-AI then overridden by the staff to approved */
  isStatusOverridden?: Maybe<Scalars['Boolean']['output']>;
  /** this is set if document-AI rejected the document then status was overridden by staff */
  reviewedBy?: Maybe<Staff>;
};

/** ReservationDocumentPayloadInput */
export type ReservationDocumentPayloadInput = {
  /**
   * One document for passports, two documents for national IDs.
   * Set it to null for manual-input.
   */
  attachments?: InputMaybe<Array<AttachmentInput>>;
  /**
   * Must be set if called by contacts, cannot be set by staff.
   * See websiteBookingRegistrationLink query.
   */
  brCode?: InputMaybe<Scalars['String']['input']>;
  content: ReservationIdentityDocumentContentInput;
  /** see config{contactDocumentTypes} */
  documentType: Scalars['String']['input'];
  /** if this upload is for the main guest, in which case, it's identical to calling createContactDocument mutation */
  isMainGuest: Scalars['Boolean']['input'];
  /**
   * If document was rejected by document-AI then overridden by the staff to approved.
   * Must be set to false if used by contacts.
   */
  isStatusOverridden: Scalars['Boolean']['input'];
  /** must be set by staff. For contacts, must be set for POC and POC only. */
  reservationID?: InputMaybe<Scalars['ID']['input']>;
};

/** ReservationEntryInput */
export type ReservationEntryInput = {
  /** check-in date in the format YYYY-MM-DD */
  checkInDate: Scalars['String']['input'];
  /**
   * Send 24h time format, padded with 0, e.g. 09:00, 17:30, etc.
   * Fetch the default check-in / check-out hour from properties{records} query.
   */
  checkInTime: Scalars['String']['input'];
  /** check-out date in the format YYYY-MM-DD */
  checkOutDate: Scalars['String']['input'];
  /** same as checkInTime */
  checkOutTime: Scalars['String']['input'];
  /**
   * The Contact ID for this reservation.
   * - For Contact bookings: this is the guest’s Contact ID (and there is only one item).
   * - For Corporate bookings: this must be set to a Contact who belongs to corporateID.
   */
  contactID: Scalars['ID']['input'];
  /**
   * An override of the default policy type, e.g. Not required, Card on file, etc.
   * Requires reservations-admin permission to allow this override, leave this value as null if not overriding.
   *
   * To get the list of applicable policy types for a property, see the "damageProtectionPolicy.ranges" field in the properties{records} query.
   */
  damageProtectionPolicyType?: InputMaybe<Scalars['String']['input']>;
  /** discount amount in the currency of the property, if applicable */
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Discount reason is required if discountAmount is set.
   * See config{reservationDiscountReasons} query.
   */
  discountReason?: InputMaybe<Scalars['String']['input']>;
  /**
   * Send the grand total that's displayed on the FE, to validate the final amount matches what's expected.
   * This also verifies prices haven't changed in the background while the booking was being created.
   *
   * The grand total can be null if creating a corporate lead.
   *
   * This amount must be discounted if discountAmount is set.
   */
  grandTotal?: InputMaybe<Scalars['Float']['input']>;
  /** number of guests for this reservation */
  numberOfGuests: Scalars['Int']['input'];
  /**
   * This is typically a single-unit or multi-unit property, subunits are also supported.
   * Use the unpaginated properties{records} query for property selection.
   */
  propertyID: Scalars['ID']['input'];
  /**
   * An override of the default security deposit of the property.
   * Requires reservations-admin permission to allow this override, leave this value as null if not overriding.
   *
   * To get the default amount, see the "securityDepositAmount" field in properties{records} query.
   *
   * This can only be set if damageProtectionPolicyType is "Security deposit (capture)".
   */
  securityDepositAmount?: InputMaybe<Scalars['Int']['input']>;
};

/** ReservationEstimatedArrivalTimePayloadInput */
export type ReservationEstimatedArrivalTimePayloadInput = {
  /**
   * This is required when sent by contacts, cannot be provided otherwise.
   * This must be the BR code for a contact reservation (corporate or regular contact), and cannot be the POC code or a code that's associated with an extension.
   */
  brCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * 24h time format, padded with 0, e.g. 09:00, 17:30, etc.
   * This value must be between the property's standard check-in time and 11:55 PM.
   */
  estimatedArrivalTime: Scalars['String']['input'];
  /** this is required when sent by staff, cannot be provided otherwise */
  reservationID?: InputMaybe<Scalars['ID']['input']>;
};

/** ReservationExtension */
export type ReservationExtension = {
  __typename?: 'ReservationExtension';
  checkInDate?: Maybe<Date>;
  checkOutDate?: Maybe<Date>;
  confirmationNumber?: Maybe<Scalars['String']['output']>;
  /** available fields: id, firstName, lastName, email */
  contact?: Maybe<Contact>;
  /** available fields: id, internalName, legalName */
  corporate?: Maybe<Corporate>;
  createdAt?: Maybe<DateTime>;
  createdBy?: Maybe<Staff>;
  extensionCompletion?: Maybe<BookingCompletionLink>;
  id: Scalars['ID']['output'];
  isOngoing?: Maybe<Scalars['Boolean']['output']>;
  /** convenience flags for use on the FE as needed */
  isPast?: Maybe<Scalars['Boolean']['output']>;
  isUpcoming?: Maybe<Scalars['Boolean']['output']>;
  lastUpdated?: Maybe<DateTime>;
  nights?: Maybe<Scalars['Int']['output']>;
  payment?: Maybe<ReservationPaymentPlan>;
  /** available fields: id, internalName, listingName */
  property?: Maybe<Property>;
  /** available fields: id, confirmationNumber */
  reservation?: Maybe<Reservation>;
  /** similar to reservations, but excluding the Lead status, this can be one of: Pending, Confirmed or Cancelled */
  status?: Maybe<Scalars['String']['output']>;
};

/** ReservationExtensionFilterInput */
export type ReservationExtensionFilterInput = {
  extensionIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  reservationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** ReservationExtensionPayloadInput */
export type ReservationExtensionPayloadInput = {
  /** extension's check-out date in the format YYYY-MM-DD */
  checkOutDate: Scalars['String']['input'];
  /**
   * For extensions, security deposit is set if extending the stay triggers a change in the damage protection policy.
   * Look for the securityDeposit field in ReservationPaymentPlan when generating an extension quotation.
   *
   * Changing the default value requires reservations-admin permission, see this field in ReservationEntryInput for more details.
   */
  damageProtectionPolicyType?: InputMaybe<Scalars['String']['input']>;
  /** discount amount in the currency of the property, if applicable */
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Discount reason is required if discountAmount is set.
   * See config{reservationDiscountReasons} query.
   */
  discountReason?: InputMaybe<Scalars['String']['input']>;
  /**
   * Send the grand total that's displayed on the FE, to validate the final amount matches what's expected.
   * This also verifies prices haven't changed in the background while the extension was being created.
   */
  grandTotal: Scalars['Float']['input'];
  /**
   * In the format YYYY-MM-DD HH:mm:ss.
   * This is identical to invitationExpiry for reservations and is required if sending payment link, gets discarded if creating a lead.
   */
  holdExpiry?: InputMaybe<Scalars['String']['input']>;
  /** true if payment is paid upfront, false for installments */
  isPaidUpfront: Scalars['Boolean']['input'];
  /**
   * List of payment methods, only set if values were overridden by the staff.
   * See paymentMethods in the response of reservationQuotation query.
   */
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  /** this is set if paymentMethods were overridden by the staff */
  paymentMethodsOverrideReason?: InputMaybe<Scalars['String']['input']>;
  reservationID: Scalars['ID']['input'];
  /** similar to damageProtectionPolicyType, see this field in ReservationEntryInput for more details */
  securityDepositAmount?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Set this to true to create a pending extension and send a payment link to the contact.
   * If false, a lead gets created instead.
   *
   * For corporate bookings, payment links get sent to the POC instead of the contact.
   */
  sendPaymentLink: Scalars['Boolean']['input'];
  /**
   * If we should use the original reservation rate for the extension.
   * See reservationQuotation query.
   */
  useOriginalReservationRate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** ReservationExtensionResult */
export type ReservationExtensionResult = {
  __typename?: 'ReservationExtensionResult';
  /** Records count */
  count: Scalars['Int']['output'];
  /**
   * Currently, this can only be fetched paginated.
   *
   * Extensions do not support exports or custom sorting fields, as it is a subpage of reservations.
   *
   * Here is the allowed field selection on the ReservationExtension type, anonymously or as a contact:
   *
   * <pre>
   * extensions {
   *     result: records(filter: $filter, options: $options) {
   *         id
   *         confirmationNumber
   *         reservation {
   *             id
   *             confirmationNumber
   *         }
   *         status
   *         checkInDate {
   *             formatted
   *             raw
   *         }
   *         checkOutDate {
   *             formatted
   *             raw
   *         }
   *         nights
   *         property {
   *             id
   *             propertyType {
   *                 name
   *                 isStandalone
   *             }
   *             entityType
   *             currency
   *             building {
   *                 id
   *                 listingNameRendered
   *                 location {
   *                     id
   *                     address
   *                     zipCode
   *                     coordinates {
   *                         lat
   *                         lng
   *                     }
   *                     neighbourhood {
   *                         id
   *                         name
   *                         city {
   *                             id
   *                             name
   *                             airportCode
   *                             vatPercentage
   *                             country {
   *                                 id
   *                                 name
   *                                 code3
   *                                 code2
   *                                 currency
   *                                 vatPercentage
   *                             }
   *                         }
   *                     }
   *                 }
   *                 highLevelAmenities {
   *                     id
   *                     name
   *                     iconUrl
   *                     contentRendered
   *                 }
   *                 images {
   *                     main {
   *                         url
   *                         webp {
   *                             thumbnailUrl
   *                             mediumUrl
   *                             largeUrl
   *                         }
   *                     }
   *                     all {
   *                         url
   *                         webp {
   *                             thumbnailUrl
   *                             mediumUrl
   *                             largeUrl
   *                         }
   *                         imageType
   *                         displayOrder
   *                         captionRendered
   *                     }
   *                 }
   *             }
   *             location {
   *                 id
   *                 address
   *                 zipCode
   *                 coordinates {
   *                     lat
   *                     lng
   *                 }
   *                 neighbourhood {
   *                     id
   *                     name
   *                     city {
   *                         id
   *                         name
   *                         airportCode
   *                         vatPercentage
   *                         country {
   *                             id
   *                             name
   *                             code3
   *                             code2
   *                             currency
   *                             vatPercentage
   *                         }
   *                     }
   *                 }
   *             }
   *             unitNumber
   *             floorNumber
   *             parkingNumber
   *             listingNameRendered
   *             bedroomCount
   *             bathCount
   *             hasKitchen
   *             sizeSqm
   *             balconySizeSqm
   *             securityDepositAmount
   *             highLevelAmenities {
   *                 id
   *                 name
   *                 iconUrl
   *                 contentRendered
   *             }
   *             images {
   *                 main {
   *                     url
   *                     webp {
   *                         thumbnailUrl
   *                         mediumUrl
   *                         largeUrl
   *                     }
   *                 }
   *                 all {
   *                     url
   *                     webp {
   *                         thumbnailUrl
   *                         mediumUrl
   *                         largeUrl
   *                     }
   *                     imageType
   *                     displayOrder
   *                     captionRendered
   *                 }
   *             }
   *             aboutPropertyRendered
   *             houseRules {
   *                 id
   *                 name
   *                 iconUrl
   *                 contentRendered {
   *                     languageCode
   *                     title
   *                     body
   *                 }
   *             }
   *             furnished {
   *                 bedCount
   *                 maximumGuests
   *                 sleepingArrangement {
   *                     bedroomNumber
   *                     bedTypes
   *                 }
   *                 checkInTime
   *                 checkOutTime
   *             }
   *             quotation {
   *                 paymentPlan {
   *                     singlePayment {
   *                         nights
   *                         nightlyRate
   *                         bookingAmount
   *                         bookingTotal
   *                     }
   *                     grandBookingTotal
   *                     grandTotal
   *                     currency
   *                 }
   *             }
   *         }
   *         contact {
   *             id
   *             firstName
   *             lastName
   *             email
   *             jwtToken
   *             phone {
   *                 code
   *                 number
   *             }
   *             isSubscribedToNewsLetter
   *             birthdate {
   *                 formatted
   *                 raw
   *             }
   *             nationality {
   *                 id
   *                 name
   *             }
   *             documents {
   *                 isMainGuest
   *                 documentStatus
   *                 document {
   *                     id
   *                     documentType
   *                     attachments {
   *                         fileName
   *                         mimeType
   *                         url
   *                     }
   *                     createdAt {
   *                         formatted
   *                         raw
   *                     }
   *                     lastUpdated {
   *                         formatted
   *                         raw
   *                     }
   *                 }
   *                 content {
   *                     firstName
   *                     lastName
   *                     fatherName
   *                     grandfatherName
   *                     documentNumber
   *                     documentVersionNumber
   *                     expiryDate {
   *                         formatted
   *                         raw
   *                     }
   *                     issuingCountry {
   *                         id
   *                         name
   *                     }
   *                     issuingDate {
   *                         formatted
   *                         raw
   *                     }
   *                     issuingPlace
   *                     nationality {
   *                         id
   *                         name
   *                     }
   *                     gender
   *                     birthdate {
   *                         formatted
   *                         raw
   *                     }
   *                     employer
   *                     occupation
   *                     placeOfBirth {
   *                         id
   *                         name
   *                     }
   *                 }
   *             }
   *             createdAt {
   *                 formatted
   *                 raw
   *             }
   *             lastUpdated {
   *                 formatted
   *                 raw
   *             }
   *         }
   *         corporate {
   *             id
   *             legalName
   *         }
   *         payment {
   *             singlePayment {
   *                 reservation {
   *                     id
   *                     confirmationNumber
   *                 }
   *                 extension {
   *                     id
   *                     confirmationNumber
   *                 }
   *                 nights
   *                 nightlyRate
   *                 bookingAmount
   *                 vat {
   *                     percentage
   *                     amount
   *                 }
   *                 fees {
   *                     name
   *                     value
   *                     percentage
   *                 }
   *                 discountAmount
   *                 bookingTotal
   *                 isPaid
   *                 amountPaid
   *                 invoices {
   *                     id
   *                     invoiceNumber
   *                     totalAmount
   *                     dueAmount
   *                     paidAmount
   *                     invoiceType
   *                     status
   *                     paymentMethod
   *                     paidAt {
   *                         formatted
   *                         raw
   *                     }
   *                     breakdown {
   *                         nights
   *                         nightlyRate
   *                         bookingAmount
   *                         vat {
   *                             percentage
   *                             amount
   *                         }
   *                         fees {
   *                             name
   *                             value
   *                             percentage
   *                         }
   *                         discountAmount
   *                         bookingTotal
   *                         otaCommission
   *                         adjustments {
   *                             amount
   *                             details
   *                         }
   *                     }
   *                     reservations {
   *                         id
   *                         confirmationNumber
   *                     }
   *                     extensions {
   *                         id
   *                         confirmationNumber
   *                     }
   *                     currency
   *                     issueDate {
   *                         formatted
   *                         raw
   *                     }
   *                     dueDate {
   *                         formatted
   *                         raw
   *                     }
   *                     totalRefunds
   *                     totalAdjustments
   *                     invoiceItems {
   *                         id
   *                         unitPrice
   *                         quantity
   *                         description
   *                         addOnService {
   *                             id
   *                             name
   *                         }
   *                         damageType {
   *                             id
   *                             name
   *                         }
   *                     }
   *                 }
   *             }
   *             installments {
   *                 isDueNow
   *                 dueOn {
   *                     formatted
   *                     raw
   *                 }
   *                 payments {
   *                     reservation {
   *                         id
   *                         confirmationNumber
   *                     }
   *                     extension {
   *                         id
   *                         confirmationNumber
   *                     }
   *                     nights
   *                     nightlyRate
   *                     bookingAmount
   *                     vat {
   *                         percentage
   *                         amount
   *                     }
   *                     fees {
   *                         name
   *                         value
   *                         percentage
   *                     }
   *                     discountAmount
   *                     bookingTotal
   *                     isPaid
   *                     amountPaid
   *                     invoices {
   *                         id
   *                         invoiceNumber
   *                         totalAmount
   *                         dueAmount
   *                         paidAmount
   *                         invoiceType
   *                         status
   *                         paymentMethod
   *                         paidAt {
   *                             formatted
   *                             raw
   *                         }
   *                         breakdown {
   *                             nights
   *                             nightlyRate
   *                             bookingAmount
   *                             vat {
   *                                 percentage
   *                                 amount
   *                             }
   *                             fees {
   *                                 name
   *                                 value
   *                                 percentage
   *                             }
   *                             discountAmount
   *                             bookingTotal
   *                             otaCommission
   *                             adjustments {
   *                                 amount
   *                                 details
   *                             }
   *                         }
   *                         reservations {
   *                             id
   *                             confirmationNumber
   *                         }
   *                         extensions {
   *                             id
   *                             confirmationNumber
   *                         }
   *                         currency
   *                         issueDate {
   *                             formatted
   *                             raw
   *                         }
   *                         dueDate {
   *                             formatted
   *                             raw
   *                         }
   *                         totalRefunds
   *                         totalAdjustments
   *                         invoiceItems {
   *                             id
   *                             unitPrice
   *                             quantity
   *                             description
   *                             addOnService {
   *                                 id
   *                                 name
   *                             }
   *                             damageType {
   *                                 id
   *                                 name
   *                             }
   *                         }
   *                     }
   *                 }
   *             }
   *             currency
   *             paymentMethods {
   *                 name
   *                 isEnabled
   *             }
   *             securityDeposit {
   *                 totalAmount
   *                 isDueNow
   *                 dueOn {
   *                     formatted
   *                     raw
   *                 }
   *                 damageProtectionPolicyType
   *                 isPaid
   *                 invoice {
   *                     id
   *                     invoiceNumber
   *                     totalAmount
   *                     dueAmount
   *                     paidAmount
   *                     invoiceType
   *                     status
   *                     paymentMethod
   *                     paidAt {
   *                         formatted
   *                         raw
   *                     }
   *                     breakdown {
   *                         nights
   *                         nightlyRate
   *                         bookingAmount
   *                         vat {
   *                             percentage
   *                             amount
   *                         }
   *                         fees {
   *                             name
   *                             value
   *                             percentage
   *                         }
   *                         discountAmount
   *                         bookingTotal
   *                         otaCommission
   *                         adjustments {
   *                             amount
   *                             details
   *                         }
   *                     }
   *                     reservations {
   *                         id
   *                         confirmationNumber
   *                     }
   *                     extensions {
   *                         id
   *                         confirmationNumber
   *                     }
   *                     currency
   *                     issueDate {
   *                         formatted
   *                         raw
   *                     }
   *                     dueDate {
   *                         formatted
   *                         raw
   *                     }
   *                     totalRefunds
   *                     totalAdjustments
   *                     invoiceItems {
   *                         id
   *                         unitPrice
   *                         quantity
   *                         description
   *                         addOnService {
   *                             id
   *                             name
   *                         }
   *                         damageType {
   *                             id
   *                             name
   *                         }
   *                     }
   *                 }
   *             }
   *             isPaid
   *             isBookingWithExtensionsPaid
   *             grandBookingTotal
   *             grandTotal
   *             originalBookingTotal
   *             originalReservationRate
   *         }
   *         isPast
   *         isOngoing
   *         isUpcoming
   *     }
   * }
   * </pre>
   */
  records: Array<ReservationExtension>;
};


/** ReservationExtensionResult */
export type ReservationExtensionResultCountArgs = {
  filter?: InputMaybe<ReservationExtensionFilterInput>;
};


/** ReservationExtensionResult */
export type ReservationExtensionResultRecordsArgs = {
  filter?: InputMaybe<ReservationExtensionFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** ReservationFee */
export type ReservationFee = {
  __typename?: 'ReservationFee';
  /**
   * This convenience field is used only to control the display order of fees in the invoice breakdown.
   * When true, the fee is shown before VAT.
   */
  isTaxable?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  percentage?: Maybe<Scalars['Float']['output']>;
  value: Scalars['Float']['output'];
};

/** ReservationFilterInput */
export type ReservationFilterInput = {
  /** See bookkeepingAccounts query */
  accountIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  bedroomCount?: InputMaybe<Scalars['Int']['input']>;
  bookingDate?: InputMaybe<DateFilterInput>;
  buildingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** see bookingChannels query */
  channelIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  checkInDate?: InputMaybe<DateFilterInput>;
  checkOutDate?: InputMaybe<DateFilterInput>;
  cityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * housekeeping-related filters.
   *
   * cleaningIDs filters both reservations and cleaning records
   */
  cleaningIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** aka packageTypes, see housekeepingServiceTypes query */
  cleaningServiceTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** see config{housekeepingCleaningStatuses} query */
  cleaningStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  /** see housekeepingCleaningTypes query */
  cleaningTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** filter by cleanings count */
  cleaningsCount?: InputMaybe<NumericFilterInput>;
  contactIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  corporateIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * A UUID that links corporate bookings created in bulk during the same session.
   * For example, this can be used to display related corporate bookings when one of them is clicked.
   */
  corporateReservationGroupReference?: InputMaybe<Scalars['String']['input']>;
  countryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** see staff{records} query (unpaginated) */
  createdByIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Filters reservations by currency.
   * See config {currencies}
   */
  currencies?: InputMaybe<Array<Scalars['String']['input']>>;
  /** see config{damageProtectionPolicyTypes} query */
  damageProtectionPolicyTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  discrepancyPercentage?: InputMaybe<NumericFilterInput>;
  /** see config{contactDocumentStatuses} query */
  documentStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  hasExtensions?: InputMaybe<Scalars['Boolean']['input']>;
  /** total invoices created for reservation */
  invoiceCount?: InputMaybe<NumericFilterInput>;
  /**
   * When true, filters by Add-on cleanings that are paid for.
   * When false, filters by Add-on cleanings that are not paid for
   */
  isCleaningPaid?: InputMaybe<Scalars['Boolean']['input']>;
  /** if true, filters by contact bookings only */
  isContactBookings?: InputMaybe<Scalars['Boolean']['input']>;
  /** if true, filters by corporate bookings only */
  isCorporateBookings?: InputMaybe<Scalars['Boolean']['input']>;
  isDamageProtectionCovered?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  /** filters by the payment plan: single or installments */
  isPaidUpfront?: InputMaybe<Scalars['Boolean']['input']>;
  /** see staff{records} query (unpaginated) */
  leadOwnerIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** see config{reservationLeadQualities} query */
  leadQuality?: InputMaybe<Array<Scalars['String']['input']>>;
  /** see leadSources query */
  leadSourceIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  lengthOfStay?: InputMaybe<NumericFilterInput>;
  locationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  neighbourhoodIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** this filter is only usable with the operator value of 'between' */
  overlapDate?: InputMaybe<DateFilterInput>;
  paymentAmount?: InputMaybe<NumericFilterInput>;
  /** total payment collections created for reservation */
  paymentCollectionCount?: InputMaybe<NumericFilterInput>;
  /** see reservationPaymentMethods query, ignore isEnabled for this filter */
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  propertyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** see config{propertyTypes} query */
  propertyTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  reservationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** see config{reservationStatuses} query */
  reservationStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Bookkeeping & invoices related filters */
  totalPaymentDue?: InputMaybe<NumericFilterInput>;
  totalPaymentOverdue?: InputMaybe<NumericFilterInput>;
  totalPaymentReceived?: InputMaybe<NumericFilterInput>;
};

/** ReservationHistoryFilterInput */
export type ReservationHistoryFilterInput = {
  reservationID: Scalars['ID']['input'];
};

/** ReservationIdentityDocumentContent */
export type ReservationIdentityDocumentContent = {
  __typename?: 'ReservationIdentityDocumentContent';
  birthdate?: Maybe<Date>;
  documentNumber?: Maybe<Scalars['String']['output']>;
  documentVersionNumber?: Maybe<Scalars['String']['output']>;
  employer?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Date>;
  fatherName?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** Male or Female */
  gender?: Maybe<Scalars['String']['output']>;
  grandfatherName?: Maybe<Scalars['String']['output']>;
  /** see nationalities query */
  issuingCountry?: Maybe<Nationality>;
  issuingDate?: Maybe<Date>;
  issuingPlace?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** see nationalities query */
  nationality?: Maybe<Nationality>;
  occupation?: Maybe<Scalars['String']['output']>;
  /** see nationalities query */
  placeOfBirth?: Maybe<Nationality>;
};

/** ReservationIdentityDocumentContentInput */
export type ReservationIdentityDocumentContentInput = {
  /** in the format YYYY-MM-DD */
  birthdate?: InputMaybe<Scalars['String']['input']>;
  /** ID / passport number */
  documentNumber: Scalars['String']['input'];
  /** set for manual input only */
  documentVersionNumber?: InputMaybe<Scalars['String']['input']>;
  employer?: InputMaybe<Scalars['String']['input']>;
  /** in the format YYYY-MM-DD */
  expiryDate: Scalars['String']['input'];
  /** set for manual input only */
  fatherName?: InputMaybe<Scalars['String']['input']>;
  /** first/given name */
  firstName: Scalars['String']['input'];
  /** Male or Female */
  gender?: InputMaybe<Scalars['String']['input']>;
  /** set for manual input only */
  grandfatherName?: InputMaybe<Scalars['String']['input']>;
  /** see nationalities query */
  issuingCountryID?: InputMaybe<Scalars['ID']['input']>;
  issuingDate?: InputMaybe<Scalars['String']['input']>;
  issuingPlace?: InputMaybe<Scalars['String']['input']>;
  /** family/surname */
  lastName: Scalars['String']['input'];
  /** see nationalities query */
  nationalityID?: InputMaybe<Scalars['ID']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
  /** see nationalities query */
  placeOfBirthID?: InputMaybe<Scalars['ID']['input']>;
};

/** ReservationNotePayloadInput */
export type ReservationNotePayloadInput = {
  note: NotePayloadInput;
  reservationID: Scalars['ID']['input'];
};

/** ReservationPayloadInput */
export type ReservationPayloadInput = {
  /**
   * Set specifically for bank transfers, if this payment method isn't enabled by default & it gets enabled as an override.
   * If enabled, we'll send out the check-in instructions even if the payment isn't received.
   */
  allowSendingCheckInInstructionsWithoutPayment?: InputMaybe<Scalars['Boolean']['input']>;
  /** if this is a corporate booking */
  corporateID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * For corporate bookings only, if true, then corporate pays for the security deposit on behalf of all contacts & the point of contact gets one check-link to pay for the booking & the SD.
   * If false, then the point of contact pays for the booking only, and each contact gets a separate link to pay for the security deposit.
   */
  corporatePaysForTheSecurityDeposit?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * One entry for contacts.
   * One or more entries for corporates.
   * One entry only on edit, regardless if contact or corporate.
   */
  entries: Array<ReservationEntryInput>;
  /**
   * In the format YYYY-MM-DD HH:mm:ss.
   * This is required if sendInvitationToBook is true.
   */
  invitationExpiry?: InputMaybe<Scalars['String']['input']>;
  /**
   * For corporate bookings only, if true, then the point of contact uploads IDs of all contacts.
   * If false, each contact gets a separate link to upload their IDs.
   */
  isCorporatePocResponsibleForIDSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  /** true if payment is paid upfront, false for installments */
  isPaidUpfront: Scalars['Boolean']['input'];
  /** notes on the lead */
  leadDetails?: InputMaybe<Scalars['String']['input']>;
  /** the staff member assigned as the lead owner */
  leadOwnerID?: InputMaybe<Scalars['ID']['input']>;
  /** see config{reservationLeadQualities} query */
  leadQuality?: InputMaybe<Scalars['String']['input']>;
  /** see leadSources query */
  leadSourceID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * List of payment methods, only set if values were overridden by the staff.
   * See paymentMethods in the response of reservationQuotation query.
   */
  paymentMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  /** this is set if paymentMethods were overridden by the staff */
  paymentMethodsOverrideReason?: InputMaybe<Scalars['String']['input']>;
  /** this is required if corporateID is set */
  pointOfContactID?: InputMaybe<Scalars['ID']['input']>;
  rentalAgreement?: InputMaybe<AttachmentInput>;
  /** set this to true to send an invitation to the guest, leave it to false to create a lead or to save the booking on edit without sending an invitation */
  sendInvitationToBook: Scalars['Boolean']['input'];
};

/** ReservationPayment */
export type ReservationPayment = {
  __typename?: 'ReservationPayment';
  /** total amount paid, sum of all paid invoices */
  amountPaid?: Maybe<Scalars['Float']['output']>;
  /** nights * nightlyRate */
  bookingAmount?: Maybe<Scalars['Float']['output']>;
  /** bookingAmount + vat + fees - discountAmount */
  bookingTotal: Scalars['Float']['output'];
  discountAmount?: Maybe<Scalars['Float']['output']>;
  discountReason?: Maybe<Scalars['String']['output']>;
  /** available fields: id, checkInDate, checkOutDate */
  extension?: Maybe<ReservationExtension>;
  fees?: Maybe<Array<ReservationFee>>;
  invoices?: Maybe<Array<Invoice>>;
  /** this is true when all invoices are paid, or when the booking is a free-stay (zero amount, e.g. for influencers) */
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  nightlyRate?: Maybe<Scalars['Float']['output']>;
  /**
   * This is used to calculate the payable corporate reservation amount based on the number of reservation days overlapping the installment month.
   * For example, if a reservation spans 20 days in May, then the payment for this reservation in May (not counting other reservations) is 20 * nightly_rate.
   * If this record isn't for a corporate installment, then nights is equal to the check-in & check-out dates of the full reservation.
   */
  nights?: Maybe<Scalars['Int']['output']>;
  /** available fields: id, confirmationNumber, checkInDate, checkOutDate, extendedCheckOutDate */
  reservation?: Maybe<Reservation>;
  vat?: Maybe<PaymentVat>;
};

/** ReservationPaymentInstallment */
export type ReservationPaymentInstallment = {
  __typename?: 'ReservationPaymentInstallment';
  /**
   * Payment due date.
   *
   * Note: whenever isDueNow is true, get today's date from the browser to take the contact's timezone into account.
   * dueOn is sent from the backend in UTC, so for example, Jun 10th at 11 PM UTC should be displayed as Jun 11th in Dubai.
   *
   * If isDueNow is false, you can safely use dueOn as is.
   */
  dueOn: Date;
  isDueNow?: Maybe<Scalars['Boolean']['output']>;
  /** This is one record only for now, but in case we support partial payments in the future */
  payments: Array<ReservationPayment>;
};

/** ReservationPaymentMethod */
export type ReservationPaymentMethod = {
  __typename?: 'ReservationPaymentMethod';
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Examples of online payment methods: Credit Card, Cryptocurrency.
   * Offline payment methods: Cash, Cheques.
   */
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

/** ReservationPaymentMethodFilterInput */
export type ReservationPaymentMethodFilterInput = {
  /** in the format YYYY-MM-DD */
  checkInDate?: InputMaybe<Scalars['String']['input']>;
  /** in the format YYYY-MM-DD */
  checkOutDate?: InputMaybe<Scalars['String']['input']>;
  /**
   * Set to true to get online payment methods: e.g. Credit Card, Cryptocurrency.
   * Set to false to get offline payment methods: e.g. Cash.
   */
  isOnline?: InputMaybe<Scalars['Boolean']['input']>;
  propertyID?: InputMaybe<Scalars['ID']['input']>;
};

/** ReservationPaymentPlan */
export type ReservationPaymentPlan = {
  __typename?: 'ReservationPaymentPlan';
  currency: Scalars['String']['output'];
  /**
   * The sum of all amounts in singlePayment or installments excluding the security deposit, use this to display the reservation total.
   * This includes the VAT & booking / extension fees, and for reservations, it includes the sum of all booking extensions.
   *
   * For extensions, it's the extension total including the VAT & fees.
   *
   * If a discount is set, this value is already discounted.
   */
  grandBookingTotal: Scalars['Float']['output'];
  /**
   * grandTotal = grandBookingTotal + securityDeposit (if applicable).
   *
   * For extensions, this amount is equal to the grandBookingTotal.
   */
  grandTotal: Scalars['Float']['output'];
  /**
   * For quotations, installments is only set if applicable for contacts or corporates.
   *
   * For existing reservations, installments is only set if it's the active payment plan.
   *
   * For bookings that have extensions, this array includes the installments of both the original booking and the extensions.
   */
  installments?: Maybe<Array<ReservationPaymentInstallment>>;
  /**
   * If booking & all of its extensions are paid, not accounting for the security deposit.
   * For installments, this reflects the payment status of the due / last installment.
   * This value is null for extensions.
   *
   * This is a convenience field for the isPaid field in ReservationPayment.
   */
  isBookingWithExtensionsPaid?: Maybe<Scalars['Boolean']['output']>;
  /**
   * If booking or extension is paid.
   * For bookings, this doesn't account for extensions or security deposit.
   * For installments, this reflects the payment status of the due / last installment.
   *
   * This is a convenience field for the isPaid field in ReservationPayment.
   */
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  /**
   * For reservations, this is grandBookingTotal - sum of all booking extensions.
   * For quotations & extensions, this value is null.
   */
  originalBookingTotal?: Maybe<Scalars['Float']['output']>;
  /** this is set when requesting a quotation and the isExtension flag is true, or when fetching an extension that was created using the original reservation rate */
  originalReservationRate?: Maybe<Scalars['Float']['output']>;
  /**
   * List of payment methods accepted for this reservation or extension based on the lead time, duration or other factors.
   * The accepted methods have isEnabled set to true.
   */
  paymentMethods: Array<ReservationPaymentMethod>;
  /** this is set if paymentMethods were overridden by the staff */
  paymentMethodsOverrideReason?: Maybe<Scalars['String']['output']>;
  /**
   * The security deposit if applicable for booking or extension. The isPaid & other related fields are unset for quotations.
   *
   * For extensions, security deposit is set if extending the stay triggers a change in the damage protection policy.
   * For example, on a short booking the policy is "Not required" then extending the stay changes the type to require a card on file or an amount to be paid.
   *
   * For corporate installments, the immediately due payment may be the security deposit only, or the deposit with the first installment.
   * If both the security deposit and the first installment are due now, then the deposit may be charged in the same transaction or a separate one.
   * See isDueNow & isInSameTransaction in DamageProtectionPolicyPayment.
   */
  securityDeposit?: Maybe<DamageProtectionPolicyPayment>;
  /**
   * For quotations, singlePayment is always populated.
   *
   * For existing reservations, singlePayment is only set if it's the active payment plan.
   *
   * For bookings that have extensions, the first record in this array is the original booking payment, then an entry for each extension's payment.
   */
  singlePayment?: Maybe<Array<ReservationPayment>>;
};

/** ReservationProgress */
export type ReservationProgress = {
  __typename?: 'ReservationProgress';
  /** if step is completed, map step to corresponding objects in Reservation to access more info */
  isCompleted: Scalars['Boolean']['output'];
  /**
   * If the step is overdue and should be highlighted for attention.
   * For example, Nest sets this to true if the reservation is checking in soon while the payment or SD are pending.
   */
  requiresReview?: Maybe<Scalars['Boolean']['output']>;
  stage: ReservationProgressStage;
  step: ReservationProgressStep;
};

/** ReservationProgressStage */
export enum ReservationProgressStage {
  CheckIn = 'checkIn',
  CheckOut = 'checkOut',
  PreArrival = 'preArrival'
}

/** ReservationProgressStep */
export enum ReservationProgressStep {
  /**
   * Aka invitationToBook, Nest sets this step as completed when successfully delivering the booking-invitation / booking-completion link to the contact.
   *
   * The link is sent to direct-contact bookings on invitations or to OTA bookings when a requirement is unmet (e.g. payment).
   *
   * See sendReservationCompletionLink mutation to manually send this link in the reservation progress view or in the reservation corporate tab.
   *
   * To get the link that was generated (e.g. to copy to clipboard), first look for the value of corporateContactOwnBookingCompletionLink field and use that if set, else use bookingCompletionLink.
   *
   * See BookingCompletionLink to access additional info.
   */
  BookingCompletionLink = 'bookingCompletionLink',
  /**
   * On Pre-Arrival, see checkInInstructions.
   *
   * To copy the check-in instructions, use checkInInstructions.content (if set).
   *
   * To send the check-in instructions, use sendReservationCheckInInstructions mutation.
   */
  CheckInInstructions = 'checkInInstructions',
  /**
   * on Check-Out, see CheckOutInstructions.
   *
   * To copy the check-out instructions, use checkOutInstructions.content (if set).
   *
   * To send the check-out instructions, use sendReservationCheckOutInstructions mutation.
   */
  CheckOutInstructions = 'checkOutInstructions',
  /**
   * On Pre-Arrival, see damageProtectionPolicyType and isPaid fields in DamageProtectionPolicyPayment under ReservationPaymentPlan.
   *
   * Display the invoice info if invoice in DamageProtectionPolicyPayment is set.
   *
   * To display the responsibility field for corporate bookings, see corporatePaysForTheSecurityDeposit in DamageProtectionPolicyPayment.
   */
  DamageProtection = 'damageProtection',
  /**
   * On Pre-Arrival, Nest sets this step as completed if all documents are approved and the documents count matches numberOfGuests.
   *
   * Set the number of verified guests as {documents count where documentStatus = Approved} of {numberOfGuests}.
   *
   * To display the responsibility field for corporate bookings, see isCorporatePocResponsibleForIDSubmission.
   *
   * See ReservationDocument to access additional info.
   */
  DocumentSubmission = 'documentSubmission',
  /**
   * On Check-In, this is set for reservations that have extensions.
   *
   * Extensions can also be paid upfront or via installments. The logic here is equivalent to upfrontPayment and installmentPayment steps used for reservations.
   *
   * The reservation payment records include extension payments as well, whether they're paid upfront or via installments, look for records where the extension field in ReservationPayment is set.
   */
  ExtensionPayment = 'extensionPayment',
  /**
   * On Check-In, see ReservationCheckInStatus.
   *
   * To manually set the check-in status, use setGuestCheckedInToProperty mutation.
   */
  GuestCheckIn = 'guestCheckIn',
  /**
   * On Check-In, this is set for installment plans only.
   *
   * Nest sets this as completed if the due installment is paid for, and updates status when the next installment is due.
   *
   * To find this installment, look for the last installment in ReservationPaymentPlan where isDueNow is true.
   */
  InstallmentPayment = 'installmentPayment',
  /** on Pre-Arrival, see SmartLockPasscode */
  Passcode = 'passcode',
  /**
   * On Check-Out, see DamageProtectionPolicyPayment in ReservationPaymentPlan.
   *
   * Check if an invoice is set in DamageProtectionPolicyPayment and display its info.
   *
   * This step is eliminated when the policy type is not "Security deposit (capture)".
   */
  SecurityDepositRefund = 'securityDepositRefund',
  /**
   * On Pre-Arrival, this is applicable to both single payment & installment plans.
   *
   * Check singlePayment and installments fields in ReservationPaymentPlan to know the payment plan.
   *
   * This reflects the payment status of the reservation's upfront payment only, and does not account for extensions or the security deposit.
   *
   * Nest sets this as completed if the upfront payment is completed (for both payment plans).
   *
   * To display relevant invoices, look for invoices in all payment records of singlePayment or all payment records of the first installment.
   *
   * You do not need to check invoice status individually as the overall status is reflected in the isCompleted flag.
   */
  UpfrontPayment = 'upfrontPayment'
}

/** ReservationQuotation */
export type ReservationQuotation = {
  __typename?: 'ReservationQuotation';
  /** error fields set when encountering quotation errors, this is either null or true */
  isDaysUnavailable?: Maybe<Scalars['Boolean']['output']>;
  isDiscountInvalid?: Maybe<Scalars['Boolean']['output']>;
  isLengthOfStayViolated?: Maybe<Scalars['Boolean']['output']>;
  paymentPlan?: Maybe<ReservationPaymentPlan>;
};

/** ReservationQuotationInput */
export type ReservationQuotationInput = {
  /** in the format YYYY-MM-DD */
  checkInDate: Scalars['String']['input'];
  /** in the format YYYY-MM-DD */
  checkOutDate: Scalars['String']['input'];
  /**
   * If contactID is available at the time of generating the quotation.
   * Must be set if corporateID is set.
   */
  contactID?: InputMaybe<Scalars['ID']['input']>;
  /** if generating a corporate quotation */
  corporateID?: InputMaybe<Scalars['ID']['input']>;
  /** when overriding the default policy type, see damageProtectionPolicyType in DamageProtectionPolicyPayment */
  damageProtectionPolicyType?: InputMaybe<Scalars['String']['input']>;
  /** discount amount set on quotation, if any */
  discountAmount?: InputMaybe<Scalars['Float']['input']>;
  /** set this id when editing lead extensions */
  extensionID?: InputMaybe<Scalars['ID']['input']>;
  /** if this quotation is for an extension */
  isExtension?: InputMaybe<Scalars['Boolean']['input']>;
  propertyID?: InputMaybe<Scalars['ID']['input']>;
  /** this is required if isExtension is true */
  reservationID?: InputMaybe<Scalars['ID']['input']>;
  /** when overriding the security deposit amount */
  securityDepositAmount?: InputMaybe<Scalars['Float']['input']>;
  /** if we should use the original reservation rate, if isExtension is true */
  useOriginalReservationRate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** ReservationResult */
export type ReservationResult = {
  __typename?: 'ReservationResult';
  /** Records count */
  count: Scalars['Int']['output'];
  /**
   * Exports to Excel.
   *
   * Pass the active ReservationFilterInput that's applied to the grid, if any to get the same records.
   *
   * Also send the active sort criteria that's applied on the grid through options.sort. Pagination is ignored here.
   *
   * The columns field is the enabled columns on the grid, in order of display as customized by the staff or the default grid columns if not customized.
   *
   * This is fetched from the query columnDisplayCustomizationOptions for the page route.
   *
   * The reason we take a direct columns array instead of route, is that there could be no previous customization by the staff but the default grid display hides a few auxiliary columns and the Excel export needs to match that.
   *
   * The exportable columns are limited to the options below and need to match each one exactly (case sensitive):
   *
   * <pre>
   *     Contact Name
   *     Corporate
   *     Reservation ID
   *     Property
   *     Reservation Status
   *     Check-In
   *     Check-Out
   *     Nights
   *     Currency
   *     Amount
   *     Payment Status
   *     Payment Plan
   *     Building
   *     Channel
   *     Damage Protection Status
   *     Damage Protection Policy
   *     Security Deposit Amount
   *     Lead Owner
   *     Lead Quality
   *     Lead Source
   *     Rental Agreement
   *     Number of Cleanings
   *     Account
   *     Invoices
   *     Pending Balance
   *     Overdue Balance
   *     Created By
   *     Booking Date
   *     Last Updated
   * </pre>
   *
   * Legacy field names are also accepted for backward compatibility and are normalized to the current field names above:
   *
   * <pre>
   *     Status
   *     Damage Protection
   *     Invoices (Paid / Total)
   *     Pending Invoices Balance
   *     Overdue Invoices Balance
   * </pre>
   */
  export: Scalars['String']['output'];
  /** Fetches the history of a reservation */
  history: Array<ResourceHistory>;
  /**
   * To fetch all reservations without pagination, when populating dropdowns for instance, create a dedicated GraphQL file with this field selection:
   *
   * <pre>
   * reservations {
   *     result: records(filter: $filter, options: $options) {
   *         id
   *         confirmationNumber
   *         status
   *         numberOfGuests
   *         property {
   *             id
   *             internalName
   *         }
   *         contact {
   *             id
   *             firstName
   *             lastName
   *             email
   *             contactType
   *         }
   *         corporate {
   *             id
   *             internalName
   *             legalName
   *         }
   *         channel {
   *             id
   *             name
   *         }
   *         checkInDate
   *         checkOutDate
   *         checkInTime
   *         checkOutTime
   *         nights
   *     }
   * }
   * </pre>
   *
   * When this exact field selection is detected, the server runs a faster query that returns all data without pagination.
   *
   * All fields of ReservationFilterInput are still applicable with the exception of "search" and housekeeping-related filters. CommonQueryOptionsInput is ignored here.
   *
   * The list of supported sort criteria in options.sort:
   *
   * <pre>
   *     Contact Name
   *     Contact Name desc
   *     Reservation ID
   *     Reservation ID desc
   *     Property
   *     Property desc
   *     Status
   *     Status desc
   *     Check-In
   *     Check-In desc
   *     Check-Out
   *     Check-Out desc
   *     Nights
   *     Nights desc
   *     Amount
   *     Amount desc
   *     Payment Status
   *     Payment Status desc
   *     Payment Plan
   *     Payment Plan desc
   *     Building
   *     Building desc
   *     Channel
   *     Channel desc
   *     Damage Protection
   *     Damage Protection desc
   *     Lead Owner
   *     Lead Owner desc
   *     Lead Quality
   *     Lead Quality desc
   *     Lead Source
   *     Lead Source desc
   *     Created By
   *     Created By desc
   *     Booking Date
   *     Booking Date desc
   *     Number of Cleanings
   *     Number of Cleanings desc
   *     Account
   *     Account desc
   *     Pending Invoices Balance
   *     Pending Invoices Balance desc
   *     Overdue Invoices Balance
   *     Overdue Invoices Balance desc
   *     Last Updated
   *     Last Updated desc
   * </pre>
   *
   * Here is the allowed field selection on the Reservation type, anonymously or as a contact:
   *
   * <pre>
   * reservations {
   *     result: records(filter: $filter, options: $options) {
   *         id
   *         confirmationNumber
   *         status
   *         numberOfGuests
   *         progress {
   *             stage
   *             step
   *             isCompleted
   *         }
   *         checkInDate {
   *             formatted
   *             raw
   *         }
   *         checkOutDate {
   *             formatted
   *             raw
   *         }
   *         extendedCheckOutDate {
   *             formatted
   *             raw
   *         }
   *         checkInTime
   *         estimatedArrivalTime
   *         checkOutTime
   *         nights
   *         isUpcoming
   *         isOngoing
   *         isPast
   *         specialRequests
   *         bookingCompletion {
   *             bookingCompletionLink
   *             corporateContactOwnBookingCompletionLink
   *         }
   *         property {
   *             id
   *             parentID
   *             listingNameRendered
   *             images {
   *                 main {
   *                     url
   *                     webp {
   *                         thumbnailUrl
   *                         mediumUrl
   *                         largeUrl
   *                     }
   *                 }
   *             }
   *         }
   *         building {
   *             id
   *         }
   *         contact {
   *             id
   *             firstName
   *             lastName
   *             email
   *             phone {
   *                 code
   *                 number
   *             }
   *             birthdate {
   *                 formatted
   *                 raw
   *             }
   *         }
   *         pointOfContact {
   *             id
   *             firstName
   *             lastName
   *             email
   *         }
   *         corporate {
   *             id
   *             legalName
   *         }
   *         documents {
   *             isMainGuest
   *             documentStatus
   *             document {
   *                 id
   *                 documentType
   *                 attachments {
   *                     fileName
   *                     mimeType
   *                     url
   *                 }
   *                 createdAt {
   *                     formatted
   *                     raw
   *                 }
   *                 lastUpdated {
   *                     formatted
   *                     raw
   *                 }
   *             }
   *             content {
   *                 firstName
   *                 lastName
   *                 fatherName
   *                 grandfatherName
   *                 documentNumber
   *                 documentVersionNumber
   *                 expiryDate {
   *                     formatted
   *                     raw
   *                 }
   *                 issuingCountry {
   *                     id
   *                     name
   *                 }
   *                 issuingDate {
   *                     formatted
   *                     raw
   *                 }
   *                 issuingPlace
   *                 nationality {
   *                     id
   *                     name
   *                 }
   *                 gender
   *                 birthdate {
   *                     formatted
   *                     raw
   *                 }
   *                 employer
   *                 occupation
   *                 placeOfBirth {
   *                     id
   *                     name
   *                 }
   *             }
   *         }
   *         payment {
   *             singlePayment {
   *                 reservation {
   *                     id
   *                     confirmationNumber
   *                 }
   *                 extension {
   *                     id
   *                 }
   *                 nights
   *                 nightlyRate
   *                 bookingAmount
   *                 vat {
   *                     percentage
   *                     amount
   *                 }
   *                 fees {
   *                     name
   *                     value
   *                     percentage
   *                 }
   *                 discountAmount
   *                 bookingTotal
   *                 isPaid
   *                 amountPaid
   *                 invoices {
   *                     id
   *                     invoiceNumber
   *                     totalAmount
   *                     dueAmount
   *                     paidAmount
   *                     status
   *                     paymentMethod
   *                     paidAt {
   *                         formatted
   *                         raw
   *                     }
   *                     currency
   *                     issueDate {
   *                         formatted
   *                         raw
   *                     }
   *                     dueDate {
   *                         formatted
   *                         raw
   *                     }
   *                     totalRefunds
   *                     totalAdjustments
   *                 }
   *             }
   *             installments {
   *                 isDueNow
   *                 dueOn {
   *                     formatted
   *                     raw
   *                 }
   *                 payments {
   *                     reservation {
   *                         id
   *                         confirmationNumber
   *                     }
   *                     extension {
   *                         id
   *                     }
   *                     nights
   *                     nightlyRate
   *                     bookingAmount
   *                     vat {
   *                         percentage
   *                         amount
   *                     }
   *                     fees {
   *                         name
   *                         value
   *                         percentage
   *                     }
   *                     discountAmount
   *                     bookingTotal
   *                     isPaid
   *                     amountPaid
   *                     invoices {
   *                         id
   *                         invoiceNumber
   *                         totalAmount
   *                         dueAmount
   *                         paidAmount
   *                         status
   *                         paymentMethod
   *                         paidAt {
   *                             formatted
   *                             raw
   *                         }
   *                         currency
   *                         issueDate {
   *                             formatted
   *                             raw
   *                         }
   *                         dueDate {
   *                             formatted
   *                             raw
   *                         }
   *                         totalRefunds
   *                         totalAdjustments
   *                     }
   *                 }
   *             }
   *             currency
   *             paymentMethods {
   *                 name
   *                 isEnabled
   *                 isOnline
   *             }
   *             securityDeposit {
   *                 totalAmount
   *                 isDueNow
   *                 dueOn {
   *                     formatted
   *                     raw
   *                 }
   *                 damageProtectionPolicyType
   *                 isPaid
   *                 invoice {
   *                     id
   *                     invoiceNumber
   *                     totalAmount
   *                     dueAmount
   *                     paidAmount
   *                     status
   *                     paymentMethod
   *                     paidAt {
   *                         formatted
   *                         raw
   *                     }
   *                     currency
   *                     issueDate {
   *                         formatted
   *                         raw
   *                     }
   *                     dueDate {
   *                         formatted
   *                         raw
   *                     }
   *                     totalRefunds
   *                     totalAdjustments
   *                 }
   *             }
   *             isPaid
   *             isBookingWithExtensionsPaid
   *             grandBookingTotal
   *             grandTotal
   *             originalBookingTotal
   *         }
   *         channel {
   *             id
   *             name
   *         }
   *         passcode {
   *             code
   *         }
   *         checkInInstructions {
   *             contentRendered
   *         }
   *         checkOutInstructions {
   *             contentRendered
   *         }
   *         invoices {
   *             id
   *             invoiceNumber
   *             totalAmount
   *             dueAmount
   *             paidAmount
   *             invoiceType
   *             status
   *             paidAt {
   *                 formatted
   *                 raw
   *             }
   *             breakdown {
   *                 nights
   *                 nightlyRate
   *                 bookingAmount
   *                 vat {
   *                     percentage
   *                     amount
   *                 }
   *                 fees {
   *                     name
   *                     value
   *                     percentage
   *                 }
   *                 discountAmount
   *                 bookingTotal
   *                 otaCommission
   *                 adjustments {
   *                     amount
   *                     details
   *                 }
   *             }
   *             reservations {
   *                 id
   *                 confirmationNumber
   *             }
   *             extensions {
   *                 id
   *                 confirmationNumber
   *             }
   *             currency
   *             issueDate {
   *                 formatted
   *                 raw
   *             }
   *             dueDate {
   *                 formatted
   *                 raw
   *             }
   *             totalRefunds
   *             totalAdjustments
   *         }
   *         createdAt {
   *             formatted
   *             raw
   *         }
   *     }
   * }
   * </pre>
   */
  records: Array<Reservation>;
};


/** ReservationResult */
export type ReservationResultCountArgs = {
  filter?: InputMaybe<ReservationFilterInput>;
};


/** ReservationResult */
export type ReservationResultExportArgs = {
  columns: Array<Scalars['String']['input']>;
  filter?: InputMaybe<ReservationFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};


/** ReservationResult */
export type ReservationResultHistoryArgs = {
  filter: ReservationHistoryFilterInput;
};


/** ReservationResult */
export type ReservationResultRecordsArgs = {
  filter?: InputMaybe<ReservationFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** ReservationSpecialRequestsPayloadInput */
export type ReservationSpecialRequestsPayloadInput = {
  /**
   * This is required when sent by contacts, cannot be provided otherwise.
   * This must be the BR code for a contact reservation (corporate or regular contact), and cannot be the POC code or a code that's associated with an extension.
   */
  brCode?: InputMaybe<Scalars['String']['input']>;
  /** this is required when sent by staff, cannot be provided otherwise */
  reservationID?: InputMaybe<Scalars['ID']['input']>;
  /** to clear existing special requests, send this value as null */
  specialRequests?: InputMaybe<Scalars['String']['input']>;
};

/** ResourceHistory */
export type ResourceHistory = {
  __typename?: 'ResourceHistory';
  /** description of the action */
  action: Scalars['String']['output'];
  createdAt: DateTime;
  id: Scalars['ID']['output'];
  /**
   * Available fields: id, firstName, lastName, email.
   * This is unset for system-initiated actions
   */
  initiator?: Maybe<Staff>;
  /** JSON payload */
  payload?: Maybe<Scalars['String']['output']>;
};

/** SettingResult */
export type SettingResult = {
  __typename?: 'SettingResult';
  /** Mute settings for staff notification channels */
  staffNotificationChannels: StaffNotificationChannel;
  /** Staff notification types and their delivery preferences */
  staffNotificationTypes: Array<StaffNotificationType>;
};

/** SettingsPayloadInput */
export type SettingsPayloadInput = {
  /** Sets mute settings for staff notification channels */
  staffNotificationChannels?: InputMaybe<StaffNotificationChannelInput>;
  /** Sets staff notification types and their delivery preferences */
  staffNotificationTypes?: InputMaybe<Array<StaffNotificationTypeInput>>;
};

/** SetupSmartLockPayloadInput */
export type SetupSmartLockPayloadInput = {
  lockID: Scalars['ID']['input'];
  propertyID: Scalars['ID']['input'];
};

/** SmartLock */
export type SmartLock = {
  __typename?: 'SmartLock';
  alias?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isOnline?: Maybe<Scalars['Boolean']['output']>;
  mac?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  timezone?: Maybe<Scalars['String']['output']>;
};

/** SmartLockEntryLog */
export type SmartLockEntryLog = {
  __typename?: 'SmartLockEntryLog';
  /** the username that performed this action as recorded in the lock, e.g. Nest, Cleaners, etc. */
  accountName?: Maybe<Scalars['String']['output']>;
  /** passcode digits entered if applicable for the record type. Use this to display inserted-passcode when present */
  code?: Maybe<Scalars['String']['output']>;
  /** the time this event happened, either as retrieved from the lock or locally when unlocking through Nest */
  createdAt?: Maybe<DateTime>;
  id: Scalars['ID']['output'];
  /** if the operation was successful */
  isSuccessful?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The type of record (aka. unlock method).
   *
   * This is the list of valid types at this time:
   *
   * App unlock
   * Touch the parking lock
   * Gateway unlock
   * Passcode unlock
   * Parking lock raise
   * Parking lock lower
   * IC card unlock
   * Fingerprint unlock
   * Wristband unlock
   * Mechanical key unlock
   * Bluetooth lock
   * Gateway lock/unlock
   * Unexpected unlock
   * Door magnet close
   * Door magnet open
   * Open from inside
   * Lock by fingerprint
   * Lock by passcode
   * Lock by IC card
   * Lock by mechanical key
   * Remote control
   * Tamper alert
   * Auto lock
   * Unlock by “unlock” key
   * Lock by “lock” key
   * Invalid passcode tried repeatedly
   */
  recordType?: Maybe<Scalars['String']['output']>;
  /** this is the unlock-reason recorded if the lock was unlocked through Nest */
  unlockReason?: Maybe<Scalars['String']['output']>;
};

/** SmartLockEntryLogFilterInput */
export type SmartLockEntryLogFilterInput = {
  lockID: Scalars['ID']['input'];
};

/** SmartLockPasscode */
export type SmartLockPasscode = {
  __typename?: 'SmartLockPasscode';
  /** the 4 or 8-digit passcode, this is null for scheduled entries */
  code?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<DateTime>;
  id: Scalars['ID']['output'];
  /** available fields: id, confirmationNumber, contact{id, firstName, lastName}, checkInDate, checkOutDate, extendedCheckOutDate, checkInTime, checkOutTime */
  reservation?: Maybe<Reservation>;
  /** if status is scheduled */
  scheduledFor?: Maybe<DateTime>;
  /** validity range of the passcode */
  startTime?: Maybe<DateTime>;
  status?: Maybe<SmartLockPasscodeStatus>;
};

/** SmartLockPasscodeFilterInput */
export type SmartLockPasscodeFilterInput = {
  lockID: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SmartLockPasscodeStatus>>;
};

/** SmartLockPasscodeResult */
export type SmartLockPasscodeResult = {
  __typename?: 'SmartLockPasscodeResult';
  /** Records count */
  count: Scalars['Int']['output'];
  /** List of passcodes */
  records: Array<SmartLockPasscode>;
};


/** SmartLockPasscodeResult */
export type SmartLockPasscodeResultCountArgs = {
  filter: SmartLockPasscodeFilterInput;
};


/** SmartLockPasscodeResult */
export type SmartLockPasscodeResultRecordsArgs = {
  filter: SmartLockPasscodeFilterInput;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** SmartLockPasscodeStatus */
export enum SmartLockPasscodeStatus {
  Active = 'active',
  Inactive = 'inactive',
  Scheduled = 'scheduled'
}

/** SmartLocksFilterInput */
export type SmartLocksFilterInput = {
  /** if the lock is mapped to a property */
  isMapped?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Staff */
export type Staff = {
  __typename?: 'Staff';
  /**
   * Buildings assigned to this staff.
   *
   * Available fields: id, internalName
   */
  buildings?: Maybe<Array<Building>>;
  /** cities staff is permitted to view, this includes the fields: id, name and airportCode */
  cities?: Maybe<Array<City>>;
  createdAt?: Maybe<DateTime>;
  createdBy?: Maybe<Staff>;
  departments?: Maybe<Array<StaffDepartment>>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** if staff is active and can sign-in */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** JWT token is returned on sign-in */
  jwtToken?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  lastSignIn?: Maybe<DateTime>;
  lastUpdated?: Maybe<DateTime>;
  /** permissions assigned to staff */
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  picture?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
};

/** StaffDepartment */
export type StaffDepartment = {
  __typename?: 'StaffDepartment';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** default permissions for department, used as a template to autofill permissions when creating staff of the same department in React */
  permissions?: Maybe<Array<Scalars['String']['output']>>;
};

/** StaffFilterInput */
export type StaffFilterInput = {
  cityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  departmentIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Applies filter by department names.
   *
   * For example, to fetch list of lead owners in reservations, set this to ['Sales', 'Reservations', 'Front Desk']
   */
  departmentNames?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filters by staff who have all of the specified permissions.
   * See config{staffPermissions} query
   */
  hasAllPermissions?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filters by staff who have any of the specified permissions.
   * See config{staffPermissions} query
   */
  hasAnyPermissions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** when null fetches all, when false or true fetches inactive or active respectively */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  staffIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** StaffNotificationChannel */
export type StaffNotificationChannel = {
  __typename?: 'StaffNotificationChannel';
  isEmailMuted: Scalars['Boolean']['output'];
  isGoogleChatMuted: Scalars['Boolean']['output'];
};

/** StaffNotificationChannelInput */
export type StaffNotificationChannelInput = {
  isEmailMuted: Scalars['Boolean']['input'];
  isGoogleChatMuted: Scalars['Boolean']['input'];
};

/** StaffNotificationType */
export type StaffNotificationType = {
  __typename?: 'StaffNotificationType';
  /** category to group notification types by */
  category: Scalars['String']['output'];
  /** event key that can be used to build notification page routing on the FE, see notifications{records} query */
  eventKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEmailEnabled: Scalars['Boolean']['output'];
  isGoogleChatEnabled: Scalars['Boolean']['output'];
  notificationType: Scalars['String']['output'];
};

/** StaffNotificationTypeInput */
export type StaffNotificationTypeInput = {
  id: Scalars['ID']['input'];
  isEmailEnabled: Scalars['Boolean']['input'];
  isGoogleChatEnabled: Scalars['Boolean']['input'];
};

/** StaffPayloadInput */
export type StaffPayloadInput = {
  /**
   * Buildings this staff is permitted to view, if they are not allowed to view all buildings by default.
   *
   * To get the list of buildings to select from, fetch the buildings{records} query without pagination (using the preset field selection).
   */
  buildingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** cities this staff is permitted to view, see cities query */
  cityIDs: Array<Scalars['ID']['input']>;
  /** see staffDepartments query */
  departmentIDs: Array<Scalars['ID']['input']>;
  /** must be a Stella Stays email */
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /**
   * See config{staffPermissions} query.
   *
   * The role-assignment tool in React must auto assign permissions as below:
   *
   * - auto assign *-viewer if *-editor is set
   * - auto assign *-viewer & *-editor if *-admin is set
   *
   * For example, selecting buildings-editor automatically assigns buildings-viewer.
   */
  permissions: Array<Scalars['String']['input']>;
  /** the timezone where staff operates, see config{timezones} query */
  timezone: Scalars['String']['input'];
};

/** StaffResult */
export type StaffResult = {
  __typename?: 'StaffResult';
  /** Records count */
  count: Scalars['Int']['output'];
  /**
   * Exports to Excel.
   *
   * Pass the active StaffFilterInput that's applied to the grid, if any to get the same records.
   *
   * Also send the active sort criteria that's applied on the grid through options.sort. Pagination is ignored here.
   *
   * The columns field is the enabled columns on the grid, in order of display as customized by the staff or the default grid columns if not customized.
   *
   * This is fetched from the query columnDisplayCustomizationOptions for the page route.
   *
   * The reason we take a direct columns array instead of route, is that there could be no previous customization by the staff but the default grid display hides a few auxiliary columns and the Excel export needs to match that.
   *
   * The exportable columns are limited to the options below and need to match each one exactly (case sensitive):
   *
   * <pre>
   *     Name
   *     Email
   *     Departments
   *     Cities
   *     Buildings
   *     Status
   *     Created At
   *     Last Updated
   *     Last Sign-in
   * </pre>
   */
  export: Scalars['String']['output'];
  /**
   * To fetch all staff without pagination, when populating dropdowns for instance, create a dedicated GraphQL file with this field selection:
   *
   * <pre>
   * staff {
   *     result: records(filter: $filter, options: $options) {
   *         id
   *         firstName
   *         lastName
   *         email
   *     }
   * }
   * </pre>
   *
   * When this exact field selection is detected, the server runs a faster query that returns all data without pagination.
   *
   * All fields of StaffFilterInput are still applicable with the exception of "search" and "isActive", as only active staff are returned here.
   *
   * The list of supported sort criteria in options.sort:
   *
   * <pre>
   *     Name
   *     Name desc
   *     Email
   *     Email desc
   *     Status
   *     Status desc
   *     Created At
   *     Created At desc
   *     Last Updated
   *     Last Updated desc
   *     Last Sign-in
   *     Last Sign-in desc
   * </pre>
   */
  records: Array<Staff>;
};


/** StaffResult */
export type StaffResultCountArgs = {
  filter?: InputMaybe<StaffFilterInput>;
};


/** StaffResult */
export type StaffResultExportArgs = {
  columns: Array<Scalars['String']['input']>;
  filter?: InputMaybe<StaffFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};


/** StaffResult */
export type StaffResultRecordsArgs = {
  filter?: InputMaybe<StaffFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** Task */
export type Task = {
  __typename?: 'Task';
  assignedAt?: Maybe<DateTime>;
  assignees?: Maybe<Array<Staff>>;
  /** task attachments */
  attachments?: Maybe<Array<Attachment>>;
  /** available fields: id, internalName, listingName, and the main image (images.main) */
  building?: Maybe<Building>;
  createdAt?: Maybe<DateTime>;
  createdBy?: Maybe<Staff>;
  description?: Maybe<Scalars['String']['output']>;
  dueDateTime?: Maybe<DateTime>;
  /**
   * Minutes elapsed since the task was created, used this against estimatedMinutes to calculate SLA progress bar.
   * Note: this might exceed estimatedMinutes.
   */
  elapsedMinutes?: Maybe<Scalars['Int']['output']>;
  /** calculated as dueDateTime - createdAt */
  estimatedMinutes?: Maybe<Scalars['Int']['output']>;
  /** gets converted to propertyTimezone */
  guestPreferredDateTime?: Maybe<DateTime>;
  /** if the task is currently on hold */
  holdReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAccessInGuestAbsenceAllowed?: Maybe<Scalars['Boolean']['output']>;
  /**
   * This is false on SLA violation regardless of the task status.
   * True if the case is resolved within dueDateTime.
   */
  isSlaMet?: Maybe<Scalars['Boolean']['output']>;
  /** available fields: id, name, taskType */
  issueType?: Maybe<TaskIssueType>;
  lastUpdated?: Maybe<DateTime>;
  notes?: Maybe<Array<Note>>;
  priority?: Maybe<Scalars['String']['output']>;
  /** available fields: id, internalName, listingName and the main image */
  property?: Maybe<Property>;
  /**
   * The timezone of guestPreferredDateTime, e.g. Asia/Dubai.
   * Nest uses this value to automatically transform guestPreferredDateTime.
   *
   * All other DateTime fields are in the staff's timezone.
   */
  propertyTimezone?: Maybe<Scalars['String']['output']>;
  /** available fields: id, confirmationNumber */
  reservation?: Maybe<Reservation>;
  /** attachments on task closure */
  resolutionAttachments?: Maybe<Array<Attachment>>;
  resolutionNotes?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<DateTime>;
  resolvedBy?: Maybe<Staff>;
  startedAt?: Maybe<DateTime>;
  startedBy?: Maybe<Staff>;
  status?: Maybe<Scalars['String']['output']>;
  taskNumber: Scalars['String']['output'];
  taskType?: Maybe<Scalars['String']['output']>;
};

/** TaskAssigneesPayloadInput */
export type TaskAssigneesPayloadInput = {
  assigneeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  taskID: Scalars['ID']['input'];
};

/** TaskFilterInput */
export type TaskFilterInput = {
  assignedAt?: InputMaybe<DateFilterInput>;
  /** list of staff IDs */
  assigneeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  buildingIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  cityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<DateFilterInput>;
  dueDate?: InputMaybe<DateFilterInput>;
  guestPreferredDate?: InputMaybe<DateFilterInput>;
  isAccessInGuestAbsenceAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** SLA breach / violation */
  isSlaBreached?: InputMaybe<Scalars['Boolean']['input']>;
  /** see taskIssueTypes query */
  issueTypeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastUpdated?: InputMaybe<DateFilterInput>;
  /** see config{taskPriorities} query */
  priorities?: InputMaybe<Array<Scalars['String']['input']>>;
  propertyIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  reservationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  resolvedAt?: InputMaybe<DateFilterInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<DateFilterInput>;
  /** see config{taskStatuses} query */
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  taskIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** see config{taskTypes} query */
  taskTypes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** TaskHistoryFilterInput */
export type TaskHistoryFilterInput = {
  taskID: Scalars['ID']['input'];
};

/** TaskIssueType */
export type TaskIssueType = {
  __typename?: 'TaskIssueType';
  estimatedHours?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  priority?: Maybe<Scalars['String']['output']>;
  /** see config{taskTypes} query */
  taskType: Scalars['String']['output'];
};

/** TaskIssueTypeFilterInput */
export type TaskIssueTypeFilterInput = {
  taskType?: InputMaybe<Scalars['String']['input']>;
};

/** TaskNotePayloadInput */
export type TaskNotePayloadInput = {
  note: NotePayloadInput;
  taskID: Scalars['ID']['input'];
};

/** TaskOnHoldPayloadInput */
export type TaskOnHoldPayloadInput = {
  holdReason: Scalars['String']['input'];
  taskID: Scalars['ID']['input'];
};

/** TaskPayloadInput */
export type TaskPayloadInput = {
  /** this is only permitted for the tasks-worker role, if the current status is Unassigned */
  assignToMe?: InputMaybe<Scalars['Boolean']['input']>;
  /** this is only permitted for the tasks-admin or tasks-editor role */
  assigneeIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  attachments?: InputMaybe<Array<AttachmentInput>>;
  buildingID?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * In the format YYYY-MM-DD HH:mm:ss.
   *
   * Set the default value to be current time + estimatedHours that you get from the taskIssueTypes query
   */
  dueDateTime?: InputMaybe<Scalars['String']['input']>;
  /** In the format YYYY-MM-DD HH:mm:ss */
  guestPreferredDateTime?: InputMaybe<Scalars['String']['input']>;
  isAccessInGuestAbsenceAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** see taskIssueTypes query, filter that query by taskType */
  issueTypeID: Scalars['ID']['input'];
  /** default priority loaded from taskIssueTypes query, or an override */
  priority?: InputMaybe<Scalars['String']['input']>;
  /** leave this as null for building-specific tasks */
  propertyID?: InputMaybe<Scalars['ID']['input']>;
  reservationID?: InputMaybe<Scalars['ID']['input']>;
  /** see config{taskTypes} query */
  taskType: Scalars['String']['input'];
};

/** TaskResolvedPayloadInput */
export type TaskResolvedPayloadInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  resolutionNotes: Scalars['String']['input'];
  taskID: Scalars['ID']['input'];
};

/** TaskResult */
export type TaskResult = {
  __typename?: 'TaskResult';
  /** Records count */
  count: Scalars['Int']['output'];
  /**
   * Exports to Excel.
   *
   * Pass the active TaskFilterInput that's applied to the grid, if any to get the same records.
   *
   * Also send the active sort criteria that's applied on the grid through options.sort. Pagination is ignored here.
   *
   * The columns field is the enabled columns on the grid, in order of display as customized by the staff or the default grid columns if not customized.
   *
   * This is fetched from the query columnDisplayCustomizationOptions for the page route.
   *
   * The reason we take a direct columns array instead of route, is that there could be no previous customization by the staff but the default grid display hides a few auxiliary columns and the Excel export needs to match that.
   *
   * The exportable columns are limited to the options below and need to match each one exactly (case sensitive):
   *
   * <pre>
   *     Task Number
   *     Building Name
   *     Property Name
   *     Reservation ID
   *     Issue
   *     Description
   *     Status
   *     Assignee
   *     Priority
   *     SLA
   *     Guest Preferred Date
   *     Access In Guest Absence Allowed
   *     Date Assigned
   *     Date Started
   *     Date Resolved
   *     Date Due
   *     Task Type
   *     Created By
   *     Created At
   *     Last Updated
   * </pre>
   */
  export: Scalars['String']['output'];
  /** Fetches the history of a task */
  history: Array<ResourceHistory>;
  /**
   * To fetch all tasks without pagination, when populating dropdowns for instance, create a dedicated GraphQL file with this field selection:
   *
   * <pre>
   * tasks {
   *     result: records(filter: $filter, options: $options) {
   *         id
   *         taskNumber
   *         issueType {
   *             id
   *             name
   *             taskType
   *         }
   *         status
   *         priority
   *     }
   * }
   * </pre>
   *
   * When this exact field selection is detected, the server runs a faster query that returns all data without pagination.
   *
   * All fields of TaskFilterInput are still applicable with the exception of "search" and CommonQueryOptionsInput is ignored here.
   *
   * The list of supported sort criteria in options.sort:
   *
   * <pre>
   *     Task Number
   *     Task Number desc
   *     Building Name
   *     Building Name desc
   *     Property Name
   *     Property Name desc
   *     Reservation ID
   *     Reservation ID desc
   *     Issue
   *     Issue desc
   *     Status
   *     Status desc
   *     Priority
   *     Priority desc
   *     SLA
   *     SLA desc
   *     Guest Preferred Date
   *     Guest Preferred Date desc
   *     Access In Guest Absence Allowed
   *     Access In Guest Absence Allowed desc
   *     Date Assigned
   *     Date Assigned desc
   *     Date Started
   *     Date Started desc
   *     Date Resolved
   *     Date Resolved desc
   *     Date Due
   *     Date Due desc
   *     Task Type
   *     Task Type desc
   *     Created At
   *     Created At desc
   *     Created By
   *     Created By desc
   *     Last Updated
   *     Last Updated desc
   * </pre>
   */
  records: Array<Task>;
};


/** TaskResult */
export type TaskResultCountArgs = {
  filter?: InputMaybe<TaskFilterInput>;
};


/** TaskResult */
export type TaskResultExportArgs = {
  columns: Array<Scalars['String']['input']>;
  filter?: InputMaybe<TaskFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};


/** TaskResult */
export type TaskResultHistoryArgs = {
  filter: TaskHistoryFilterInput;
};


/** TaskResult */
export type TaskResultRecordsArgs = {
  filter?: InputMaybe<TaskFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** ThingsToNote */
export type ThingsToNote = {
  __typename?: 'ThingsToNote';
  /** id, name & airportCode only */
  city?: Maybe<City>;
  content: Array<TranslatedContent>;
  /** id & name only */
  country?: Maybe<Country>;
  createdAt?: Maybe<DateTime>;
  createdBy?: Maybe<Staff>;
  id: Scalars['ID']['output'];
  lastUpdated?: Maybe<DateTime>;
  /** building or standalone property with basic location info */
  location?: Maybe<ExtendedEntityLocation>;
  name: Scalars['String']['output'];
  /** id & name only */
  neighbourhood?: Maybe<Neighbourhood>;
};

/** ThingsToNoteFilterInput */
export type ThingsToNoteFilterInput = {
  cityIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  countryIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  locationIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  neighbourhoodIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  noteIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** ThingsToNotePayloadInput */
export type ThingsToNotePayloadInput = {
  /** see cities query */
  cityID?: InputMaybe<Scalars['ID']['input']>;
  /** The number of records in content must match the number of languages fetched through languages query */
  content: Array<TranslatedContentInput>;
  /** see countries query */
  countryID?: InputMaybe<Scalars['ID']['input']>;
  /** see entityLocations query */
  locationID?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  /** see neighbourhoods query */
  neighbourhoodID?: InputMaybe<Scalars['ID']['input']>;
};

/** ThingsToNoteResult */
export type ThingsToNoteResult = {
  __typename?: 'ThingsToNoteResult';
  count: Scalars['Int']['output'];
  records: Array<ThingsToNote>;
};


/** ThingsToNoteResult */
export type ThingsToNoteResultCountArgs = {
  filter?: InputMaybe<ThingsToNoteFilterInput>;
};


/** ThingsToNoteResult */
export type ThingsToNoteResultRecordsArgs = {
  filter?: InputMaybe<ThingsToNoteFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
};

/** TranslatedContent */
export type TranslatedContent = {
  __typename?: 'TranslatedContent';
  body: Scalars['String']['output'];
  languageCode: LanguageCode;
};

/** TranslatedContentInput */
export type TranslatedContentInput = {
  body: Scalars['String']['input'];
  languageCode: LanguageCode;
};

/** UnfurnishedProperty */
export type UnfurnishedProperty = {
  __typename?: 'UnfurnishedProperty';
  electricityNumber?: Maybe<Scalars['String']['output']>;
  gasNumber?: Maybe<Scalars['String']['output']>;
  municipalityNumber?: Maybe<Scalars['String']['output']>;
};

/** UnfurnishedPropertyInput */
export type UnfurnishedPropertyInput = {
  gasNumber?: InputMaybe<Scalars['String']['input']>;
  municipalityNumber?: InputMaybe<Scalars['String']['input']>;
};

/** UploadResponse */
export type UploadResponse = {
  __typename?: 'UploadResponse';
  /** the URL to send back to the server when the final mutation is submitted */
  assetUrl: Scalars['String']['output'];
  /** name of the file as provided */
  name: Scalars['String']['output'];
  /** signed URL to upload file to */
  signedUrl: Scalars['String']['output'];
};

/** Webp images */
export type Webp = {
  __typename?: 'Webp';
  largeUrl?: Maybe<Scalars['String']['output']>;
  mediumUrl?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

/** WebsiteBRLinkBusinessInvoiceDetailsPayloadInput */
export type WebsiteBrLinkBusinessInvoiceDetailsPayloadInput = {
  /** the same code sent to the websiteBookingRegistrationLink query */
  brCode?: InputMaybe<Scalars['String']['input']>;
  /** Business invoice details. */
  businessInvoiceDetails: WebsiteBookingRegistrationBusinessInvoiceDetailsInput;
  /** the same code sent to the websitePaymentLink query */
  plNumber?: InputMaybe<Scalars['String']['input']>;
};

/** WebsiteBRLinkCardOnFileInfoInput */
export type WebsiteBrLinkCardOnFileInfoInput = {
  /** the same code sent to the websiteBookingRegistrationLink query */
  brCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * For TotalPay, this is "publicID" from "WebsiteBRLinkCardPurchaseResponse".
   * For Stripe, it's the intent key.
   */
  paymentReferenceKey: Scalars['String']['input'];
  /** the same code sent to the websitePaymentLink query */
  plNumber?: InputMaybe<Scalars['String']['input']>;
};

/** WebsiteBRLinkCardOnFileIntentPayloadInput */
export type WebsiteBrLinkCardOnFileIntentPayloadInput = {
  /** the same code sent to the websiteBookingRegistrationLink query */
  brCode: Scalars['String']['input'];
  /** 3DS redirection destination */
  returnUrl: Scalars['String']['input'];
};

/** WebsiteBRLinkCardPurchaseBillingAddressInput */
export type WebsiteBrLinkCardPurchaseBillingAddressInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** WebsiteBRLinkCardPurchaseBrowserInfoInput */
export type WebsiteBrLinkCardPurchaseBrowserInfoInput = {
  colorDepth?: InputMaybe<Scalars['String']['input']>;
  javaEnabled?: InputMaybe<Scalars['String']['input']>;
  javaScriptEnabled?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  screenHeight?: InputMaybe<Scalars['String']['input']>;
  screenWidth?: InputMaybe<Scalars['String']['input']>;
  timeZoneOffset?: InputMaybe<Scalars['String']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

/** WebsiteBRLinkCardPurchasePayloadInput */
export type WebsiteBrLinkCardPurchasePayloadInput = {
  /** Billing address. */
  billingAddress?: InputMaybe<WebsiteBrLinkCardPurchaseBillingAddressInput>;
  /** Example: 1970-02-17 */
  birthDay?: InputMaybe<Scalars['String']['input']>;
  /** the same code sent to the websiteBookingRegistrationLink query */
  brCode?: InputMaybe<Scalars['String']['input']>;
  /** Browser info. */
  browserInfo?: InputMaybe<WebsiteBrLinkCardPurchaseBrowserInfoInput>;
  /** Example: test@gmail.com */
  email?: InputMaybe<Scalars['String']['input']>;
  /** the intent key / session token received from the call to createWebsiteBRLinkPaymentIntent or createWebsiteBRLinkCardOnFileIntent */
  intentReferenceKey: Scalars['String']['input'];
  /** Example: JOHN DOE */
  name: Scalars['String']['input'];
  /** the same code sent to the websitePaymentLink query */
  plNumber?: InputMaybe<Scalars['String']['input']>;
  /** Example: en */
  selectedLanguage?: InputMaybe<Scalars['String']['input']>;
  /** Example: true */
  withHostedFields: Scalars['Boolean']['input'];
};

/** WebsiteBRLinkCardPurchaseRedirectParam */
export type WebsiteBrLinkCardPurchaseRedirectParam = {
  __typename?: 'WebsiteBRLinkCardPurchaseRedirectParam';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** WebsiteBRLinkCardPurchaseResponse */
export type WebsiteBrLinkCardPurchaseResponse = {
  __typename?: 'WebsiteBRLinkCardPurchaseResponse';
  /** If result is decline, this contains the decline message. */
  declineMessage?: Maybe<Scalars['String']['output']>;
  /** The unique identifier of the payment. */
  publicID?: Maybe<Scalars['String']['output']>;
  /** If present, the redirect must be performed using POST. */
  redirectParams?: Maybe<Array<WebsiteBrLinkCardPurchaseRedirectParam>>;
  /** If result is redirect, this contains the URL to redirect to. */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Possible values:
   * - success: transaction is successfully completed
   * - decline: transaction is declined
   * - redirect: redirect is required
   * - waiting: transaction is being processed
   * - undefined: uncertain payment status due to some problems
   */
  result: Scalars['String']['output'];
  /** If present, append these query params to the return URL. */
  returnUrlQueryParams?: Maybe<Array<WebsiteBrLinkCardPurchaseRedirectParam>>;
  /** If true, do not poll for final payment state. */
  skipWaiting?: Maybe<Scalars['Boolean']['output']>;
};

/** WebsiteBRLinkCryptoTotalAmountInput */
export type WebsiteBrLinkCryptoTotalAmountInput = {
  /** the same code sent to the websiteBookingRegistrationLink query */
  brCode?: InputMaybe<Scalars['String']['input']>;
  /** e.g. USDT */
  coin: Scalars['String']['input'];
  /** the same code sent to the websitePaymentLink query */
  plNumber?: InputMaybe<Scalars['String']['input']>;
};

/** WebsiteBRLinkGuestCountPayloadInput */
export type WebsiteBrLinkGuestCountPayloadInput = {
  /** the same code sent to the websiteBookingRegistrationLink query */
  brCode: Scalars['String']['input'];
  numberOfGuests: Scalars['Int']['input'];
  /** must be set for POC and POC only */
  reservationID?: InputMaybe<Scalars['ID']['input']>;
};

/** WebsiteBRLinkLegacyPaymentSessionPayloadInput */
export type WebsiteBrLinkLegacyPaymentSessionPayloadInput = {
  /** the same code sent to the websiteBookingRegistrationLink query */
  brCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * Set this to paymentCollection.totalPaymentAmount from WebsiteBookingRegistrationLink or WebsitePaymentLink.
   *
   * This is used to ensure the amount hasn't changed in the background, if the guest takes too long to complete the payment flow.
   */
  paymentAmount: Scalars['Float']['input'];
  /** the same code sent to the websitePaymentLink query */
  plNumber?: InputMaybe<Scalars['String']['input']>;
  /** PSP-hosted flow redirection destination */
  returnUrl: Scalars['String']['input'];
};

/** WebsiteBRLinkLegacyPaymentSessionResponse */
export type WebsiteBrLinkLegacyPaymentSessionResponse = {
  __typename?: 'WebsiteBRLinkLegacyPaymentSessionResponse';
  /** TotalPay hosted payment-page URL. */
  redirectUrl: Scalars['String']['output'];
};

/** WebsiteBRLinkPaymentIntentPayloadInput */
export type WebsiteBrLinkPaymentIntentPayloadInput = {
  /** the same code sent to the websiteBookingRegistrationLink query */
  brCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * Set this to paymentCollection.totalPaymentAmount from WebsiteBookingRegistrationLink or WebsitePaymentLink.
   *
   * This is used to ensure the amount hasn't changed in the background, if the guest takes too long to complete the payment form.
   */
  paymentAmount: Scalars['Float']['input'];
  /** the same code sent to the websitePaymentLink query */
  plNumber?: InputMaybe<Scalars['String']['input']>;
  /** 3DS redirection destination */
  returnUrl: Scalars['String']['input'];
};

/** WebsiteBRLinkPaymentIntentPayloadResponse */
export type WebsiteBrLinkPaymentIntentPayloadResponse = {
  __typename?: 'WebsiteBRLinkPaymentIntentPayloadResponse';
  /** Stripe-specific */
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** this is the session token (TotalPay) or intent reference key (Stripe) */
  intentReferenceKey: Scalars['String']['output'];
  /** Stripe-specific */
  publishableKey?: Maybe<Scalars['String']['output']>;
};

/** WebsiteBRLinkRefundBankDetailsPayloadInput */
export type WebsiteBrLinkRefundBankDetailsPayloadInput = {
  /** the same code sent to the websiteBookingRegistrationLink query */
  brCode: Scalars['String']['input'];
  /** Bank transfer refund details for security deposit. */
  refundBankDetails: WebsiteBookingRegistrationRefundBankDetailsInput;
};

/** WebsiteBRLinkRefundCryptoDetailsPayloadInput */
export type WebsiteBrLinkRefundCryptoDetailsPayloadInput = {
  /** the same code sent to the websiteBookingRegistrationLink query */
  brCode: Scalars['String']['input'];
  /** Cryptocurrency refund details for security deposit. */
  refundCryptoDetails: WebsiteBookingRegistrationRefundCryptoDetailsInput;
};

/** WebsiteBRLinkUpgradeDamageProtectionPolicyPayloadInput */
export type WebsiteBrLinkUpgradeDamageProtectionPolicyPayloadInput = {
  /** the same code sent to the websiteBookingRegistrationLink query */
  brCode: Scalars['String']['input'];
};

/** Bank transfer beneficiary details. */
export type WebsiteBookingRegistrationBankBeneficiaryDetails = {
  __typename?: 'WebsiteBookingRegistrationBankBeneficiaryDetails';
  accountCurrency?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  accountNumber?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  branch?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  swiftCode?: Maybe<Scalars['String']['output']>;
};

/** Business invoice details. */
export type WebsiteBookingRegistrationBusinessInvoiceDetails = {
  __typename?: 'WebsiteBookingRegistrationBusinessInvoiceDetails';
  companyLegalName?: Maybe<Scalars['String']['output']>;
  registeredCity?: Maybe<Scalars['String']['output']>;
  registeredCountryName?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

/** WebsiteBookingRegistrationBusinessInvoiceDetailsInput */
export type WebsiteBookingRegistrationBusinessInvoiceDetailsInput = {
  companyLegalName: Scalars['String']['input'];
  registeredCity: Scalars['String']['input'];
  registeredCountryName: Scalars['String']['input'];
  vatNumber: Scalars['String']['input'];
};

/** Cryptocurrency beneficiary details (USDT). */
export type WebsiteBookingRegistrationCryptoBeneficiaryDetails = {
  __typename?: 'WebsiteBookingRegistrationCryptoBeneficiaryDetails';
  networks: Array<WebsiteBookingRegistrationCryptoNetwork>;
  tokenSymbol: Scalars['String']['output'];
};

/** Cryptocurrency network details. */
export type WebsiteBookingRegistrationCryptoNetwork = {
  __typename?: 'WebsiteBookingRegistrationCryptoNetwork';
  address: Scalars['String']['output'];
  networkName: Scalars['String']['output'];
  qrCodeUrl: Scalars['String']['output'];
};

/** Document display state for a reservation on the website BR link. */
export type WebsiteBookingRegistrationDisplayStatus = {
  __typename?: 'WebsiteBookingRegistrationDisplayStatus';
  /** Use this flag to display or hide the document submission section for this reservation. */
  canSetDocuments: Scalars['Boolean']['output'];
  /**
   * Reservation reference for this display state.
   *
   * Only id and confirmationNumber are supported here.
   */
  reservation: Reservation;
};

/** Union of reservations and extensions for website booking registration. */
export type WebsiteBookingRegistrationEntry = Reservation | ReservationExtension;

/** Booking registration link payload. */
export type WebsiteBookingRegistrationLink = {
  __typename?: 'WebsiteBookingRegistrationLink';
  /** Bank transfer beneficiary details for the property city (our bank account). */
  bankTransferBeneficiary?: Maybe<WebsiteBookingRegistrationBankBeneficiaryDetails>;
  /** business invoice details already provided by the guest, if any */
  businessInvoiceDetails?: Maybe<WebsiteBookingRegistrationBusinessInvoiceDetails>;
  /** True if the guest can request a business invoice (non-corporate only). */
  canRequestBusinessInvoice: Scalars['Boolean']['output'];
  /** this is false for POC links, extension links, or after the guest has checked in (when a door unlock is detected or manually set by staff) */
  canSetETA: Scalars['Boolean']['output'];
  /** this is false if the guest has already checked-in or it's a POC link */
  canSetSpecialRequests: Scalars['Boolean']['output'];
  /**
   * True If pending actions are completed and we're within the check-in window.
   * Check if the passcode is available (see Reservation{passcode} in entries) as it may not always be set if this flag is true (if previous attempts to generate it failed).
   *
   * This value is false for POC links or if the current time is not within the reservation's check-in time window.
   */
  canShowCheckInDetailsOnSuccess: Scalars['Boolean']['output'];
  /** If we should display the signature pad, if it's required in contracts */
  canShowSignaturePad: Scalars['Boolean']['output'];
  /**
   * True if the BR link can show a successful-payment view based on payment completion / accepted-proof rules,
   * without requiring the current time to be within the reservation's check-in window.
   */
  canShowSuccessfulPaymentView: Scalars['Boolean']['output'];
  /**
   * Prefilled contact info for the current link.
   *
   * This is the contact that's associated with the BR code, and not the signed-in contact on the website.
   *
   * For POC links, this is the POC-own contact info.
   *
   * See contacts{records} query for the allowed field selection.
   */
  contact?: Maybe<Contact>;
  /**
   * The signature drawing in base64. Can be used to display existing signature on extensions.
   * Discard if canShowSignaturePad is false.
   */
  contractBase64Signature?: Maybe<Scalars['String']['output']>;
  /**
   * Corporate info if this is a corporate booking.
   *
   * See corporates{records} query for the allowed field selection.
   */
  corporate?: Maybe<Corporate>;
  /** Cryptocurrency beneficiary details (USDT). */
  cryptoBeneficiary?: Maybe<WebsiteBookingRegistrationCryptoBeneficiaryDetails>;
  /**
   * Use this list to display or hide the document submission section per reservation, regardless of pendingSteps.
   * We use this additional field as guests may still be allowed to edit documents after the pending step is initially completed.
   *
   * For extension links, this list is empty unless documents are still pending.
   */
  documentDisplayStatus: Array<WebsiteBookingRegistrationDisplayStatus>;
  /**
   * Reservation or extension entries tied to this link.
   *
   * Entries are always set, regardless if reservation or extension is pending any steps.
   * Links can still return entries after all steps are completed, up until the reservation has passed local checkout.
   * Use this field to access main reservation / extension data (confirmation number, property details, etc.).
   *
   * To view entries pending document submission, see reservationsPendingDocumentSubmission.
   * To view the list of pending invoices (and their corresponding reservation / extension), see pendingInvoices.
   *
   * See reservation{records} and extensions{records} queries for the allowed field selection.
   *
   * Note: Access reservation documents using entries.reservation.documents or entries.extension.reservation.documents.
   */
  entries: Array<WebsiteBookingRegistrationEntry>;
  /**
   * Allowed ETA values to display on the BR page (in 24h format).
   * This is empty when canSetETA is false.
   */
  etaTimeSlots: Array<Scalars['String']['output']>;
  /** true when the current BR code belongs to an extension */
  isExtension: Scalars['Boolean']['output'];
  /** true when the current link is for the corporate point of contact (POC) */
  isPointOfContact: Scalars['Boolean']['output'];
  /** true when BR terms and conditions are accepted for the current link */
  isTermsConditionsAccepted: Scalars['Boolean']['output'];
  /**
   * Payment collection associated with this link.
   *
   * For corporate POC, this is a single combined collection for all reservations.
   *
   * See paymentCollections{records} query for the allowed field selection.
   *
   * Note: totalPaymentAmount in PaymentCollection is the total due for all reservations / extensions, including SD.
   * See supportedPaymentMethods for the list of allowed payment methods.
   *
   * See paymentSummary for the totals of bookings or SDs separately.
   */
  paymentCollection?: Maybe<PaymentCollection>;
  /**
   * Aggregated payment summary for the link.
   * This is the aggregated amounts of all pendingInvoices entries.
   */
  paymentSummary?: Maybe<WebsiteBookingRegistrationPaymentSummary>;
  /**
   * List of invoices that are pending for all reservations / extensions.
   *
   * Inspect reservations / extensions on Invoice to see which reservation / extension they belong to.
   *
   * See invoiceType on Invoice, which is one of 'Reservation', 'Extension', 'Service' or 'Security Deposit'.
   *
   * Note: For corporate, the invoice list is filtered for POC or corporate contact. For example, POC only views invoices that are their responsibility to pay.
   */
  pendingInvoices?: Maybe<Array<Invoice>>;
  /**
   * Pending steps for this link (payment, damage protection, documents).
   *
   * For POC, a step is pending if it's pending for at least one reservation.
   */
  pendingSteps: Array<WebsiteBookingRegistrationPendingStep>;
  /**
   * One or more reservations that are pending document submission.
   *
   * For POC, this is the list of reservations pending document submissions, where it's the POC's responsibility to upload documents.
   *
   * See maximumGuests field on Property > FurnishedProperty.
   * See numberOfGuests on Reservation, this sets the default value for the guests count.
   * See documents field on Reservation, for the previously uploaded documents.
   */
  reservationsPendingDocumentSubmission?: Maybe<Array<Reservation>>;
  /** Security deposit refund details already provided by the guest, if any. */
  securityDepositRefundDetails?: Maybe<WebsiteBookingRegistrationSecurityDepositRefundDetails>;
  /**
   * True when the FE should redirect the guest through the temporary SAR legacy PSP payment-page flow.
   *
   * This is only true when activate_legacy_sar_payment_processing is enabled, paymentCollection.currency is SAR,
   * and Credit Card is one of paymentCollection.supportedPaymentMethods.
   */
  shouldUseLegacySarPaymentProcessing: Scalars['Boolean']['output'];
};

/** Aggregated payment summary. */
export type WebsiteBookingRegistrationPaymentSummary = {
  __typename?: 'WebsiteBookingRegistrationPaymentSummary';
  /**
   * Total alternative security deposit amount.
   * Use this amount for Bank Transfer & Cryptocurrency payments, when isSecurityDepositCardOnFile is true and the guest selects the option to pay SD instead.
   *
   * For POC, this is the sum of all SD amounts for reservations that are pending SD, and are the responsibility of the POC.
   */
  alternativeSecurityDepositAmount?: Maybe<Scalars['Float']['output']>;
  /** true if a card on file is required for damage protection */
  isSecurityDepositCardOnFile?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Pending booking amount for reservation / extension, not including SD or services.
   *
   * For POC, this is the sum of all pending reservation / extension amounts (not including SD or services).
   */
  pendingBookingAmount?: Maybe<Scalars['Float']['output']>;
  /**
   * Pending security deposit amount, if any.
   *
   * For POC, this is the sum of all pending SD amounts for reservations that are the responsibility of the POC.
   *
   * This value is null if isSecurityDepositCardOnFile is true.
   */
  pendingSecurityDepositAmount?: Maybe<Scalars['Float']['output']>;
  /** pending add-on services or damage-replacement amounts, if any */
  pendingServicesAmount?: Maybe<Scalars['Float']['output']>;
  /**
   * Total pending amount (pendingBookingAmount + pendingServicesAmount + pendingSecurityDepositAmount).
   * This is identical to totalPaymentAmount in PaymentCollection.
   */
  pendingTotalAmount?: Maybe<Scalars['Float']['output']>;
};

/** Pending steps for website booking registration. */
export enum WebsiteBookingRegistrationPendingStep {
  DamageProtection = 'damageProtection',
  Documents = 'documents',
  Payment = 'payment'
}

/** Bank transfer refund details for security deposit. */
export type WebsiteBookingRegistrationRefundBankDetails = {
  __typename?: 'WebsiteBookingRegistrationRefundBankDetails';
  accountCurrency?: Maybe<Scalars['String']['output']>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  beneficiaryName?: Maybe<Scalars['String']['output']>;
  branchAddress?: Maybe<Scalars['String']['output']>;
  branchName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  swiftCode?: Maybe<Scalars['String']['output']>;
};

/** WebsiteBookingRegistrationRefundBankDetailsInput */
export type WebsiteBookingRegistrationRefundBankDetailsInput = {
  accountCurrency: Scalars['String']['input'];
  bankAccountNumber: Scalars['String']['input'];
  bankName: Scalars['String']['input'];
  beneficiaryName: Scalars['String']['input'];
  branchAddress: Scalars['String']['input'];
  branchName: Scalars['String']['input'];
  country: Scalars['String']['input'];
  iban: Scalars['String']['input'];
  swiftCode: Scalars['String']['input'];
};

/** Cryptocurrency refund details for security deposit. */
export type WebsiteBookingRegistrationRefundCryptoDetails = {
  __typename?: 'WebsiteBookingRegistrationRefundCryptoDetails';
  networkName?: Maybe<Scalars['String']['output']>;
  walletAddress?: Maybe<Scalars['String']['output']>;
};

/** WebsiteBookingRegistrationRefundCryptoDetailsInput */
export type WebsiteBookingRegistrationRefundCryptoDetailsInput = {
  networkName: Scalars['String']['input'];
  walletAddress: Scalars['String']['input'];
};

/** Security deposit refund details provided by the guest. */
export type WebsiteBookingRegistrationSecurityDepositRefundDetails = {
  __typename?: 'WebsiteBookingRegistrationSecurityDepositRefundDetails';
  bankTransfer?: Maybe<WebsiteBookingRegistrationRefundBankDetails>;
  cryptocurrency?: Maybe<WebsiteBookingRegistrationRefundCryptoDetails>;
};

/** WebsiteContactMessageInput */
export type WebsiteContactMessageInput = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  propertyLocation?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** WebsiteCorporateContactInput */
export type WebsiteCorporateContactInput = {
  cityInterest: Array<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  companyContactUrl: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

/** WebsiteHelpCenterContent */
export type WebsiteHelpCenterContent = {
  __typename?: 'WebsiteHelpCenterContent';
  answer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
  sectionID: Scalars['String']['output'];
  sectionTitle: Scalars['String']['output'];
};

/** WebsiteLeaseFormInput */
export type WebsiteLeaseFormInput = {
  email: Scalars['String']['input'];
  message: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  propertyLocation?: InputMaybe<Scalars['String']['input']>;
};

/** WebsitePaymentLink */
export type WebsitePaymentLink = {
  __typename?: 'WebsitePaymentLink';
  /** Bookkeeping account associated with the payment collection. */
  account?: Maybe<BookkeepingAccount>;
  /** Bank transfer beneficiary details for the property city (our bank account). */
  bankTransferBeneficiary?: Maybe<WebsiteBookingRegistrationBankBeneficiaryDetails>;
  /** If false, we don't show the "I need a business invoice" checkbox. */
  canRequestBusinessInvoice: Scalars['Boolean']['output'];
  /** True once paymentCollection.isPaid is true. */
  canShowSuccessfulPaymentView: Scalars['Boolean']['output'];
  /** Cryptocurrency beneficiary details (USDT). */
  cryptoBeneficiary?: Maybe<WebsiteBookingRegistrationCryptoBeneficiaryDetails>;
  /** Reservation or extension entries associated with the payment collection. */
  entries: Array<WebsiteBookingRegistrationEntry>;
  /**
   * Payment collection associated with this link.
   *
   * See paymentCollections{records} query for the allowed field selection.
   */
  paymentCollection?: Maybe<PaymentCollection>;
  /**
   * List of invoices that are pending for all reservations / extensions.
   *
   * Inspect reservations / extensions on Invoice to see which reservation / extension they belong to.
   *
   * See invoiceType on Invoice, which is one of 'Reservation', 'Extension', 'Service', 'Security Deposit' and 'Damage Replacement'.
   */
  pendingInvoices?: Maybe<Array<Invoice>>;
  /** when this payment link was superseded by a replacement collection, this points to the latest URL to use. */
  redirectToPaymentLink?: Maybe<Scalars['String']['output']>;
  /**
   * True when the FE should redirect the guest through the temporary SAR legacy PSP payment-page flow.
   *
   * This is only true when activate_legacy_sar_payment_processing is enabled, paymentCollection.currency is SAR,
   * and Credit Card is one of paymentCollection.supportedPaymentMethods.
   */
  shouldUseLegacySarPaymentProcessing: Scalars['Boolean']['output'];
};

/** WebsiteReservationPayloadInput */
export type WebsiteReservationPayloadInput = {
  /** check-in date in the format YYYY-MM-DD */
  checkInDate: Scalars['String']['input'];
  /** check-out date in the format YYYY-MM-DD */
  checkOutDate: Scalars['String']['input'];
  numberOfGuests: Scalars['Int']['input'];
  /** A multi-unit or a single unit */
  propertyID: Scalars['ID']['input'];
};

/** WebsiteReservationResult */
export type WebsiteReservationResult = {
  __typename?: 'WebsiteReservationResult';
  bookingCompletionLink: Scalars['String']['output'];
  /** reservation ID */
  id: Scalars['ID']['output'];
};

/**
 * City of the requested viewing, which also determines the time zone of preferredDate / preferredTime:
 * dubai = Asia/Dubai, riyadh = Asia/Riyadh, cairo = Africa/Cairo.
 */
export enum WebsiteViewingCity {
  Cairo = 'cairo',
  Dubai = 'dubai',
  Riyadh = 'riyadh'
}

/** When the visitor plans to move in. */
export enum WebsiteViewingMoveTimeframe {
  /** As soon as possible. */
  Asap = 'asap',
  /** More than three months from now. */
  Later = 'later',
  NotSure = 'notSure',
  WithinOneMonth = 'withinOneMonth',
  WithinThreeMonths = 'withinThreeMonths'
}

/** WebsiteViewingRequestInput */
export type WebsiteViewingRequestInput = {
  /** City of the viewing, preferredDate and preferredTime are expressed in this city's local time. */
  city: WebsiteViewingCity;
  /** Visitor's email, at least one of email / phone is required. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Optional, when the visitor plans to move in. */
  moveInTimeframe?: InputMaybe<WebsiteViewingMoveTimeframe>;
  /** Visitor's name, at least 2 characters after trimming. */
  name: Scalars['String']['input'];
  /** Visitor's phone number (digits, spaces, "+", "(", ")", ".", "-", at least 7 characters), at least one of email / phone is required. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Viewing date in the format YYYY-MM-DD, in the selected city's local time. */
  preferredDate: Scalars['String']['input'];
  /**
   * Viewing time in the format HH:MM (24h, on the hour, 10:00 to 21:00), in the selected city's local time.
   *
   * Together with preferredDate it must be at least 6 hours from now in the city's time zone: hour H on date D is allowed
   * when D is after the threshold date, or D equals the threshold date and H is after the threshold hour
   * (or equals it while the threshold minute is 0), where threshold = now + 6 hours in the city's time zone.
   */
  preferredTime: Scalars['String']['input'];
  /** Optional, how long the visitor plans to stay. */
  stayLength?: InputMaybe<WebsiteViewingStayLength>;
  /** In person or virtual tour. */
  tourType: WebsiteViewingTourType;
};

/** How long the visitor plans to stay. */
export enum WebsiteViewingStayLength {
  LessThanThreeMonths = 'lessThanThreeMonths',
  MoreThanAYear = 'moreThanAYear',
  NotSure = 'notSure',
  SixToTwelveMonths = 'sixToTwelveMonths',
  ThreeToSixMonths = 'threeToSixMonths'
}

/** How the visitor wants to view the property. */
export enum WebsiteViewingTourType {
  /** Visit the property in person. */
  InPerson = 'inPerson',
  /** Video call tour. */
  Virtual = 'virtual'
}

/** Corporate or contact profile on Zoho */
export type ZohoProfile = {
  __typename?: 'ZohoProfile';
  /** ID of the entity on Zoho Books */
  booksID?: Maybe<Scalars['ID']['output']>;
  /** ID of the entity on Zoho Desk */
  deskID?: Maybe<Scalars['ID']['output']>;
  /** ID of the entity on Zoho CRM */
  id?: Maybe<Scalars['ID']['output']>;
  /** Zoho Books organization ID */
  organizationID?: Maybe<Scalars['ID']['output']>;
  /** error encountered while trying to sync the profile with Zoho */
  syncError?: Maybe<Scalars['String']['output']>;
};

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', result:
    | { __typename: 'Contact', id: string, firstName: string, lastName: string, email: string, isSubscribedToNewsLetter?: boolean | null, birthdate?: { __typename?: 'Date', formatted: string, raw?: string | null } | null, phone?: { __typename?: 'Phone', code: string, number: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null }
    | { __typename?: 'Staff' }
   };

export type SignUpContactWithEmailPasswordMutationVariables = Exact<{
  payload: ContactSignUpPayloadInput;
}>;


export type SignUpContactWithEmailPasswordMutation = { __typename?: 'Mutation', result: { __typename: 'Contact', id: string, firstName: string, lastName: string, email: string, isSubscribedToNewsLetter?: boolean | null, jwtToken?: string | null } };

export type SignInContactMutationVariables = Exact<{
  payload: ContactSignInPayloadInput;
  firebaseToken: Scalars['String']['input'];
}>;


export type SignInContactMutation = { __typename?: 'Mutation', result: { __typename: 'Contact', id: string, firstName: string, lastName: string, email: string, isSubscribedToNewsLetter?: boolean | null, jwtToken?: string | null } };

export type SetContactLanguageMutationVariables = Exact<{
  languageID: Scalars['ID']['input'];
}>;


export type SetContactLanguageMutation = { __typename?: 'Mutation', result: boolean };

export type RequestContactPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestContactPasswordResetMutation = { __typename?: 'Mutation', result: boolean };

export type PropertyAvailabilityRangesQueryVariables = Exact<{
  filter: PropertyAvailabilityRangesFilterInput;
}>;


export type PropertyAvailabilityRangesQuery = { __typename?: 'Query', propertyAvailabilityRanges: Array<{ __typename?: 'PropertyAvailabilityRange', startDate: string, endDate: string, propertyID: string, isBlocked: boolean }> };

export type PropertyLengthOfStayDaysQueryVariables = Exact<{
  filter: PropertyLengthOfStayFilterInput;
}>;


export type PropertyLengthOfStayDaysQuery = { __typename?: 'Query', propertyLengthOfStayDays: Array<{ __typename?: 'LengthOfStayDay', propertyID: string, day: string, lengthOfStay: number }> };

export type ReservationsPendingDocumentSubmissionQueryVariables = Exact<{
  brCode: Scalars['String']['input'];
}>;


export type ReservationsPendingDocumentSubmissionQuery = { __typename?: 'Query', result?: { __typename?: 'WebsiteBookingRegistrationLink', reservationsPendingDocumentSubmission?: Array<{ __typename?: 'Reservation', id: string }> | null, documentDisplayStatus: Array<{ __typename?: 'WebsiteBookingRegistrationDisplayStatus', canSetDocuments: boolean, reservation: { __typename?: 'Reservation', id: string } }> } | null };

export type WebsiteBookingRegistrationLinkQueryVariables = Exact<{
  brCode: Scalars['String']['input'];
}>;


export type WebsiteBookingRegistrationLinkQuery = { __typename?: 'Query', result?: { __typename?: 'WebsiteBookingRegistrationLink', canShowSuccessfulPaymentView: boolean, isPointOfContact: boolean, isTermsConditionsAccepted: boolean, etaTimeSlots: Array<string>, contractBase64Signature?: string | null, canShowSignaturePad: boolean, isExtension: boolean, canRequestBusinessInvoice: boolean, canSetETA: boolean, canSetSpecialRequests: boolean, canShowCheckInDetailsOnSuccess: boolean, pendingSteps: Array<WebsiteBookingRegistrationPendingStep>, contact?: { __typename?: 'Contact', id: string, firstName: string, lastName: string, email: string, isOTAEmail?: boolean | null, hasAccount?: boolean | null, phone?: { __typename?: 'Phone', code: string, number: string } | null } | null, corporate?: { __typename?: 'Corporate', id: string, legalName?: string | null } | null, reservationsPendingDocumentSubmission?: Array<{ __typename?: 'Reservation', id: string }> | null, entries: Array<
      | { __typename?: 'Reservation', id: string, estimatedArrivalTime?: string | null, specialRequests?: string | null, nights?: number | null, checkInTime?: string | null, checkOutTime?: string | null, numberOfGuests?: number | null, reservationConfirmationNumber: string, payment?: { __typename?: 'ReservationPaymentPlan', grandTotal: number, grandBookingTotal: number, currency: string, isPaid?: boolean | null, paymentMethods: Array<{ __typename: 'ReservationPaymentMethod', isEnabled?: boolean | null, isOnline?: boolean | null, name: string }>, singlePayment?: Array<{ __typename?: 'ReservationPayment', amountPaid?: number | null, nights?: number | null, isPaid?: boolean | null, vat?: { __typename?: 'PaymentVat', amount: number, percentage: number } | null }> | null } | null, documents?: Array<{ __typename?: 'ReservationDocument', isMainGuest?: boolean | null, documentStatus?: string | null, document: { __typename?: 'Document', id: string, documentType?: string | null, attachments: Array<{ __typename?: 'Attachment', fileName: string, mimeType: string, url: string }> }, content?: { __typename?: 'ReservationIdentityDocumentContent', firstName?: string | null, lastName?: string | null, fatherName?: string | null, grandfatherName?: string | null, documentNumber?: string | null, expiryDate?: { __typename?: 'Date', raw?: string | null, formatted: string } | null } | null }> | null, checkInDate?: { __typename?: 'Date', raw?: string | null, formatted: string } | null, checkOutDate?: { __typename?: 'Date', raw?: string | null, formatted: string } | null, extendedCheckOutDate?: { __typename?: 'Date', raw?: string | null, formatted: string } | null, property?: { __typename?: 'Property', id: string, listingNameRendered?: string | null, unitNumber?: string | null, parkingNumber?: string | null, location?: { __typename?: 'EntityLocation', id: string, address: string, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null, neighbourhood?: { __typename?: 'Neighbourhood', id: string, name: string, city?: { __typename?: 'City', name: string, id: string } | null } | null } | null, propertyType?: { __typename?: 'PropertyType', name: string } | null, images?: { __typename?: 'ImageSet', all?: Array<{ __typename?: 'OptimizedImage', url: string, captionRendered?: string | null, displayOrder?: number | null, imageType?: string | null, webp?: { __typename?: 'Webp', largeUrl?: string | null, mediumUrl?: string | null, thumbnailUrl?: string | null } | null }> | null, main?: { __typename?: 'OptimizedImage', url: string, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null } | null } | null, building?: { __typename?: 'Building', id: string, listingNameRendered?: string | null, location?: { __typename?: 'EntityLocation', address: string, neighbourhood?: { __typename?: 'Neighbourhood', id: string, name: string, city?: { __typename?: 'City', name: string, id: string } | null } | null, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null } | null } | null, furnished?: { __typename?: 'FurnishedProperty', checkInTime?: string | null, maximumGuests?: number | null, wifiSSID?: string | null, wifiPassword?: string | null } | null } | null, passcode?: { __typename?: 'SmartLockPasscode', code?: string | null } | null, contact?: { __typename?: 'Contact', firstName: string, lastName: string, id: string, email: string } | null }
      | { __typename?: 'ReservationExtension', id: string, nights?: number | null, reservation?: { __typename?: 'Reservation', id: string, confirmationNumber: string, checkInTime?: string | null, property?: { __typename?: 'Property', id: string, listingNameRendered?: string | null, images?: { __typename?: 'ImageSet', main?: { __typename?: 'OptimizedImage', url: string, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null } | null } | null } | null, invoices?: Array<{ __typename?: 'Invoice', id: string, invoiceNumber: string, invoiceType?: string | null }> | null, documents?: Array<{ __typename?: 'ReservationDocument', isMainGuest?: boolean | null, documentStatus?: string | null, content?: { __typename?: 'ReservationIdentityDocumentContent', issuingPlace?: string | null, lastName?: string | null, occupation?: string | null, documentNumber?: string | null, firstName?: string | null, fatherName?: string | null, birthdate?: { __typename?: 'Date', formatted: string, raw?: string | null } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null } | null, document: { __typename?: 'Document', documentType?: string | null, id: string, attachments: Array<{ __typename?: 'Attachment', fileName: string, mimeType: string, url: string }> } }> | null, passcode?: { __typename?: 'SmartLockPasscode', code?: string | null } | null } | null, payment?: { __typename?: 'ReservationPaymentPlan', grandTotal: number, grandBookingTotal: number, currency: string, isPaid?: boolean | null, paymentMethods: Array<{ __typename: 'ReservationPaymentMethod', isEnabled?: boolean | null, isOnline?: boolean | null, name: string }>, singlePayment?: Array<{ __typename?: 'ReservationPayment', amountPaid?: number | null, nights?: number | null, isPaid?: boolean | null, vat?: { __typename?: 'PaymentVat', amount: number, percentage: number } | null }> | null } | null, checkInDate?: { __typename?: 'Date', raw?: string | null, formatted: string } | null, checkOutDate?: { __typename?: 'Date', raw?: string | null, formatted: string } | null, property?: { __typename?: 'Property', id: string, listingNameRendered?: string | null, unitNumber?: string | null, parkingNumber?: string | null, location?: { __typename?: 'EntityLocation', id: string, address: string, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null, neighbourhood?: { __typename?: 'Neighbourhood', id: string, name: string, city?: { __typename?: 'City', name: string, id: string } | null } | null } | null, propertyType?: { __typename?: 'PropertyType', name: string } | null, images?: { __typename?: 'ImageSet', all?: Array<{ __typename?: 'OptimizedImage', url: string, captionRendered?: string | null, displayOrder?: number | null, imageType?: string | null, webp?: { __typename?: 'Webp', largeUrl?: string | null, mediumUrl?: string | null, thumbnailUrl?: string | null } | null }> | null, main?: { __typename?: 'OptimizedImage', url: string, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null } | null } | null, building?: { __typename?: 'Building', id: string, listingNameRendered?: string | null, location?: { __typename?: 'EntityLocation', address: string, neighbourhood?: { __typename?: 'Neighbourhood', id: string, name: string, city?: { __typename?: 'City', name: string, id: string } | null } | null, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null } | null } | null, furnished?: { __typename?: 'FurnishedProperty', checkInTime?: string | null, maximumGuests?: number | null, wifiSSID?: string | null, wifiPassword?: string | null } | null } | null, contact?: { __typename?: 'Contact', firstName: string, lastName: string, id: string, email: string } | null }
    >, paymentCollection?: { __typename?: 'PaymentCollection', id: string, currency?: string | null, isPaid?: boolean | null, totalPaymentAmount?: number | null, proofStatus?: string | null, supportedPaymentMethods?: Array<{ __typename?: 'ReservationPaymentMethod', name: string, isEnabled?: boolean | null }> | null, proofAttachments?: Array<{ __typename?: 'Attachment', fileName: string, mimeType: string, url: string }> | null, invoices?: Array<{ __typename?: 'PaymentCollectionInvoice', id: string, allocatedAmount: number, invoiceNumber: string }> | null } | null, paymentSummary?: { __typename?: 'WebsiteBookingRegistrationPaymentSummary', pendingBookingAmount?: number | null, pendingServicesAmount?: number | null, pendingSecurityDepositAmount?: number | null, pendingTotalAmount?: number | null, isSecurityDepositCardOnFile?: boolean | null, alternativeSecurityDepositAmount?: number | null } | null, bankTransferBeneficiary?: { __typename?: 'WebsiteBookingRegistrationBankBeneficiaryDetails', bankName?: string | null, branch?: string | null, accountName?: string | null, accountNumber?: string | null, iban?: string | null, swiftCode?: string | null, accountCurrency?: string | null } | null, cryptoBeneficiary?: { __typename?: 'WebsiteBookingRegistrationCryptoBeneficiaryDetails', tokenSymbol: string, networks: Array<{ __typename?: 'WebsiteBookingRegistrationCryptoNetwork', networkName: string, address: string, qrCodeUrl: string }> } | null, securityDepositRefundDetails?: { __typename?: 'WebsiteBookingRegistrationSecurityDepositRefundDetails', bankTransfer?: { __typename?: 'WebsiteBookingRegistrationRefundBankDetails', beneficiaryName?: string | null, bankAccountNumber?: string | null, bankName?: string | null, branchName?: string | null, branchAddress?: string | null, country?: string | null, iban?: string | null, swiftCode?: string | null, accountCurrency?: string | null } | null, cryptocurrency?: { __typename?: 'WebsiteBookingRegistrationRefundCryptoDetails', networkName?: string | null, walletAddress?: string | null } | null } | null, businessInvoiceDetails?: { __typename?: 'WebsiteBookingRegistrationBusinessInvoiceDetails', companyLegalName?: string | null, vatNumber?: string | null, registeredCountryName?: string | null, registeredCity?: string | null } | null, pendingInvoices?: Array<{ __typename?: 'Invoice', id: string, status?: string | null, invoiceNumber: string, totalAmount: number, dueAmount?: number | null, paidAmount?: number | null, invoiceType?: string | null, currency?: string | null, paymentMethod?: string | null, reservations?: Array<{ __typename?: 'Reservation', id: string, confirmationNumber: string }> | null, extensions?: Array<{ __typename?: 'ReservationExtension', id: string, confirmationNumber?: string | null }> | null, issueDate?: { __typename?: 'Date', formatted: string } | null, dueDate?: { __typename?: 'Date', formatted: string } | null, breakdown?: Array<{ __typename?: 'InvoiceBreakdown', nights?: number | null, nightlyRate?: number | null, bookingAmount?: number | null, discountAmount?: number | null, bookingTotal?: number | null, vat?: { __typename?: 'PaymentVat', amount: number, percentage: number } | null, fees?: Array<{ __typename?: 'ReservationFee', name: string, value: number, percentage?: number | null, isTaxable?: boolean | null }> | null }> | null, invoiceItems?: Array<{ __typename?: 'InvoiceItem', id: string, unitPrice: number, quantity: number, description?: string | null, addOnService?: { __typename?: 'ReservationAddOnService', id: string, name: string } | null, damageType?: { __typename?: 'ReservationDamageType', id: string, name: string } | null }> | null }> | null, documentDisplayStatus: Array<{ __typename?: 'WebsiteBookingRegistrationDisplayStatus', canSetDocuments: boolean, reservation: { __typename?: 'Reservation', id: string } }> } | null };

export type CreateWebsiteReservationMutationVariables = Exact<{
  payload: WebsiteReservationPayloadInput;
}>;


export type CreateWebsiteReservationMutation = { __typename?: 'Mutation', createWebsiteReservation: { __typename?: 'WebsiteReservationResult', id: string, bookingCompletionLink: string } };

export type SetWebsiteBrLinkRefundBankDetailsMutationVariables = Exact<{
  payload: WebsiteBrLinkRefundBankDetailsPayloadInput;
}>;


export type SetWebsiteBrLinkRefundBankDetailsMutation = { __typename?: 'Mutation', setWebsiteBRLinkRefundBankDetails: boolean };

export type SetWebsiteBrLinkRefundCryptoDetailsMutationVariables = Exact<{
  payload: WebsiteBrLinkRefundCryptoDetailsPayloadInput;
}>;


export type SetWebsiteBrLinkRefundCryptoDetailsMutation = { __typename?: 'Mutation', setWebsiteBRLinkRefundCryptoDetails: boolean };

export type SetWebsiteBrLinkBusinessInvoiceDetailsMutationVariables = Exact<{
  payload: WebsiteBrLinkBusinessInvoiceDetailsPayloadInput;
}>;


export type SetWebsiteBrLinkBusinessInvoiceDetailsMutation = { __typename?: 'Mutation', setWebsiteBRLinkBusinessInvoiceDetails: boolean };

export type UpgradeWebsiteBrLinkDamageProtectionPolicyMutationVariables = Exact<{
  payload: WebsiteBrLinkUpgradeDamageProtectionPolicyPayloadInput;
}>;


export type UpgradeWebsiteBrLinkDamageProtectionPolicyMutation = { __typename?: 'Mutation', upgradeWebsiteBRLinkDamageProtectionPolicy?: { __typename?: 'WebsiteBookingRegistrationLink', isPointOfContact: boolean, etaTimeSlots: Array<string>, canRequestBusinessInvoice: boolean, canSetETA: boolean, canSetSpecialRequests: boolean, canShowCheckInDetailsOnSuccess: boolean, pendingSteps: Array<WebsiteBookingRegistrationPendingStep>, contact?: { __typename?: 'Contact', id: string, firstName: string, lastName: string, email: string, isOTAEmail?: boolean | null, hasAccount?: boolean | null, phone?: { __typename?: 'Phone', code: string, number: string } | null } | null, corporate?: { __typename?: 'Corporate', id: string, legalName?: string | null } | null, entries: Array<
      | { __typename?: 'Reservation', id: string, estimatedArrivalTime?: string | null, specialRequests?: string | null, nights?: number | null, checkInTime?: string | null, checkOutTime?: string | null, numberOfGuests?: number | null, reservationConfirmationNumber: string, documents?: Array<{ __typename?: 'ReservationDocument', isMainGuest?: boolean | null, documentStatus?: string | null, document: { __typename?: 'Document', id: string, documentType?: string | null, attachments: Array<{ __typename?: 'Attachment', fileName: string, mimeType: string, url: string }> }, content?: { __typename?: 'ReservationIdentityDocumentContent', firstName?: string | null, lastName?: string | null, fatherName?: string | null, grandfatherName?: string | null, documentNumber?: string | null, expiryDate?: { __typename?: 'Date', raw?: string | null, formatted: string } | null } | null }> | null, checkInDate?: { __typename?: 'Date', raw?: string | null, formatted: string } | null, checkOutDate?: { __typename?: 'Date', raw?: string | null, formatted: string } | null, extendedCheckOutDate?: { __typename?: 'Date', raw?: string | null, formatted: string } | null, property?: { __typename?: 'Property', id: string, listingNameRendered?: string | null, unitNumber?: string | null, parkingNumber?: string | null, propertyType?: { __typename?: 'PropertyType', name: string } | null, images?: { __typename?: 'ImageSet', all?: Array<{ __typename?: 'OptimizedImage', url: string, captionRendered?: string | null, displayOrder?: number | null, imageType?: string | null, webp?: { __typename?: 'Webp', largeUrl?: string | null, mediumUrl?: string | null, thumbnailUrl?: string | null } | null }> | null, main?: { __typename?: 'OptimizedImage', url: string, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null } | null } | null, building?: { __typename?: 'Building', id: string, listingNameRendered?: string | null, location?: { __typename?: 'EntityLocation', address: string, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null } | null } | null, location?: { __typename?: 'EntityLocation', address: string, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null } | null, furnished?: { __typename?: 'FurnishedProperty', checkInTime?: string | null, maximumGuests?: number | null, wifiSSID?: string | null, wifiPassword?: string | null } | null } | null, passcode?: { __typename?: 'SmartLockPasscode', code?: string | null } | null }
      | { __typename?: 'ReservationExtension', id: string, nights?: number | null, extensionConfirmationNumber?: string | null, checkInDate?: { __typename?: 'Date', raw?: string | null, formatted: string } | null, checkOutDate?: { __typename?: 'Date', raw?: string | null, formatted: string } | null, property?: { __typename?: 'Property', id: string, listingNameRendered?: string | null, unitNumber?: string | null, parkingNumber?: string | null, propertyType?: { __typename?: 'PropertyType', name: string } | null, images?: { __typename?: 'ImageSet', main?: { __typename?: 'OptimizedImage', url: string, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, largeUrl?: string | null, mediumUrl?: string | null } | null } | null } | null, building?: { __typename?: 'Building', id: string, listingNameRendered?: string | null, location?: { __typename?: 'EntityLocation', address: string, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null } | null } | null, location?: { __typename?: 'EntityLocation', address: string, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null } | null, furnished?: { __typename?: 'FurnishedProperty', checkInTime?: string | null, maximumGuests?: number | null, wifiSSID?: string | null, wifiPassword?: string | null } | null } | null, reservation?: { __typename?: 'Reservation', id: string, estimatedArrivalTime?: string | null, specialRequests?: string | null, property?: { __typename?: 'Property', id: string, listingNameRendered?: string | null, images?: { __typename?: 'ImageSet', main?: { __typename?: 'OptimizedImage', url: string, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null } | null } | null } | null, nights?: number | null, checkInTime?: string | null, checkOutTime?: string | null, numberOfGuests?: number | null, reservationConfirmationNumber: string, checkInDate?: { __typename?: 'Date', raw?: string | null, formatted: string } | null, checkOutDate?: { __typename?: 'Date', raw?: string | null, formatted: string } | null, invoices?: Array<{ __typename?: 'Invoice', id: string, invoiceNumber: string }> | null, extendedCheckOutDate?: { __typename?: 'Date', raw?: string | null, formatted: string } | null, documents?: Array<{ __typename?: 'ReservationDocument', isMainGuest?: boolean | null, documentStatus?: string | null, document: { __typename?: 'Document', id: string, documentType?: string | null, attachments: Array<{ __typename?: 'Attachment', fileName: string, mimeType: string, url: string }> }, content?: { __typename?: 'ReservationIdentityDocumentContent', firstName?: string | null, lastName?: string | null, documentNumber?: string | null, expiryDate?: { __typename?: 'Date', raw?: string | null, formatted: string } | null } | null }> | null, passcode?: { __typename?: 'SmartLockPasscode', code?: string | null } | null } | null }
    >, paymentCollection?: { __typename?: 'PaymentCollection', id: string, currency?: string | null, isPaid?: boolean | null, totalPaymentAmount?: number | null, supportedPaymentMethods?: Array<{ __typename?: 'ReservationPaymentMethod', name: string, isEnabled?: boolean | null }> | null, proofAttachments?: Array<{ __typename?: 'Attachment', fileName: string, mimeType: string, url: string }> | null } | null, paymentSummary?: { __typename?: 'WebsiteBookingRegistrationPaymentSummary', pendingBookingAmount?: number | null, pendingServicesAmount?: number | null, pendingSecurityDepositAmount?: number | null, pendingTotalAmount?: number | null, isSecurityDepositCardOnFile?: boolean | null, alternativeSecurityDepositAmount?: number | null } | null, bankTransferBeneficiary?: { __typename?: 'WebsiteBookingRegistrationBankBeneficiaryDetails', bankName?: string | null, branch?: string | null, accountName?: string | null, accountNumber?: string | null, iban?: string | null, swiftCode?: string | null, accountCurrency?: string | null } | null, cryptoBeneficiary?: { __typename?: 'WebsiteBookingRegistrationCryptoBeneficiaryDetails', tokenSymbol: string, networks: Array<{ __typename?: 'WebsiteBookingRegistrationCryptoNetwork', networkName: string, address: string, qrCodeUrl: string }> } | null, securityDepositRefundDetails?: { __typename?: 'WebsiteBookingRegistrationSecurityDepositRefundDetails', bankTransfer?: { __typename?: 'WebsiteBookingRegistrationRefundBankDetails', beneficiaryName?: string | null, bankAccountNumber?: string | null, bankName?: string | null, branchName?: string | null, branchAddress?: string | null, country?: string | null, iban?: string | null, swiftCode?: string | null, accountCurrency?: string | null } | null, cryptocurrency?: { __typename?: 'WebsiteBookingRegistrationRefundCryptoDetails', networkName?: string | null, walletAddress?: string | null } | null } | null, businessInvoiceDetails?: { __typename?: 'WebsiteBookingRegistrationBusinessInvoiceDetails', companyLegalName?: string | null, vatNumber?: string | null, registeredCountryName?: string | null, registeredCity?: string | null } | null, pendingInvoices?: Array<{ __typename?: 'Invoice', id: string, invoiceNumber: string, totalAmount: number, dueAmount?: number | null, paidAmount?: number | null, invoiceType?: string | null, currency?: string | null, paymentMethod?: string | null, reservations?: Array<{ __typename?: 'Reservation', id: string, confirmationNumber: string }> | null, extensions?: Array<{ __typename?: 'ReservationExtension', id: string, confirmationNumber?: string | null }> | null, issueDate?: { __typename?: 'Date', formatted: string } | null, dueDate?: { __typename?: 'Date', formatted: string } | null, breakdown?: Array<{ __typename?: 'InvoiceBreakdown', nights?: number | null, nightlyRate?: number | null, bookingAmount?: number | null, discountAmount?: number | null, bookingTotal?: number | null, vat?: { __typename?: 'PaymentVat', amount: number, percentage: number } | null, fees?: Array<{ __typename?: 'ReservationFee', name: string, value: number, percentage?: number | null, isTaxable?: boolean | null }> | null }> | null, invoiceItems?: Array<{ __typename?: 'InvoiceItem', id: string, unitPrice: number, quantity: number, description?: string | null, addOnService?: { __typename?: 'ReservationAddOnService', id: string, name: string } | null, damageType?: { __typename?: 'ReservationDamageType', id: string, name: string } | null }> | null }> | null } | null };

export type SetWebsiteBrLinkGuestCountMutationVariables = Exact<{
  payload: WebsiteBrLinkGuestCountPayloadInput;
}>;


export type SetWebsiteBrLinkGuestCountMutation = { __typename?: 'Mutation', setWebsiteBRLinkGuestCount: boolean };

export type SetContactProfileMutationVariables = Exact<{
  brCode?: InputMaybe<Scalars['String']['input']>;
  payload: ContactPayloadInput;
}>;


export type SetContactProfileMutation = { __typename?: 'Mutation', setContactProfile: boolean };

export type SetReservationEstimatedArrivalTimeMutationVariables = Exact<{
  payload: ReservationEstimatedArrivalTimePayloadInput;
}>;


export type SetReservationEstimatedArrivalTimeMutation = { __typename?: 'Mutation', setReservationEstimatedArrivalTime: boolean };

export type SetReservationSpecialRequestsMutationVariables = Exact<{
  payload: ReservationSpecialRequestsPayloadInput;
}>;


export type SetReservationSpecialRequestsMutation = { __typename?: 'Mutation', setReservationSpecialRequests: boolean };

export type FindMyReservationQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type FindMyReservationQuery = { __typename?: 'Query', findMyReservation?: { __typename?: 'FindMyReservationResult', contact: { __typename?: 'Contact', id: string, firstName: string, lastName: string, email: string, isOTAEmail?: boolean | null, hasAccount?: boolean | null, phone?: { __typename?: 'Phone', code: string, number: string } | null }, reservation: { __typename?: 'Reservation', checkInTime?: string | null, numberOfGuests?: number | null, specialRequests?: string | null, checkInDate?: { __typename?: 'Date', formatted: string, raw?: string | null } | null, checkOutDate?: { __typename?: 'Date', formatted: string, raw?: string | null } | null, property?: { __typename?: 'Property', aboutPropertyRendered?: string | null, currency?: string | null, entityType?: PropertyEntityType | null, floorNumber?: number | null } | null, payment?: { __typename?: 'ReservationPaymentPlan', currency: string, grandBookingTotal: number, isPaid?: boolean | null, paymentMethods: Array<{ __typename: 'ReservationPaymentMethod', isEnabled?: boolean | null, isOnline?: boolean | null, name: string }> } | null } } | null };

export type PasscodeCheckQueryVariables = Exact<{
  brCode: Scalars['String']['input'];
}>;


export type PasscodeCheckQuery = { __typename?: 'Query', result?: { __typename?: 'WebsiteBookingRegistrationLink', entries: Array<
      | { __typename?: 'Reservation', id: string, passcode?: { __typename?: 'SmartLockPasscode', code?: string | null, id: string, status?: SmartLockPasscodeStatus | null } | null }
      | { __typename?: 'ReservationExtension' }
    > } | null };

export type AcceptWebsiteBrLinkTermsConditionsMutationVariables = Exact<{
  brCode: Scalars['String']['input'];
  contractBase64Signature?: InputMaybe<Scalars['String']['input']>;
}>;


export type AcceptWebsiteBrLinkTermsConditionsMutation = { __typename?: 'Mutation', acceptWebsiteBRLinkTermsConditions: boolean };

export type SetWebsiteBrWizardAsCompletedMutationVariables = Exact<{
  brCode: Scalars['String']['input'];
}>;


export type SetWebsiteBrWizardAsCompletedMutation = { __typename?: 'Mutation', setWebsiteBRWizardAsCompleted: boolean };

export type GetBuildingDetailsQueryVariables = Exact<{
  buildingID: Scalars['ID']['input'];
  options?: InputMaybe<CommonQueryOptionsInput>;
}>;


export type GetBuildingDetailsQuery = { __typename?: 'Query', buildings: { __typename: 'BuildingResult', count: number, records: Array<{ __typename: 'Building', id: string, listingNameRendered?: string | null, aboutBuildingRendered?: string | null, quotation?: { __typename?: 'ReservationQuotation', paymentPlan?: { __typename?: 'ReservationPaymentPlan', grandBookingTotal: number, grandTotal: number, currency: string, originalBookingTotal?: number | null, singlePayment?: Array<{ __typename?: 'ReservationPayment', nights?: number | null, nightlyRate?: number | null, bookingAmount?: number | null, bookingTotal: number, discountAmount?: number | null, isPaid?: boolean | null, amountPaid?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string }> | null, fees?: Array<{ __typename?: 'ReservationFee', value: number, name: string }> | null }> | null, securityDeposit?: { __typename?: 'DamageProtectionPolicyPayment', isInSameTransaction?: boolean | null, corporatePaysForTheSecurityDeposit?: boolean | null, damageProtectionPolicyType?: string | null, isPaid?: boolean | null, totalAmount?: number | null, isDueNow?: boolean | null, dueOn?: { __typename?: 'Date', formatted: string } | null } | null, paymentMethods: Array<{ __typename?: 'ReservationPaymentMethod', name: string, isEnabled?: boolean | null }> } | null } | null, location?: { __typename: 'EntityLocation', address: string, coordinates?: { __typename: 'Coordinates', lat: number, lng: number } | null, neighbourhood?: { __typename: 'Neighbourhood', id: string, name: string, city?: { __typename: 'City', id: string, name: string, country?: { __typename: 'Country', id: string, name: string, code2?: string | null } | null } | null } | null } | null, highLevelAmenities?: Array<{ __typename: 'HighLevelAmenity', id: string, name: string, iconUrl: string, contentRendered?: string | null }> | null, images?: { __typename: 'ImageSet', all?: Array<{ __typename: 'OptimizedImage', displayOrder?: number | null, imageType?: string | null, url: string, webp?: { __typename: 'Webp', largeUrl?: string | null, mediumUrl?: string | null, thumbnailUrl?: string | null } | null }> | null, main?: { __typename: 'OptimizedImage', url: string, webp?: { __typename: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null } | null } | null }> } };

export type SearchBuildingsQueryVariables = Exact<{
  filter?: InputMaybe<BuildingFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
}>;


export type SearchBuildingsQuery = { __typename?: 'Query', buildings: { __typename: 'BuildingResult', count: number, records: Array<{ __typename: 'Building', id: string, listingNameRendered?: string | null, aboutBuildingRendered?: string | null, location?: { __typename: 'EntityLocation', address: string, coordinates?: { __typename: 'Coordinates', lat: number, lng: number } | null, neighbourhood?: { __typename: 'Neighbourhood', id: string, name: string, city?: { __typename: 'City', id: string, name: string, country?: { __typename: 'Country', id: string, name: string, code2?: string | null } | null } | null } | null } | null, highLevelAmenities?: Array<{ __typename: 'HighLevelAmenity', id: string, name: string, iconUrl: string }> | null, images?: { __typename: 'ImageSet', main?: { __typename: 'OptimizedImage', url: string, webp?: { __typename: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null } | null, all?: Array<{ __typename: 'OptimizedImage', url: string, imageType?: string | null, captionRendered?: string | null, webp?: { __typename: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null }> | null } | null, quotation?: { __typename?: 'ReservationQuotation', paymentPlan?: { __typename?: 'ReservationPaymentPlan', currency: string, originalBookingTotal?: number | null, grandTotal: number, paymentMethods: Array<{ __typename?: 'ReservationPaymentMethod', name: string, isEnabled?: boolean | null }>, securityDeposit?: { __typename?: 'DamageProtectionPolicyPayment', totalAmount?: number | null, isDueNow?: boolean | null, isInSameTransaction?: boolean | null, damageProtectionPolicyType?: string | null, corporatePaysForTheSecurityDeposit?: boolean | null, isPaid?: boolean | null, dueOn?: { __typename?: 'Date', formatted: string } | null } | null, singlePayment?: Array<{ __typename?: 'ReservationPayment', nights?: number | null, bookingTotal: number, nightlyRate?: number | null, discountAmount?: number | null, bookingAmount?: number | null, isPaid?: boolean | null, amountPaid?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string }> | null, fees?: Array<{ __typename?: 'ReservationFee', value: number, name: string }> | null }> | null } | null } | null }> } };

export type BuildingsWithStandalonePropertiesQueryVariables = Exact<{
  filter: BuildingsWithStandalonePropertiesFilterInput;
  options?: InputMaybe<CommonQueryOptionsInput>;
}>;


export type BuildingsWithStandalonePropertiesQuery = { __typename?: 'Query', result: Array<
    | { __typename: 'Building', id: string, listingNameRendered?: string | null, aboutBuildingRendered?: string | null, location?: { __typename?: 'EntityLocation', id: string, address: string, zipCode?: string | null, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null, neighbourhood?: { __typename?: 'Neighbourhood', id: string, name: string, city?: { __typename?: 'City', id: string, name: string, airportCode: string, country?: { __typename?: 'Country', id: string, name: string, code3?: string | null, code2?: string | null, currency?: string | null } | null } | null } | null } | null, highLevelAmenities?: Array<{ __typename?: 'HighLevelAmenity', id: string, name: string, iconUrl: string, contentRendered?: string | null }> | null, images?: { __typename?: 'ImageSet', main?: { __typename?: 'OptimizedImage', url: string, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null } | null, all?: Array<{ __typename?: 'OptimizedImage', url: string, imageType?: string | null, displayOrder?: number | null, captionRendered?: string | null, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null }> | null } | null, quotation?: { __typename?: 'ReservationQuotation', paymentPlan?: { __typename?: 'ReservationPaymentPlan', currency: string, originalBookingTotal?: number | null, grandTotal: number, paymentMethods: Array<{ __typename?: 'ReservationPaymentMethod', name: string, isEnabled?: boolean | null }>, securityDeposit?: { __typename?: 'DamageProtectionPolicyPayment', totalAmount?: number | null, isDueNow?: boolean | null, isInSameTransaction?: boolean | null, damageProtectionPolicyType?: string | null, corporatePaysForTheSecurityDeposit?: boolean | null, isPaid?: boolean | null, dueOn?: { __typename?: 'Date', formatted: string } | null } | null, singlePayment?: Array<{ __typename?: 'ReservationPayment', nights?: number | null, bookingTotal: number, nightlyRate?: number | null, discountAmount?: number | null, bookingAmount?: number | null, isPaid?: boolean | null, amountPaid?: number | null, vat?: { __typename?: 'PaymentVat', amount: number, percentage: number } | null, invoices?: Array<{ __typename?: 'Invoice', invoiceNumber: string, id: string, totalAmount: number, dueAmount?: number | null, paidAmount?: number | null }> | null, fees?: Array<{ __typename?: 'ReservationFee', percentage?: number | null, value: number, name: string }> | null }> | null } | null } | null }
    | { __typename: 'Property', id: string, entityType?: PropertyEntityType | null, currency?: string | null, unitNumber?: string | null, floorNumber?: number | null, parkingNumber?: string | null, listingNameRendered?: string | null, bedroomCount?: number | null, bathCount?: number | null, hasKitchen?: boolean | null, sizeSqm?: number | null, balconySizeSqm?: number | null, securityDepositAmount?: number | null, aboutPropertyRendered?: string | null, propertyType?: { __typename?: 'PropertyType', name: string, isStandalone: boolean } | null, building?: { __typename?: 'Building', id: string, listingNameRendered?: string | null, location?: { __typename?: 'EntityLocation', id: string, address: string, zipCode?: string | null, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null, neighbourhood?: { __typename?: 'Neighbourhood', id: string, name: string, city?: { __typename?: 'City', id: string, name: string, airportCode: string, vatPercentage?: number | null, country?: { __typename?: 'Country', id: string, name: string, code3?: string | null, code2?: string | null, currency?: string | null, vatPercentage?: number | null } | null } | null } | null } | null, highLevelAmenities?: Array<{ __typename?: 'HighLevelAmenity', id: string, name: string, iconUrl: string, contentRendered?: string | null }> | null, images?: { __typename?: 'ImageSet', main?: { __typename?: 'OptimizedImage', url: string, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null } | null, all?: Array<{ __typename?: 'OptimizedImage', url: string, imageType?: string | null, displayOrder?: number | null, captionRendered?: string | null, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null }> | null } | null } | null, location?: { __typename?: 'EntityLocation', id: string, address: string, zipCode?: string | null, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null, neighbourhood?: { __typename?: 'Neighbourhood', id: string, name: string, city?: { __typename?: 'City', id: string, name: string, airportCode: string, vatPercentage?: number | null, country?: { __typename?: 'Country', id: string, name: string, code3?: string | null, code2?: string | null, currency?: string | null, vatPercentage?: number | null } | null } | null } | null } | null, highLevelAmenities?: Array<{ __typename?: 'HighLevelAmenity', id: string, name: string, iconUrl: string, contentRendered?: string | null }> | null, images?: { __typename?: 'ImageSet', main?: { __typename?: 'OptimizedImage', url: string, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null } | null, all?: Array<{ __typename?: 'OptimizedImage', url: string, imageType?: string | null, displayOrder?: number | null, captionRendered?: string | null, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null }> | null } | null, houseRules?: Array<{ __typename?: 'HouseRule', id: string, name: string, iconUrl: string, contentRendered?: { __typename?: 'HouseRuleContent', languageCode: LanguageCode, title: string, body: string } | null }> | null, furnished?: { __typename?: 'FurnishedProperty', bedCount?: number | null, maximumGuests?: number | null, checkInTime?: string | null, checkOutTime?: string | null, sleepingArrangement?: Array<{ __typename?: 'FurnishedPropertySleepingArrangement', bedroomNumber?: number | null, bedTypes: Array<string> }> | null } | null, quotation?: { __typename?: 'ReservationQuotation', paymentPlan?: { __typename?: 'ReservationPaymentPlan', currency: string, originalBookingTotal?: number | null, grandTotal: number, paymentMethods: Array<{ __typename?: 'ReservationPaymentMethod', name: string, isEnabled?: boolean | null }>, securityDeposit?: { __typename?: 'DamageProtectionPolicyPayment', totalAmount?: number | null, isDueNow?: boolean | null, isInSameTransaction?: boolean | null, damageProtectionPolicyType?: string | null, corporatePaysForTheSecurityDeposit?: boolean | null, isPaid?: boolean | null, dueOn?: { __typename?: 'Date', formatted: string } | null } | null, singlePayment?: Array<{ __typename?: 'ReservationPayment', nights?: number | null, bookingTotal: number, nightlyRate?: number | null, discountAmount?: number | null, bookingAmount?: number | null, isPaid?: boolean | null, amountPaid?: number | null, vat?: { __typename?: 'PaymentVat', amount: number, percentage: number } | null, invoices?: Array<{ __typename?: 'Invoice', invoiceNumber: string, id: string, totalAmount: number, dueAmount?: number | null, paidAmount?: number | null }> | null, fees?: Array<{ __typename?: 'ReservationFee', percentage?: number | null, value: number, name: string }> | null }> | null } | null } | null }
  > };

export type SubmitWebsiteContactUsMutationVariables = Exact<{
  payload: WebsiteContactMessageInput;
}>;


export type SubmitWebsiteContactUsMutation = { __typename?: 'Mutation', submitWebsiteContactUs: boolean };

export type SubmitWebsiteLeaseFormMutationVariables = Exact<{
  payload: WebsiteLeaseFormInput;
}>;


export type SubmitWebsiteLeaseFormMutation = { __typename?: 'Mutation', submitWebsiteLeaseForm: boolean };

export type SubmitWebsiteCorporateContactMutationVariables = Exact<{
  payload: WebsiteCorporateContactInput;
}>;


export type SubmitWebsiteCorporateContactMutation = { __typename?: 'Mutation', submitWebsiteCorporateContact: boolean };

export type WebsiteHelpCenterContentQueryVariables = Exact<{ [key: string]: never; }>;


export type WebsiteHelpCenterContentQuery = { __typename?: 'Query', websiteHelpCenterContent: Array<{ __typename?: 'WebsiteHelpCenterContent', id: string, sectionTitle: string, sectionID: string, question: string, answer: string }> };

export type SubmitWebsiteViewingRequestMutationVariables = Exact<{
  payload: WebsiteViewingRequestInput;
}>;


export type SubmitWebsiteViewingRequestMutation = { __typename?: 'Mutation', submitWebsiteViewingRequest: boolean };

export type RequestFileUploadHandleMutationVariables = Exact<{
  payload: FileUploadHandlePayloadInput;
}>;


export type RequestFileUploadHandleMutation = { __typename?: 'Mutation', requestFileUploadHandle: { __typename: 'UploadResponse', name: string, signedUrl: string, assetUrl: string } };

export type GetInvoicesQueryVariables = Exact<{
  filters?: InputMaybe<InvoiceFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
}>;


export type GetInvoicesQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceResult', records: Array<{ __typename?: 'Invoice', id: string, invoiceNumber: string, totalAmount: number, dueAmount?: number | null, paidAmount?: number | null, invoiceType?: string | null, status?: string | null, paymentMethod?: string | null, currency?: string | null, paidAt?: { __typename?: 'DateTime', formatted: string, raw?: string | null } | null, breakdown?: Array<{ __typename?: 'InvoiceBreakdown', nights?: number | null, nightlyRate?: number | null, bookingAmount?: number | null, discountAmount?: number | null, discountReason?: string | null, bookingTotal?: number | null, otaCommission?: number | null, vat?: { __typename?: 'PaymentVat', percentage: number, amount: number } | null, fees?: Array<{ __typename?: 'ReservationFee', name: string, value: number, percentage?: number | null }> | null, adjustments?: Array<{ __typename?: 'InvoiceAdjustmentDetails', amount: number, details?: string | null }> | null }> | null, discrepancy?: { __typename?: 'InvoiceDiscrepancy', amount: number, percentage: number } | null, reservations?: Array<{ __typename?: 'Reservation', numberOfGuests?: number | null, id: string, confirmationNumber: string, checkInTime?: string | null, checkOutTime?: string | null, documents?: Array<{ __typename?: 'ReservationDocument', isMainGuest?: boolean | null, documentStatus?: string | null, document: { __typename?: 'Document', id: string, documentType?: string | null, attachments: Array<{ __typename?: 'Attachment', fileName: string, mimeType: string, url: string }>, lastUpdated?: { __typename?: 'DateTime', formatted: string, raw?: string | null } | null }, reviewedBy?: { __typename?: 'Staff', lastName: string, firstName: string, email: string, picture?: string | null } | null, content?: { __typename?: 'ReservationIdentityDocumentContent', firstName?: string | null, lastName?: string | null, fatherName?: string | null, grandfatherName?: string | null, documentNumber?: string | null } | null }> | null, channel?: { __typename?: 'BookingChannel', id: string, name: string } | null, checkInDate?: { __typename?: 'Date', formatted: string, raw?: string | null } | null, checkOutDate?: { __typename?: 'Date', formatted: string, raw?: string | null } | null, property?: { __typename?: 'Property', listingNameRendered?: string | null, aboutPropertyRendered?: string | null, internalName?: string | null, location?: { __typename?: 'EntityLocation', id: string, address: string, zipCode?: string | null, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null, neighbourhood?: { __typename?: 'Neighbourhood', id: string, name: string, city?: { __typename?: 'City', id: string, name: string } | null } | null } | null, images?: { __typename?: 'ImageSet', main?: { __typename?: 'OptimizedImage', url: string, imageType?: string | null, displayOrder?: number | null, captionRendered?: string | null, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null } | null } | null } | null }> | null }> } };

export type GetCancellationPolicyTextQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCancellationPolicyTextQuery = { __typename?: 'Query', cancellationPolicyText: Array<{ __typename?: 'TranslatedContent', body: string, languageCode: LanguageCode }> };

export type SupportedLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type SupportedLanguagesQuery = { __typename?: 'Query', languages: Array<{ __typename?: 'Language', code: LanguageCode, direction: string, name: string, id: string }> };

export type LocalizationsQueryVariables = Exact<{
  filters: LocalisationsFilterInput;
}>;


export type LocalizationsQuery = { __typename?: 'Query', localisations: Array<{ __typename?: 'Localisation', lookupKey: string, content: string, tags?: Array<string> | null }> };

export type GetCitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCitiesQuery = { __typename?: 'Query', cities: Array<{ __typename?: 'City', id: string, name: string }> };

export type CreateWebsiteBrLinkPaymentIntentMutationVariables = Exact<{
  payload: WebsiteBrLinkPaymentIntentPayloadInput;
}>;


export type CreateWebsiteBrLinkPaymentIntentMutation = { __typename?: 'Mutation', createWebsiteBRLinkPaymentIntent: { __typename?: 'WebsiteBRLinkPaymentIntentPayloadResponse', intentReferenceKey: string, clientSecret?: string | null, publishableKey?: string | null } };

export type CreateWebsiteBrLinkCardOnFileIntentMutationVariables = Exact<{
  payload: WebsiteBrLinkCardOnFileIntentPayloadInput;
}>;


export type CreateWebsiteBrLinkCardOnFileIntentMutation = { __typename?: 'Mutation', createWebsiteBRLinkCardOnFileIntent: { __typename?: 'WebsiteBRLinkPaymentIntentPayloadResponse', intentReferenceKey: string, clientSecret?: string | null, publishableKey?: string | null } };

export type SubmitPaymentCollectionProofMutationVariables = Exact<{
  payload: PaymentCollectionProofSubmissionPayloadInput;
}>;


export type SubmitPaymentCollectionProofMutation = { __typename?: 'Mutation', submitPaymentCollectionProof: boolean };

export type ProcessWebsiteBrLinkCardPurchaseMutationVariables = Exact<{
  payload: WebsiteBrLinkCardPurchasePayloadInput;
}>;


export type ProcessWebsiteBrLinkCardPurchaseMutation = { __typename?: 'Mutation', processWebsiteBRLinkCardPurchase: { __typename?: 'WebsiteBRLinkCardPurchaseResponse', result: string, redirectUrl?: string | null, declineMessage?: string | null, publicID?: string | null, skipWaiting?: boolean | null, redirectParams?: Array<{ __typename?: 'WebsiteBRLinkCardPurchaseRedirectParam', name: string, value: string }> | null, returnUrlQueryParams?: Array<{ __typename?: 'WebsiteBRLinkCardPurchaseRedirectParam', name: string, value: string }> | null } };

export type WebsiteBrLinkCryptoTotalAmountQueryVariables = Exact<{
  payload: WebsiteBrLinkCryptoTotalAmountInput;
}>;


export type WebsiteBrLinkCryptoTotalAmountQuery = { __typename?: 'Query', websiteBRLinkCryptoTotalAmount: number };

export type WebsiteBrLinkPendingInvoicesStatusQueryVariables = Exact<{
  brCode: Scalars['String']['input'];
}>;


export type WebsiteBrLinkPendingInvoicesStatusQuery = { __typename?: 'Query', result?: { __typename?: 'WebsiteBookingRegistrationLink', pendingInvoices?: Array<{ __typename?: 'Invoice', status?: string | null, invoiceNumber: string, invoiceType?: string | null }> | null } | null };

export type WebsitePaymentLinkPendingInvoicesStatusQueryVariables = Exact<{
  plNumber: Scalars['String']['input'];
}>;


export type WebsitePaymentLinkPendingInvoicesStatusQuery = { __typename?: 'Query', result?: { __typename?: 'WebsitePaymentLink', pendingInvoices?: Array<{ __typename?: 'Invoice', status?: string | null, invoiceNumber: string, invoiceType?: string | null }> | null } | null };

export type WebsitePaymentLinkQueryVariables = Exact<{
  plNumber: Scalars['String']['input'];
}>;


export type WebsitePaymentLinkQuery = { __typename?: 'Query', websitePaymentLink?: { __typename?: 'WebsitePaymentLink', redirectToPaymentLink?: string | null, canShowSuccessfulPaymentView: boolean, canRequestBusinessInvoice: boolean, account?: { __typename?: 'BookkeepingAccount', name: string, id: string } | null, paymentCollection?: { __typename?: 'PaymentCollection', id: string, isOnlineCollection?: boolean | null, isPaid?: boolean | null, proofStatus?: string | null, currency?: string | null, totalPaymentAmount?: number | null, invoices?: Array<{ __typename?: 'PaymentCollectionInvoice', id: string, invoiceNumber: string, allocatedAmount: number }> | null, supportedPaymentMethods?: Array<{ __typename?: 'ReservationPaymentMethod', name: string, isEnabled?: boolean | null, isOnline?: boolean | null }> | null, actualPaymentMethod?: { __typename?: 'ReservationPaymentMethod', name: string, isEnabled?: boolean | null, isOnline?: boolean | null } | null, proofAttachments?: Array<{ __typename?: 'Attachment', fileName: string, mimeType: string, url: string }> | null } | null, pendingInvoices?: Array<{ __typename?: 'Invoice', id: string, currency?: string | null, invoiceNumber: string, totalAmount: number, dueAmount?: number | null, paidAmount?: number | null, invoiceType?: string | null, reservations?: Array<{ __typename?: 'Reservation', id: string }> | null, invoiceItems?: Array<{ __typename?: 'InvoiceItem', description?: string | null, quantity: number, id: string, unitPrice: number, addOnService?: { __typename?: 'ReservationAddOnService', cost?: number | null, name: string, id: string } | null, damageType?: { __typename?: 'ReservationDamageType', cost?: number | null, id: string, name: string } | null }> | null, breakdown?: Array<{ __typename?: 'InvoiceBreakdown', nights?: number | null, nightlyRate?: number | null, bookingAmount?: number | null, discountAmount?: number | null, bookingTotal?: number | null, otaCommission?: number | null, vat?: { __typename?: 'PaymentVat', percentage: number, amount: number } | null, fees?: Array<{ __typename?: 'ReservationFee', name: string, value: number, percentage?: number | null, isTaxable?: boolean | null }> | null }> | null }> | null, bankTransferBeneficiary?: { __typename?: 'WebsiteBookingRegistrationBankBeneficiaryDetails', bankName?: string | null, branch?: string | null, accountName?: string | null, accountNumber?: string | null, iban?: string | null, swiftCode?: string | null, accountCurrency?: string | null } | null, cryptoBeneficiary?: { __typename?: 'WebsiteBookingRegistrationCryptoBeneficiaryDetails', tokenSymbol: string, networks: Array<{ __typename?: 'WebsiteBookingRegistrationCryptoNetwork', networkName: string, address: string, qrCodeUrl: string }> } | null, entries: Array<
      | { __typename: 'Reservation', id: string, nights?: number | null, numberOfGuests?: number | null, checkInTime?: string | null, checkOutTime?: string | null, confirmationNumber: string, contact?: { __typename?: 'Contact', firstName: string, lastName: string, id: string } | null, checkInDate?: { __typename?: 'Date', formatted: string, raw?: string | null } | null, checkOutDate?: { __typename?: 'Date', formatted: string, raw?: string | null } | null, property?: { __typename?: 'Property', id: string, listingNameRendered?: string | null, location?: { __typename?: 'EntityLocation', id: string, zipCode?: string | null, address: string, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null, neighbourhood?: { __typename?: 'Neighbourhood', name: string, id: string, city?: { __typename?: 'City', id: string, name: string, airportCode: string } | null } | null } | null, images?: { __typename?: 'ImageSet', main?: { __typename?: 'OptimizedImage', url: string, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null } | null, all?: Array<{ __typename?: 'OptimizedImage', url: string, displayOrder?: number | null, captionRendered?: string | null, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null }> | null } | null } | null }
      | { __typename: 'ReservationExtension', id: string, nights?: number | null, extensionConfirmationNumber?: string | null, reservation?: { __typename?: 'Reservation', id: string } | null, contact?: { __typename?: 'Contact', firstName: string, lastName: string, id: string } | null, property?: { __typename?: 'Property', id: string, listingNameRendered?: string | null, location?: { __typename?: 'EntityLocation', id: string, zipCode?: string | null, address: string, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null, neighbourhood?: { __typename?: 'Neighbourhood', name: string, id: string, city?: { __typename?: 'City', id: string, name: string, airportCode: string } | null } | null } | null, images?: { __typename?: 'ImageSet', main?: { __typename?: 'OptimizedImage', url: string, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null } | null, all?: Array<{ __typename?: 'OptimizedImage', url: string, displayOrder?: number | null, captionRendered?: string | null, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null }> | null } | null } | null }
    > } | null };

export type WebsiteBrLinkCardOnFileInfoQueryVariables = Exact<{
  payload: WebsiteBrLinkCardOnFileInfoInput;
}>;


export type WebsiteBrLinkCardOnFileInfoQuery = { __typename?: 'Query', websiteBRLinkCardOnFileInfo?: { __typename?: 'CardOnFile', cardBrand?: string | null, cardNumber: string, currency?: string | null, id: string, pspType?: string | null } | null };

export type GetPropertyQuotationQueryVariables = Exact<{
  filters: PropertyFilterInput;
}>;


export type GetPropertyQuotationQuery = { __typename?: 'Query', properties: { __typename?: 'PropertyResult', records: Array<{ __typename?: 'Property', quotation?: { __typename?: 'ReservationQuotation', isDaysUnavailable?: boolean | null, isLengthOfStayViolated?: boolean | null, isDiscountInvalid?: boolean | null, paymentPlan?: { __typename?: 'ReservationPaymentPlan', currency: string, originalBookingTotal?: number | null, grandTotal: number, paymentMethods: Array<{ __typename?: 'ReservationPaymentMethod', name: string, isEnabled?: boolean | null }>, securityDeposit?: { __typename?: 'DamageProtectionPolicyPayment', totalAmount?: number | null, isDueNow?: boolean | null, isInSameTransaction?: boolean | null, damageProtectionPolicyType?: string | null, corporatePaysForTheSecurityDeposit?: boolean | null, isPaid?: boolean | null, dueOn?: { __typename?: 'Date', formatted: string } | null } | null, singlePayment?: Array<{ __typename?: 'ReservationPayment', nights?: number | null, bookingTotal: number, nightlyRate?: number | null, discountAmount?: number | null, bookingAmount?: number | null, isPaid?: boolean | null, amountPaid?: number | null, reservation?: { __typename?: 'Reservation', checkInTime?: string | null, checkOutTime?: string | null, checkOutInstructions?: { __typename?: 'CheckInOutInstructions', content?: Array<{ __typename?: 'TranslatedContent', body: string }> | null, email?: { __typename?: 'EmailDeliveryInfo', content?: string | null } | null } | null } | null, vat?: { __typename?: 'PaymentVat', amount: number, percentage: number } | null, invoices?: Array<{ __typename?: 'Invoice', invoiceNumber: string, id: string, totalAmount: number, dueAmount?: number | null, paidAmount?: number | null }> | null, fees?: Array<{ __typename?: 'ReservationFee', percentage?: number | null, value: number, name: string, isTaxable?: boolean | null }> | null }> | null } | null } | null }> } };

export type GetReservationsQueryVariables = Exact<{
  filters?: InputMaybe<ReservationFilterInput>;
}>;


export type GetReservationsQuery = { __typename?: 'Query', reservations: { __typename?: 'ReservationResult', records: Array<{ __typename?: 'Reservation', id: string, confirmationNumber: string, status?: string | null, numberOfGuests?: number | null, checkInTime?: string | null, checkOutTime?: string | null, extendedCheckOutDate?: { __typename?: 'Date', formatted: string, raw?: string | null } | null, documents?: Array<{ __typename: 'ReservationDocument', isMainGuest?: boolean | null, documentStatus?: string | null, isStatusOverridden?: boolean | null, document: { __typename: 'Document', id: string, documentType?: string | null, attachments: Array<{ __typename: 'Attachment', fileName: string, url: string, mimeType: string }> }, content?: { __typename?: 'ReservationIdentityDocumentContent', firstName?: string | null, lastName?: string | null, fatherName?: string | null, grandfatherName?: string | null, documentNumber?: string | null, documentVersionNumber?: string | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null } | null }> | null, invoices?: Array<{ __typename?: 'Invoice', id: string, totalAmount: number, currency?: string | null, paidAmount?: number | null, paymentMethod?: string | null, paidAt?: { __typename?: 'DateTime', formatted: string, raw?: string | null } | null, breakdown?: Array<{ __typename?: 'InvoiceBreakdown', nights?: number | null, nightlyRate?: number | null, bookingAmount?: number | null, discountAmount?: number | null, discountReason?: string | null, otaCommission?: number | null, vat?: { __typename?: 'PaymentVat', percentage: number, amount: number } | null, adjustments?: Array<{ __typename?: 'InvoiceAdjustmentDetails', amount: number, details?: string | null }> | null, fees?: Array<{ __typename?: 'ReservationFee', name: string, value: number, percentage?: number | null }> | null }> | null }> | null, checkInDate?: { __typename?: 'Date', formatted: string, raw?: string | null } | null, checkOutDate?: { __typename?: 'Date', formatted: string, raw?: string | null } | null, pointOfContact?: { __typename?: 'Contact', firstName: string, lastName: string, id: string, email: string, phone?: { __typename?: 'Phone', code: string, number: string } | null } | null, property?: { __typename: 'Property', id: string, internalName?: string | null, listingNameRendered?: string | null, bedroomCount?: number | null, bathCount?: number | null, furnished?: { __typename?: 'FurnishedProperty', maximumGuests?: number | null } | null, location?: { __typename: 'EntityLocation', id: string, address: string, coordinates?: { __typename: 'Coordinates', lat: number, lng: number } | null, neighbourhood?: { __typename?: 'Neighbourhood', id: string, name: string, city?: { __typename?: 'City', id: string, name: string, state?: string | null, vatPercentage?: number | null } | null } | null } | null, highLevelAmenities?: Array<{ __typename: 'HighLevelAmenity', id: string, name: string, iconUrl: string }> | null, images?: { __typename: 'ImageSet', main?: { __typename: 'OptimizedImage', url: string, webp?: { __typename: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null } | null, all?: Array<{ __typename: 'OptimizedImage', url: string, webp?: { __typename: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null }> | null } | null } | null }> } };

export type ExtractReservationIdentityDocumentsMutationVariables = Exact<{
  payload: ExtractReservationIdentityDocumentsPayloadInput;
}>;


export type ExtractReservationIdentityDocumentsMutation = { __typename?: 'Mutation', extractReservationIdentityDocuments: { __typename?: 'ExtractReservationIdentityDocumentsResult', isApproved?: boolean | null, rejectionReasons?: Array<string> | null, content?: { __typename?: 'ReservationIdentityDocumentContent', firstName?: string | null, lastName?: string | null, fatherName?: string | null, grandfatherName?: string | null, documentNumber?: string | null, gender?: string | null, expiryDate?: { __typename?: 'Date', raw?: string | null, formatted: string } | null, birthdate?: { __typename?: 'Date', raw?: string | null, formatted: string } | null, nationality?: { __typename?: 'Nationality', id: string, name: string } | null, issuingCountry?: { __typename?: 'Nationality', id: string, name: string } | null, placeOfBirth?: { __typename?: 'Nationality', id: string, name: string } | null } | null } };

export type CreateReservationDocumentMutationVariables = Exact<{
  documentID?: InputMaybe<Scalars['ID']['input']>;
  payload: ReservationDocumentPayloadInput;
}>;


export type CreateReservationDocumentMutation = { __typename?: 'Mutation', createReservationDocument: string };

export type DeleteReservationDocumentMutationVariables = Exact<{
  brCode?: InputMaybe<Scalars['String']['input']>;
  documentID: Scalars['ID']['input'];
  reservationID?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteReservationDocumentMutation = { __typename?: 'Mutation', deleteReservationDocument: boolean };

export type SearchUnitsQueryVariables = Exact<{
  filter?: InputMaybe<PropertyFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
}>;


export type SearchUnitsQuery = { __typename?: 'Query', properties: { __typename: 'PropertyResult', count: number, records: Array<{ __typename: 'Property', id: string, listingNameRendered?: string | null, bedroomCount?: number | null, bathCount?: number | null, propertyType?: { __typename?: 'PropertyType', isStandalone: boolean, name: string } | null, furnished?: { __typename?: 'FurnishedProperty', maximumGuests?: number | null } | null, houseRules?: Array<{ __typename: 'HouseRule', id: string, name: string, iconUrl: string, contentRendered?: { __typename?: 'HouseRuleContent', languageCode: LanguageCode, title: string, body: string } | null }> | null, location?: { __typename: 'EntityLocation', id: string, address: string, coordinates?: { __typename: 'Coordinates', lat: number, lng: number } | null } | null, highLevelAmenities?: Array<{ __typename: 'HighLevelAmenity', id: string, name: string, iconUrl: string }> | null, quotation?: { __typename?: 'ReservationQuotation', paymentPlan?: { __typename?: 'ReservationPaymentPlan', currency: string, originalBookingTotal?: number | null, grandTotal: number, paymentMethods: Array<{ __typename?: 'ReservationPaymentMethod', name: string, isEnabled?: boolean | null }>, securityDeposit?: { __typename?: 'DamageProtectionPolicyPayment', totalAmount?: number | null, isDueNow?: boolean | null, isInSameTransaction?: boolean | null, damageProtectionPolicyType?: string | null, corporatePaysForTheSecurityDeposit?: boolean | null, isPaid?: boolean | null, dueOn?: { __typename?: 'Date', formatted: string } | null } | null, singlePayment?: Array<{ __typename?: 'ReservationPayment', nights?: number | null, bookingTotal: number, nightlyRate?: number | null, discountAmount?: number | null, bookingAmount?: number | null, isPaid?: boolean | null, amountPaid?: number | null, vat?: { __typename?: 'PaymentVat', amount: number, percentage: number } | null, invoices?: Array<{ __typename?: 'Invoice', invoiceNumber: string, id: string, totalAmount: number, dueAmount?: number | null, paidAmount?: number | null }> | null, fees?: Array<{ __typename?: 'ReservationFee', percentage?: number | null, value: number, name: string }> | null }> | null } | null } | null, images?: { __typename: 'ImageSet', main?: { __typename: 'OptimizedImage', url: string, webp?: { __typename: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null } | null, all?: Array<{ __typename: 'OptimizedImage', url: string, webp?: { __typename: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null }> | null } | null }> } };

export type GetUnitDetailsQueryVariables = Exact<{
  filter?: InputMaybe<PropertyFilterInput>;
  options?: InputMaybe<CommonQueryOptionsInput>;
}>;


export type GetUnitDetailsQuery = { __typename?: 'Query', properties: { __typename?: 'PropertyResult', records: Array<{ __typename?: 'Property', id: string, listingNameRendered?: string | null, bedroomCount?: number | null, bathCount?: number | null, aboutPropertyRendered?: string | null, currency?: string | null, entityType?: PropertyEntityType | null, propertyType?: { __typename?: 'PropertyType', isStandalone: boolean, name: string } | null, houseRules?: Array<{ __typename: 'HouseRule', id: string, iconUrl: string, name: string, contentRendered?: { __typename: 'HouseRuleContent', body: string, title: string, languageCode: LanguageCode } | null }> | null, building?: { __typename?: 'Building', highLevelAmenities?: Array<{ __typename?: 'HighLevelAmenity', contentRendered?: string | null, iconUrl: string, id: string, name: string }> | null, location?: { __typename?: 'EntityLocation', address: string, neighbourhood?: { __typename?: 'Neighbourhood', name: string, id: string, city?: { __typename?: 'City', name: string, id: string } | null } | null, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null } | null } | null, furnished?: { __typename?: 'FurnishedProperty', bedCount?: number | null, maximumGuests?: number | null, sleepingArrangement?: Array<{ __typename?: 'FurnishedPropertySleepingArrangement', bedTypes: Array<string>, bedroomNumber?: number | null }> | null } | null, location?: { __typename?: 'EntityLocation', id: string, address: string, neighbourhood?: { __typename?: 'Neighbourhood', name: string, city?: { __typename?: 'City', name: string } | null } | null, coordinates?: { __typename?: 'Coordinates', lat: number, lng: number } | null } | null, highLevelAmenities?: Array<{ __typename: 'HighLevelAmenity', id: string, name: string, iconUrl: string, contentRendered?: string | null }> | null, quotation?: { __typename?: 'ReservationQuotation', paymentPlan?: { __typename?: 'ReservationPaymentPlan', currency: string, originalBookingTotal?: number | null, grandTotal: number, paymentMethods: Array<{ __typename?: 'ReservationPaymentMethod', name: string, isEnabled?: boolean | null }>, securityDeposit?: { __typename?: 'DamageProtectionPolicyPayment', totalAmount?: number | null, isDueNow?: boolean | null, isInSameTransaction?: boolean | null, damageProtectionPolicyType?: string | null, corporatePaysForTheSecurityDeposit?: boolean | null, isPaid?: boolean | null, dueOn?: { __typename?: 'Date', formatted: string } | null } | null, singlePayment?: Array<{ __typename?: 'ReservationPayment', nights?: number | null, bookingTotal: number, nightlyRate?: number | null, discountAmount?: number | null, bookingAmount?: number | null, isPaid?: boolean | null, amountPaid?: number | null, vat?: { __typename?: 'PaymentVat', amount: number, percentage: number } | null, invoices?: Array<{ __typename?: 'Invoice', invoiceNumber: string, id: string, totalAmount: number, dueAmount?: number | null, paidAmount?: number | null }> | null, fees?: Array<{ __typename?: 'ReservationFee', percentage?: number | null, value: number, name: string }> | null }> | null } | null } | null, images?: { __typename?: 'ImageSet', main?: { __typename?: 'OptimizedImage', url: string, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null } | null, all?: Array<{ __typename?: 'OptimizedImage', url: string, webp?: { __typename?: 'Webp', thumbnailUrl?: string | null, mediumUrl?: string | null, largeUrl?: string | null } | null }> | null } | null }> } };


export const MeDocument = gql`
    query me {
  result: me {
    ... on Contact {
      __typename
      id
      firstName
      lastName
      email
      isSubscribedToNewsLetter
      birthdate {
        formatted
        raw
      }
      phone {
        code
        number
      }
      nationality {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
// @ts-ignore
export function useMeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>): Apollo.UseSuspenseQueryResult<MeQuery, MeQueryVariables>;
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>): Apollo.UseSuspenseQueryResult<MeQuery | undefined, MeQueryVariables>;
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const SignUpContactWithEmailPasswordDocument = gql`
    mutation signUpContactWithEmailPassword($payload: ContactSignUpPayloadInput!) {
  result: signUpContactWithEmailPassword(payload: $payload) {
    ... on Contact {
      __typename
      id
      firstName
      lastName
      email
      isSubscribedToNewsLetter
      jwtToken
    }
  }
}
    `;
export type SignUpContactWithEmailPasswordMutationFn = Apollo.MutationFunction<SignUpContactWithEmailPasswordMutation, SignUpContactWithEmailPasswordMutationVariables>;

/**
 * __useSignUpContactWithEmailPasswordMutation__
 *
 * To run a mutation, you first call `useSignUpContactWithEmailPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpContactWithEmailPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpContactWithEmailPasswordMutation, { data, loading, error }] = useSignUpContactWithEmailPasswordMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSignUpContactWithEmailPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SignUpContactWithEmailPasswordMutation, SignUpContactWithEmailPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpContactWithEmailPasswordMutation, SignUpContactWithEmailPasswordMutationVariables>(SignUpContactWithEmailPasswordDocument, options);
      }
export type SignUpContactWithEmailPasswordMutationHookResult = ReturnType<typeof useSignUpContactWithEmailPasswordMutation>;
export type SignUpContactWithEmailPasswordMutationResult = Apollo.MutationResult<SignUpContactWithEmailPasswordMutation>;
export type SignUpContactWithEmailPasswordMutationOptions = Apollo.BaseMutationOptions<SignUpContactWithEmailPasswordMutation, SignUpContactWithEmailPasswordMutationVariables>;
export const SignInContactDocument = gql`
    mutation signInContact($payload: ContactSignInPayloadInput!, $firebaseToken: String!) {
  result: signInContact(payload: $payload, firebaseToken: $firebaseToken) {
    ... on Contact {
      __typename
      id
      firstName
      lastName
      email
      isSubscribedToNewsLetter
      jwtToken
    }
  }
}
    `;
export type SignInContactMutationFn = Apollo.MutationFunction<SignInContactMutation, SignInContactMutationVariables>;

/**
 * __useSignInContactMutation__
 *
 * To run a mutation, you first call `useSignInContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInContactMutation, { data, loading, error }] = useSignInContactMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *      firebaseToken: // value for 'firebaseToken'
 *   },
 * });
 */
export function useSignInContactMutation(baseOptions?: Apollo.MutationHookOptions<SignInContactMutation, SignInContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInContactMutation, SignInContactMutationVariables>(SignInContactDocument, options);
      }
export type SignInContactMutationHookResult = ReturnType<typeof useSignInContactMutation>;
export type SignInContactMutationResult = Apollo.MutationResult<SignInContactMutation>;
export type SignInContactMutationOptions = Apollo.BaseMutationOptions<SignInContactMutation, SignInContactMutationVariables>;
export const SetContactLanguageDocument = gql`
    mutation SetContactLanguage($languageID: ID!) {
  result: setContactLanguage(languageID: $languageID)
}
    `;
export type SetContactLanguageMutationFn = Apollo.MutationFunction<SetContactLanguageMutation, SetContactLanguageMutationVariables>;

/**
 * __useSetContactLanguageMutation__
 *
 * To run a mutation, you first call `useSetContactLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetContactLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setContactLanguageMutation, { data, loading, error }] = useSetContactLanguageMutation({
 *   variables: {
 *      languageID: // value for 'languageID'
 *   },
 * });
 */
export function useSetContactLanguageMutation(baseOptions?: Apollo.MutationHookOptions<SetContactLanguageMutation, SetContactLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetContactLanguageMutation, SetContactLanguageMutationVariables>(SetContactLanguageDocument, options);
      }
export type SetContactLanguageMutationHookResult = ReturnType<typeof useSetContactLanguageMutation>;
export type SetContactLanguageMutationResult = Apollo.MutationResult<SetContactLanguageMutation>;
export type SetContactLanguageMutationOptions = Apollo.BaseMutationOptions<SetContactLanguageMutation, SetContactLanguageMutationVariables>;
export const RequestContactPasswordResetDocument = gql`
    mutation RequestContactPasswordReset($email: String!) {
  result: requestContactPasswordReset(email: $email)
}
    `;
export type RequestContactPasswordResetMutationFn = Apollo.MutationFunction<RequestContactPasswordResetMutation, RequestContactPasswordResetMutationVariables>;

/**
 * __useRequestContactPasswordResetMutation__
 *
 * To run a mutation, you first call `useRequestContactPasswordResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestContactPasswordResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestContactPasswordResetMutation, { data, loading, error }] = useRequestContactPasswordResetMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestContactPasswordResetMutation(baseOptions?: Apollo.MutationHookOptions<RequestContactPasswordResetMutation, RequestContactPasswordResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestContactPasswordResetMutation, RequestContactPasswordResetMutationVariables>(RequestContactPasswordResetDocument, options);
      }
export type RequestContactPasswordResetMutationHookResult = ReturnType<typeof useRequestContactPasswordResetMutation>;
export type RequestContactPasswordResetMutationResult = Apollo.MutationResult<RequestContactPasswordResetMutation>;
export type RequestContactPasswordResetMutationOptions = Apollo.BaseMutationOptions<RequestContactPasswordResetMutation, RequestContactPasswordResetMutationVariables>;
export const PropertyAvailabilityRangesDocument = gql`
    query PropertyAvailabilityRanges($filter: PropertyAvailabilityRangesFilterInput!) {
  propertyAvailabilityRanges(filter: $filter) {
    startDate
    endDate
    propertyID
    isBlocked
  }
}
    `;

/**
 * __usePropertyAvailabilityRangesQuery__
 *
 * To run a query within a React component, call `usePropertyAvailabilityRangesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyAvailabilityRangesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyAvailabilityRangesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePropertyAvailabilityRangesQuery(baseOptions: Apollo.QueryHookOptions<PropertyAvailabilityRangesQuery, PropertyAvailabilityRangesQueryVariables> & ({ variables: PropertyAvailabilityRangesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyAvailabilityRangesQuery, PropertyAvailabilityRangesQueryVariables>(PropertyAvailabilityRangesDocument, options);
      }
export function usePropertyAvailabilityRangesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyAvailabilityRangesQuery, PropertyAvailabilityRangesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyAvailabilityRangesQuery, PropertyAvailabilityRangesQueryVariables>(PropertyAvailabilityRangesDocument, options);
        }
// @ts-ignore
export function usePropertyAvailabilityRangesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PropertyAvailabilityRangesQuery, PropertyAvailabilityRangesQueryVariables>): Apollo.UseSuspenseQueryResult<PropertyAvailabilityRangesQuery, PropertyAvailabilityRangesQueryVariables>;
export function usePropertyAvailabilityRangesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PropertyAvailabilityRangesQuery, PropertyAvailabilityRangesQueryVariables>): Apollo.UseSuspenseQueryResult<PropertyAvailabilityRangesQuery | undefined, PropertyAvailabilityRangesQueryVariables>;
export function usePropertyAvailabilityRangesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PropertyAvailabilityRangesQuery, PropertyAvailabilityRangesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PropertyAvailabilityRangesQuery, PropertyAvailabilityRangesQueryVariables>(PropertyAvailabilityRangesDocument, options);
        }
export type PropertyAvailabilityRangesQueryHookResult = ReturnType<typeof usePropertyAvailabilityRangesQuery>;
export type PropertyAvailabilityRangesLazyQueryHookResult = ReturnType<typeof usePropertyAvailabilityRangesLazyQuery>;
export type PropertyAvailabilityRangesSuspenseQueryHookResult = ReturnType<typeof usePropertyAvailabilityRangesSuspenseQuery>;
export type PropertyAvailabilityRangesQueryResult = Apollo.QueryResult<PropertyAvailabilityRangesQuery, PropertyAvailabilityRangesQueryVariables>;
export const PropertyLengthOfStayDaysDocument = gql`
    query PropertyLengthOfStayDays($filter: PropertyLengthOfStayFilterInput!) {
  propertyLengthOfStayDays(filter: $filter) {
    propertyID
    day
    lengthOfStay
  }
}
    `;

/**
 * __usePropertyLengthOfStayDaysQuery__
 *
 * To run a query within a React component, call `usePropertyLengthOfStayDaysQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyLengthOfStayDaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyLengthOfStayDaysQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePropertyLengthOfStayDaysQuery(baseOptions: Apollo.QueryHookOptions<PropertyLengthOfStayDaysQuery, PropertyLengthOfStayDaysQueryVariables> & ({ variables: PropertyLengthOfStayDaysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyLengthOfStayDaysQuery, PropertyLengthOfStayDaysQueryVariables>(PropertyLengthOfStayDaysDocument, options);
      }
export function usePropertyLengthOfStayDaysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyLengthOfStayDaysQuery, PropertyLengthOfStayDaysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyLengthOfStayDaysQuery, PropertyLengthOfStayDaysQueryVariables>(PropertyLengthOfStayDaysDocument, options);
        }
// @ts-ignore
export function usePropertyLengthOfStayDaysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PropertyLengthOfStayDaysQuery, PropertyLengthOfStayDaysQueryVariables>): Apollo.UseSuspenseQueryResult<PropertyLengthOfStayDaysQuery, PropertyLengthOfStayDaysQueryVariables>;
export function usePropertyLengthOfStayDaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PropertyLengthOfStayDaysQuery, PropertyLengthOfStayDaysQueryVariables>): Apollo.UseSuspenseQueryResult<PropertyLengthOfStayDaysQuery | undefined, PropertyLengthOfStayDaysQueryVariables>;
export function usePropertyLengthOfStayDaysSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PropertyLengthOfStayDaysQuery, PropertyLengthOfStayDaysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PropertyLengthOfStayDaysQuery, PropertyLengthOfStayDaysQueryVariables>(PropertyLengthOfStayDaysDocument, options);
        }
export type PropertyLengthOfStayDaysQueryHookResult = ReturnType<typeof usePropertyLengthOfStayDaysQuery>;
export type PropertyLengthOfStayDaysLazyQueryHookResult = ReturnType<typeof usePropertyLengthOfStayDaysLazyQuery>;
export type PropertyLengthOfStayDaysSuspenseQueryHookResult = ReturnType<typeof usePropertyLengthOfStayDaysSuspenseQuery>;
export type PropertyLengthOfStayDaysQueryResult = Apollo.QueryResult<PropertyLengthOfStayDaysQuery, PropertyLengthOfStayDaysQueryVariables>;
export const ReservationsPendingDocumentSubmissionDocument = gql`
    query ReservationsPendingDocumentSubmission($brCode: String!) {
  result: websiteBookingRegistrationLink(brCode: $brCode) {
    reservationsPendingDocumentSubmission {
      id
    }
    documentDisplayStatus {
      canSetDocuments
      reservation {
        id
      }
    }
  }
}
    `;

/**
 * __useReservationsPendingDocumentSubmissionQuery__
 *
 * To run a query within a React component, call `useReservationsPendingDocumentSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useReservationsPendingDocumentSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReservationsPendingDocumentSubmissionQuery({
 *   variables: {
 *      brCode: // value for 'brCode'
 *   },
 * });
 */
export function useReservationsPendingDocumentSubmissionQuery(baseOptions: Apollo.QueryHookOptions<ReservationsPendingDocumentSubmissionQuery, ReservationsPendingDocumentSubmissionQueryVariables> & ({ variables: ReservationsPendingDocumentSubmissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReservationsPendingDocumentSubmissionQuery, ReservationsPendingDocumentSubmissionQueryVariables>(ReservationsPendingDocumentSubmissionDocument, options);
      }
export function useReservationsPendingDocumentSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReservationsPendingDocumentSubmissionQuery, ReservationsPendingDocumentSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReservationsPendingDocumentSubmissionQuery, ReservationsPendingDocumentSubmissionQueryVariables>(ReservationsPendingDocumentSubmissionDocument, options);
        }
// @ts-ignore
export function useReservationsPendingDocumentSubmissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReservationsPendingDocumentSubmissionQuery, ReservationsPendingDocumentSubmissionQueryVariables>): Apollo.UseSuspenseQueryResult<ReservationsPendingDocumentSubmissionQuery, ReservationsPendingDocumentSubmissionQueryVariables>;
export function useReservationsPendingDocumentSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReservationsPendingDocumentSubmissionQuery, ReservationsPendingDocumentSubmissionQueryVariables>): Apollo.UseSuspenseQueryResult<ReservationsPendingDocumentSubmissionQuery | undefined, ReservationsPendingDocumentSubmissionQueryVariables>;
export function useReservationsPendingDocumentSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReservationsPendingDocumentSubmissionQuery, ReservationsPendingDocumentSubmissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReservationsPendingDocumentSubmissionQuery, ReservationsPendingDocumentSubmissionQueryVariables>(ReservationsPendingDocumentSubmissionDocument, options);
        }
export type ReservationsPendingDocumentSubmissionQueryHookResult = ReturnType<typeof useReservationsPendingDocumentSubmissionQuery>;
export type ReservationsPendingDocumentSubmissionLazyQueryHookResult = ReturnType<typeof useReservationsPendingDocumentSubmissionLazyQuery>;
export type ReservationsPendingDocumentSubmissionSuspenseQueryHookResult = ReturnType<typeof useReservationsPendingDocumentSubmissionSuspenseQuery>;
export type ReservationsPendingDocumentSubmissionQueryResult = Apollo.QueryResult<ReservationsPendingDocumentSubmissionQuery, ReservationsPendingDocumentSubmissionQueryVariables>;
export const WebsiteBookingRegistrationLinkDocument = gql`
    query websiteBookingRegistrationLink($brCode: String!) {
  result: websiteBookingRegistrationLink(brCode: $brCode) {
    canShowSuccessfulPaymentView
    isPointOfContact
    isTermsConditionsAccepted
    etaTimeSlots
    contact {
      id
      firstName
      lastName
      email
      isOTAEmail
      hasAccount
      phone {
        code
        number
      }
    }
    corporate {
      id
      legalName
    }
    reservationsPendingDocumentSubmission {
      id
    }
    entries {
      ... on Reservation {
        id
        payment {
          grandTotal
          grandBookingTotal
          currency
          isPaid
          paymentMethods {
            isEnabled
            isOnline
            name
            __typename
          }
          singlePayment {
            amountPaid
            nights
            vat {
              amount
              percentage
            }
            isPaid
          }
        }
        documents {
          isMainGuest
          documentStatus
          document {
            id
            documentType
          }
          content {
            firstName
            lastName
            fatherName
            grandfatherName
            documentNumber
          }
        }
        reservationConfirmationNumber: confirmationNumber
        estimatedArrivalTime
        specialRequests
        checkInDate {
          raw
          formatted
        }
        checkOutDate {
          raw
          formatted
        }
        extendedCheckOutDate {
          raw
          formatted
        }
        nights
        checkInTime
        checkOutTime
        numberOfGuests
        property {
          id
          listingNameRendered
          location {
            id
            address
            coordinates {
              lat
              lng
            }
            neighbourhood {
              city {
                name
                id
              }
              id
              name
            }
          }
          propertyType {
            name
          }
          unitNumber
          images {
            all {
              url
              captionRendered
              displayOrder
              imageType
              webp {
                largeUrl
                mediumUrl
                thumbnailUrl
              }
            }
            main {
              webp {
                thumbnailUrl
                mediumUrl
                largeUrl
              }
              url
            }
          }
          building {
            id
            listingNameRendered
            location {
              address
              neighbourhood {
                city {
                  name
                  id
                }
                id
                name
              }
              coordinates {
                lat
                lng
              }
            }
          }
          location {
            address
            coordinates {
              lat
              lng
            }
            neighbourhood {
              id
              name
              city {
                id
                name
              }
            }
          }
          furnished {
            checkInTime
            maximumGuests
            wifiSSID
            wifiPassword
          }
          parkingNumber
        }
        documents {
          isMainGuest
          document {
            id
            documentType
            attachments {
              fileName
              mimeType
              url
            }
          }
          content {
            firstName
            lastName
            documentNumber
            expiryDate {
              raw
              formatted
            }
          }
        }
        passcode {
          code
        }
        contact {
          firstName
          lastName
          id
          email
        }
      }
      ... on ReservationExtension {
        id
        reservation {
          id
          confirmationNumber
          checkInTime
          invoices {
            id
            invoiceNumber
            invoiceType
          }
          documents {
            isMainGuest
            documentStatus
            content {
              birthdate {
                formatted
                raw
              }
              issuingPlace
              lastName
              nationality {
                id
                name
              }
              occupation
              documentNumber
              firstName
              lastName
              fatherName
            }
            document {
              attachments {
                fileName
                mimeType
                url
              }
              documentType
              id
            }
          }
          passcode {
            code
          }
        }
        payment {
          grandTotal
          grandBookingTotal
          currency
          isPaid
          paymentMethods {
            isEnabled
            isOnline
            name
            __typename
          }
          singlePayment {
            amountPaid
            nights
            vat {
              amount
              percentage
            }
            isPaid
          }
        }
        checkInDate {
          raw
          formatted
        }
        checkOutDate {
          raw
          formatted
        }
        nights
        property {
          id
          listingNameRendered
          location {
            id
            address
            coordinates {
              lat
              lng
            }
            neighbourhood {
              city {
                name
                id
              }
              id
              name
            }
          }
          propertyType {
            name
          }
          unitNumber
          images {
            all {
              url
              captionRendered
              displayOrder
              imageType
              webp {
                largeUrl
                mediumUrl
                thumbnailUrl
              }
            }
            main {
              webp {
                thumbnailUrl
                mediumUrl
                largeUrl
              }
              url
            }
          }
          building {
            id
            listingNameRendered
            location {
              address
              neighbourhood {
                city {
                  name
                  id
                }
                id
                name
              }
              coordinates {
                lat
                lng
              }
            }
          }
          location {
            address
            coordinates {
              lat
              lng
            }
            neighbourhood {
              id
              name
              city {
                id
                name
              }
            }
          }
          furnished {
            checkInTime
            maximumGuests
            wifiSSID
            wifiPassword
          }
          parkingNumber
        }
        contact {
          firstName
          lastName
          id
          email
        }
      }
    }
    contractBase64Signature
    canShowSignaturePad
    paymentCollection {
      id
      currency
      isPaid
      totalPaymentAmount
      proofStatus
      supportedPaymentMethods {
        name
        isEnabled
      }
      proofAttachments {
        fileName
        mimeType
        url
      }
      invoices {
        id
        allocatedAmount
        invoiceNumber
      }
    }
    paymentSummary {
      pendingBookingAmount
      pendingServicesAmount
      pendingSecurityDepositAmount
      pendingTotalAmount
      isSecurityDepositCardOnFile
      alternativeSecurityDepositAmount
    }
    isExtension
    bankTransferBeneficiary {
      bankName
      branch
      accountName
      accountNumber
      iban
      swiftCode
      accountCurrency
    }
    cryptoBeneficiary {
      tokenSymbol
      networks {
        networkName
        address
        qrCodeUrl
      }
    }
    securityDepositRefundDetails {
      bankTransfer {
        beneficiaryName
        bankAccountNumber
        bankName
        branchName
        branchAddress
        country
        iban
        swiftCode
        accountCurrency
      }
      cryptocurrency {
        networkName
        walletAddress
      }
    }
    canRequestBusinessInvoice
    businessInvoiceDetails {
      companyLegalName
      vatNumber
      registeredCountryName
      registeredCity
    }
    canSetETA
    canSetSpecialRequests
    canShowCheckInDetailsOnSuccess
    pendingSteps
    pendingInvoices {
      id
      status
      invoiceNumber
      totalAmount
      dueAmount
      paidAmount
      invoiceType
      currency
      reservations {
        id
        confirmationNumber
      }
      extensions {
        id
        confirmationNumber
      }
      issueDate {
        formatted
      }
      dueDate {
        formatted
      }
      breakdown {
        nights
        nightlyRate
        bookingAmount
        vat {
          amount
          percentage
        }
        fees {
          name
          value
          percentage
          isTaxable
        }
        discountAmount
        bookingTotal
      }
      invoiceItems {
        id
        unitPrice
        quantity
        description
        addOnService {
          id
          name
        }
        damageType {
          id
          name
        }
      }
      paymentMethod
    }
    documentDisplayStatus {
      canSetDocuments
      reservation {
        id
      }
    }
  }
}
    `;

/**
 * __useWebsiteBookingRegistrationLinkQuery__
 *
 * To run a query within a React component, call `useWebsiteBookingRegistrationLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteBookingRegistrationLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteBookingRegistrationLinkQuery({
 *   variables: {
 *      brCode: // value for 'brCode'
 *   },
 * });
 */
export function useWebsiteBookingRegistrationLinkQuery(baseOptions: Apollo.QueryHookOptions<WebsiteBookingRegistrationLinkQuery, WebsiteBookingRegistrationLinkQueryVariables> & ({ variables: WebsiteBookingRegistrationLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsiteBookingRegistrationLinkQuery, WebsiteBookingRegistrationLinkQueryVariables>(WebsiteBookingRegistrationLinkDocument, options);
      }
export function useWebsiteBookingRegistrationLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsiteBookingRegistrationLinkQuery, WebsiteBookingRegistrationLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsiteBookingRegistrationLinkQuery, WebsiteBookingRegistrationLinkQueryVariables>(WebsiteBookingRegistrationLinkDocument, options);
        }
// @ts-ignore
export function useWebsiteBookingRegistrationLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WebsiteBookingRegistrationLinkQuery, WebsiteBookingRegistrationLinkQueryVariables>): Apollo.UseSuspenseQueryResult<WebsiteBookingRegistrationLinkQuery, WebsiteBookingRegistrationLinkQueryVariables>;
export function useWebsiteBookingRegistrationLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteBookingRegistrationLinkQuery, WebsiteBookingRegistrationLinkQueryVariables>): Apollo.UseSuspenseQueryResult<WebsiteBookingRegistrationLinkQuery | undefined, WebsiteBookingRegistrationLinkQueryVariables>;
export function useWebsiteBookingRegistrationLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteBookingRegistrationLinkQuery, WebsiteBookingRegistrationLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsiteBookingRegistrationLinkQuery, WebsiteBookingRegistrationLinkQueryVariables>(WebsiteBookingRegistrationLinkDocument, options);
        }
export type WebsiteBookingRegistrationLinkQueryHookResult = ReturnType<typeof useWebsiteBookingRegistrationLinkQuery>;
export type WebsiteBookingRegistrationLinkLazyQueryHookResult = ReturnType<typeof useWebsiteBookingRegistrationLinkLazyQuery>;
export type WebsiteBookingRegistrationLinkSuspenseQueryHookResult = ReturnType<typeof useWebsiteBookingRegistrationLinkSuspenseQuery>;
export type WebsiteBookingRegistrationLinkQueryResult = Apollo.QueryResult<WebsiteBookingRegistrationLinkQuery, WebsiteBookingRegistrationLinkQueryVariables>;
export const CreateWebsiteReservationDocument = gql`
    mutation CreateWebsiteReservation($payload: WebsiteReservationPayloadInput!) {
  createWebsiteReservation(payload: $payload) {
    id
    bookingCompletionLink
  }
}
    `;
export type CreateWebsiteReservationMutationFn = Apollo.MutationFunction<CreateWebsiteReservationMutation, CreateWebsiteReservationMutationVariables>;

/**
 * __useCreateWebsiteReservationMutation__
 *
 * To run a mutation, you first call `useCreateWebsiteReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebsiteReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebsiteReservationMutation, { data, loading, error }] = useCreateWebsiteReservationMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateWebsiteReservationMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebsiteReservationMutation, CreateWebsiteReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebsiteReservationMutation, CreateWebsiteReservationMutationVariables>(CreateWebsiteReservationDocument, options);
      }
export type CreateWebsiteReservationMutationHookResult = ReturnType<typeof useCreateWebsiteReservationMutation>;
export type CreateWebsiteReservationMutationResult = Apollo.MutationResult<CreateWebsiteReservationMutation>;
export type CreateWebsiteReservationMutationOptions = Apollo.BaseMutationOptions<CreateWebsiteReservationMutation, CreateWebsiteReservationMutationVariables>;
export const SetWebsiteBrLinkRefundBankDetailsDocument = gql`
    mutation SetWebsiteBRLinkRefundBankDetails($payload: WebsiteBRLinkRefundBankDetailsPayloadInput!) {
  setWebsiteBRLinkRefundBankDetails(payload: $payload)
}
    `;
export type SetWebsiteBrLinkRefundBankDetailsMutationFn = Apollo.MutationFunction<SetWebsiteBrLinkRefundBankDetailsMutation, SetWebsiteBrLinkRefundBankDetailsMutationVariables>;

/**
 * __useSetWebsiteBrLinkRefundBankDetailsMutation__
 *
 * To run a mutation, you first call `useSetWebsiteBrLinkRefundBankDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWebsiteBrLinkRefundBankDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWebsiteBrLinkRefundBankDetailsMutation, { data, loading, error }] = useSetWebsiteBrLinkRefundBankDetailsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetWebsiteBrLinkRefundBankDetailsMutation(baseOptions?: Apollo.MutationHookOptions<SetWebsiteBrLinkRefundBankDetailsMutation, SetWebsiteBrLinkRefundBankDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWebsiteBrLinkRefundBankDetailsMutation, SetWebsiteBrLinkRefundBankDetailsMutationVariables>(SetWebsiteBrLinkRefundBankDetailsDocument, options);
      }
export type SetWebsiteBrLinkRefundBankDetailsMutationHookResult = ReturnType<typeof useSetWebsiteBrLinkRefundBankDetailsMutation>;
export type SetWebsiteBrLinkRefundBankDetailsMutationResult = Apollo.MutationResult<SetWebsiteBrLinkRefundBankDetailsMutation>;
export type SetWebsiteBrLinkRefundBankDetailsMutationOptions = Apollo.BaseMutationOptions<SetWebsiteBrLinkRefundBankDetailsMutation, SetWebsiteBrLinkRefundBankDetailsMutationVariables>;
export const SetWebsiteBrLinkRefundCryptoDetailsDocument = gql`
    mutation SetWebsiteBRLinkRefundCryptoDetails($payload: WebsiteBRLinkRefundCryptoDetailsPayloadInput!) {
  setWebsiteBRLinkRefundCryptoDetails(payload: $payload)
}
    `;
export type SetWebsiteBrLinkRefundCryptoDetailsMutationFn = Apollo.MutationFunction<SetWebsiteBrLinkRefundCryptoDetailsMutation, SetWebsiteBrLinkRefundCryptoDetailsMutationVariables>;

/**
 * __useSetWebsiteBrLinkRefundCryptoDetailsMutation__
 *
 * To run a mutation, you first call `useSetWebsiteBrLinkRefundCryptoDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWebsiteBrLinkRefundCryptoDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWebsiteBrLinkRefundCryptoDetailsMutation, { data, loading, error }] = useSetWebsiteBrLinkRefundCryptoDetailsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetWebsiteBrLinkRefundCryptoDetailsMutation(baseOptions?: Apollo.MutationHookOptions<SetWebsiteBrLinkRefundCryptoDetailsMutation, SetWebsiteBrLinkRefundCryptoDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWebsiteBrLinkRefundCryptoDetailsMutation, SetWebsiteBrLinkRefundCryptoDetailsMutationVariables>(SetWebsiteBrLinkRefundCryptoDetailsDocument, options);
      }
export type SetWebsiteBrLinkRefundCryptoDetailsMutationHookResult = ReturnType<typeof useSetWebsiteBrLinkRefundCryptoDetailsMutation>;
export type SetWebsiteBrLinkRefundCryptoDetailsMutationResult = Apollo.MutationResult<SetWebsiteBrLinkRefundCryptoDetailsMutation>;
export type SetWebsiteBrLinkRefundCryptoDetailsMutationOptions = Apollo.BaseMutationOptions<SetWebsiteBrLinkRefundCryptoDetailsMutation, SetWebsiteBrLinkRefundCryptoDetailsMutationVariables>;
export const SetWebsiteBrLinkBusinessInvoiceDetailsDocument = gql`
    mutation SetWebsiteBRLinkBusinessInvoiceDetails($payload: WebsiteBRLinkBusinessInvoiceDetailsPayloadInput!) {
  setWebsiteBRLinkBusinessInvoiceDetails(payload: $payload)
}
    `;
export type SetWebsiteBrLinkBusinessInvoiceDetailsMutationFn = Apollo.MutationFunction<SetWebsiteBrLinkBusinessInvoiceDetailsMutation, SetWebsiteBrLinkBusinessInvoiceDetailsMutationVariables>;

/**
 * __useSetWebsiteBrLinkBusinessInvoiceDetailsMutation__
 *
 * To run a mutation, you first call `useSetWebsiteBrLinkBusinessInvoiceDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWebsiteBrLinkBusinessInvoiceDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWebsiteBrLinkBusinessInvoiceDetailsMutation, { data, loading, error }] = useSetWebsiteBrLinkBusinessInvoiceDetailsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetWebsiteBrLinkBusinessInvoiceDetailsMutation(baseOptions?: Apollo.MutationHookOptions<SetWebsiteBrLinkBusinessInvoiceDetailsMutation, SetWebsiteBrLinkBusinessInvoiceDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWebsiteBrLinkBusinessInvoiceDetailsMutation, SetWebsiteBrLinkBusinessInvoiceDetailsMutationVariables>(SetWebsiteBrLinkBusinessInvoiceDetailsDocument, options);
      }
export type SetWebsiteBrLinkBusinessInvoiceDetailsMutationHookResult = ReturnType<typeof useSetWebsiteBrLinkBusinessInvoiceDetailsMutation>;
export type SetWebsiteBrLinkBusinessInvoiceDetailsMutationResult = Apollo.MutationResult<SetWebsiteBrLinkBusinessInvoiceDetailsMutation>;
export type SetWebsiteBrLinkBusinessInvoiceDetailsMutationOptions = Apollo.BaseMutationOptions<SetWebsiteBrLinkBusinessInvoiceDetailsMutation, SetWebsiteBrLinkBusinessInvoiceDetailsMutationVariables>;
export const UpgradeWebsiteBrLinkDamageProtectionPolicyDocument = gql`
    mutation UpgradeWebsiteBRLinkDamageProtectionPolicy($payload: WebsiteBRLinkUpgradeDamageProtectionPolicyPayloadInput!) {
  upgradeWebsiteBRLinkDamageProtectionPolicy(payload: $payload) {
    isPointOfContact
    etaTimeSlots
    contact {
      id
      firstName
      lastName
      email
      isOTAEmail
      hasAccount
      phone {
        code
        number
      }
    }
    corporate {
      id
      legalName
    }
    entries {
      ... on Reservation {
        id
        documents {
          isMainGuest
          documentStatus
          document {
            id
            documentType
          }
          content {
            firstName
            lastName
            fatherName
            grandfatherName
            documentNumber
          }
        }
        reservationConfirmationNumber: confirmationNumber
        estimatedArrivalTime
        specialRequests
        checkInDate {
          raw
          formatted
        }
        checkOutDate {
          raw
          formatted
        }
        extendedCheckOutDate {
          raw
          formatted
        }
        nights
        checkInTime
        checkOutTime
        numberOfGuests
        property {
          id
          listingNameRendered
          propertyType {
            name
          }
          unitNumber
          images {
            all {
              url
              captionRendered
              displayOrder
              imageType
              webp {
                largeUrl
                mediumUrl
                thumbnailUrl
              }
            }
            main {
              webp {
                thumbnailUrl
                mediumUrl
                largeUrl
              }
              url
            }
          }
          building {
            id
            listingNameRendered
            location {
              address
              coordinates {
                lat
                lng
              }
            }
          }
          location {
            address
            coordinates {
              lat
              lng
            }
          }
          furnished {
            checkInTime
            maximumGuests
            wifiSSID
            wifiPassword
          }
          parkingNumber
        }
        documents {
          isMainGuest
          document {
            id
            documentType
            attachments {
              fileName
              mimeType
              url
            }
          }
          content {
            firstName
            lastName
            documentNumber
            expiryDate {
              raw
              formatted
            }
          }
        }
        passcode {
          code
        }
      }
      ... on ReservationExtension {
        id
        extensionConfirmationNumber: confirmationNumber
        checkInDate {
          raw
          formatted
        }
        checkOutDate {
          raw
          formatted
        }
        nights
        property {
          id
          listingNameRendered
          propertyType {
            name
          }
          unitNumber
          images {
            main {
              webp {
                thumbnailUrl
                largeUrl
                mediumUrl
              }
              url
            }
          }
          building {
            id
            listingNameRendered
            location {
              address
              coordinates {
                lat
                lng
              }
            }
          }
          location {
            address
            coordinates {
              lat
              lng
            }
          }
          furnished {
            checkInTime
            maximumGuests
            wifiSSID
            wifiPassword
          }
          parkingNumber
        }
        reservation {
          id
          reservationConfirmationNumber: confirmationNumber
          estimatedArrivalTime
          specialRequests
          checkInDate {
            raw
            formatted
          }
          checkOutDate {
            raw
            formatted
          }
          invoices {
            id
            invoiceNumber
          }
          extendedCheckOutDate {
            raw
            formatted
          }
          nights
          checkInTime
          checkOutTime
          numberOfGuests
          documents {
            isMainGuest
            documentStatus
            document {
              id
              documentType
              attachments {
                fileName
                mimeType
                url
              }
            }
            content {
              firstName
              lastName
              documentNumber
              expiryDate {
                raw
                formatted
              }
            }
          }
          passcode {
            code
          }
        }
      }
    }
    paymentCollection {
      id
      currency
      isPaid
      totalPaymentAmount
      supportedPaymentMethods {
        name
        isEnabled
      }
      proofAttachments {
        fileName
        mimeType
        url
      }
    }
    paymentSummary {
      pendingBookingAmount
      pendingServicesAmount
      pendingSecurityDepositAmount
      pendingTotalAmount
      isSecurityDepositCardOnFile
      alternativeSecurityDepositAmount
    }
    bankTransferBeneficiary {
      bankName
      branch
      accountName
      accountNumber
      iban
      swiftCode
      accountCurrency
    }
    cryptoBeneficiary {
      tokenSymbol
      networks {
        networkName
        address
        qrCodeUrl
      }
    }
    securityDepositRefundDetails {
      bankTransfer {
        beneficiaryName
        bankAccountNumber
        bankName
        branchName
        branchAddress
        country
        iban
        swiftCode
        accountCurrency
      }
      cryptocurrency {
        networkName
        walletAddress
      }
    }
    canRequestBusinessInvoice
    businessInvoiceDetails {
      companyLegalName
      vatNumber
      registeredCountryName
      registeredCity
    }
    canSetETA
    canSetSpecialRequests
    canShowCheckInDetailsOnSuccess
    pendingSteps
    pendingInvoices {
      id
      invoiceNumber
      totalAmount
      dueAmount
      paidAmount
      invoiceType
      currency
      reservations {
        id
        confirmationNumber
      }
      extensions {
        id
        confirmationNumber
      }
      issueDate {
        formatted
      }
      dueDate {
        formatted
      }
      breakdown {
        nights
        nightlyRate
        bookingAmount
        vat {
          amount
          percentage
        }
        fees {
          name
          value
          percentage
          isTaxable
        }
        discountAmount
        bookingTotal
      }
      invoiceItems {
        id
        unitPrice
        quantity
        description
        addOnService {
          id
          name
        }
        damageType {
          id
          name
        }
      }
      paymentMethod
    }
  }
}
    `;
export type UpgradeWebsiteBrLinkDamageProtectionPolicyMutationFn = Apollo.MutationFunction<UpgradeWebsiteBrLinkDamageProtectionPolicyMutation, UpgradeWebsiteBrLinkDamageProtectionPolicyMutationVariables>;

/**
 * __useUpgradeWebsiteBrLinkDamageProtectionPolicyMutation__
 *
 * To run a mutation, you first call `useUpgradeWebsiteBrLinkDamageProtectionPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpgradeWebsiteBrLinkDamageProtectionPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upgradeWebsiteBrLinkDamageProtectionPolicyMutation, { data, loading, error }] = useUpgradeWebsiteBrLinkDamageProtectionPolicyMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpgradeWebsiteBrLinkDamageProtectionPolicyMutation(baseOptions?: Apollo.MutationHookOptions<UpgradeWebsiteBrLinkDamageProtectionPolicyMutation, UpgradeWebsiteBrLinkDamageProtectionPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpgradeWebsiteBrLinkDamageProtectionPolicyMutation, UpgradeWebsiteBrLinkDamageProtectionPolicyMutationVariables>(UpgradeWebsiteBrLinkDamageProtectionPolicyDocument, options);
      }
export type UpgradeWebsiteBrLinkDamageProtectionPolicyMutationHookResult = ReturnType<typeof useUpgradeWebsiteBrLinkDamageProtectionPolicyMutation>;
export type UpgradeWebsiteBrLinkDamageProtectionPolicyMutationResult = Apollo.MutationResult<UpgradeWebsiteBrLinkDamageProtectionPolicyMutation>;
export type UpgradeWebsiteBrLinkDamageProtectionPolicyMutationOptions = Apollo.BaseMutationOptions<UpgradeWebsiteBrLinkDamageProtectionPolicyMutation, UpgradeWebsiteBrLinkDamageProtectionPolicyMutationVariables>;
export const SetWebsiteBrLinkGuestCountDocument = gql`
    mutation SetWebsiteBRLinkGuestCount($payload: WebsiteBRLinkGuestCountPayloadInput!) {
  setWebsiteBRLinkGuestCount(payload: $payload)
}
    `;
export type SetWebsiteBrLinkGuestCountMutationFn = Apollo.MutationFunction<SetWebsiteBrLinkGuestCountMutation, SetWebsiteBrLinkGuestCountMutationVariables>;

/**
 * __useSetWebsiteBrLinkGuestCountMutation__
 *
 * To run a mutation, you first call `useSetWebsiteBrLinkGuestCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWebsiteBrLinkGuestCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWebsiteBrLinkGuestCountMutation, { data, loading, error }] = useSetWebsiteBrLinkGuestCountMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetWebsiteBrLinkGuestCountMutation(baseOptions?: Apollo.MutationHookOptions<SetWebsiteBrLinkGuestCountMutation, SetWebsiteBrLinkGuestCountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWebsiteBrLinkGuestCountMutation, SetWebsiteBrLinkGuestCountMutationVariables>(SetWebsiteBrLinkGuestCountDocument, options);
      }
export type SetWebsiteBrLinkGuestCountMutationHookResult = ReturnType<typeof useSetWebsiteBrLinkGuestCountMutation>;
export type SetWebsiteBrLinkGuestCountMutationResult = Apollo.MutationResult<SetWebsiteBrLinkGuestCountMutation>;
export type SetWebsiteBrLinkGuestCountMutationOptions = Apollo.BaseMutationOptions<SetWebsiteBrLinkGuestCountMutation, SetWebsiteBrLinkGuestCountMutationVariables>;
export const SetContactProfileDocument = gql`
    mutation SetContactProfile($brCode: String, $payload: ContactPayloadInput!) {
  setContactProfile(brCode: $brCode, payload: $payload)
}
    `;
export type SetContactProfileMutationFn = Apollo.MutationFunction<SetContactProfileMutation, SetContactProfileMutationVariables>;

/**
 * __useSetContactProfileMutation__
 *
 * To run a mutation, you first call `useSetContactProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetContactProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setContactProfileMutation, { data, loading, error }] = useSetContactProfileMutation({
 *   variables: {
 *      brCode: // value for 'brCode'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetContactProfileMutation(baseOptions?: Apollo.MutationHookOptions<SetContactProfileMutation, SetContactProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetContactProfileMutation, SetContactProfileMutationVariables>(SetContactProfileDocument, options);
      }
export type SetContactProfileMutationHookResult = ReturnType<typeof useSetContactProfileMutation>;
export type SetContactProfileMutationResult = Apollo.MutationResult<SetContactProfileMutation>;
export type SetContactProfileMutationOptions = Apollo.BaseMutationOptions<SetContactProfileMutation, SetContactProfileMutationVariables>;
export const SetReservationEstimatedArrivalTimeDocument = gql`
    mutation SetReservationEstimatedArrivalTime($payload: ReservationEstimatedArrivalTimePayloadInput!) {
  setReservationEstimatedArrivalTime(payload: $payload)
}
    `;
export type SetReservationEstimatedArrivalTimeMutationFn = Apollo.MutationFunction<SetReservationEstimatedArrivalTimeMutation, SetReservationEstimatedArrivalTimeMutationVariables>;

/**
 * __useSetReservationEstimatedArrivalTimeMutation__
 *
 * To run a mutation, you first call `useSetReservationEstimatedArrivalTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetReservationEstimatedArrivalTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setReservationEstimatedArrivalTimeMutation, { data, loading, error }] = useSetReservationEstimatedArrivalTimeMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetReservationEstimatedArrivalTimeMutation(baseOptions?: Apollo.MutationHookOptions<SetReservationEstimatedArrivalTimeMutation, SetReservationEstimatedArrivalTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetReservationEstimatedArrivalTimeMutation, SetReservationEstimatedArrivalTimeMutationVariables>(SetReservationEstimatedArrivalTimeDocument, options);
      }
export type SetReservationEstimatedArrivalTimeMutationHookResult = ReturnType<typeof useSetReservationEstimatedArrivalTimeMutation>;
export type SetReservationEstimatedArrivalTimeMutationResult = Apollo.MutationResult<SetReservationEstimatedArrivalTimeMutation>;
export type SetReservationEstimatedArrivalTimeMutationOptions = Apollo.BaseMutationOptions<SetReservationEstimatedArrivalTimeMutation, SetReservationEstimatedArrivalTimeMutationVariables>;
export const SetReservationSpecialRequestsDocument = gql`
    mutation SetReservationSpecialRequests($payload: ReservationSpecialRequestsPayloadInput!) {
  setReservationSpecialRequests(payload: $payload)
}
    `;
export type SetReservationSpecialRequestsMutationFn = Apollo.MutationFunction<SetReservationSpecialRequestsMutation, SetReservationSpecialRequestsMutationVariables>;

/**
 * __useSetReservationSpecialRequestsMutation__
 *
 * To run a mutation, you first call `useSetReservationSpecialRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetReservationSpecialRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setReservationSpecialRequestsMutation, { data, loading, error }] = useSetReservationSpecialRequestsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetReservationSpecialRequestsMutation(baseOptions?: Apollo.MutationHookOptions<SetReservationSpecialRequestsMutation, SetReservationSpecialRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetReservationSpecialRequestsMutation, SetReservationSpecialRequestsMutationVariables>(SetReservationSpecialRequestsDocument, options);
      }
export type SetReservationSpecialRequestsMutationHookResult = ReturnType<typeof useSetReservationSpecialRequestsMutation>;
export type SetReservationSpecialRequestsMutationResult = Apollo.MutationResult<SetReservationSpecialRequestsMutation>;
export type SetReservationSpecialRequestsMutationOptions = Apollo.BaseMutationOptions<SetReservationSpecialRequestsMutation, SetReservationSpecialRequestsMutationVariables>;
export const FindMyReservationDocument = gql`
    query FindMyReservation($code: String!) {
  findMyReservation(confirmationNumber: $code) {
    contact {
      id
      firstName
      lastName
      email
      isOTAEmail
      hasAccount
      phone {
        code
        number
      }
    }
    reservation {
      checkInTime
      checkInDate {
        formatted
        raw
      }
      checkOutDate {
        formatted
        raw
      }
      numberOfGuests
      specialRequests
      numberOfGuests
      property {
        aboutPropertyRendered
        currency
        entityType
        floorNumber
      }
      payment {
        currency
        grandBookingTotal
        isPaid
        paymentMethods {
          isEnabled
          isOnline
          name
          __typename
        }
      }
    }
  }
}
    `;

/**
 * __useFindMyReservationQuery__
 *
 * To run a query within a React component, call `useFindMyReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindMyReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindMyReservationQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useFindMyReservationQuery(baseOptions: Apollo.QueryHookOptions<FindMyReservationQuery, FindMyReservationQueryVariables> & ({ variables: FindMyReservationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindMyReservationQuery, FindMyReservationQueryVariables>(FindMyReservationDocument, options);
      }
export function useFindMyReservationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindMyReservationQuery, FindMyReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindMyReservationQuery, FindMyReservationQueryVariables>(FindMyReservationDocument, options);
        }
// @ts-ignore
export function useFindMyReservationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FindMyReservationQuery, FindMyReservationQueryVariables>): Apollo.UseSuspenseQueryResult<FindMyReservationQuery, FindMyReservationQueryVariables>;
export function useFindMyReservationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindMyReservationQuery, FindMyReservationQueryVariables>): Apollo.UseSuspenseQueryResult<FindMyReservationQuery | undefined, FindMyReservationQueryVariables>;
export function useFindMyReservationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindMyReservationQuery, FindMyReservationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindMyReservationQuery, FindMyReservationQueryVariables>(FindMyReservationDocument, options);
        }
export type FindMyReservationQueryHookResult = ReturnType<typeof useFindMyReservationQuery>;
export type FindMyReservationLazyQueryHookResult = ReturnType<typeof useFindMyReservationLazyQuery>;
export type FindMyReservationSuspenseQueryHookResult = ReturnType<typeof useFindMyReservationSuspenseQuery>;
export type FindMyReservationQueryResult = Apollo.QueryResult<FindMyReservationQuery, FindMyReservationQueryVariables>;
export const PasscodeCheckDocument = gql`
    query PasscodeCheck($brCode: String!) {
  result: websiteBookingRegistrationLink(brCode: $brCode) {
    entries {
      ... on Reservation {
        id
        passcode {
          code
          id
          status
        }
      }
    }
  }
}
    `;

/**
 * __usePasscodeCheckQuery__
 *
 * To run a query within a React component, call `usePasscodeCheckQuery` and pass it any options that fit your needs.
 * When your component renders, `usePasscodeCheckQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePasscodeCheckQuery({
 *   variables: {
 *      brCode: // value for 'brCode'
 *   },
 * });
 */
export function usePasscodeCheckQuery(baseOptions: Apollo.QueryHookOptions<PasscodeCheckQuery, PasscodeCheckQueryVariables> & ({ variables: PasscodeCheckQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PasscodeCheckQuery, PasscodeCheckQueryVariables>(PasscodeCheckDocument, options);
      }
export function usePasscodeCheckLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PasscodeCheckQuery, PasscodeCheckQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PasscodeCheckQuery, PasscodeCheckQueryVariables>(PasscodeCheckDocument, options);
        }
// @ts-ignore
export function usePasscodeCheckSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PasscodeCheckQuery, PasscodeCheckQueryVariables>): Apollo.UseSuspenseQueryResult<PasscodeCheckQuery, PasscodeCheckQueryVariables>;
export function usePasscodeCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PasscodeCheckQuery, PasscodeCheckQueryVariables>): Apollo.UseSuspenseQueryResult<PasscodeCheckQuery | undefined, PasscodeCheckQueryVariables>;
export function usePasscodeCheckSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PasscodeCheckQuery, PasscodeCheckQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PasscodeCheckQuery, PasscodeCheckQueryVariables>(PasscodeCheckDocument, options);
        }
export type PasscodeCheckQueryHookResult = ReturnType<typeof usePasscodeCheckQuery>;
export type PasscodeCheckLazyQueryHookResult = ReturnType<typeof usePasscodeCheckLazyQuery>;
export type PasscodeCheckSuspenseQueryHookResult = ReturnType<typeof usePasscodeCheckSuspenseQuery>;
export type PasscodeCheckQueryResult = Apollo.QueryResult<PasscodeCheckQuery, PasscodeCheckQueryVariables>;
export const AcceptWebsiteBrLinkTermsConditionsDocument = gql`
    mutation AcceptWebsiteBrLinkTermsConditions($brCode: String!, $contractBase64Signature: String) {
  acceptWebsiteBRLinkTermsConditions(
    brCode: $brCode
    contractBase64Signature: $contractBase64Signature
  )
}
    `;
export type AcceptWebsiteBrLinkTermsConditionsMutationFn = Apollo.MutationFunction<AcceptWebsiteBrLinkTermsConditionsMutation, AcceptWebsiteBrLinkTermsConditionsMutationVariables>;

/**
 * __useAcceptWebsiteBrLinkTermsConditionsMutation__
 *
 * To run a mutation, you first call `useAcceptWebsiteBrLinkTermsConditionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptWebsiteBrLinkTermsConditionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptWebsiteBrLinkTermsConditionsMutation, { data, loading, error }] = useAcceptWebsiteBrLinkTermsConditionsMutation({
 *   variables: {
 *      brCode: // value for 'brCode'
 *      contractBase64Signature: // value for 'contractBase64Signature'
 *   },
 * });
 */
export function useAcceptWebsiteBrLinkTermsConditionsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptWebsiteBrLinkTermsConditionsMutation, AcceptWebsiteBrLinkTermsConditionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptWebsiteBrLinkTermsConditionsMutation, AcceptWebsiteBrLinkTermsConditionsMutationVariables>(AcceptWebsiteBrLinkTermsConditionsDocument, options);
      }
export type AcceptWebsiteBrLinkTermsConditionsMutationHookResult = ReturnType<typeof useAcceptWebsiteBrLinkTermsConditionsMutation>;
export type AcceptWebsiteBrLinkTermsConditionsMutationResult = Apollo.MutationResult<AcceptWebsiteBrLinkTermsConditionsMutation>;
export type AcceptWebsiteBrLinkTermsConditionsMutationOptions = Apollo.BaseMutationOptions<AcceptWebsiteBrLinkTermsConditionsMutation, AcceptWebsiteBrLinkTermsConditionsMutationVariables>;
export const SetWebsiteBrWizardAsCompletedDocument = gql`
    mutation SetWebsiteBRWizardAsCompleted($brCode: String!) {
  setWebsiteBRWizardAsCompleted(brCode: $brCode)
}
    `;
export type SetWebsiteBrWizardAsCompletedMutationFn = Apollo.MutationFunction<SetWebsiteBrWizardAsCompletedMutation, SetWebsiteBrWizardAsCompletedMutationVariables>;

/**
 * __useSetWebsiteBrWizardAsCompletedMutation__
 *
 * To run a mutation, you first call `useSetWebsiteBrWizardAsCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWebsiteBrWizardAsCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWebsiteBrWizardAsCompletedMutation, { data, loading, error }] = useSetWebsiteBrWizardAsCompletedMutation({
 *   variables: {
 *      brCode: // value for 'brCode'
 *   },
 * });
 */
export function useSetWebsiteBrWizardAsCompletedMutation(baseOptions?: Apollo.MutationHookOptions<SetWebsiteBrWizardAsCompletedMutation, SetWebsiteBrWizardAsCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWebsiteBrWizardAsCompletedMutation, SetWebsiteBrWizardAsCompletedMutationVariables>(SetWebsiteBrWizardAsCompletedDocument, options);
      }
export type SetWebsiteBrWizardAsCompletedMutationHookResult = ReturnType<typeof useSetWebsiteBrWizardAsCompletedMutation>;
export type SetWebsiteBrWizardAsCompletedMutationResult = Apollo.MutationResult<SetWebsiteBrWizardAsCompletedMutation>;
export type SetWebsiteBrWizardAsCompletedMutationOptions = Apollo.BaseMutationOptions<SetWebsiteBrWizardAsCompletedMutation, SetWebsiteBrWizardAsCompletedMutationVariables>;
export const GetBuildingDetailsDocument = gql`
    query GetBuildingDetails($buildingID: ID!, $options: CommonQueryOptionsInput) {
  buildings {
    __typename
    count(filter: {buildingIDs: [$buildingID]})
    records(filter: {buildingIDs: [$buildingID]}, options: $options) {
      __typename
      id
      listingNameRendered
      aboutBuildingRendered
      aboutBuildingRendered
      quotation {
        paymentPlan {
          singlePayment {
            nights
            nightlyRate
            bookingAmount
            bookingTotal
          }
          grandBookingTotal
          grandTotal
          currency
          securityDeposit {
            isInSameTransaction
            corporatePaysForTheSecurityDeposit
            damageProtectionPolicyType
            dueOn {
              formatted
            }
            isPaid
            totalAmount
          }
        }
      }
      quotation {
        paymentPlan {
          currency
          paymentMethods {
            name
            isEnabled
          }
          originalBookingTotal
          grandTotal
          securityDeposit {
            totalAmount
            isDueNow
            dueOn {
              formatted
            }
            isInSameTransaction
            damageProtectionPolicyType
            corporatePaysForTheSecurityDeposit
            isPaid
          }
          singlePayment {
            nights
            bookingTotal
            nightlyRate
            discountAmount
            bookingAmount
            isPaid
            amountPaid
            invoices {
              id
            }
            fees {
              value
              name
            }
          }
        }
      }
      location {
        __typename
        address
        coordinates {
          __typename
          lat
          lng
        }
        neighbourhood {
          __typename
          id
          name
          city {
            __typename
            id
            name
            country {
              __typename
              id
              name
              code2
            }
          }
        }
      }
      highLevelAmenities {
        __typename
        id
        name
        iconUrl
        contentRendered
      }
      images {
        __typename
        all {
          __typename
          displayOrder
          imageType
          url
          webp {
            __typename
            largeUrl
            mediumUrl
            thumbnailUrl
          }
        }
        main {
          __typename
          url
          webp {
            __typename
            thumbnailUrl
            mediumUrl
            largeUrl
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetBuildingDetailsQuery__
 *
 * To run a query within a React component, call `useGetBuildingDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuildingDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuildingDetailsQuery({
 *   variables: {
 *      buildingID: // value for 'buildingID'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetBuildingDetailsQuery(baseOptions: Apollo.QueryHookOptions<GetBuildingDetailsQuery, GetBuildingDetailsQueryVariables> & ({ variables: GetBuildingDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBuildingDetailsQuery, GetBuildingDetailsQueryVariables>(GetBuildingDetailsDocument, options);
      }
export function useGetBuildingDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuildingDetailsQuery, GetBuildingDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBuildingDetailsQuery, GetBuildingDetailsQueryVariables>(GetBuildingDetailsDocument, options);
        }
// @ts-ignore
export function useGetBuildingDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBuildingDetailsQuery, GetBuildingDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetBuildingDetailsQuery, GetBuildingDetailsQueryVariables>;
export function useGetBuildingDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBuildingDetailsQuery, GetBuildingDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetBuildingDetailsQuery | undefined, GetBuildingDetailsQueryVariables>;
export function useGetBuildingDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBuildingDetailsQuery, GetBuildingDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBuildingDetailsQuery, GetBuildingDetailsQueryVariables>(GetBuildingDetailsDocument, options);
        }
export type GetBuildingDetailsQueryHookResult = ReturnType<typeof useGetBuildingDetailsQuery>;
export type GetBuildingDetailsLazyQueryHookResult = ReturnType<typeof useGetBuildingDetailsLazyQuery>;
export type GetBuildingDetailsSuspenseQueryHookResult = ReturnType<typeof useGetBuildingDetailsSuspenseQuery>;
export type GetBuildingDetailsQueryResult = Apollo.QueryResult<GetBuildingDetailsQuery, GetBuildingDetailsQueryVariables>;
export const SearchBuildingsDocument = gql`
    query SearchBuildings($filter: BuildingFilterInput, $options: CommonQueryOptionsInput) {
  buildings {
    __typename
    count(filter: $filter)
    records(filter: $filter, options: $options) {
      __typename
      id
      listingNameRendered
      aboutBuildingRendered
      location {
        __typename
        address
        coordinates {
          __typename
          lat
          lng
        }
        neighbourhood {
          __typename
          id
          name
          city {
            __typename
            id
            name
            country {
              __typename
              id
              name
              code2
            }
          }
        }
      }
      highLevelAmenities {
        __typename
        id
        name
        iconUrl
      }
      images {
        __typename
        main {
          __typename
          url
          webp {
            __typename
            thumbnailUrl
            mediumUrl
            largeUrl
          }
        }
        all {
          __typename
          url
          imageType
          captionRendered
          webp {
            __typename
            thumbnailUrl
            mediumUrl
            largeUrl
          }
        }
      }
      quotation {
        paymentPlan {
          currency
          paymentMethods {
            name
            isEnabled
          }
          originalBookingTotal
          grandTotal
          securityDeposit {
            totalAmount
            isDueNow
            dueOn {
              formatted
            }
            isInSameTransaction
            damageProtectionPolicyType
            corporatePaysForTheSecurityDeposit
            isPaid
          }
          singlePayment {
            nights
            bookingTotal
            nightlyRate
            discountAmount
            bookingAmount
            isPaid
            amountPaid
            invoices {
              id
            }
            fees {
              value
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchBuildingsQuery__
 *
 * To run a query within a React component, call `useSearchBuildingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchBuildingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchBuildingsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSearchBuildingsQuery(baseOptions?: Apollo.QueryHookOptions<SearchBuildingsQuery, SearchBuildingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchBuildingsQuery, SearchBuildingsQueryVariables>(SearchBuildingsDocument, options);
      }
export function useSearchBuildingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchBuildingsQuery, SearchBuildingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchBuildingsQuery, SearchBuildingsQueryVariables>(SearchBuildingsDocument, options);
        }
// @ts-ignore
export function useSearchBuildingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchBuildingsQuery, SearchBuildingsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchBuildingsQuery, SearchBuildingsQueryVariables>;
export function useSearchBuildingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchBuildingsQuery, SearchBuildingsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchBuildingsQuery | undefined, SearchBuildingsQueryVariables>;
export function useSearchBuildingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchBuildingsQuery, SearchBuildingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchBuildingsQuery, SearchBuildingsQueryVariables>(SearchBuildingsDocument, options);
        }
export type SearchBuildingsQueryHookResult = ReturnType<typeof useSearchBuildingsQuery>;
export type SearchBuildingsLazyQueryHookResult = ReturnType<typeof useSearchBuildingsLazyQuery>;
export type SearchBuildingsSuspenseQueryHookResult = ReturnType<typeof useSearchBuildingsSuspenseQuery>;
export type SearchBuildingsQueryResult = Apollo.QueryResult<SearchBuildingsQuery, SearchBuildingsQueryVariables>;
export const BuildingsWithStandalonePropertiesDocument = gql`
    query BuildingsWithStandaloneProperties($filter: BuildingsWithStandalonePropertiesFilterInput!, $options: CommonQueryOptionsInput) {
  result: buildingsWithStandaloneProperties(filter: $filter, options: $options) {
    __typename
    ... on Building {
      id
      listingNameRendered
      location {
        id
        address
        zipCode
        coordinates {
          lat
          lng
        }
        neighbourhood {
          id
          name
          city {
            id
            name
            airportCode
            country {
              id
              name
              code3
              code2
              currency
            }
          }
        }
      }
      highLevelAmenities {
        id
        name
        iconUrl
        contentRendered
      }
      images {
        main {
          url
          webp {
            thumbnailUrl
            mediumUrl
            largeUrl
          }
        }
        all {
          url
          webp {
            thumbnailUrl
            mediumUrl
            largeUrl
          }
          imageType
          displayOrder
          captionRendered
        }
      }
      aboutBuildingRendered
      quotation {
        paymentPlan {
          currency
          paymentMethods {
            name
            isEnabled
          }
          originalBookingTotal
          grandTotal
          securityDeposit {
            totalAmount
            isDueNow
            dueOn {
              formatted
            }
            isInSameTransaction
            damageProtectionPolicyType
            corporatePaysForTheSecurityDeposit
            isPaid
          }
          singlePayment {
            nights
            vat {
              amount
              percentage
            }
            bookingTotal
            nightlyRate
            discountAmount
            bookingAmount
            isPaid
            amountPaid
            invoices {
              invoiceNumber
              id
              totalAmount
              dueAmount
              paidAmount
            }
            fees {
              percentage
              value
              name
            }
          }
        }
      }
    }
    ... on Property {
      id
      propertyType {
        name
        isStandalone
      }
      entityType
      currency
      building {
        id
        listingNameRendered
        location {
          id
          address
          zipCode
          coordinates {
            lat
            lng
          }
          neighbourhood {
            id
            name
            city {
              id
              name
              airportCode
              vatPercentage
              country {
                id
                name
                code3
                code2
                currency
                vatPercentage
              }
            }
          }
        }
        highLevelAmenities {
          id
          name
          iconUrl
          contentRendered
        }
        images {
          main {
            url
            webp {
              thumbnailUrl
              mediumUrl
              largeUrl
            }
          }
          all {
            url
            webp {
              thumbnailUrl
              mediumUrl
              largeUrl
            }
            imageType
            displayOrder
            captionRendered
          }
        }
      }
      location {
        id
        address
        zipCode
        coordinates {
          lat
          lng
        }
        neighbourhood {
          id
          name
          city {
            id
            name
            airportCode
            vatPercentage
            country {
              id
              name
              code3
              code2
              currency
              vatPercentage
            }
          }
        }
      }
      unitNumber
      floorNumber
      parkingNumber
      listingNameRendered
      bedroomCount
      bathCount
      hasKitchen
      sizeSqm
      balconySizeSqm
      securityDepositAmount
      highLevelAmenities {
        id
        name
        iconUrl
        contentRendered
      }
      images {
        main {
          url
          webp {
            thumbnailUrl
            mediumUrl
            largeUrl
          }
        }
        all {
          url
          webp {
            thumbnailUrl
            mediumUrl
            largeUrl
          }
          imageType
          displayOrder
          captionRendered
        }
      }
      aboutPropertyRendered
      houseRules {
        id
        name
        iconUrl
        contentRendered {
          languageCode
          title
          body
        }
      }
      furnished {
        bedCount
        maximumGuests
        sleepingArrangement {
          bedroomNumber
          bedTypes
        }
        checkInTime
        checkOutTime
      }
      quotation {
        paymentPlan {
          currency
          paymentMethods {
            name
            isEnabled
          }
          originalBookingTotal
          grandTotal
          securityDeposit {
            totalAmount
            isDueNow
            dueOn {
              formatted
            }
            isInSameTransaction
            damageProtectionPolicyType
            corporatePaysForTheSecurityDeposit
            isPaid
          }
          singlePayment {
            nights
            vat {
              amount
              percentage
            }
            bookingTotal
            nightlyRate
            discountAmount
            bookingAmount
            isPaid
            amountPaid
            invoices {
              invoiceNumber
              id
              totalAmount
              dueAmount
              paidAmount
            }
            fees {
              percentage
              value
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useBuildingsWithStandalonePropertiesQuery__
 *
 * To run a query within a React component, call `useBuildingsWithStandalonePropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildingsWithStandalonePropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildingsWithStandalonePropertiesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useBuildingsWithStandalonePropertiesQuery(baseOptions: Apollo.QueryHookOptions<BuildingsWithStandalonePropertiesQuery, BuildingsWithStandalonePropertiesQueryVariables> & ({ variables: BuildingsWithStandalonePropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildingsWithStandalonePropertiesQuery, BuildingsWithStandalonePropertiesQueryVariables>(BuildingsWithStandalonePropertiesDocument, options);
      }
export function useBuildingsWithStandalonePropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildingsWithStandalonePropertiesQuery, BuildingsWithStandalonePropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildingsWithStandalonePropertiesQuery, BuildingsWithStandalonePropertiesQueryVariables>(BuildingsWithStandalonePropertiesDocument, options);
        }
// @ts-ignore
export function useBuildingsWithStandalonePropertiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BuildingsWithStandalonePropertiesQuery, BuildingsWithStandalonePropertiesQueryVariables>): Apollo.UseSuspenseQueryResult<BuildingsWithStandalonePropertiesQuery, BuildingsWithStandalonePropertiesQueryVariables>;
export function useBuildingsWithStandalonePropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BuildingsWithStandalonePropertiesQuery, BuildingsWithStandalonePropertiesQueryVariables>): Apollo.UseSuspenseQueryResult<BuildingsWithStandalonePropertiesQuery | undefined, BuildingsWithStandalonePropertiesQueryVariables>;
export function useBuildingsWithStandalonePropertiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BuildingsWithStandalonePropertiesQuery, BuildingsWithStandalonePropertiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BuildingsWithStandalonePropertiesQuery, BuildingsWithStandalonePropertiesQueryVariables>(BuildingsWithStandalonePropertiesDocument, options);
        }
export type BuildingsWithStandalonePropertiesQueryHookResult = ReturnType<typeof useBuildingsWithStandalonePropertiesQuery>;
export type BuildingsWithStandalonePropertiesLazyQueryHookResult = ReturnType<typeof useBuildingsWithStandalonePropertiesLazyQuery>;
export type BuildingsWithStandalonePropertiesSuspenseQueryHookResult = ReturnType<typeof useBuildingsWithStandalonePropertiesSuspenseQuery>;
export type BuildingsWithStandalonePropertiesQueryResult = Apollo.QueryResult<BuildingsWithStandalonePropertiesQuery, BuildingsWithStandalonePropertiesQueryVariables>;
export const SubmitWebsiteContactUsDocument = gql`
    mutation SubmitWebsiteContactUs($payload: WebsiteContactMessageInput!) {
  submitWebsiteContactUs(payload: $payload)
}
    `;
export type SubmitWebsiteContactUsMutationFn = Apollo.MutationFunction<SubmitWebsiteContactUsMutation, SubmitWebsiteContactUsMutationVariables>;

/**
 * __useSubmitWebsiteContactUsMutation__
 *
 * To run a mutation, you first call `useSubmitWebsiteContactUsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitWebsiteContactUsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitWebsiteContactUsMutation, { data, loading, error }] = useSubmitWebsiteContactUsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSubmitWebsiteContactUsMutation(baseOptions?: Apollo.MutationHookOptions<SubmitWebsiteContactUsMutation, SubmitWebsiteContactUsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitWebsiteContactUsMutation, SubmitWebsiteContactUsMutationVariables>(SubmitWebsiteContactUsDocument, options);
      }
export type SubmitWebsiteContactUsMutationHookResult = ReturnType<typeof useSubmitWebsiteContactUsMutation>;
export type SubmitWebsiteContactUsMutationResult = Apollo.MutationResult<SubmitWebsiteContactUsMutation>;
export type SubmitWebsiteContactUsMutationOptions = Apollo.BaseMutationOptions<SubmitWebsiteContactUsMutation, SubmitWebsiteContactUsMutationVariables>;
export const SubmitWebsiteLeaseFormDocument = gql`
    mutation SubmitWebsiteLeaseForm($payload: WebsiteLeaseFormInput!) {
  submitWebsiteLeaseForm(payload: $payload)
}
    `;
export type SubmitWebsiteLeaseFormMutationFn = Apollo.MutationFunction<SubmitWebsiteLeaseFormMutation, SubmitWebsiteLeaseFormMutationVariables>;

/**
 * __useSubmitWebsiteLeaseFormMutation__
 *
 * To run a mutation, you first call `useSubmitWebsiteLeaseFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitWebsiteLeaseFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitWebsiteLeaseFormMutation, { data, loading, error }] = useSubmitWebsiteLeaseFormMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSubmitWebsiteLeaseFormMutation(baseOptions?: Apollo.MutationHookOptions<SubmitWebsiteLeaseFormMutation, SubmitWebsiteLeaseFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitWebsiteLeaseFormMutation, SubmitWebsiteLeaseFormMutationVariables>(SubmitWebsiteLeaseFormDocument, options);
      }
export type SubmitWebsiteLeaseFormMutationHookResult = ReturnType<typeof useSubmitWebsiteLeaseFormMutation>;
export type SubmitWebsiteLeaseFormMutationResult = Apollo.MutationResult<SubmitWebsiteLeaseFormMutation>;
export type SubmitWebsiteLeaseFormMutationOptions = Apollo.BaseMutationOptions<SubmitWebsiteLeaseFormMutation, SubmitWebsiteLeaseFormMutationVariables>;
export const SubmitWebsiteCorporateContactDocument = gql`
    mutation SubmitWebsiteCorporateContact($payload: WebsiteCorporateContactInput!) {
  submitWebsiteCorporateContact(payload: $payload)
}
    `;
export type SubmitWebsiteCorporateContactMutationFn = Apollo.MutationFunction<SubmitWebsiteCorporateContactMutation, SubmitWebsiteCorporateContactMutationVariables>;

/**
 * __useSubmitWebsiteCorporateContactMutation__
 *
 * To run a mutation, you first call `useSubmitWebsiteCorporateContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitWebsiteCorporateContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitWebsiteCorporateContactMutation, { data, loading, error }] = useSubmitWebsiteCorporateContactMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSubmitWebsiteCorporateContactMutation(baseOptions?: Apollo.MutationHookOptions<SubmitWebsiteCorporateContactMutation, SubmitWebsiteCorporateContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitWebsiteCorporateContactMutation, SubmitWebsiteCorporateContactMutationVariables>(SubmitWebsiteCorporateContactDocument, options);
      }
export type SubmitWebsiteCorporateContactMutationHookResult = ReturnType<typeof useSubmitWebsiteCorporateContactMutation>;
export type SubmitWebsiteCorporateContactMutationResult = Apollo.MutationResult<SubmitWebsiteCorporateContactMutation>;
export type SubmitWebsiteCorporateContactMutationOptions = Apollo.BaseMutationOptions<SubmitWebsiteCorporateContactMutation, SubmitWebsiteCorporateContactMutationVariables>;
export const WebsiteHelpCenterContentDocument = gql`
    query WebsiteHelpCenterContent {
  websiteHelpCenterContent {
    id
    sectionTitle
    sectionID
    question
    answer
  }
}
    `;

/**
 * __useWebsiteHelpCenterContentQuery__
 *
 * To run a query within a React component, call `useWebsiteHelpCenterContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteHelpCenterContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteHelpCenterContentQuery({
 *   variables: {
 *   },
 * });
 */
export function useWebsiteHelpCenterContentQuery(baseOptions?: Apollo.QueryHookOptions<WebsiteHelpCenterContentQuery, WebsiteHelpCenterContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsiteHelpCenterContentQuery, WebsiteHelpCenterContentQueryVariables>(WebsiteHelpCenterContentDocument, options);
      }
export function useWebsiteHelpCenterContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsiteHelpCenterContentQuery, WebsiteHelpCenterContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsiteHelpCenterContentQuery, WebsiteHelpCenterContentQueryVariables>(WebsiteHelpCenterContentDocument, options);
        }
// @ts-ignore
export function useWebsiteHelpCenterContentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WebsiteHelpCenterContentQuery, WebsiteHelpCenterContentQueryVariables>): Apollo.UseSuspenseQueryResult<WebsiteHelpCenterContentQuery, WebsiteHelpCenterContentQueryVariables>;
export function useWebsiteHelpCenterContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteHelpCenterContentQuery, WebsiteHelpCenterContentQueryVariables>): Apollo.UseSuspenseQueryResult<WebsiteHelpCenterContentQuery | undefined, WebsiteHelpCenterContentQueryVariables>;
export function useWebsiteHelpCenterContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteHelpCenterContentQuery, WebsiteHelpCenterContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsiteHelpCenterContentQuery, WebsiteHelpCenterContentQueryVariables>(WebsiteHelpCenterContentDocument, options);
        }
export type WebsiteHelpCenterContentQueryHookResult = ReturnType<typeof useWebsiteHelpCenterContentQuery>;
export type WebsiteHelpCenterContentLazyQueryHookResult = ReturnType<typeof useWebsiteHelpCenterContentLazyQuery>;
export type WebsiteHelpCenterContentSuspenseQueryHookResult = ReturnType<typeof useWebsiteHelpCenterContentSuspenseQuery>;
export type WebsiteHelpCenterContentQueryResult = Apollo.QueryResult<WebsiteHelpCenterContentQuery, WebsiteHelpCenterContentQueryVariables>;
export const SubmitWebsiteViewingRequestDocument = gql`
    mutation SubmitWebsiteViewingRequest($payload: WebsiteViewingRequestInput!) {
  submitWebsiteViewingRequest(payload: $payload)
}
    `;
export type SubmitWebsiteViewingRequestMutationFn = Apollo.MutationFunction<SubmitWebsiteViewingRequestMutation, SubmitWebsiteViewingRequestMutationVariables>;

/**
 * __useSubmitWebsiteViewingRequestMutation__
 *
 * To run a mutation, you first call `useSubmitWebsiteViewingRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitWebsiteViewingRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitWebsiteViewingRequestMutation, { data, loading, error }] = useSubmitWebsiteViewingRequestMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSubmitWebsiteViewingRequestMutation(baseOptions?: Apollo.MutationHookOptions<SubmitWebsiteViewingRequestMutation, SubmitWebsiteViewingRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitWebsiteViewingRequestMutation, SubmitWebsiteViewingRequestMutationVariables>(SubmitWebsiteViewingRequestDocument, options);
      }
export type SubmitWebsiteViewingRequestMutationHookResult = ReturnType<typeof useSubmitWebsiteViewingRequestMutation>;
export type SubmitWebsiteViewingRequestMutationResult = Apollo.MutationResult<SubmitWebsiteViewingRequestMutation>;
export type SubmitWebsiteViewingRequestMutationOptions = Apollo.BaseMutationOptions<SubmitWebsiteViewingRequestMutation, SubmitWebsiteViewingRequestMutationVariables>;
export const RequestFileUploadHandleDocument = gql`
    mutation RequestFileUploadHandle($payload: FileUploadHandlePayloadInput!) {
  requestFileUploadHandle(payload: $payload) {
    name
    signedUrl
    assetUrl
    __typename
  }
}
    `;
export type RequestFileUploadHandleMutationFn = Apollo.MutationFunction<RequestFileUploadHandleMutation, RequestFileUploadHandleMutationVariables>;

/**
 * __useRequestFileUploadHandleMutation__
 *
 * To run a mutation, you first call `useRequestFileUploadHandleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestFileUploadHandleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestFileUploadHandleMutation, { data, loading, error }] = useRequestFileUploadHandleMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useRequestFileUploadHandleMutation(baseOptions?: Apollo.MutationHookOptions<RequestFileUploadHandleMutation, RequestFileUploadHandleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestFileUploadHandleMutation, RequestFileUploadHandleMutationVariables>(RequestFileUploadHandleDocument, options);
      }
export type RequestFileUploadHandleMutationHookResult = ReturnType<typeof useRequestFileUploadHandleMutation>;
export type RequestFileUploadHandleMutationResult = Apollo.MutationResult<RequestFileUploadHandleMutation>;
export type RequestFileUploadHandleMutationOptions = Apollo.BaseMutationOptions<RequestFileUploadHandleMutation, RequestFileUploadHandleMutationVariables>;
export const GetInvoicesDocument = gql`
    query GetInvoices($filters: InvoiceFilterInput, $options: CommonQueryOptionsInput) {
  invoices {
    records(filter: $filters, options: $options) {
      id
      invoiceNumber
      totalAmount
      dueAmount
      paidAmount
      invoiceType
      status
      paymentMethod
      currency
      paidAt {
        formatted
        raw
      }
      breakdown {
        nights
        nightlyRate
        bookingAmount
        vat {
          percentage
          amount
        }
        fees {
          name
          value
          percentage
        }
        discountAmount
        discountReason
        bookingTotal
        otaCommission
        adjustments {
          amount
          details
        }
      }
      discrepancy {
        amount
        percentage
      }
      reservations {
        numberOfGuests
        documents {
          isMainGuest
          documentStatus
          document {
            id
            documentType
            attachments {
              fileName
              mimeType
              url
            }
            lastUpdated {
              formatted
              raw
            }
          }
          reviewedBy {
            lastName
            firstName
            email
            picture
          }
          content {
            firstName
            lastName
            fatherName
            grandfatherName
            documentNumber
          }
        }
        channel {
          id
          name
        }
        id
        confirmationNumber
        checkInDate {
          formatted
          raw
        }
        checkInTime
        checkOutDate {
          formatted
          raw
        }
        checkOutTime
        property {
          listingNameRendered
          aboutPropertyRendered
          internalName
          location {
            id
            address
            zipCode
            coordinates {
              lat
              lng
            }
            neighbourhood {
              id
              name
              city {
                id
                name
              }
            }
          }
          images {
            main {
              url
              webp {
                thumbnailUrl
                mediumUrl
                largeUrl
              }
              imageType
              displayOrder
              captionRendered
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetInvoicesQuery__
 *
 * To run a query within a React component, call `useGetInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
      }
export function useGetInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
        }
// @ts-ignore
export function useGetInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoicesQuery, GetInvoicesQueryVariables>;
export function useGetInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvoicesQuery | undefined, GetInvoicesQueryVariables>;
export function useGetInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvoicesQuery, GetInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvoicesQuery, GetInvoicesQueryVariables>(GetInvoicesDocument, options);
        }
export type GetInvoicesQueryHookResult = ReturnType<typeof useGetInvoicesQuery>;
export type GetInvoicesLazyQueryHookResult = ReturnType<typeof useGetInvoicesLazyQuery>;
export type GetInvoicesSuspenseQueryHookResult = ReturnType<typeof useGetInvoicesSuspenseQuery>;
export type GetInvoicesQueryResult = Apollo.QueryResult<GetInvoicesQuery, GetInvoicesQueryVariables>;
export const GetCancellationPolicyTextDocument = gql`
    query GetCancellationPolicyText {
  cancellationPolicyText {
    body
    languageCode
  }
}
    `;

/**
 * __useGetCancellationPolicyTextQuery__
 *
 * To run a query within a React component, call `useGetCancellationPolicyTextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCancellationPolicyTextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCancellationPolicyTextQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCancellationPolicyTextQuery(baseOptions?: Apollo.QueryHookOptions<GetCancellationPolicyTextQuery, GetCancellationPolicyTextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCancellationPolicyTextQuery, GetCancellationPolicyTextQueryVariables>(GetCancellationPolicyTextDocument, options);
      }
export function useGetCancellationPolicyTextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCancellationPolicyTextQuery, GetCancellationPolicyTextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCancellationPolicyTextQuery, GetCancellationPolicyTextQueryVariables>(GetCancellationPolicyTextDocument, options);
        }
// @ts-ignore
export function useGetCancellationPolicyTextSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCancellationPolicyTextQuery, GetCancellationPolicyTextQueryVariables>): Apollo.UseSuspenseQueryResult<GetCancellationPolicyTextQuery, GetCancellationPolicyTextQueryVariables>;
export function useGetCancellationPolicyTextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCancellationPolicyTextQuery, GetCancellationPolicyTextQueryVariables>): Apollo.UseSuspenseQueryResult<GetCancellationPolicyTextQuery | undefined, GetCancellationPolicyTextQueryVariables>;
export function useGetCancellationPolicyTextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCancellationPolicyTextQuery, GetCancellationPolicyTextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCancellationPolicyTextQuery, GetCancellationPolicyTextQueryVariables>(GetCancellationPolicyTextDocument, options);
        }
export type GetCancellationPolicyTextQueryHookResult = ReturnType<typeof useGetCancellationPolicyTextQuery>;
export type GetCancellationPolicyTextLazyQueryHookResult = ReturnType<typeof useGetCancellationPolicyTextLazyQuery>;
export type GetCancellationPolicyTextSuspenseQueryHookResult = ReturnType<typeof useGetCancellationPolicyTextSuspenseQuery>;
export type GetCancellationPolicyTextQueryResult = Apollo.QueryResult<GetCancellationPolicyTextQuery, GetCancellationPolicyTextQueryVariables>;
export const SupportedLanguagesDocument = gql`
    query SupportedLanguages {
  languages {
    code
    direction
    name
    id
  }
}
    `;

/**
 * __useSupportedLanguagesQuery__
 *
 * To run a query within a React component, call `useSupportedLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSupportedLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupportedLanguagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSupportedLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>(SupportedLanguagesDocument, options);
      }
export function useSupportedLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>(SupportedLanguagesDocument, options);
        }
// @ts-ignore
export function useSupportedLanguagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>): Apollo.UseSuspenseQueryResult<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>;
export function useSupportedLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>): Apollo.UseSuspenseQueryResult<SupportedLanguagesQuery | undefined, SupportedLanguagesQueryVariables>;
export function useSupportedLanguagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>(SupportedLanguagesDocument, options);
        }
export type SupportedLanguagesQueryHookResult = ReturnType<typeof useSupportedLanguagesQuery>;
export type SupportedLanguagesLazyQueryHookResult = ReturnType<typeof useSupportedLanguagesLazyQuery>;
export type SupportedLanguagesSuspenseQueryHookResult = ReturnType<typeof useSupportedLanguagesSuspenseQuery>;
export type SupportedLanguagesQueryResult = Apollo.QueryResult<SupportedLanguagesQuery, SupportedLanguagesQueryVariables>;
export const LocalizationsDocument = gql`
    query Localizations($filters: LocalisationsFilterInput!) {
  localisations(filter: $filters) {
    lookupKey
    content
    tags
  }
}
    `;

/**
 * __useLocalizationsQuery__
 *
 * To run a query within a React component, call `useLocalizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocalizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocalizationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useLocalizationsQuery(baseOptions: Apollo.QueryHookOptions<LocalizationsQuery, LocalizationsQueryVariables> & ({ variables: LocalizationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocalizationsQuery, LocalizationsQueryVariables>(LocalizationsDocument, options);
      }
export function useLocalizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocalizationsQuery, LocalizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocalizationsQuery, LocalizationsQueryVariables>(LocalizationsDocument, options);
        }
// @ts-ignore
export function useLocalizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LocalizationsQuery, LocalizationsQueryVariables>): Apollo.UseSuspenseQueryResult<LocalizationsQuery, LocalizationsQueryVariables>;
export function useLocalizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocalizationsQuery, LocalizationsQueryVariables>): Apollo.UseSuspenseQueryResult<LocalizationsQuery | undefined, LocalizationsQueryVariables>;
export function useLocalizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LocalizationsQuery, LocalizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LocalizationsQuery, LocalizationsQueryVariables>(LocalizationsDocument, options);
        }
export type LocalizationsQueryHookResult = ReturnType<typeof useLocalizationsQuery>;
export type LocalizationsLazyQueryHookResult = ReturnType<typeof useLocalizationsLazyQuery>;
export type LocalizationsSuspenseQueryHookResult = ReturnType<typeof useLocalizationsSuspenseQuery>;
export type LocalizationsQueryResult = Apollo.QueryResult<LocalizationsQuery, LocalizationsQueryVariables>;
export const GetCitiesDocument = gql`
    query GetCities {
  cities {
    id
    name
  }
}
    `;

/**
 * __useGetCitiesQuery__
 *
 * To run a query within a React component, call `useGetCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCitiesQuery(baseOptions?: Apollo.QueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
      }
export function useGetCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
        }
// @ts-ignore
export function useGetCitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCitiesQuery, GetCitiesQueryVariables>;
export function useGetCitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCitiesQuery | undefined, GetCitiesQueryVariables>;
export function useGetCitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCitiesQuery, GetCitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCitiesQuery, GetCitiesQueryVariables>(GetCitiesDocument, options);
        }
export type GetCitiesQueryHookResult = ReturnType<typeof useGetCitiesQuery>;
export type GetCitiesLazyQueryHookResult = ReturnType<typeof useGetCitiesLazyQuery>;
export type GetCitiesSuspenseQueryHookResult = ReturnType<typeof useGetCitiesSuspenseQuery>;
export type GetCitiesQueryResult = Apollo.QueryResult<GetCitiesQuery, GetCitiesQueryVariables>;
export const CreateWebsiteBrLinkPaymentIntentDocument = gql`
    mutation CreateWebsiteBRLinkPaymentIntent($payload: WebsiteBRLinkPaymentIntentPayloadInput!) {
  createWebsiteBRLinkPaymentIntent(payload: $payload) {
    intentReferenceKey
    clientSecret
    publishableKey
  }
}
    `;
export type CreateWebsiteBrLinkPaymentIntentMutationFn = Apollo.MutationFunction<CreateWebsiteBrLinkPaymentIntentMutation, CreateWebsiteBrLinkPaymentIntentMutationVariables>;

/**
 * __useCreateWebsiteBrLinkPaymentIntentMutation__
 *
 * To run a mutation, you first call `useCreateWebsiteBrLinkPaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebsiteBrLinkPaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebsiteBrLinkPaymentIntentMutation, { data, loading, error }] = useCreateWebsiteBrLinkPaymentIntentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateWebsiteBrLinkPaymentIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebsiteBrLinkPaymentIntentMutation, CreateWebsiteBrLinkPaymentIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebsiteBrLinkPaymentIntentMutation, CreateWebsiteBrLinkPaymentIntentMutationVariables>(CreateWebsiteBrLinkPaymentIntentDocument, options);
      }
export type CreateWebsiteBrLinkPaymentIntentMutationHookResult = ReturnType<typeof useCreateWebsiteBrLinkPaymentIntentMutation>;
export type CreateWebsiteBrLinkPaymentIntentMutationResult = Apollo.MutationResult<CreateWebsiteBrLinkPaymentIntentMutation>;
export type CreateWebsiteBrLinkPaymentIntentMutationOptions = Apollo.BaseMutationOptions<CreateWebsiteBrLinkPaymentIntentMutation, CreateWebsiteBrLinkPaymentIntentMutationVariables>;
export const CreateWebsiteBrLinkCardOnFileIntentDocument = gql`
    mutation CreateWebsiteBRLinkCardOnFileIntent($payload: WebsiteBRLinkCardOnFileIntentPayloadInput!) {
  createWebsiteBRLinkCardOnFileIntent(payload: $payload) {
    intentReferenceKey
    clientSecret
    publishableKey
  }
}
    `;
export type CreateWebsiteBrLinkCardOnFileIntentMutationFn = Apollo.MutationFunction<CreateWebsiteBrLinkCardOnFileIntentMutation, CreateWebsiteBrLinkCardOnFileIntentMutationVariables>;

/**
 * __useCreateWebsiteBrLinkCardOnFileIntentMutation__
 *
 * To run a mutation, you first call `useCreateWebsiteBrLinkCardOnFileIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebsiteBrLinkCardOnFileIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWebsiteBrLinkCardOnFileIntentMutation, { data, loading, error }] = useCreateWebsiteBrLinkCardOnFileIntentMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateWebsiteBrLinkCardOnFileIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreateWebsiteBrLinkCardOnFileIntentMutation, CreateWebsiteBrLinkCardOnFileIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWebsiteBrLinkCardOnFileIntentMutation, CreateWebsiteBrLinkCardOnFileIntentMutationVariables>(CreateWebsiteBrLinkCardOnFileIntentDocument, options);
      }
export type CreateWebsiteBrLinkCardOnFileIntentMutationHookResult = ReturnType<typeof useCreateWebsiteBrLinkCardOnFileIntentMutation>;
export type CreateWebsiteBrLinkCardOnFileIntentMutationResult = Apollo.MutationResult<CreateWebsiteBrLinkCardOnFileIntentMutation>;
export type CreateWebsiteBrLinkCardOnFileIntentMutationOptions = Apollo.BaseMutationOptions<CreateWebsiteBrLinkCardOnFileIntentMutation, CreateWebsiteBrLinkCardOnFileIntentMutationVariables>;
export const SubmitPaymentCollectionProofDocument = gql`
    mutation SubmitPaymentCollectionProof($payload: PaymentCollectionProofSubmissionPayloadInput!) {
  submitPaymentCollectionProof(payload: $payload)
}
    `;
export type SubmitPaymentCollectionProofMutationFn = Apollo.MutationFunction<SubmitPaymentCollectionProofMutation, SubmitPaymentCollectionProofMutationVariables>;

/**
 * __useSubmitPaymentCollectionProofMutation__
 *
 * To run a mutation, you first call `useSubmitPaymentCollectionProofMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitPaymentCollectionProofMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitPaymentCollectionProofMutation, { data, loading, error }] = useSubmitPaymentCollectionProofMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSubmitPaymentCollectionProofMutation(baseOptions?: Apollo.MutationHookOptions<SubmitPaymentCollectionProofMutation, SubmitPaymentCollectionProofMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitPaymentCollectionProofMutation, SubmitPaymentCollectionProofMutationVariables>(SubmitPaymentCollectionProofDocument, options);
      }
export type SubmitPaymentCollectionProofMutationHookResult = ReturnType<typeof useSubmitPaymentCollectionProofMutation>;
export type SubmitPaymentCollectionProofMutationResult = Apollo.MutationResult<SubmitPaymentCollectionProofMutation>;
export type SubmitPaymentCollectionProofMutationOptions = Apollo.BaseMutationOptions<SubmitPaymentCollectionProofMutation, SubmitPaymentCollectionProofMutationVariables>;
export const ProcessWebsiteBrLinkCardPurchaseDocument = gql`
    mutation ProcessWebsiteBRLinkCardPurchase($payload: WebsiteBRLinkCardPurchasePayloadInput!) {
  processWebsiteBRLinkCardPurchase(payload: $payload) {
    result
    redirectUrl
    redirectParams {
      name
      value
    }
    returnUrlQueryParams {
      name
      value
    }
    declineMessage
    publicID
    skipWaiting
  }
}
    `;
export type ProcessWebsiteBrLinkCardPurchaseMutationFn = Apollo.MutationFunction<ProcessWebsiteBrLinkCardPurchaseMutation, ProcessWebsiteBrLinkCardPurchaseMutationVariables>;

/**
 * __useProcessWebsiteBrLinkCardPurchaseMutation__
 *
 * To run a mutation, you first call `useProcessWebsiteBrLinkCardPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessWebsiteBrLinkCardPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processWebsiteBrLinkCardPurchaseMutation, { data, loading, error }] = useProcessWebsiteBrLinkCardPurchaseMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useProcessWebsiteBrLinkCardPurchaseMutation(baseOptions?: Apollo.MutationHookOptions<ProcessWebsiteBrLinkCardPurchaseMutation, ProcessWebsiteBrLinkCardPurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProcessWebsiteBrLinkCardPurchaseMutation, ProcessWebsiteBrLinkCardPurchaseMutationVariables>(ProcessWebsiteBrLinkCardPurchaseDocument, options);
      }
export type ProcessWebsiteBrLinkCardPurchaseMutationHookResult = ReturnType<typeof useProcessWebsiteBrLinkCardPurchaseMutation>;
export type ProcessWebsiteBrLinkCardPurchaseMutationResult = Apollo.MutationResult<ProcessWebsiteBrLinkCardPurchaseMutation>;
export type ProcessWebsiteBrLinkCardPurchaseMutationOptions = Apollo.BaseMutationOptions<ProcessWebsiteBrLinkCardPurchaseMutation, ProcessWebsiteBrLinkCardPurchaseMutationVariables>;
export const WebsiteBrLinkCryptoTotalAmountDocument = gql`
    query WebsiteBRLinkCryptoTotalAmount($payload: WebsiteBRLinkCryptoTotalAmountInput!) {
  websiteBRLinkCryptoTotalAmount(params: $payload)
}
    `;

/**
 * __useWebsiteBrLinkCryptoTotalAmountQuery__
 *
 * To run a query within a React component, call `useWebsiteBrLinkCryptoTotalAmountQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteBrLinkCryptoTotalAmountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteBrLinkCryptoTotalAmountQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useWebsiteBrLinkCryptoTotalAmountQuery(baseOptions: Apollo.QueryHookOptions<WebsiteBrLinkCryptoTotalAmountQuery, WebsiteBrLinkCryptoTotalAmountQueryVariables> & ({ variables: WebsiteBrLinkCryptoTotalAmountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsiteBrLinkCryptoTotalAmountQuery, WebsiteBrLinkCryptoTotalAmountQueryVariables>(WebsiteBrLinkCryptoTotalAmountDocument, options);
      }
export function useWebsiteBrLinkCryptoTotalAmountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsiteBrLinkCryptoTotalAmountQuery, WebsiteBrLinkCryptoTotalAmountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsiteBrLinkCryptoTotalAmountQuery, WebsiteBrLinkCryptoTotalAmountQueryVariables>(WebsiteBrLinkCryptoTotalAmountDocument, options);
        }
// @ts-ignore
export function useWebsiteBrLinkCryptoTotalAmountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WebsiteBrLinkCryptoTotalAmountQuery, WebsiteBrLinkCryptoTotalAmountQueryVariables>): Apollo.UseSuspenseQueryResult<WebsiteBrLinkCryptoTotalAmountQuery, WebsiteBrLinkCryptoTotalAmountQueryVariables>;
export function useWebsiteBrLinkCryptoTotalAmountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteBrLinkCryptoTotalAmountQuery, WebsiteBrLinkCryptoTotalAmountQueryVariables>): Apollo.UseSuspenseQueryResult<WebsiteBrLinkCryptoTotalAmountQuery | undefined, WebsiteBrLinkCryptoTotalAmountQueryVariables>;
export function useWebsiteBrLinkCryptoTotalAmountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteBrLinkCryptoTotalAmountQuery, WebsiteBrLinkCryptoTotalAmountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsiteBrLinkCryptoTotalAmountQuery, WebsiteBrLinkCryptoTotalAmountQueryVariables>(WebsiteBrLinkCryptoTotalAmountDocument, options);
        }
export type WebsiteBrLinkCryptoTotalAmountQueryHookResult = ReturnType<typeof useWebsiteBrLinkCryptoTotalAmountQuery>;
export type WebsiteBrLinkCryptoTotalAmountLazyQueryHookResult = ReturnType<typeof useWebsiteBrLinkCryptoTotalAmountLazyQuery>;
export type WebsiteBrLinkCryptoTotalAmountSuspenseQueryHookResult = ReturnType<typeof useWebsiteBrLinkCryptoTotalAmountSuspenseQuery>;
export type WebsiteBrLinkCryptoTotalAmountQueryResult = Apollo.QueryResult<WebsiteBrLinkCryptoTotalAmountQuery, WebsiteBrLinkCryptoTotalAmountQueryVariables>;
export const WebsiteBrLinkPendingInvoicesStatusDocument = gql`
    query WebsiteBRLinkPendingInvoicesStatus($brCode: String!) {
  result: websiteBookingRegistrationLink(brCode: $brCode) {
    pendingInvoices {
      status
      invoiceNumber
      invoiceType
    }
  }
}
    `;

/**
 * __useWebsiteBrLinkPendingInvoicesStatusQuery__
 *
 * To run a query within a React component, call `useWebsiteBrLinkPendingInvoicesStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteBrLinkPendingInvoicesStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteBrLinkPendingInvoicesStatusQuery({
 *   variables: {
 *      brCode: // value for 'brCode'
 *   },
 * });
 */
export function useWebsiteBrLinkPendingInvoicesStatusQuery(baseOptions: Apollo.QueryHookOptions<WebsiteBrLinkPendingInvoicesStatusQuery, WebsiteBrLinkPendingInvoicesStatusQueryVariables> & ({ variables: WebsiteBrLinkPendingInvoicesStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsiteBrLinkPendingInvoicesStatusQuery, WebsiteBrLinkPendingInvoicesStatusQueryVariables>(WebsiteBrLinkPendingInvoicesStatusDocument, options);
      }
export function useWebsiteBrLinkPendingInvoicesStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsiteBrLinkPendingInvoicesStatusQuery, WebsiteBrLinkPendingInvoicesStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsiteBrLinkPendingInvoicesStatusQuery, WebsiteBrLinkPendingInvoicesStatusQueryVariables>(WebsiteBrLinkPendingInvoicesStatusDocument, options);
        }
// @ts-ignore
export function useWebsiteBrLinkPendingInvoicesStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WebsiteBrLinkPendingInvoicesStatusQuery, WebsiteBrLinkPendingInvoicesStatusQueryVariables>): Apollo.UseSuspenseQueryResult<WebsiteBrLinkPendingInvoicesStatusQuery, WebsiteBrLinkPendingInvoicesStatusQueryVariables>;
export function useWebsiteBrLinkPendingInvoicesStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteBrLinkPendingInvoicesStatusQuery, WebsiteBrLinkPendingInvoicesStatusQueryVariables>): Apollo.UseSuspenseQueryResult<WebsiteBrLinkPendingInvoicesStatusQuery | undefined, WebsiteBrLinkPendingInvoicesStatusQueryVariables>;
export function useWebsiteBrLinkPendingInvoicesStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteBrLinkPendingInvoicesStatusQuery, WebsiteBrLinkPendingInvoicesStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsiteBrLinkPendingInvoicesStatusQuery, WebsiteBrLinkPendingInvoicesStatusQueryVariables>(WebsiteBrLinkPendingInvoicesStatusDocument, options);
        }
export type WebsiteBrLinkPendingInvoicesStatusQueryHookResult = ReturnType<typeof useWebsiteBrLinkPendingInvoicesStatusQuery>;
export type WebsiteBrLinkPendingInvoicesStatusLazyQueryHookResult = ReturnType<typeof useWebsiteBrLinkPendingInvoicesStatusLazyQuery>;
export type WebsiteBrLinkPendingInvoicesStatusSuspenseQueryHookResult = ReturnType<typeof useWebsiteBrLinkPendingInvoicesStatusSuspenseQuery>;
export type WebsiteBrLinkPendingInvoicesStatusQueryResult = Apollo.QueryResult<WebsiteBrLinkPendingInvoicesStatusQuery, WebsiteBrLinkPendingInvoicesStatusQueryVariables>;
export const WebsitePaymentLinkPendingInvoicesStatusDocument = gql`
    query WebsitePaymentLinkPendingInvoicesStatus($plNumber: String!) {
  result: websitePaymentLink(plNumber: $plNumber) {
    pendingInvoices {
      status
      invoiceNumber
      invoiceType
    }
  }
}
    `;

/**
 * __useWebsitePaymentLinkPendingInvoicesStatusQuery__
 *
 * To run a query within a React component, call `useWebsitePaymentLinkPendingInvoicesStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsitePaymentLinkPendingInvoicesStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsitePaymentLinkPendingInvoicesStatusQuery({
 *   variables: {
 *      plNumber: // value for 'plNumber'
 *   },
 * });
 */
export function useWebsitePaymentLinkPendingInvoicesStatusQuery(baseOptions: Apollo.QueryHookOptions<WebsitePaymentLinkPendingInvoicesStatusQuery, WebsitePaymentLinkPendingInvoicesStatusQueryVariables> & ({ variables: WebsitePaymentLinkPendingInvoicesStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsitePaymentLinkPendingInvoicesStatusQuery, WebsitePaymentLinkPendingInvoicesStatusQueryVariables>(WebsitePaymentLinkPendingInvoicesStatusDocument, options);
      }
export function useWebsitePaymentLinkPendingInvoicesStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsitePaymentLinkPendingInvoicesStatusQuery, WebsitePaymentLinkPendingInvoicesStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsitePaymentLinkPendingInvoicesStatusQuery, WebsitePaymentLinkPendingInvoicesStatusQueryVariables>(WebsitePaymentLinkPendingInvoicesStatusDocument, options);
        }
// @ts-ignore
export function useWebsitePaymentLinkPendingInvoicesStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WebsitePaymentLinkPendingInvoicesStatusQuery, WebsitePaymentLinkPendingInvoicesStatusQueryVariables>): Apollo.UseSuspenseQueryResult<WebsitePaymentLinkPendingInvoicesStatusQuery, WebsitePaymentLinkPendingInvoicesStatusQueryVariables>;
export function useWebsitePaymentLinkPendingInvoicesStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsitePaymentLinkPendingInvoicesStatusQuery, WebsitePaymentLinkPendingInvoicesStatusQueryVariables>): Apollo.UseSuspenseQueryResult<WebsitePaymentLinkPendingInvoicesStatusQuery | undefined, WebsitePaymentLinkPendingInvoicesStatusQueryVariables>;
export function useWebsitePaymentLinkPendingInvoicesStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsitePaymentLinkPendingInvoicesStatusQuery, WebsitePaymentLinkPendingInvoicesStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsitePaymentLinkPendingInvoicesStatusQuery, WebsitePaymentLinkPendingInvoicesStatusQueryVariables>(WebsitePaymentLinkPendingInvoicesStatusDocument, options);
        }
export type WebsitePaymentLinkPendingInvoicesStatusQueryHookResult = ReturnType<typeof useWebsitePaymentLinkPendingInvoicesStatusQuery>;
export type WebsitePaymentLinkPendingInvoicesStatusLazyQueryHookResult = ReturnType<typeof useWebsitePaymentLinkPendingInvoicesStatusLazyQuery>;
export type WebsitePaymentLinkPendingInvoicesStatusSuspenseQueryHookResult = ReturnType<typeof useWebsitePaymentLinkPendingInvoicesStatusSuspenseQuery>;
export type WebsitePaymentLinkPendingInvoicesStatusQueryResult = Apollo.QueryResult<WebsitePaymentLinkPendingInvoicesStatusQuery, WebsitePaymentLinkPendingInvoicesStatusQueryVariables>;
export const WebsitePaymentLinkDocument = gql`
    query WebsitePaymentLink($plNumber: String!) {
  websitePaymentLink(plNumber: $plNumber) {
    redirectToPaymentLink
    canShowSuccessfulPaymentView
    account {
      name
      id
    }
    paymentCollection {
      id
      isOnlineCollection
      isPaid
      proofStatus
      currency
      invoices {
        id
        invoiceNumber
        allocatedAmount
      }
      totalPaymentAmount
      supportedPaymentMethods {
        name
        isEnabled
        isOnline
      }
      actualPaymentMethod {
        name
        isEnabled
        isOnline
      }
      proofAttachments {
        fileName
        mimeType
        url
      }
    }
    pendingInvoices {
      id
      currency
      reservations {
        id
      }
      invoiceItems {
        addOnService {
          cost
          name
          id
        }
        damageType {
          cost
          id
          name
        }
        description
        quantity
        id
        unitPrice
      }
      invoiceNumber
      totalAmount
      dueAmount
      paidAmount
      invoiceType
      breakdown {
        nights
        nightlyRate
        bookingAmount
        vat {
          percentage
          amount
        }
        fees {
          name
          value
          percentage
          isTaxable
        }
        discountAmount
        bookingTotal
        otaCommission
      }
    }
    bankTransferBeneficiary {
      bankName
      branch
      accountName
      accountNumber
      iban
      swiftCode
      accountCurrency
    }
    cryptoBeneficiary {
      tokenSymbol
      networks {
        networkName
        address
        qrCodeUrl
      }
    }
    canRequestBusinessInvoice
    entries {
      __typename
      ... on Reservation {
        id
        nights
        contact {
          firstName
          lastName
          id
        }
        numberOfGuests
        checkInDate {
          formatted
          raw
        }
        checkInTime
        checkOutDate {
          formatted
          raw
        }
        checkOutTime
        confirmationNumber
        property {
          id
          listingNameRendered
          location {
            id
            zipCode
            address
            coordinates {
              lat
              lng
            }
            neighbourhood {
              name
              city {
                id
                name
                airportCode
              }
              id
            }
          }
          images {
            main {
              url
              webp {
                thumbnailUrl
                mediumUrl
                largeUrl
              }
            }
            all {
              url
              webp {
                thumbnailUrl
                mediumUrl
                largeUrl
              }
              displayOrder
              captionRendered
            }
          }
        }
      }
      ... on ReservationExtension {
        id
        reservation {
          id
        }
        contact {
          firstName
          lastName
          id
        }
        property {
          id
          listingNameRendered
          location {
            id
            zipCode
            address
            coordinates {
              lat
              lng
            }
            neighbourhood {
              name
              city {
                id
                name
                airportCode
              }
              id
            }
          }
          images {
            main {
              url
              webp {
                thumbnailUrl
                mediumUrl
                largeUrl
              }
            }
            all {
              url
              webp {
                thumbnailUrl
                mediumUrl
                largeUrl
              }
              displayOrder
              captionRendered
            }
          }
        }
        nights
        extensionConfirmationNumber: confirmationNumber
      }
    }
  }
}
    `;

/**
 * __useWebsitePaymentLinkQuery__
 *
 * To run a query within a React component, call `useWebsitePaymentLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsitePaymentLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsitePaymentLinkQuery({
 *   variables: {
 *      plNumber: // value for 'plNumber'
 *   },
 * });
 */
export function useWebsitePaymentLinkQuery(baseOptions: Apollo.QueryHookOptions<WebsitePaymentLinkQuery, WebsitePaymentLinkQueryVariables> & ({ variables: WebsitePaymentLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsitePaymentLinkQuery, WebsitePaymentLinkQueryVariables>(WebsitePaymentLinkDocument, options);
      }
export function useWebsitePaymentLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsitePaymentLinkQuery, WebsitePaymentLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsitePaymentLinkQuery, WebsitePaymentLinkQueryVariables>(WebsitePaymentLinkDocument, options);
        }
// @ts-ignore
export function useWebsitePaymentLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WebsitePaymentLinkQuery, WebsitePaymentLinkQueryVariables>): Apollo.UseSuspenseQueryResult<WebsitePaymentLinkQuery, WebsitePaymentLinkQueryVariables>;
export function useWebsitePaymentLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsitePaymentLinkQuery, WebsitePaymentLinkQueryVariables>): Apollo.UseSuspenseQueryResult<WebsitePaymentLinkQuery | undefined, WebsitePaymentLinkQueryVariables>;
export function useWebsitePaymentLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsitePaymentLinkQuery, WebsitePaymentLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsitePaymentLinkQuery, WebsitePaymentLinkQueryVariables>(WebsitePaymentLinkDocument, options);
        }
export type WebsitePaymentLinkQueryHookResult = ReturnType<typeof useWebsitePaymentLinkQuery>;
export type WebsitePaymentLinkLazyQueryHookResult = ReturnType<typeof useWebsitePaymentLinkLazyQuery>;
export type WebsitePaymentLinkSuspenseQueryHookResult = ReturnType<typeof useWebsitePaymentLinkSuspenseQuery>;
export type WebsitePaymentLinkQueryResult = Apollo.QueryResult<WebsitePaymentLinkQuery, WebsitePaymentLinkQueryVariables>;
export const WebsiteBrLinkCardOnFileInfoDocument = gql`
    query WebsiteBRLinkCardOnFileInfo($payload: WebsiteBRLinkCardOnFileInfoInput!) {
  websiteBRLinkCardOnFileInfo(params: $payload) {
    cardBrand
    cardNumber
    currency
    id
    pspType
  }
}
    `;

/**
 * __useWebsiteBrLinkCardOnFileInfoQuery__
 *
 * To run a query within a React component, call `useWebsiteBrLinkCardOnFileInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsiteBrLinkCardOnFileInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebsiteBrLinkCardOnFileInfoQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useWebsiteBrLinkCardOnFileInfoQuery(baseOptions: Apollo.QueryHookOptions<WebsiteBrLinkCardOnFileInfoQuery, WebsiteBrLinkCardOnFileInfoQueryVariables> & ({ variables: WebsiteBrLinkCardOnFileInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebsiteBrLinkCardOnFileInfoQuery, WebsiteBrLinkCardOnFileInfoQueryVariables>(WebsiteBrLinkCardOnFileInfoDocument, options);
      }
export function useWebsiteBrLinkCardOnFileInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WebsiteBrLinkCardOnFileInfoQuery, WebsiteBrLinkCardOnFileInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebsiteBrLinkCardOnFileInfoQuery, WebsiteBrLinkCardOnFileInfoQueryVariables>(WebsiteBrLinkCardOnFileInfoDocument, options);
        }
// @ts-ignore
export function useWebsiteBrLinkCardOnFileInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<WebsiteBrLinkCardOnFileInfoQuery, WebsiteBrLinkCardOnFileInfoQueryVariables>): Apollo.UseSuspenseQueryResult<WebsiteBrLinkCardOnFileInfoQuery, WebsiteBrLinkCardOnFileInfoQueryVariables>;
export function useWebsiteBrLinkCardOnFileInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteBrLinkCardOnFileInfoQuery, WebsiteBrLinkCardOnFileInfoQueryVariables>): Apollo.UseSuspenseQueryResult<WebsiteBrLinkCardOnFileInfoQuery | undefined, WebsiteBrLinkCardOnFileInfoQueryVariables>;
export function useWebsiteBrLinkCardOnFileInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebsiteBrLinkCardOnFileInfoQuery, WebsiteBrLinkCardOnFileInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebsiteBrLinkCardOnFileInfoQuery, WebsiteBrLinkCardOnFileInfoQueryVariables>(WebsiteBrLinkCardOnFileInfoDocument, options);
        }
export type WebsiteBrLinkCardOnFileInfoQueryHookResult = ReturnType<typeof useWebsiteBrLinkCardOnFileInfoQuery>;
export type WebsiteBrLinkCardOnFileInfoLazyQueryHookResult = ReturnType<typeof useWebsiteBrLinkCardOnFileInfoLazyQuery>;
export type WebsiteBrLinkCardOnFileInfoSuspenseQueryHookResult = ReturnType<typeof useWebsiteBrLinkCardOnFileInfoSuspenseQuery>;
export type WebsiteBrLinkCardOnFileInfoQueryResult = Apollo.QueryResult<WebsiteBrLinkCardOnFileInfoQuery, WebsiteBrLinkCardOnFileInfoQueryVariables>;
export const GetPropertyQuotationDocument = gql`
    query GetPropertyQuotation($filters: PropertyFilterInput!) {
  properties {
    records(filter: $filters) {
      quotation {
        isDaysUnavailable
        isLengthOfStayViolated
        isDiscountInvalid
        paymentPlan {
          currency
          paymentMethods {
            name
            isEnabled
          }
          originalBookingTotal
          grandTotal
          securityDeposit {
            totalAmount
            isDueNow
            dueOn {
              formatted
            }
            isInSameTransaction
            damageProtectionPolicyType
            corporatePaysForTheSecurityDeposit
            isPaid
          }
          singlePayment {
            reservation {
              checkInTime
              checkOutTime
              checkOutInstructions {
                content {
                  body
                }
                email {
                  content
                }
              }
            }
            nights
            vat {
              amount
              percentage
            }
            bookingTotal
            nightlyRate
            discountAmount
            bookingAmount
            isPaid
            amountPaid
            invoices {
              invoiceNumber
              id
              totalAmount
              dueAmount
              paidAmount
            }
            fees {
              percentage
              value
              name
              isTaxable
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPropertyQuotationQuery__
 *
 * To run a query within a React component, call `useGetPropertyQuotationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPropertyQuotationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPropertyQuotationQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetPropertyQuotationQuery(baseOptions: Apollo.QueryHookOptions<GetPropertyQuotationQuery, GetPropertyQuotationQueryVariables> & ({ variables: GetPropertyQuotationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPropertyQuotationQuery, GetPropertyQuotationQueryVariables>(GetPropertyQuotationDocument, options);
      }
export function useGetPropertyQuotationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPropertyQuotationQuery, GetPropertyQuotationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPropertyQuotationQuery, GetPropertyQuotationQueryVariables>(GetPropertyQuotationDocument, options);
        }
// @ts-ignore
export function useGetPropertyQuotationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPropertyQuotationQuery, GetPropertyQuotationQueryVariables>): Apollo.UseSuspenseQueryResult<GetPropertyQuotationQuery, GetPropertyQuotationQueryVariables>;
export function useGetPropertyQuotationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyQuotationQuery, GetPropertyQuotationQueryVariables>): Apollo.UseSuspenseQueryResult<GetPropertyQuotationQuery | undefined, GetPropertyQuotationQueryVariables>;
export function useGetPropertyQuotationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPropertyQuotationQuery, GetPropertyQuotationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPropertyQuotationQuery, GetPropertyQuotationQueryVariables>(GetPropertyQuotationDocument, options);
        }
export type GetPropertyQuotationQueryHookResult = ReturnType<typeof useGetPropertyQuotationQuery>;
export type GetPropertyQuotationLazyQueryHookResult = ReturnType<typeof useGetPropertyQuotationLazyQuery>;
export type GetPropertyQuotationSuspenseQueryHookResult = ReturnType<typeof useGetPropertyQuotationSuspenseQuery>;
export type GetPropertyQuotationQueryResult = Apollo.QueryResult<GetPropertyQuotationQuery, GetPropertyQuotationQueryVariables>;
export const GetReservationsDocument = gql`
    query GetReservations($filters: ReservationFilterInput) {
  reservations {
    records(filter: $filters) {
      id
      confirmationNumber
      status
      numberOfGuests
      extendedCheckOutDate {
        formatted
        raw
      }
      documents {
        __typename
        isMainGuest
        documentStatus
        document {
          __typename
          id
          documentType
          attachments {
            fileName
            url
            mimeType
            __typename
          }
        }
        content {
          firstName
          lastName
          fatherName
          grandfatherName
          documentNumber
          documentVersionNumber
          nationality {
            id
            name
          }
        }
        isStatusOverridden
      }
      invoices {
        id
        totalAmount
        currency
        paidAt {
          formatted
          raw
        }
        paidAmount
        paymentMethod
        breakdown {
          nights
          nightlyRate
          bookingAmount
          vat {
            percentage
            amount
          }
          discountAmount
          discountReason
          otaCommission
          adjustments {
            amount
            details
          }
          fees {
            name
            value
            percentage
          }
        }
      }
      checkInDate {
        formatted
        raw
      }
      checkOutDate {
        formatted
        raw
      }
      checkInTime
      checkOutTime
      pointOfContact {
        firstName
        lastName
        id
        email
        phone {
          code
          number
        }
      }
      property {
        __typename
        id
        internalName
        listingNameRendered
        bedroomCount
        bathCount
        furnished {
          maximumGuests
        }
        location {
          __typename
          id
          address
          coordinates {
            __typename
            lat
            lng
          }
          neighbourhood {
            id
            name
            city {
              id
              name
              state
              vatPercentage
            }
          }
        }
        highLevelAmenities {
          __typename
          id
          name
          iconUrl
        }
        images {
          __typename
          main {
            __typename
            url
            webp {
              __typename
              thumbnailUrl
              mediumUrl
              largeUrl
            }
          }
          all {
            __typename
            url
            webp {
              __typename
              thumbnailUrl
              mediumUrl
              largeUrl
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetReservationsQuery__
 *
 * To run a query within a React component, call `useGetReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReservationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetReservationsQuery(baseOptions?: Apollo.QueryHookOptions<GetReservationsQuery, GetReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReservationsQuery, GetReservationsQueryVariables>(GetReservationsDocument, options);
      }
export function useGetReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReservationsQuery, GetReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReservationsQuery, GetReservationsQueryVariables>(GetReservationsDocument, options);
        }
// @ts-ignore
export function useGetReservationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetReservationsQuery, GetReservationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReservationsQuery, GetReservationsQueryVariables>;
export function useGetReservationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReservationsQuery, GetReservationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetReservationsQuery | undefined, GetReservationsQueryVariables>;
export function useGetReservationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetReservationsQuery, GetReservationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetReservationsQuery, GetReservationsQueryVariables>(GetReservationsDocument, options);
        }
export type GetReservationsQueryHookResult = ReturnType<typeof useGetReservationsQuery>;
export type GetReservationsLazyQueryHookResult = ReturnType<typeof useGetReservationsLazyQuery>;
export type GetReservationsSuspenseQueryHookResult = ReturnType<typeof useGetReservationsSuspenseQuery>;
export type GetReservationsQueryResult = Apollo.QueryResult<GetReservationsQuery, GetReservationsQueryVariables>;
export const ExtractReservationIdentityDocumentsDocument = gql`
    mutation ExtractReservationIdentityDocuments($payload: ExtractReservationIdentityDocumentsPayloadInput!) {
  extractReservationIdentityDocuments(payload: $payload) {
    content {
      firstName
      lastName
      fatherName
      grandfatherName
      documentNumber
      expiryDate {
        raw
        formatted
      }
      birthdate {
        raw
        formatted
      }
      gender
      nationality {
        id
        name
      }
      issuingCountry {
        id
        name
      }
      placeOfBirth {
        id
        name
      }
    }
    isApproved
    rejectionReasons
  }
}
    `;
export type ExtractReservationIdentityDocumentsMutationFn = Apollo.MutationFunction<ExtractReservationIdentityDocumentsMutation, ExtractReservationIdentityDocumentsMutationVariables>;

/**
 * __useExtractReservationIdentityDocumentsMutation__
 *
 * To run a mutation, you first call `useExtractReservationIdentityDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExtractReservationIdentityDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [extractReservationIdentityDocumentsMutation, { data, loading, error }] = useExtractReservationIdentityDocumentsMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useExtractReservationIdentityDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<ExtractReservationIdentityDocumentsMutation, ExtractReservationIdentityDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExtractReservationIdentityDocumentsMutation, ExtractReservationIdentityDocumentsMutationVariables>(ExtractReservationIdentityDocumentsDocument, options);
      }
export type ExtractReservationIdentityDocumentsMutationHookResult = ReturnType<typeof useExtractReservationIdentityDocumentsMutation>;
export type ExtractReservationIdentityDocumentsMutationResult = Apollo.MutationResult<ExtractReservationIdentityDocumentsMutation>;
export type ExtractReservationIdentityDocumentsMutationOptions = Apollo.BaseMutationOptions<ExtractReservationIdentityDocumentsMutation, ExtractReservationIdentityDocumentsMutationVariables>;
export const CreateReservationDocumentDocument = gql`
    mutation CreateReservationDocument($documentID: ID, $payload: ReservationDocumentPayloadInput!) {
  createReservationDocument(documentID: $documentID, payload: $payload)
}
    `;
export type CreateReservationDocumentMutationFn = Apollo.MutationFunction<CreateReservationDocumentMutation, CreateReservationDocumentMutationVariables>;

/**
 * __useCreateReservationDocumentMutation__
 *
 * To run a mutation, you first call `useCreateReservationDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReservationDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReservationDocumentMutation, { data, loading, error }] = useCreateReservationDocumentMutation({
 *   variables: {
 *      documentID: // value for 'documentID'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateReservationDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateReservationDocumentMutation, CreateReservationDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReservationDocumentMutation, CreateReservationDocumentMutationVariables>(CreateReservationDocumentDocument, options);
      }
export type CreateReservationDocumentMutationHookResult = ReturnType<typeof useCreateReservationDocumentMutation>;
export type CreateReservationDocumentMutationResult = Apollo.MutationResult<CreateReservationDocumentMutation>;
export type CreateReservationDocumentMutationOptions = Apollo.BaseMutationOptions<CreateReservationDocumentMutation, CreateReservationDocumentMutationVariables>;
export const DeleteReservationDocumentDocument = gql`
    mutation DeleteReservationDocument($brCode: String, $documentID: ID!, $reservationID: ID) {
  deleteReservationDocument(
    brCode: $brCode
    documentID: $documentID
    reservationID: $reservationID
  )
}
    `;
export type DeleteReservationDocumentMutationFn = Apollo.MutationFunction<DeleteReservationDocumentMutation, DeleteReservationDocumentMutationVariables>;

/**
 * __useDeleteReservationDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteReservationDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReservationDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReservationDocumentMutation, { data, loading, error }] = useDeleteReservationDocumentMutation({
 *   variables: {
 *      brCode: // value for 'brCode'
 *      documentID: // value for 'documentID'
 *      reservationID: // value for 'reservationID'
 *   },
 * });
 */
export function useDeleteReservationDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReservationDocumentMutation, DeleteReservationDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReservationDocumentMutation, DeleteReservationDocumentMutationVariables>(DeleteReservationDocumentDocument, options);
      }
export type DeleteReservationDocumentMutationHookResult = ReturnType<typeof useDeleteReservationDocumentMutation>;
export type DeleteReservationDocumentMutationResult = Apollo.MutationResult<DeleteReservationDocumentMutation>;
export type DeleteReservationDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteReservationDocumentMutation, DeleteReservationDocumentMutationVariables>;
export const SearchUnitsDocument = gql`
    query SearchUnits($filter: PropertyFilterInput, $options: CommonQueryOptionsInput) {
  properties {
    __typename
    count(filter: $filter)
    records(filter: $filter, options: $options) {
      __typename
      id
      listingNameRendered
      bedroomCount
      bathCount
      propertyType {
        isStandalone
        name
      }
      furnished {
        maximumGuests
      }
      houseRules {
        id
        name
        iconUrl
        contentRendered {
          languageCode
          title
          body
        }
        __typename
      }
      location {
        __typename
        id
        address
        coordinates {
          __typename
          lat
          lng
        }
      }
      highLevelAmenities {
        __typename
        id
        name
        iconUrl
      }
      quotation {
        paymentPlan {
          currency
          paymentMethods {
            name
            isEnabled
          }
          originalBookingTotal
          grandTotal
          securityDeposit {
            totalAmount
            isDueNow
            dueOn {
              formatted
            }
            isInSameTransaction
            damageProtectionPolicyType
            corporatePaysForTheSecurityDeposit
            isPaid
          }
          singlePayment {
            nights
            vat {
              amount
              percentage
            }
            bookingTotal
            nightlyRate
            discountAmount
            bookingAmount
            isPaid
            amountPaid
            invoices {
              invoiceNumber
              id
              totalAmount
              dueAmount
              paidAmount
            }
            fees {
              percentage
              value
              name
            }
          }
        }
      }
      images {
        __typename
        main {
          __typename
          url
          webp {
            __typename
            thumbnailUrl
            mediumUrl
            largeUrl
          }
        }
        all {
          __typename
          url
          webp {
            __typename
            thumbnailUrl
            mediumUrl
            largeUrl
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchUnitsQuery__
 *
 * To run a query within a React component, call `useSearchUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUnitsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useSearchUnitsQuery(baseOptions?: Apollo.QueryHookOptions<SearchUnitsQuery, SearchUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUnitsQuery, SearchUnitsQueryVariables>(SearchUnitsDocument, options);
      }
export function useSearchUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUnitsQuery, SearchUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUnitsQuery, SearchUnitsQueryVariables>(SearchUnitsDocument, options);
        }
// @ts-ignore
export function useSearchUnitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchUnitsQuery, SearchUnitsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUnitsQuery, SearchUnitsQueryVariables>;
export function useSearchUnitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUnitsQuery, SearchUnitsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchUnitsQuery | undefined, SearchUnitsQueryVariables>;
export function useSearchUnitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUnitsQuery, SearchUnitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUnitsQuery, SearchUnitsQueryVariables>(SearchUnitsDocument, options);
        }
export type SearchUnitsQueryHookResult = ReturnType<typeof useSearchUnitsQuery>;
export type SearchUnitsLazyQueryHookResult = ReturnType<typeof useSearchUnitsLazyQuery>;
export type SearchUnitsSuspenseQueryHookResult = ReturnType<typeof useSearchUnitsSuspenseQuery>;
export type SearchUnitsQueryResult = Apollo.QueryResult<SearchUnitsQuery, SearchUnitsQueryVariables>;
export const GetUnitDetailsDocument = gql`
    query GetUnitDetails($filter: PropertyFilterInput, $options: CommonQueryOptionsInput) {
  properties {
    records(filter: $filter, options: $options) {
      id
      propertyType {
        isStandalone
        name
      }
      houseRules {
        __typename
        id
        iconUrl
        name
        contentRendered {
          body
          title
          languageCode
          __typename
        }
      }
      listingNameRendered
      bedroomCount
      bathCount
      aboutPropertyRendered
      currency
      entityType
      building {
        highLevelAmenities {
          contentRendered
          iconUrl
          id
          name
        }
        location {
          address
          neighbourhood {
            name
            id
            city {
              name
              id
            }
          }
          coordinates {
            lat
            lng
          }
        }
      }
      furnished {
        bedCount
        sleepingArrangement {
          bedTypes
          bedroomNumber
        }
        maximumGuests
      }
      location {
        id
        address
        neighbourhood {
          name
          city {
            name
          }
        }
        coordinates {
          lat
          lng
        }
      }
      highLevelAmenities {
        __typename
        id
        name
        iconUrl
        contentRendered
      }
      quotation {
        paymentPlan {
          currency
          paymentMethods {
            name
            isEnabled
          }
          originalBookingTotal
          grandTotal
          securityDeposit {
            totalAmount
            isDueNow
            dueOn {
              formatted
            }
            isInSameTransaction
            damageProtectionPolicyType
            corporatePaysForTheSecurityDeposit
            isPaid
          }
          singlePayment {
            nights
            vat {
              amount
              percentage
            }
            bookingTotal
            nightlyRate
            discountAmount
            bookingAmount
            isPaid
            amountPaid
            invoices {
              invoiceNumber
              id
              totalAmount
              dueAmount
              paidAmount
            }
            fees {
              percentage
              value
              name
            }
          }
        }
      }
      houseRules {
        contentRendered {
          body
          title
          languageCode
        }
        iconUrl
        id
        name
      }
      images {
        main {
          url
          webp {
            thumbnailUrl
            mediumUrl
            largeUrl
          }
        }
        all {
          url
          webp {
            thumbnailUrl
            mediumUrl
            largeUrl
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetUnitDetailsQuery__
 *
 * To run a query within a React component, call `useGetUnitDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnitDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnitDetailsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useGetUnitDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetUnitDetailsQuery, GetUnitDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUnitDetailsQuery, GetUnitDetailsQueryVariables>(GetUnitDetailsDocument, options);
      }
export function useGetUnitDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUnitDetailsQuery, GetUnitDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUnitDetailsQuery, GetUnitDetailsQueryVariables>(GetUnitDetailsDocument, options);
        }
// @ts-ignore
export function useGetUnitDetailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUnitDetailsQuery, GetUnitDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnitDetailsQuery, GetUnitDetailsQueryVariables>;
export function useGetUnitDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnitDetailsQuery, GetUnitDetailsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUnitDetailsQuery | undefined, GetUnitDetailsQueryVariables>;
export function useGetUnitDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUnitDetailsQuery, GetUnitDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUnitDetailsQuery, GetUnitDetailsQueryVariables>(GetUnitDetailsDocument, options);
        }
export type GetUnitDetailsQueryHookResult = ReturnType<typeof useGetUnitDetailsQuery>;
export type GetUnitDetailsLazyQueryHookResult = ReturnType<typeof useGetUnitDetailsLazyQuery>;
export type GetUnitDetailsSuspenseQueryHookResult = ReturnType<typeof useGetUnitDetailsSuspenseQuery>;
export type GetUnitDetailsQueryResult = Apollo.QueryResult<GetUnitDetailsQuery, GetUnitDetailsQueryVariables>;